import {assignInlineVars as $kyBEk$assignInlineVars} from "@vanilla-extract/dynamic";
import $kyBEk$fastifydeepmerge from "@fastify/deepmerge";
import {createStore as $kyBEk$createStore} from "zustand/vanilla";
import {persist as $kyBEk$persist} from "zustand/middleware";
import {immer as $kyBEk$immer} from "zustand/middleware/immer";
import {jsx as $kyBEk$jsx, jsxs as $kyBEk$jsxs, Fragment as $kyBEk$Fragment} from "react/jsx-runtime";
import {useState as $kyBEk$useState, useEffect as $kyBEk$useEffect, useRef as $kyBEk$useRef, forwardRef as $kyBEk$forwardRef, useId as $kyBEk$useId, useMemo as $kyBEk$useMemo, cloneElement as $kyBEk$cloneElement} from "react";
import $kyBEk$clsx from "clsx";
import {createSprinkles as $kyBEk$createSprinkles} from "@vanilla-extract/sprinkles/createRuntimeSprinkles";
import {createRuntimeFn as $kyBEk$createRuntimeFn} from "@vanilla-extract/recipes/createRuntimeFn";
import $kyBEk$copytoclipboard from "copy-to-clipboard";
import $kyBEk$animejs from "animejs";
import {machine as $kyBEk$machine, connect as $kyBEk$connect} from "@zag-js/dialog";
import {create as $kyBEk$create} from "zustand";
import {useMachine as $kyBEk$useMachine, normalizeProps as $kyBEk$normalizeProps, Portal as $kyBEk$Portal} from "@zag-js/react";
import $kyBEk$lodashdebounce from "lodash/debounce";
import $kyBEk$bignumberjs from "bignumber.js";

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
/// <reference types="./global.d.ts" />
var $ee947b15541e898f$var$_a;
var $ee947b15541e898f$export$81abf30fb640fb72;
(function(DebugLevel) {
    DebugLevel[DebugLevel["None"] = 0] = "None";
    DebugLevel[DebugLevel["Log"] = 1] = "Log";
    DebugLevel[DebugLevel["Breakpoint"] = 2] = "Breakpoint";
})($ee947b15541e898f$export$81abf30fb640fb72 || ($ee947b15541e898f$export$81abf30fb640fb72 = {}));
var $ee947b15541e898f$var$debugLevel = $ee947b15541e898f$export$81abf30fb640fb72.None;
var $ee947b15541e898f$var$debugStrategies = ($ee947b15541e898f$var$_a = {}, $ee947b15541e898f$var$_a[$ee947b15541e898f$export$81abf30fb640fb72.None] = function() {
    return null;
}, $ee947b15541e898f$var$_a[$ee947b15541e898f$export$81abf30fb640fb72.Log] = function(message) {
    return console.log(message);
}, $ee947b15541e898f$var$_a[$ee947b15541e898f$export$81abf30fb640fb72.Breakpoint] = function(message) {
    console.log(message);
    debugger;
}, $ee947b15541e898f$var$_a);
function $ee947b15541e898f$export$d6c2b47acf98a8f8(level) {
    $ee947b15541e898f$var$debugLevel = level;
}
function $ee947b15541e898f$export$1c9f709888824e05(message) {
    $ee947b15541e898f$var$debugStrategies[$ee947b15541e898f$var$debugLevel](message);
}



var $3a23b7a7442a0ab3$export$2dffd0b5373a4389;
(function(Platform) {
    Platform["Default"] = "default";
    Platform["Angular"] = "angular";
    Platform["Preact"] = "preact";
    Platform["Qwik"] = "qwik";
    Platform["React"] = "react";
    Platform["Solid"] = "solid";
    Platform["Svelte"] = "svelte";
    Platform["Vue"] = "vue";
    Platform["Webcomponents"] = "webcomponent";
})($3a23b7a7442a0ab3$export$2dffd0b5373a4389 || ($3a23b7a7442a0ab3$export$2dffd0b5373a4389 = {}));
var $3a23b7a7442a0ab3$var$platform = $3a23b7a7442a0ab3$export$2dffd0b5373a4389.Default;
function $3a23b7a7442a0ab3$export$5f05d56a0f2349cc(newPlatform) {
    (0, $ee947b15541e898f$export$1c9f709888824e05)("Setting new platform ".concat(newPlatform));
    $3a23b7a7442a0ab3$var$platform = newPlatform;
}
function $3a23b7a7442a0ab3$export$867a782338812cb4() {
    return $3a23b7a7442a0ab3$var$platform;
}
function $3a23b7a7442a0ab3$export$48d7c418edadb60c() {
    try {
        return window, false;
    } catch (error) {}
    return true;
}




var $c3e45e6361c17de0$export$16e1fc8de5cd9687 = {
    xs: "0 0 0 1px rgba(0, 0, 0, 0.05)",
    sm: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
    base: "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)",
    md: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
    lg: "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
    xl: "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
    "2xl": "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
    inset: "inset 0 2px 4px 0 rgba(0,0,0,0.06)",
    primaryOutline: "0 0 0 2px #929ce4",
    none: "none",
    "dark-lg": "rgba(0, 0, 0, 0.1) 0px 0px 0px 1px, rgba(0, 0, 0, 0.2) 0px 5px 10px, rgba(0, 0, 0, 0.4) 0px 15px 40px"
};
var $c3e45e6361c17de0$export$894a3adda1f2fe57 = {
    font: {
        body: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,\nHelvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"'
    },
    fontSize: {
        "3xs": "0.5rem",
        "2xs": "0.625rem",
        xs: "0.75rem",
        sm: "0.875rem",
        md: "1rem",
        lg: "1.125rem",
        xl: "1.25rem",
        "2xl": "1.375rem",
        "3xl": "1.5rem",
        "4xl": "1.625rem",
        "5xl": "1.75rem",
        "6xl": "1.875rem",
        "7xl": "2rem",
        "8xl": "2.25rem",
        "9xl": "2.5rem",
        "10xl": "3rem",
        "11xl": "3.5rem",
        "12xl": "4rem",
        "13xl": "4.5rem",
        "14xl": "5rem",
        "15xl": "5.5rem"
    },
    fontWeight: {
        hairline: "100",
        thin: "200",
        light: "300",
        normal: "400",
        medium: "500",
        semibold: "600",
        bold: "700",
        extrabold: "800",
        black: "900"
    },
    letterSpacing: {
        tighter: "-0.05em",
        tight: "-0.025em",
        normal: "0",
        wide: "0.025em",
        wider: "0.05em",
        widest: "0.1em"
    },
    lineHeight: {
        normal: "normal",
        none: "1",
        shorter: "1.1",
        "short": "1.25",
        base: "1.5",
        tall: "1.75",
        taller: "2"
    },
    space: {
        "0": "0rem",
        "1": "0.125rem",
        "2": "0.25rem",
        "3": "0.375rem",
        "4": "0.5rem",
        "5": "0.625rem",
        "6": "0.75rem",
        "7": "0.875rem",
        "8": "1rem",
        "9": "1.25rem",
        "10": "1.5rem",
        "11": "1.75rem",
        "12": "2rem",
        "13": "2.25rem",
        "14": "2.5rem",
        "15": "3rem",
        "16": "3.5rem",
        "17": "4rem",
        "18": "4.5rem",
        "19": "5rem",
        "20": "5.5rem",
        "21": "6rem",
        "22": "7rem",
        "23": "8rem",
        "24": "9rem",
        "25": "10rem",
        "26": "11rem",
        "27": "12rem",
        "28": "13rem",
        "29": "14rem",
        "30": "15rem",
        auto: "auto",
        full: "100%",
        fit: "fit-content",
        max: "max-content",
        min: "min-content",
        viewHeight: "100vh",
        viewWidth: "100vw",
        none: "0"
    },
    boxShadow: $c3e45e6361c17de0$export$16e1fc8de5cd9687,
    radii: {
        none: "0",
        sm: "0.125rem",
        base: "0.25rem",
        md: "0.375rem",
        lg: "0.5rem",
        xl: "0.625rem",
        "2xl": "0.75rem",
        "3xl": "0.875rem",
        "4xl": "1rem",
        full: "9999px"
    },
    borderWidth: {
        none: "0px",
        sm: "1px",
        base: "2px",
        md: "4px",
        lg: "8px",
        xl: "16px"
    },
    borderStyle: {
        none: "none",
        solid: "solid",
        dotted: "dotted",
        dashed: "dashed",
        groove: "groove",
        ridge: "ridge",
        hidden: "hidden",
        "double": "double",
        inset: "inset",
        outset: "outset",
        unset: "unset"
    }
};
var $c3e45e6361c17de0$export$9dd2d987c51823e6 = "_1o241ds6q";
var $c3e45e6361c17de0$export$1f0a7f6a566674cf = "_1o241ds6p";
var $c3e45e6361c17de0$export$1d87a38ace0b2bb3 = {
    colors: {
        primary: "var(--_1o241ds0)",
        body: "var(--_1o241ds1)",
        background: "var(--_1o241ds2)",
        link: "var(--_1o241ds3)",
        linkHover: "var(--_1o241ds4)",
        text: "var(--_1o241ds5)",
        textSecondary: "var(--_1o241ds6)",
        textDanger: "var(--_1o241ds7)",
        textWarning: "var(--_1o241ds8)",
        rewardBg: "var(--_1o241ds9)",
        rewardContent: "var(--_1o241dsa)",
        cardBg: "var(--_1o241dsb)",
        inputBorder: "var(--_1o241dsc)",
        progressBg: "var(--_1o241dsd)",
        progressValue: "var(--_1o241dse)",
        progressCursor: "var(--_1o241dsf)",
        black: "var(--_1o241dsg)",
        white: "var(--_1o241dsh)",
        transparent: "var(--_1o241dsi)",
        current: "var(--_1o241dsj)",
        whiteAlpha50: "var(--_1o241dsk)",
        whiteAlpha100: "var(--_1o241dsl)",
        whiteAlpha200: "var(--_1o241dsm)",
        whiteAlpha300: "var(--_1o241dsn)",
        whiteAlpha400: "var(--_1o241dso)",
        whiteAlpha500: "var(--_1o241dsp)",
        whiteAlpha600: "var(--_1o241dsq)",
        whiteAlpha700: "var(--_1o241dsr)",
        whiteAlpha800: "var(--_1o241dss)",
        whiteAlpha900: "var(--_1o241dst)",
        blackAlpha50: "var(--_1o241dsu)",
        blackAlpha100: "var(--_1o241dsv)",
        blackAlpha200: "var(--_1o241dsw)",
        blackAlpha300: "var(--_1o241dsx)",
        blackAlpha400: "var(--_1o241dsy)",
        blackAlpha500: "var(--_1o241dsz)",
        blackAlpha600: "var(--_1o241ds10)",
        blackAlpha700: "var(--_1o241ds11)",
        blackAlpha800: "var(--_1o241ds12)",
        blackAlpha900: "var(--_1o241ds13)",
        gray50: "var(--_1o241ds14)",
        gray100: "var(--_1o241ds15)",
        gray200: "var(--_1o241ds16)",
        gray300: "var(--_1o241ds17)",
        gray400: "var(--_1o241ds18)",
        gray500: "var(--_1o241ds19)",
        gray600: "var(--_1o241ds1a)",
        gray700: "var(--_1o241ds1b)",
        gray800: "var(--_1o241ds1c)",
        gray900: "var(--_1o241ds1d)",
        red50: "var(--_1o241ds1e)",
        red100: "var(--_1o241ds1f)",
        red200: "var(--_1o241ds1g)",
        red300: "var(--_1o241ds1h)",
        red400: "var(--_1o241ds1i)",
        red500: "var(--_1o241ds1j)",
        red600: "var(--_1o241ds1k)",
        red700: "var(--_1o241ds1l)",
        red800: "var(--_1o241ds1m)",
        red900: "var(--_1o241ds1n)",
        orange50: "var(--_1o241ds1o)",
        orange100: "var(--_1o241ds1p)",
        orange200: "var(--_1o241ds1q)",
        orange300: "var(--_1o241ds1r)",
        orange400: "var(--_1o241ds1s)",
        orange500: "var(--_1o241ds1t)",
        orange600: "var(--_1o241ds1u)",
        orange700: "var(--_1o241ds1v)",
        orange800: "var(--_1o241ds1w)",
        orange900: "var(--_1o241ds1x)",
        yellow50: "var(--_1o241ds1y)",
        yellow100: "var(--_1o241ds1z)",
        yellow200: "var(--_1o241ds20)",
        yellow300: "var(--_1o241ds21)",
        yellow400: "var(--_1o241ds22)",
        yellow500: "var(--_1o241ds23)",
        yellow600: "var(--_1o241ds24)",
        yellow700: "var(--_1o241ds25)",
        yellow800: "var(--_1o241ds26)",
        yellow900: "var(--_1o241ds27)",
        green50: "var(--_1o241ds28)",
        green100: "var(--_1o241ds29)",
        green200: "var(--_1o241ds2a)",
        green300: "var(--_1o241ds2b)",
        green400: "var(--_1o241ds2c)",
        green500: "var(--_1o241ds2d)",
        green600: "var(--_1o241ds2e)",
        green700: "var(--_1o241ds2f)",
        green800: "var(--_1o241ds2g)",
        green900: "var(--_1o241ds2h)",
        blue50: "var(--_1o241ds2i)",
        blue100: "var(--_1o241ds2j)",
        blue200: "var(--_1o241ds2k)",
        blue300: "var(--_1o241ds2l)",
        blue400: "var(--_1o241ds2m)",
        blue500: "var(--_1o241ds2n)",
        blue600: "var(--_1o241ds2o)",
        blue700: "var(--_1o241ds2p)",
        blue800: "var(--_1o241ds2q)",
        blue900: "var(--_1o241ds2r)",
        primary50: "var(--_1o241ds2s)",
        primary100: "var(--_1o241ds2t)",
        primary200: "var(--_1o241ds2u)",
        primary300: "var(--_1o241ds2v)",
        primary400: "var(--_1o241ds2w)",
        primary500: "var(--_1o241ds2x)",
        primary600: "var(--_1o241ds2y)",
        primary700: "var(--_1o241ds2z)",
        primary800: "var(--_1o241ds30)",
        primary900: "var(--_1o241ds31)",
        purple50: "var(--_1o241ds32)",
        purple100: "var(--_1o241ds33)",
        purple200: "var(--_1o241ds34)",
        purple300: "var(--_1o241ds35)",
        purple400: "var(--_1o241ds36)",
        purple500: "var(--_1o241ds37)",
        purple600: "var(--_1o241ds38)",
        purple700: "var(--_1o241ds39)",
        purple800: "var(--_1o241ds3a)",
        purple900: "var(--_1o241ds3b)"
    },
    font: {
        body: "var(--_1o241ds3c)"
    },
    space: {
        "0": "var(--_1o241ds3d)",
        "1": "var(--_1o241ds3e)",
        "2": "var(--_1o241ds3f)",
        "3": "var(--_1o241ds3g)",
        "4": "var(--_1o241ds3h)",
        "5": "var(--_1o241ds3i)",
        "6": "var(--_1o241ds3j)",
        "7": "var(--_1o241ds3k)",
        "8": "var(--_1o241ds3l)",
        "9": "var(--_1o241ds3m)",
        "10": "var(--_1o241ds3n)",
        "11": "var(--_1o241ds3o)",
        "12": "var(--_1o241ds3p)",
        "13": "var(--_1o241ds3q)",
        "14": "var(--_1o241ds3r)",
        "15": "var(--_1o241ds3s)",
        "16": "var(--_1o241ds3t)",
        "17": "var(--_1o241ds3u)",
        "18": "var(--_1o241ds3v)",
        "19": "var(--_1o241ds3w)",
        "20": "var(--_1o241ds3x)",
        "21": "var(--_1o241ds3y)",
        "22": "var(--_1o241ds3z)",
        "23": "var(--_1o241ds40)",
        "24": "var(--_1o241ds41)",
        "25": "var(--_1o241ds42)",
        "26": "var(--_1o241ds43)",
        "27": "var(--_1o241ds44)",
        "28": "var(--_1o241ds45)",
        "29": "var(--_1o241ds46)",
        "30": "var(--_1o241ds47)",
        auto: "var(--_1o241ds48)",
        full: "var(--_1o241ds49)",
        fit: "var(--_1o241ds4a)",
        max: "var(--_1o241ds4b)",
        min: "var(--_1o241ds4c)",
        viewHeight: "var(--_1o241ds4d)",
        viewWidth: "var(--_1o241ds4e)",
        none: "var(--_1o241ds4f)"
    },
    borderWidth: {
        none: "var(--_1o241ds4g)",
        sm: "var(--_1o241ds4h)",
        base: "var(--_1o241ds4i)",
        md: "var(--_1o241ds4j)",
        lg: "var(--_1o241ds4k)",
        xl: "var(--_1o241ds4l)"
    },
    borderStyle: {
        none: "var(--_1o241ds4m)",
        solid: "var(--_1o241ds4n)",
        dotted: "var(--_1o241ds4o)",
        dashed: "var(--_1o241ds4p)",
        groove: "var(--_1o241ds4q)",
        ridge: "var(--_1o241ds4r)",
        hidden: "var(--_1o241ds4s)",
        "double": "var(--_1o241ds4t)",
        inset: "var(--_1o241ds4u)",
        outset: "var(--_1o241ds4v)",
        unset: "var(--_1o241ds4w)"
    },
    boxShadow: {
        xs: "var(--_1o241ds4x)",
        sm: "var(--_1o241ds4y)",
        base: "var(--_1o241ds4z)",
        md: "var(--_1o241ds50)",
        lg: "var(--_1o241ds51)",
        xl: "var(--_1o241ds52)",
        "2xl": "var(--_1o241ds53)",
        inset: "var(--_1o241ds54)",
        primaryOutline: "var(--_1o241ds55)",
        none: "var(--_1o241ds56)",
        "dark-lg": "var(--_1o241ds57)"
    },
    radii: {
        none: "var(--_1o241ds58)",
        sm: "var(--_1o241ds59)",
        base: "var(--_1o241ds5a)",
        md: "var(--_1o241ds5b)",
        lg: "var(--_1o241ds5c)",
        xl: "var(--_1o241ds5d)",
        "2xl": "var(--_1o241ds5e)",
        "3xl": "var(--_1o241ds5f)",
        "4xl": "var(--_1o241ds5g)",
        full: "var(--_1o241ds5h)"
    },
    letterSpacing: {
        tighter: "var(--_1o241ds5i)",
        tight: "var(--_1o241ds5j)",
        normal: "var(--_1o241ds5k)",
        wide: "var(--_1o241ds5l)",
        wider: "var(--_1o241ds5m)",
        widest: "var(--_1o241ds5n)"
    },
    lineHeight: {
        normal: "var(--_1o241ds5o)",
        none: "var(--_1o241ds5p)",
        shorter: "var(--_1o241ds5q)",
        "short": "var(--_1o241ds5r)",
        base: "var(--_1o241ds5s)",
        tall: "var(--_1o241ds5t)",
        taller: "var(--_1o241ds5u)"
    },
    fontWeight: {
        hairline: "var(--_1o241ds5v)",
        thin: "var(--_1o241ds5w)",
        light: "var(--_1o241ds5x)",
        normal: "var(--_1o241ds5y)",
        medium: "var(--_1o241ds5z)",
        semibold: "var(--_1o241ds60)",
        bold: "var(--_1o241ds61)",
        extrabold: "var(--_1o241ds62)",
        black: "var(--_1o241ds63)"
    },
    fontSize: {
        "3xs": "var(--_1o241ds64)",
        "2xs": "var(--_1o241ds65)",
        xs: "var(--_1o241ds66)",
        sm: "var(--_1o241ds67)",
        md: "var(--_1o241ds68)",
        lg: "var(--_1o241ds69)",
        xl: "var(--_1o241ds6a)",
        "2xl": "var(--_1o241ds6b)",
        "3xl": "var(--_1o241ds6c)",
        "4xl": "var(--_1o241ds6d)",
        "5xl": "var(--_1o241ds6e)",
        "6xl": "var(--_1o241ds6f)",
        "7xl": "var(--_1o241ds6g)",
        "8xl": "var(--_1o241ds6h)",
        "9xl": "var(--_1o241ds6i)",
        "10xl": "var(--_1o241ds6j)",
        "11xl": "var(--_1o241ds6k)",
        "12xl": "var(--_1o241ds6l)",
        "13xl": "var(--_1o241ds6m)",
        "14xl": "var(--_1o241ds6n)",
        "15xl": "var(--_1o241ds6o)"
    }
};







var $65ee908e933b27be$export$c362d7d98eda2752 = "interchain-ui-store";
var $65ee908e933b27be$export$6f57813fe9f31bf9 = (0, $kyBEk$createStore)((0, $kyBEk$persist)((0, $kyBEk$immer)(function(set) {
    return {
        themeMode: null,
        theme: null,
        themeClass: "",
        _hasHydrated: false,
        setTheme: function(newTheme, themeClass) {
            return set(function(state) {
                state.theme = newTheme;
                state.themeClass = themeClass;
            });
        },
        setThemeMode: function(newThemeMode) {
            return set(function(state) {
                var resolveSystemMode = function(themeMode) {
                    if (themeMode === "system") {
                        if ((0, $dd30de1fdfe56750$export$b167c75d54706639)()) return [
                            "dark",
                            (0, $c3e45e6361c17de0$export$9dd2d987c51823e6)
                        ];
                        if ((0, $dd30de1fdfe56750$export$ebc9fe044e96e7ed)()) return [
                            "light",
                            (0, $c3e45e6361c17de0$export$1f0a7f6a566674cf)
                        ];
                    } else {
                        var themeClass = {
                            dark: (0, $c3e45e6361c17de0$export$9dd2d987c51823e6),
                            light: (0, $c3e45e6361c17de0$export$1f0a7f6a566674cf)
                        }[newThemeMode];
                        return [
                            themeMode,
                            themeClass
                        ];
                    }
                };
                var _a = resolveSystemMode(newThemeMode), resolvedTheme = _a[0], resolvedClass = _a[1];
                state.themeMode = newThemeMode;
                state.theme = resolvedTheme;
                state.themeClass = resolvedClass;
            });
        },
        formatNumber: null,
        setFormatNumberFn: function(fn) {
            return set(function(state) {
                state.formatNumber = fn;
            });
        },
        setHasHydrated: function(hasHydrated) {
            set({
                _hasHydrated: hasHydrated
            });
        }
    };
}), {
    name: $65ee908e933b27be$export$c362d7d98eda2752,
    onRehydrateStorage: function() {
        return function(state) {
            state.setHasHydrated(true);
        };
    },
    // Only choose to persist theme preference, ignore other state
    partialize: function(state) {
        return {
            themeMode: state.themeMode
        };
    }
}));


var $6eaca5c1b6178241$export$dc3e8878c31a5f1c;
(function(Intent) {
    Intent["None"] = "";
    Intent["Info"] = "info";
    Intent["Success"] = "warning";
    Intent["Warning"] = "success";
    Intent["Error"] = "error";
})($6eaca5c1b6178241$export$dc3e8878c31a5f1c || ($6eaca5c1b6178241$export$dc3e8878c31a5f1c = {}));
var $6eaca5c1b6178241$export$c49dcf7bd77282d0 = Object.entries($6eaca5c1b6178241$export$dc3e8878c31a5f1c).map(function(_a) {
    var key = _a[0], value = _a[1];
    return {
        key: key,
        value: value
    };
});
var $6eaca5c1b6178241$export$f47e598ab0fa7f08 = [
    "light",
    "dark",
    "system"
];



var $dd30de1fdfe56750$var$merge = (0, $kyBEk$fastifydeepmerge)({
    all: true
});
var $dd30de1fdfe56750$export$79a8956d7e99dd16 = function(mode) {
    return "(prefers-color-scheme: ".concat(mode, ")");
};
var $dd30de1fdfe56750$export$3d2702f5c006feb7 = function(customTheme) {
    return (0, $kyBEk$assignInlineVars)((0, $c3e45e6361c17de0$export$1d87a38ace0b2bb3), $dd30de1fdfe56750$var$merge((0, $c3e45e6361c17de0$export$894a3adda1f2fe57), customTheme));
};
var $dd30de1fdfe56750$var$isValidThemeMode = function(mode) {
    return (0, $6eaca5c1b6178241$export$f47e598ab0fa7f08).includes(mode);
};
var $dd30de1fdfe56750$export$de2f59649721f6be = function(defaultThemeMode) {
    var hasHydrated = (0, $65ee908e933b27be$export$6f57813fe9f31bf9).getState()._hasHydrated;
    // While in SSR, return a default theme
    // TODO: document for package consumer to provide fallback UI using _hasHydrated to prevent flashing content
    if ((0, $3a23b7a7442a0ab3$export$48d7c418edadb60c)() || !hasHydrated) return "light";
    if ($dd30de1fdfe56750$var$isValidThemeMode(defaultThemeMode)) {
        (0, $65ee908e933b27be$export$6f57813fe9f31bf9).getState().setThemeMode(defaultThemeMode);
        return defaultThemeMode;
    }
    // props.defaultThemeMode is not provided or invalid, rely on persisted theme
    var savedTheme = (0, $65ee908e933b27be$export$6f57813fe9f31bf9).getState().themeMode;
    if ($dd30de1fdfe56750$var$isValidThemeMode(savedTheme)) {
        (0, $65ee908e933b27be$export$6f57813fe9f31bf9).getState().setThemeMode(savedTheme);
        return savedTheme;
    }
    // persisted value not a valid theme mode, fallback to 'system'
    (0, $65ee908e933b27be$export$6f57813fe9f31bf9).getState().setThemeMode("system");
    return "system";
};
var $dd30de1fdfe56750$export$ebc9fe044e96e7ed = function() {
    return window.matchMedia && window.matchMedia("(prefers-color-scheme: light)").matches;
};
var $dd30de1fdfe56750$export$b167c75d54706639 = function() {
    return window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches;
};


function $b63aebbaf0c2c0b0$var$getNoOpFormatter(// locale: string = "default",
locale, options) {
    return {
        format: function(x) {
            return (x === null || x === void 0 ? void 0 : x.toString()) || "";
        },
        formatToParts: function(x) {
            return [
                {
                    type: "unknown",
                    value: (x === null || x === void 0 ? void 0 : x.toString()) || ""
                }
            ];
        },
        resolvedOptions: new Intl.NumberFormat(locale, options).resolvedOptions
    };
}
function $b63aebbaf0c2c0b0$export$67198cb146c234dd(// locale: string = "default",
locale, options) {
    return new Intl.NumberFormat(locale, options);
}
function $b63aebbaf0c2c0b0$export$54906d710afac876(formatter, value) {
    // First, attempt to format the BigNumber as a number primitive
    try {
        return formatter.format(value.toNumber());
    } catch (_a) {}
    // As a fallback, simply return the ugly string value
    return value.toString();
}






var $c05182ab934fe0bd$exports = {};

$parcel$export($c05182ab934fe0bd$exports, "default", function () { return $c05182ab934fe0bd$export$2e2bcd8739ae039; }, function (v) { return $c05182ab934fe0bd$export$2e2bcd8739ae039 = v; });





var $47a3451e57ac14cf$export$9f2265a541a48bf2 = (0, $kyBEk$createSprinkles)(function() {
    var x = {
        conditions: {
            defaultCondition: "mobile",
            conditionNames: [
                "mobile",
                "tablet",
                "desktop"
            ],
            responsiveArray: [
                "mobile",
                "tablet",
                "desktop"
            ]
        },
        styles: {
            borderLeftRadius: {
                mappings: [
                    "borderBottomLeftRadius",
                    "borderTopLeftRadius"
                ]
            },
            borderRightRadius: {
                mappings: [
                    "borderBottomRightRadius",
                    "borderTopRightRadius"
                ]
            },
            borderTopRadius: {
                mappings: [
                    "borderTopLeftRadius",
                    "borderTopRightRadius"
                ]
            },
            borderBottomRadius: {
                mappings: [
                    "borderBottomLeftRadius",
                    "borderBottomRightRadius"
                ]
            },
            p: {
                mappings: [
                    "paddingTop",
                    "paddingBottom",
                    "paddingLeft",
                    "paddingRight"
                ]
            },
            px: {
                mappings: [
                    "paddingLeft",
                    "paddingRight"
                ]
            },
            py: {
                mappings: [
                    "paddingTop",
                    "paddingBottom"
                ]
            },
            m: {
                mappings: [
                    "marginTop",
                    "marginBottom",
                    "marginLeft",
                    "marginRight"
                ]
            },
            mx: {
                mappings: [
                    "marginLeft",
                    "marginRight"
                ]
            },
            my: {
                mappings: [
                    "marginTop",
                    "marginBottom"
                ]
            },
            alignItems: {
                values: {
                    "flex-start": {
                        conditions: {
                            mobile: "gvc3qt171",
                            tablet: "gvc3qt172",
                            desktop: "gvc3qt173"
                        },
                        defaultClass: "gvc3qt171"
                    },
                    "flex-end": {
                        conditions: {
                            mobile: "gvc3qt174",
                            tablet: "gvc3qt175",
                            desktop: "gvc3qt176"
                        },
                        defaultClass: "gvc3qt174"
                    },
                    center: {
                        conditions: {
                            mobile: "gvc3qt177",
                            tablet: "gvc3qt178",
                            desktop: "gvc3qt179"
                        },
                        defaultClass: "gvc3qt177"
                    },
                    stretch: {
                        conditions: {
                            mobile: "gvc3qt17a",
                            tablet: "gvc3qt17b",
                            desktop: "gvc3qt17c"
                        },
                        defaultClass: "gvc3qt17a"
                    },
                    baseline: {
                        conditions: {
                            mobile: "gvc3qt17d",
                            tablet: "gvc3qt17e",
                            desktop: "gvc3qt17f"
                        },
                        defaultClass: "gvc3qt17d"
                    }
                },
                responsiveArray: undefined
            },
            alignSelf: {
                values: {
                    "flex-start": {
                        conditions: {
                            mobile: "gvc3qt17g",
                            tablet: "gvc3qt17h",
                            desktop: "gvc3qt17i"
                        },
                        defaultClass: "gvc3qt17g"
                    },
                    "flex-end": {
                        conditions: {
                            mobile: "gvc3qt17j",
                            tablet: "gvc3qt17k",
                            desktop: "gvc3qt17l"
                        },
                        defaultClass: "gvc3qt17j"
                    },
                    center: {
                        conditions: {
                            mobile: "gvc3qt17m",
                            tablet: "gvc3qt17n",
                            desktop: "gvc3qt17o"
                        },
                        defaultClass: "gvc3qt17m"
                    },
                    stretch: {
                        conditions: {
                            mobile: "gvc3qt17p",
                            tablet: "gvc3qt17q",
                            desktop: "gvc3qt17r"
                        },
                        defaultClass: "gvc3qt17p"
                    },
                    baseline: {
                        conditions: {
                            mobile: "gvc3qt17s",
                            tablet: "gvc3qt17t",
                            desktop: "gvc3qt17u"
                        },
                        defaultClass: "gvc3qt17s"
                    }
                },
                responsiveArray: undefined
            },
            borderWidth: {
                values: {
                    none: {
                        conditions: {
                            mobile: "gvc3qt17v",
                            tablet: "gvc3qt17w",
                            desktop: "gvc3qt17x"
                        },
                        defaultClass: "gvc3qt17v"
                    },
                    sm: {
                        conditions: {
                            mobile: "gvc3qt17y",
                            tablet: "gvc3qt17z",
                            desktop: "gvc3qt180"
                        },
                        defaultClass: "gvc3qt17y"
                    },
                    base: {
                        conditions: {
                            mobile: "gvc3qt181",
                            tablet: "gvc3qt182",
                            desktop: "gvc3qt183"
                        },
                        defaultClass: "gvc3qt181"
                    },
                    md: {
                        conditions: {
                            mobile: "gvc3qt184",
                            tablet: "gvc3qt185",
                            desktop: "gvc3qt186"
                        },
                        defaultClass: "gvc3qt184"
                    },
                    lg: {
                        conditions: {
                            mobile: "gvc3qt187",
                            tablet: "gvc3qt188",
                            desktop: "gvc3qt189"
                        },
                        defaultClass: "gvc3qt187"
                    },
                    xl: {
                        conditions: {
                            mobile: "gvc3qt18a",
                            tablet: "gvc3qt18b",
                            desktop: "gvc3qt18c"
                        },
                        defaultClass: "gvc3qt18a"
                    }
                },
                responsiveArray: undefined
            },
            borderBottomWidth: {
                values: {
                    none: {
                        conditions: {
                            mobile: "gvc3qt18d",
                            tablet: "gvc3qt18e",
                            desktop: "gvc3qt18f"
                        },
                        defaultClass: "gvc3qt18d"
                    },
                    sm: {
                        conditions: {
                            mobile: "gvc3qt18g",
                            tablet: "gvc3qt18h",
                            desktop: "gvc3qt18i"
                        },
                        defaultClass: "gvc3qt18g"
                    },
                    base: {
                        conditions: {
                            mobile: "gvc3qt18j",
                            tablet: "gvc3qt18k",
                            desktop: "gvc3qt18l"
                        },
                        defaultClass: "gvc3qt18j"
                    },
                    md: {
                        conditions: {
                            mobile: "gvc3qt18m",
                            tablet: "gvc3qt18n",
                            desktop: "gvc3qt18o"
                        },
                        defaultClass: "gvc3qt18m"
                    },
                    lg: {
                        conditions: {
                            mobile: "gvc3qt18p",
                            tablet: "gvc3qt18q",
                            desktop: "gvc3qt18r"
                        },
                        defaultClass: "gvc3qt18p"
                    },
                    xl: {
                        conditions: {
                            mobile: "gvc3qt18s",
                            tablet: "gvc3qt18t",
                            desktop: "gvc3qt18u"
                        },
                        defaultClass: "gvc3qt18s"
                    }
                },
                responsiveArray: undefined
            },
            borderLeftWidth: {
                values: {
                    none: {
                        conditions: {
                            mobile: "gvc3qt18v",
                            tablet: "gvc3qt18w",
                            desktop: "gvc3qt18x"
                        },
                        defaultClass: "gvc3qt18v"
                    },
                    sm: {
                        conditions: {
                            mobile: "gvc3qt18y",
                            tablet: "gvc3qt18z",
                            desktop: "gvc3qt190"
                        },
                        defaultClass: "gvc3qt18y"
                    },
                    base: {
                        conditions: {
                            mobile: "gvc3qt191",
                            tablet: "gvc3qt192",
                            desktop: "gvc3qt193"
                        },
                        defaultClass: "gvc3qt191"
                    },
                    md: {
                        conditions: {
                            mobile: "gvc3qt194",
                            tablet: "gvc3qt195",
                            desktop: "gvc3qt196"
                        },
                        defaultClass: "gvc3qt194"
                    },
                    lg: {
                        conditions: {
                            mobile: "gvc3qt197",
                            tablet: "gvc3qt198",
                            desktop: "gvc3qt199"
                        },
                        defaultClass: "gvc3qt197"
                    },
                    xl: {
                        conditions: {
                            mobile: "gvc3qt19a",
                            tablet: "gvc3qt19b",
                            desktop: "gvc3qt19c"
                        },
                        defaultClass: "gvc3qt19a"
                    }
                },
                responsiveArray: undefined
            },
            borderRightWidth: {
                values: {
                    none: {
                        conditions: {
                            mobile: "gvc3qt19d",
                            tablet: "gvc3qt19e",
                            desktop: "gvc3qt19f"
                        },
                        defaultClass: "gvc3qt19d"
                    },
                    sm: {
                        conditions: {
                            mobile: "gvc3qt19g",
                            tablet: "gvc3qt19h",
                            desktop: "gvc3qt19i"
                        },
                        defaultClass: "gvc3qt19g"
                    },
                    base: {
                        conditions: {
                            mobile: "gvc3qt19j",
                            tablet: "gvc3qt19k",
                            desktop: "gvc3qt19l"
                        },
                        defaultClass: "gvc3qt19j"
                    },
                    md: {
                        conditions: {
                            mobile: "gvc3qt19m",
                            tablet: "gvc3qt19n",
                            desktop: "gvc3qt19o"
                        },
                        defaultClass: "gvc3qt19m"
                    },
                    lg: {
                        conditions: {
                            mobile: "gvc3qt19p",
                            tablet: "gvc3qt19q",
                            desktop: "gvc3qt19r"
                        },
                        defaultClass: "gvc3qt19p"
                    },
                    xl: {
                        conditions: {
                            mobile: "gvc3qt19s",
                            tablet: "gvc3qt19t",
                            desktop: "gvc3qt19u"
                        },
                        defaultClass: "gvc3qt19s"
                    }
                },
                responsiveArray: undefined
            },
            borderTopWidth: {
                values: {
                    none: {
                        conditions: {
                            mobile: "gvc3qt19v",
                            tablet: "gvc3qt19w",
                            desktop: "gvc3qt19x"
                        },
                        defaultClass: "gvc3qt19v"
                    },
                    sm: {
                        conditions: {
                            mobile: "gvc3qt19y",
                            tablet: "gvc3qt19z",
                            desktop: "gvc3qt1a0"
                        },
                        defaultClass: "gvc3qt19y"
                    },
                    base: {
                        conditions: {
                            mobile: "gvc3qt1a1",
                            tablet: "gvc3qt1a2",
                            desktop: "gvc3qt1a3"
                        },
                        defaultClass: "gvc3qt1a1"
                    },
                    md: {
                        conditions: {
                            mobile: "gvc3qt1a4",
                            tablet: "gvc3qt1a5",
                            desktop: "gvc3qt1a6"
                        },
                        defaultClass: "gvc3qt1a4"
                    },
                    lg: {
                        conditions: {
                            mobile: "gvc3qt1a7",
                            tablet: "gvc3qt1a8",
                            desktop: "gvc3qt1a9"
                        },
                        defaultClass: "gvc3qt1a7"
                    },
                    xl: {
                        conditions: {
                            mobile: "gvc3qt1aa",
                            tablet: "gvc3qt1ab",
                            desktop: "gvc3qt1ac"
                        },
                        defaultClass: "gvc3qt1aa"
                    }
                },
                responsiveArray: undefined
            },
            borderRadius: {
                values: {
                    none: {
                        conditions: {
                            mobile: "gvc3qt1ad",
                            tablet: "gvc3qt1ae",
                            desktop: "gvc3qt1af"
                        },
                        defaultClass: "gvc3qt1ad"
                    },
                    sm: {
                        conditions: {
                            mobile: "gvc3qt1ag",
                            tablet: "gvc3qt1ah",
                            desktop: "gvc3qt1ai"
                        },
                        defaultClass: "gvc3qt1ag"
                    },
                    base: {
                        conditions: {
                            mobile: "gvc3qt1aj",
                            tablet: "gvc3qt1ak",
                            desktop: "gvc3qt1al"
                        },
                        defaultClass: "gvc3qt1aj"
                    },
                    md: {
                        conditions: {
                            mobile: "gvc3qt1am",
                            tablet: "gvc3qt1an",
                            desktop: "gvc3qt1ao"
                        },
                        defaultClass: "gvc3qt1am"
                    },
                    lg: {
                        conditions: {
                            mobile: "gvc3qt1ap",
                            tablet: "gvc3qt1aq",
                            desktop: "gvc3qt1ar"
                        },
                        defaultClass: "gvc3qt1ap"
                    },
                    xl: {
                        conditions: {
                            mobile: "gvc3qt1as",
                            tablet: "gvc3qt1at",
                            desktop: "gvc3qt1au"
                        },
                        defaultClass: "gvc3qt1as"
                    },
                    "2xl": {
                        conditions: {
                            mobile: "gvc3qt1av",
                            tablet: "gvc3qt1aw",
                            desktop: "gvc3qt1ax"
                        },
                        defaultClass: "gvc3qt1av"
                    },
                    "3xl": {
                        conditions: {
                            mobile: "gvc3qt1ay",
                            tablet: "gvc3qt1az",
                            desktop: "gvc3qt1b0"
                        },
                        defaultClass: "gvc3qt1ay"
                    },
                    "4xl": {
                        conditions: {
                            mobile: "gvc3qt1b1",
                            tablet: "gvc3qt1b2",
                            desktop: "gvc3qt1b3"
                        },
                        defaultClass: "gvc3qt1b1"
                    },
                    full: {
                        conditions: {
                            mobile: "gvc3qt1b4",
                            tablet: "gvc3qt1b5",
                            desktop: "gvc3qt1b6"
                        },
                        defaultClass: "gvc3qt1b4"
                    }
                },
                responsiveArray: undefined
            },
            borderBottomLeftRadius: {
                values: {
                    none: {
                        conditions: {
                            mobile: "gvc3qt1b7",
                            tablet: "gvc3qt1b8",
                            desktop: "gvc3qt1b9"
                        },
                        defaultClass: "gvc3qt1b7"
                    },
                    sm: {
                        conditions: {
                            mobile: "gvc3qt1ba",
                            tablet: "gvc3qt1bb",
                            desktop: "gvc3qt1bc"
                        },
                        defaultClass: "gvc3qt1ba"
                    },
                    base: {
                        conditions: {
                            mobile: "gvc3qt1bd",
                            tablet: "gvc3qt1be",
                            desktop: "gvc3qt1bf"
                        },
                        defaultClass: "gvc3qt1bd"
                    },
                    md: {
                        conditions: {
                            mobile: "gvc3qt1bg",
                            tablet: "gvc3qt1bh",
                            desktop: "gvc3qt1bi"
                        },
                        defaultClass: "gvc3qt1bg"
                    },
                    lg: {
                        conditions: {
                            mobile: "gvc3qt1bj",
                            tablet: "gvc3qt1bk",
                            desktop: "gvc3qt1bl"
                        },
                        defaultClass: "gvc3qt1bj"
                    },
                    xl: {
                        conditions: {
                            mobile: "gvc3qt1bm",
                            tablet: "gvc3qt1bn",
                            desktop: "gvc3qt1bo"
                        },
                        defaultClass: "gvc3qt1bm"
                    },
                    "2xl": {
                        conditions: {
                            mobile: "gvc3qt1bp",
                            tablet: "gvc3qt1bq",
                            desktop: "gvc3qt1br"
                        },
                        defaultClass: "gvc3qt1bp"
                    },
                    "3xl": {
                        conditions: {
                            mobile: "gvc3qt1bs",
                            tablet: "gvc3qt1bt",
                            desktop: "gvc3qt1bu"
                        },
                        defaultClass: "gvc3qt1bs"
                    },
                    "4xl": {
                        conditions: {
                            mobile: "gvc3qt1bv",
                            tablet: "gvc3qt1bw",
                            desktop: "gvc3qt1bx"
                        },
                        defaultClass: "gvc3qt1bv"
                    },
                    full: {
                        conditions: {
                            mobile: "gvc3qt1by",
                            tablet: "gvc3qt1bz",
                            desktop: "gvc3qt1c0"
                        },
                        defaultClass: "gvc3qt1by"
                    }
                },
                responsiveArray: undefined
            },
            borderBottomRightRadius: {
                values: {
                    none: {
                        conditions: {
                            mobile: "gvc3qt1c1",
                            tablet: "gvc3qt1c2",
                            desktop: "gvc3qt1c3"
                        },
                        defaultClass: "gvc3qt1c1"
                    },
                    sm: {
                        conditions: {
                            mobile: "gvc3qt1c4",
                            tablet: "gvc3qt1c5",
                            desktop: "gvc3qt1c6"
                        },
                        defaultClass: "gvc3qt1c4"
                    },
                    base: {
                        conditions: {
                            mobile: "gvc3qt1c7",
                            tablet: "gvc3qt1c8",
                            desktop: "gvc3qt1c9"
                        },
                        defaultClass: "gvc3qt1c7"
                    },
                    md: {
                        conditions: {
                            mobile: "gvc3qt1ca",
                            tablet: "gvc3qt1cb",
                            desktop: "gvc3qt1cc"
                        },
                        defaultClass: "gvc3qt1ca"
                    },
                    lg: {
                        conditions: {
                            mobile: "gvc3qt1cd",
                            tablet: "gvc3qt1ce",
                            desktop: "gvc3qt1cf"
                        },
                        defaultClass: "gvc3qt1cd"
                    },
                    xl: {
                        conditions: {
                            mobile: "gvc3qt1cg",
                            tablet: "gvc3qt1ch",
                            desktop: "gvc3qt1ci"
                        },
                        defaultClass: "gvc3qt1cg"
                    },
                    "2xl": {
                        conditions: {
                            mobile: "gvc3qt1cj",
                            tablet: "gvc3qt1ck",
                            desktop: "gvc3qt1cl"
                        },
                        defaultClass: "gvc3qt1cj"
                    },
                    "3xl": {
                        conditions: {
                            mobile: "gvc3qt1cm",
                            tablet: "gvc3qt1cn",
                            desktop: "gvc3qt1co"
                        },
                        defaultClass: "gvc3qt1cm"
                    },
                    "4xl": {
                        conditions: {
                            mobile: "gvc3qt1cp",
                            tablet: "gvc3qt1cq",
                            desktop: "gvc3qt1cr"
                        },
                        defaultClass: "gvc3qt1cp"
                    },
                    full: {
                        conditions: {
                            mobile: "gvc3qt1cs",
                            tablet: "gvc3qt1ct",
                            desktop: "gvc3qt1cu"
                        },
                        defaultClass: "gvc3qt1cs"
                    }
                },
                responsiveArray: undefined
            },
            borderTopLeftRadius: {
                values: {
                    none: {
                        conditions: {
                            mobile: "gvc3qt1cv",
                            tablet: "gvc3qt1cw",
                            desktop: "gvc3qt1cx"
                        },
                        defaultClass: "gvc3qt1cv"
                    },
                    sm: {
                        conditions: {
                            mobile: "gvc3qt1cy",
                            tablet: "gvc3qt1cz",
                            desktop: "gvc3qt1d0"
                        },
                        defaultClass: "gvc3qt1cy"
                    },
                    base: {
                        conditions: {
                            mobile: "gvc3qt1d1",
                            tablet: "gvc3qt1d2",
                            desktop: "gvc3qt1d3"
                        },
                        defaultClass: "gvc3qt1d1"
                    },
                    md: {
                        conditions: {
                            mobile: "gvc3qt1d4",
                            tablet: "gvc3qt1d5",
                            desktop: "gvc3qt1d6"
                        },
                        defaultClass: "gvc3qt1d4"
                    },
                    lg: {
                        conditions: {
                            mobile: "gvc3qt1d7",
                            tablet: "gvc3qt1d8",
                            desktop: "gvc3qt1d9"
                        },
                        defaultClass: "gvc3qt1d7"
                    },
                    xl: {
                        conditions: {
                            mobile: "gvc3qt1da",
                            tablet: "gvc3qt1db",
                            desktop: "gvc3qt1dc"
                        },
                        defaultClass: "gvc3qt1da"
                    },
                    "2xl": {
                        conditions: {
                            mobile: "gvc3qt1dd",
                            tablet: "gvc3qt1de",
                            desktop: "gvc3qt1df"
                        },
                        defaultClass: "gvc3qt1dd"
                    },
                    "3xl": {
                        conditions: {
                            mobile: "gvc3qt1dg",
                            tablet: "gvc3qt1dh",
                            desktop: "gvc3qt1di"
                        },
                        defaultClass: "gvc3qt1dg"
                    },
                    "4xl": {
                        conditions: {
                            mobile: "gvc3qt1dj",
                            tablet: "gvc3qt1dk",
                            desktop: "gvc3qt1dl"
                        },
                        defaultClass: "gvc3qt1dj"
                    },
                    full: {
                        conditions: {
                            mobile: "gvc3qt1dm",
                            tablet: "gvc3qt1dn",
                            desktop: "gvc3qt1do"
                        },
                        defaultClass: "gvc3qt1dm"
                    }
                },
                responsiveArray: undefined
            },
            borderTopRightRadius: {
                values: {
                    none: {
                        conditions: {
                            mobile: "gvc3qt1dp",
                            tablet: "gvc3qt1dq",
                            desktop: "gvc3qt1dr"
                        },
                        defaultClass: "gvc3qt1dp"
                    },
                    sm: {
                        conditions: {
                            mobile: "gvc3qt1ds",
                            tablet: "gvc3qt1dt",
                            desktop: "gvc3qt1du"
                        },
                        defaultClass: "gvc3qt1ds"
                    },
                    base: {
                        conditions: {
                            mobile: "gvc3qt1dv",
                            tablet: "gvc3qt1dw",
                            desktop: "gvc3qt1dx"
                        },
                        defaultClass: "gvc3qt1dv"
                    },
                    md: {
                        conditions: {
                            mobile: "gvc3qt1dy",
                            tablet: "gvc3qt1dz",
                            desktop: "gvc3qt1e0"
                        },
                        defaultClass: "gvc3qt1dy"
                    },
                    lg: {
                        conditions: {
                            mobile: "gvc3qt1e1",
                            tablet: "gvc3qt1e2",
                            desktop: "gvc3qt1e3"
                        },
                        defaultClass: "gvc3qt1e1"
                    },
                    xl: {
                        conditions: {
                            mobile: "gvc3qt1e4",
                            tablet: "gvc3qt1e5",
                            desktop: "gvc3qt1e6"
                        },
                        defaultClass: "gvc3qt1e4"
                    },
                    "2xl": {
                        conditions: {
                            mobile: "gvc3qt1e7",
                            tablet: "gvc3qt1e8",
                            desktop: "gvc3qt1e9"
                        },
                        defaultClass: "gvc3qt1e7"
                    },
                    "3xl": {
                        conditions: {
                            mobile: "gvc3qt1ea",
                            tablet: "gvc3qt1eb",
                            desktop: "gvc3qt1ec"
                        },
                        defaultClass: "gvc3qt1ea"
                    },
                    "4xl": {
                        conditions: {
                            mobile: "gvc3qt1ed",
                            tablet: "gvc3qt1ee",
                            desktop: "gvc3qt1ef"
                        },
                        defaultClass: "gvc3qt1ed"
                    },
                    full: {
                        conditions: {
                            mobile: "gvc3qt1eg",
                            tablet: "gvc3qt1eh",
                            desktop: "gvc3qt1ei"
                        },
                        defaultClass: "gvc3qt1eg"
                    }
                },
                responsiveArray: undefined
            },
            bottom: {
                values: {
                    "0": {
                        conditions: {
                            mobile: "gvc3qt1ej",
                            tablet: "gvc3qt1ek",
                            desktop: "gvc3qt1el"
                        },
                        defaultClass: "gvc3qt1ej"
                    },
                    "1": {
                        conditions: {
                            mobile: "gvc3qt1em",
                            tablet: "gvc3qt1en",
                            desktop: "gvc3qt1eo"
                        },
                        defaultClass: "gvc3qt1em"
                    },
                    "2": {
                        conditions: {
                            mobile: "gvc3qt1ep",
                            tablet: "gvc3qt1eq",
                            desktop: "gvc3qt1er"
                        },
                        defaultClass: "gvc3qt1ep"
                    },
                    "3": {
                        conditions: {
                            mobile: "gvc3qt1es",
                            tablet: "gvc3qt1et",
                            desktop: "gvc3qt1eu"
                        },
                        defaultClass: "gvc3qt1es"
                    },
                    "4": {
                        conditions: {
                            mobile: "gvc3qt1ev",
                            tablet: "gvc3qt1ew",
                            desktop: "gvc3qt1ex"
                        },
                        defaultClass: "gvc3qt1ev"
                    },
                    "5": {
                        conditions: {
                            mobile: "gvc3qt1ey",
                            tablet: "gvc3qt1ez",
                            desktop: "gvc3qt1f0"
                        },
                        defaultClass: "gvc3qt1ey"
                    },
                    "6": {
                        conditions: {
                            mobile: "gvc3qt1f1",
                            tablet: "gvc3qt1f2",
                            desktop: "gvc3qt1f3"
                        },
                        defaultClass: "gvc3qt1f1"
                    },
                    "7": {
                        conditions: {
                            mobile: "gvc3qt1f4",
                            tablet: "gvc3qt1f5",
                            desktop: "gvc3qt1f6"
                        },
                        defaultClass: "gvc3qt1f4"
                    },
                    "8": {
                        conditions: {
                            mobile: "gvc3qt1f7",
                            tablet: "gvc3qt1f8",
                            desktop: "gvc3qt1f9"
                        },
                        defaultClass: "gvc3qt1f7"
                    },
                    "9": {
                        conditions: {
                            mobile: "gvc3qt1fa",
                            tablet: "gvc3qt1fb",
                            desktop: "gvc3qt1fc"
                        },
                        defaultClass: "gvc3qt1fa"
                    },
                    "10": {
                        conditions: {
                            mobile: "gvc3qt1fd",
                            tablet: "gvc3qt1fe",
                            desktop: "gvc3qt1ff"
                        },
                        defaultClass: "gvc3qt1fd"
                    },
                    "11": {
                        conditions: {
                            mobile: "gvc3qt1fg",
                            tablet: "gvc3qt1fh",
                            desktop: "gvc3qt1fi"
                        },
                        defaultClass: "gvc3qt1fg"
                    },
                    "12": {
                        conditions: {
                            mobile: "gvc3qt1fj",
                            tablet: "gvc3qt1fk",
                            desktop: "gvc3qt1fl"
                        },
                        defaultClass: "gvc3qt1fj"
                    },
                    "13": {
                        conditions: {
                            mobile: "gvc3qt1fm",
                            tablet: "gvc3qt1fn",
                            desktop: "gvc3qt1fo"
                        },
                        defaultClass: "gvc3qt1fm"
                    },
                    "14": {
                        conditions: {
                            mobile: "gvc3qt1fp",
                            tablet: "gvc3qt1fq",
                            desktop: "gvc3qt1fr"
                        },
                        defaultClass: "gvc3qt1fp"
                    },
                    "15": {
                        conditions: {
                            mobile: "gvc3qt1fs",
                            tablet: "gvc3qt1ft",
                            desktop: "gvc3qt1fu"
                        },
                        defaultClass: "gvc3qt1fs"
                    },
                    "16": {
                        conditions: {
                            mobile: "gvc3qt1fv",
                            tablet: "gvc3qt1fw",
                            desktop: "gvc3qt1fx"
                        },
                        defaultClass: "gvc3qt1fv"
                    },
                    "17": {
                        conditions: {
                            mobile: "gvc3qt1fy",
                            tablet: "gvc3qt1fz",
                            desktop: "gvc3qt1g0"
                        },
                        defaultClass: "gvc3qt1fy"
                    },
                    "18": {
                        conditions: {
                            mobile: "gvc3qt1g1",
                            tablet: "gvc3qt1g2",
                            desktop: "gvc3qt1g3"
                        },
                        defaultClass: "gvc3qt1g1"
                    },
                    "19": {
                        conditions: {
                            mobile: "gvc3qt1g4",
                            tablet: "gvc3qt1g5",
                            desktop: "gvc3qt1g6"
                        },
                        defaultClass: "gvc3qt1g4"
                    },
                    "20": {
                        conditions: {
                            mobile: "gvc3qt1g7",
                            tablet: "gvc3qt1g8",
                            desktop: "gvc3qt1g9"
                        },
                        defaultClass: "gvc3qt1g7"
                    },
                    "21": {
                        conditions: {
                            mobile: "gvc3qt1ga",
                            tablet: "gvc3qt1gb",
                            desktop: "gvc3qt1gc"
                        },
                        defaultClass: "gvc3qt1ga"
                    },
                    "22": {
                        conditions: {
                            mobile: "gvc3qt1gd",
                            tablet: "gvc3qt1ge",
                            desktop: "gvc3qt1gf"
                        },
                        defaultClass: "gvc3qt1gd"
                    },
                    "23": {
                        conditions: {
                            mobile: "gvc3qt1gg",
                            tablet: "gvc3qt1gh",
                            desktop: "gvc3qt1gi"
                        },
                        defaultClass: "gvc3qt1gg"
                    },
                    "24": {
                        conditions: {
                            mobile: "gvc3qt1gj",
                            tablet: "gvc3qt1gk",
                            desktop: "gvc3qt1gl"
                        },
                        defaultClass: "gvc3qt1gj"
                    },
                    "25": {
                        conditions: {
                            mobile: "gvc3qt1gm",
                            tablet: "gvc3qt1gn",
                            desktop: "gvc3qt1go"
                        },
                        defaultClass: "gvc3qt1gm"
                    },
                    "26": {
                        conditions: {
                            mobile: "gvc3qt1gp",
                            tablet: "gvc3qt1gq",
                            desktop: "gvc3qt1gr"
                        },
                        defaultClass: "gvc3qt1gp"
                    },
                    "27": {
                        conditions: {
                            mobile: "gvc3qt1gs",
                            tablet: "gvc3qt1gt",
                            desktop: "gvc3qt1gu"
                        },
                        defaultClass: "gvc3qt1gs"
                    },
                    "28": {
                        conditions: {
                            mobile: "gvc3qt1gv",
                            tablet: "gvc3qt1gw",
                            desktop: "gvc3qt1gx"
                        },
                        defaultClass: "gvc3qt1gv"
                    },
                    "29": {
                        conditions: {
                            mobile: "gvc3qt1gy",
                            tablet: "gvc3qt1gz",
                            desktop: "gvc3qt1h0"
                        },
                        defaultClass: "gvc3qt1gy"
                    },
                    "30": {
                        conditions: {
                            mobile: "gvc3qt1h1",
                            tablet: "gvc3qt1h2",
                            desktop: "gvc3qt1h3"
                        },
                        defaultClass: "gvc3qt1h1"
                    },
                    auto: {
                        conditions: {
                            mobile: "gvc3qt1h4",
                            tablet: "gvc3qt1h5",
                            desktop: "gvc3qt1h6"
                        },
                        defaultClass: "gvc3qt1h4"
                    },
                    full: {
                        conditions: {
                            mobile: "gvc3qt1h7",
                            tablet: "gvc3qt1h8",
                            desktop: "gvc3qt1h9"
                        },
                        defaultClass: "gvc3qt1h7"
                    },
                    fit: {
                        conditions: {
                            mobile: "gvc3qt1ha",
                            tablet: "gvc3qt1hb",
                            desktop: "gvc3qt1hc"
                        },
                        defaultClass: "gvc3qt1ha"
                    },
                    max: {
                        conditions: {
                            mobile: "gvc3qt1hd",
                            tablet: "gvc3qt1he",
                            desktop: "gvc3qt1hf"
                        },
                        defaultClass: "gvc3qt1hd"
                    },
                    min: {
                        conditions: {
                            mobile: "gvc3qt1hg",
                            tablet: "gvc3qt1hh",
                            desktop: "gvc3qt1hi"
                        },
                        defaultClass: "gvc3qt1hg"
                    },
                    viewHeight: {
                        conditions: {
                            mobile: "gvc3qt1hj",
                            tablet: "gvc3qt1hk",
                            desktop: "gvc3qt1hl"
                        },
                        defaultClass: "gvc3qt1hj"
                    },
                    viewWidth: {
                        conditions: {
                            mobile: "gvc3qt1hm",
                            tablet: "gvc3qt1hn",
                            desktop: "gvc3qt1ho"
                        },
                        defaultClass: "gvc3qt1hm"
                    },
                    none: {
                        conditions: {
                            mobile: "gvc3qt1hp",
                            tablet: "gvc3qt1hq",
                            desktop: "gvc3qt1hr"
                        },
                        defaultClass: "gvc3qt1hp"
                    }
                },
                responsiveArray: undefined
            },
            display: {
                values: {
                    block: {
                        conditions: {
                            mobile: "gvc3qt1hs",
                            tablet: "gvc3qt1ht",
                            desktop: "gvc3qt1hu"
                        },
                        defaultClass: "gvc3qt1hs"
                    },
                    flex: {
                        conditions: {
                            mobile: "gvc3qt1hv",
                            tablet: "gvc3qt1hw",
                            desktop: "gvc3qt1hx"
                        },
                        defaultClass: "gvc3qt1hv"
                    },
                    grid: {
                        conditions: {
                            mobile: "gvc3qt1hy",
                            tablet: "gvc3qt1hz",
                            desktop: "gvc3qt1i0"
                        },
                        defaultClass: "gvc3qt1hy"
                    },
                    "inline-block": {
                        conditions: {
                            mobile: "gvc3qt1i1",
                            tablet: "gvc3qt1i2",
                            desktop: "gvc3qt1i3"
                        },
                        defaultClass: "gvc3qt1i1"
                    },
                    none: {
                        conditions: {
                            mobile: "gvc3qt1i4",
                            tablet: "gvc3qt1i5",
                            desktop: "gvc3qt1i6"
                        },
                        defaultClass: "gvc3qt1i4"
                    },
                    contents: {
                        conditions: {
                            mobile: "gvc3qt1i7",
                            tablet: "gvc3qt1i8",
                            desktop: "gvc3qt1i9"
                        },
                        defaultClass: "gvc3qt1i7"
                    }
                },
                responsiveArray: undefined
            },
            flex: {
                values: {
                    "1": {
                        conditions: {
                            mobile: "gvc3qt1ia",
                            tablet: "gvc3qt1ib",
                            desktop: "gvc3qt1ic"
                        },
                        defaultClass: "gvc3qt1ia"
                    },
                    auto: {
                        conditions: {
                            mobile: "gvc3qt1id",
                            tablet: "gvc3qt1ie",
                            desktop: "gvc3qt1if"
                        },
                        defaultClass: "gvc3qt1id"
                    },
                    initial: {
                        conditions: {
                            mobile: "gvc3qt1ig",
                            tablet: "gvc3qt1ih",
                            desktop: "gvc3qt1ii"
                        },
                        defaultClass: "gvc3qt1ig"
                    },
                    none: {
                        conditions: {
                            mobile: "gvc3qt1ij",
                            tablet: "gvc3qt1ik",
                            desktop: "gvc3qt1il"
                        },
                        defaultClass: "gvc3qt1ij"
                    }
                },
                responsiveArray: undefined
            },
            flexBasis: {
                values: {
                    "0": {
                        conditions: {
                            mobile: "gvc3qt1im",
                            tablet: "gvc3qt1in",
                            desktop: "gvc3qt1io"
                        },
                        defaultClass: "gvc3qt1im"
                    },
                    "1": {
                        conditions: {
                            mobile: "gvc3qt1ip",
                            tablet: "gvc3qt1iq",
                            desktop: "gvc3qt1ir"
                        },
                        defaultClass: "gvc3qt1ip"
                    },
                    "2": {
                        conditions: {
                            mobile: "gvc3qt1is",
                            tablet: "gvc3qt1it",
                            desktop: "gvc3qt1iu"
                        },
                        defaultClass: "gvc3qt1is"
                    },
                    "3": {
                        conditions: {
                            mobile: "gvc3qt1iv",
                            tablet: "gvc3qt1iw",
                            desktop: "gvc3qt1ix"
                        },
                        defaultClass: "gvc3qt1iv"
                    },
                    "4": {
                        conditions: {
                            mobile: "gvc3qt1iy",
                            tablet: "gvc3qt1iz",
                            desktop: "gvc3qt1j0"
                        },
                        defaultClass: "gvc3qt1iy"
                    },
                    "5": {
                        conditions: {
                            mobile: "gvc3qt1j1",
                            tablet: "gvc3qt1j2",
                            desktop: "gvc3qt1j3"
                        },
                        defaultClass: "gvc3qt1j1"
                    },
                    "6": {
                        conditions: {
                            mobile: "gvc3qt1j4",
                            tablet: "gvc3qt1j5",
                            desktop: "gvc3qt1j6"
                        },
                        defaultClass: "gvc3qt1j4"
                    },
                    "7": {
                        conditions: {
                            mobile: "gvc3qt1j7",
                            tablet: "gvc3qt1j8",
                            desktop: "gvc3qt1j9"
                        },
                        defaultClass: "gvc3qt1j7"
                    },
                    "8": {
                        conditions: {
                            mobile: "gvc3qt1ja",
                            tablet: "gvc3qt1jb",
                            desktop: "gvc3qt1jc"
                        },
                        defaultClass: "gvc3qt1ja"
                    },
                    "9": {
                        conditions: {
                            mobile: "gvc3qt1jd",
                            tablet: "gvc3qt1je",
                            desktop: "gvc3qt1jf"
                        },
                        defaultClass: "gvc3qt1jd"
                    },
                    "10": {
                        conditions: {
                            mobile: "gvc3qt1jg",
                            tablet: "gvc3qt1jh",
                            desktop: "gvc3qt1ji"
                        },
                        defaultClass: "gvc3qt1jg"
                    },
                    "11": {
                        conditions: {
                            mobile: "gvc3qt1jj",
                            tablet: "gvc3qt1jk",
                            desktop: "gvc3qt1jl"
                        },
                        defaultClass: "gvc3qt1jj"
                    },
                    "12": {
                        conditions: {
                            mobile: "gvc3qt1jm",
                            tablet: "gvc3qt1jn",
                            desktop: "gvc3qt1jo"
                        },
                        defaultClass: "gvc3qt1jm"
                    },
                    "13": {
                        conditions: {
                            mobile: "gvc3qt1jp",
                            tablet: "gvc3qt1jq",
                            desktop: "gvc3qt1jr"
                        },
                        defaultClass: "gvc3qt1jp"
                    },
                    "14": {
                        conditions: {
                            mobile: "gvc3qt1js",
                            tablet: "gvc3qt1jt",
                            desktop: "gvc3qt1ju"
                        },
                        defaultClass: "gvc3qt1js"
                    },
                    "15": {
                        conditions: {
                            mobile: "gvc3qt1jv",
                            tablet: "gvc3qt1jw",
                            desktop: "gvc3qt1jx"
                        },
                        defaultClass: "gvc3qt1jv"
                    },
                    "16": {
                        conditions: {
                            mobile: "gvc3qt1jy",
                            tablet: "gvc3qt1jz",
                            desktop: "gvc3qt1k0"
                        },
                        defaultClass: "gvc3qt1jy"
                    },
                    "17": {
                        conditions: {
                            mobile: "gvc3qt1k1",
                            tablet: "gvc3qt1k2",
                            desktop: "gvc3qt1k3"
                        },
                        defaultClass: "gvc3qt1k1"
                    },
                    "18": {
                        conditions: {
                            mobile: "gvc3qt1k4",
                            tablet: "gvc3qt1k5",
                            desktop: "gvc3qt1k6"
                        },
                        defaultClass: "gvc3qt1k4"
                    },
                    "19": {
                        conditions: {
                            mobile: "gvc3qt1k7",
                            tablet: "gvc3qt1k8",
                            desktop: "gvc3qt1k9"
                        },
                        defaultClass: "gvc3qt1k7"
                    },
                    "20": {
                        conditions: {
                            mobile: "gvc3qt1ka",
                            tablet: "gvc3qt1kb",
                            desktop: "gvc3qt1kc"
                        },
                        defaultClass: "gvc3qt1ka"
                    },
                    "21": {
                        conditions: {
                            mobile: "gvc3qt1kd",
                            tablet: "gvc3qt1ke",
                            desktop: "gvc3qt1kf"
                        },
                        defaultClass: "gvc3qt1kd"
                    },
                    "22": {
                        conditions: {
                            mobile: "gvc3qt1kg",
                            tablet: "gvc3qt1kh",
                            desktop: "gvc3qt1ki"
                        },
                        defaultClass: "gvc3qt1kg"
                    },
                    "23": {
                        conditions: {
                            mobile: "gvc3qt1kj",
                            tablet: "gvc3qt1kk",
                            desktop: "gvc3qt1kl"
                        },
                        defaultClass: "gvc3qt1kj"
                    },
                    "24": {
                        conditions: {
                            mobile: "gvc3qt1km",
                            tablet: "gvc3qt1kn",
                            desktop: "gvc3qt1ko"
                        },
                        defaultClass: "gvc3qt1km"
                    },
                    "25": {
                        conditions: {
                            mobile: "gvc3qt1kp",
                            tablet: "gvc3qt1kq",
                            desktop: "gvc3qt1kr"
                        },
                        defaultClass: "gvc3qt1kp"
                    },
                    "26": {
                        conditions: {
                            mobile: "gvc3qt1ks",
                            tablet: "gvc3qt1kt",
                            desktop: "gvc3qt1ku"
                        },
                        defaultClass: "gvc3qt1ks"
                    },
                    "27": {
                        conditions: {
                            mobile: "gvc3qt1kv",
                            tablet: "gvc3qt1kw",
                            desktop: "gvc3qt1kx"
                        },
                        defaultClass: "gvc3qt1kv"
                    },
                    "28": {
                        conditions: {
                            mobile: "gvc3qt1ky",
                            tablet: "gvc3qt1kz",
                            desktop: "gvc3qt1l0"
                        },
                        defaultClass: "gvc3qt1ky"
                    },
                    "29": {
                        conditions: {
                            mobile: "gvc3qt1l1",
                            tablet: "gvc3qt1l2",
                            desktop: "gvc3qt1l3"
                        },
                        defaultClass: "gvc3qt1l1"
                    },
                    "30": {
                        conditions: {
                            mobile: "gvc3qt1l4",
                            tablet: "gvc3qt1l5",
                            desktop: "gvc3qt1l6"
                        },
                        defaultClass: "gvc3qt1l4"
                    },
                    auto: {
                        conditions: {
                            mobile: "gvc3qt1l7",
                            tablet: "gvc3qt1l8",
                            desktop: "gvc3qt1l9"
                        },
                        defaultClass: "gvc3qt1l7"
                    },
                    full: {
                        conditions: {
                            mobile: "gvc3qt1la",
                            tablet: "gvc3qt1lb",
                            desktop: "gvc3qt1lc"
                        },
                        defaultClass: "gvc3qt1la"
                    },
                    fit: {
                        conditions: {
                            mobile: "gvc3qt1ld",
                            tablet: "gvc3qt1le",
                            desktop: "gvc3qt1lf"
                        },
                        defaultClass: "gvc3qt1ld"
                    },
                    max: {
                        conditions: {
                            mobile: "gvc3qt1lg",
                            tablet: "gvc3qt1lh",
                            desktop: "gvc3qt1li"
                        },
                        defaultClass: "gvc3qt1lg"
                    },
                    min: {
                        conditions: {
                            mobile: "gvc3qt1lj",
                            tablet: "gvc3qt1lk",
                            desktop: "gvc3qt1ll"
                        },
                        defaultClass: "gvc3qt1lj"
                    },
                    viewHeight: {
                        conditions: {
                            mobile: "gvc3qt1lm",
                            tablet: "gvc3qt1ln",
                            desktop: "gvc3qt1lo"
                        },
                        defaultClass: "gvc3qt1lm"
                    },
                    viewWidth: {
                        conditions: {
                            mobile: "gvc3qt1lp",
                            tablet: "gvc3qt1lq",
                            desktop: "gvc3qt1lr"
                        },
                        defaultClass: "gvc3qt1lp"
                    },
                    none: {
                        conditions: {
                            mobile: "gvc3qt1ls",
                            tablet: "gvc3qt1lt",
                            desktop: "gvc3qt1lu"
                        },
                        defaultClass: "gvc3qt1ls"
                    }
                },
                responsiveArray: undefined
            },
            flexDirection: {
                values: {
                    column: {
                        conditions: {
                            mobile: "gvc3qt1lv",
                            tablet: "gvc3qt1lw",
                            desktop: "gvc3qt1lx"
                        },
                        defaultClass: "gvc3qt1lv"
                    },
                    row: {
                        conditions: {
                            mobile: "gvc3qt1ly",
                            tablet: "gvc3qt1lz",
                            desktop: "gvc3qt1m0"
                        },
                        defaultClass: "gvc3qt1ly"
                    }
                },
                responsiveArray: undefined
            },
            flexWrap: {
                values: {
                    wrap: {
                        conditions: {
                            mobile: "gvc3qt1m1",
                            tablet: "gvc3qt1m2",
                            desktop: "gvc3qt1m3"
                        },
                        defaultClass: "gvc3qt1m1"
                    },
                    nowrap: {
                        conditions: {
                            mobile: "gvc3qt1m4",
                            tablet: "gvc3qt1m5",
                            desktop: "gvc3qt1m6"
                        },
                        defaultClass: "gvc3qt1m4"
                    }
                },
                responsiveArray: undefined
            },
            fontSize: {
                values: {
                    "3xs": {
                        conditions: {
                            mobile: "gvc3qt1m7",
                            tablet: "gvc3qt1m8",
                            desktop: "gvc3qt1m9"
                        },
                        defaultClass: "gvc3qt1m7"
                    },
                    "2xs": {
                        conditions: {
                            mobile: "gvc3qt1ma",
                            tablet: "gvc3qt1mb",
                            desktop: "gvc3qt1mc"
                        },
                        defaultClass: "gvc3qt1ma"
                    },
                    xs: {
                        conditions: {
                            mobile: "gvc3qt1md",
                            tablet: "gvc3qt1me",
                            desktop: "gvc3qt1mf"
                        },
                        defaultClass: "gvc3qt1md"
                    },
                    sm: {
                        conditions: {
                            mobile: "gvc3qt1mg",
                            tablet: "gvc3qt1mh",
                            desktop: "gvc3qt1mi"
                        },
                        defaultClass: "gvc3qt1mg"
                    },
                    md: {
                        conditions: {
                            mobile: "gvc3qt1mj",
                            tablet: "gvc3qt1mk",
                            desktop: "gvc3qt1ml"
                        },
                        defaultClass: "gvc3qt1mj"
                    },
                    lg: {
                        conditions: {
                            mobile: "gvc3qt1mm",
                            tablet: "gvc3qt1mn",
                            desktop: "gvc3qt1mo"
                        },
                        defaultClass: "gvc3qt1mm"
                    },
                    xl: {
                        conditions: {
                            mobile: "gvc3qt1mp",
                            tablet: "gvc3qt1mq",
                            desktop: "gvc3qt1mr"
                        },
                        defaultClass: "gvc3qt1mp"
                    },
                    "2xl": {
                        conditions: {
                            mobile: "gvc3qt1ms",
                            tablet: "gvc3qt1mt",
                            desktop: "gvc3qt1mu"
                        },
                        defaultClass: "gvc3qt1ms"
                    },
                    "3xl": {
                        conditions: {
                            mobile: "gvc3qt1mv",
                            tablet: "gvc3qt1mw",
                            desktop: "gvc3qt1mx"
                        },
                        defaultClass: "gvc3qt1mv"
                    },
                    "4xl": {
                        conditions: {
                            mobile: "gvc3qt1my",
                            tablet: "gvc3qt1mz",
                            desktop: "gvc3qt1n0"
                        },
                        defaultClass: "gvc3qt1my"
                    },
                    "5xl": {
                        conditions: {
                            mobile: "gvc3qt1n1",
                            tablet: "gvc3qt1n2",
                            desktop: "gvc3qt1n3"
                        },
                        defaultClass: "gvc3qt1n1"
                    },
                    "6xl": {
                        conditions: {
                            mobile: "gvc3qt1n4",
                            tablet: "gvc3qt1n5",
                            desktop: "gvc3qt1n6"
                        },
                        defaultClass: "gvc3qt1n4"
                    },
                    "7xl": {
                        conditions: {
                            mobile: "gvc3qt1n7",
                            tablet: "gvc3qt1n8",
                            desktop: "gvc3qt1n9"
                        },
                        defaultClass: "gvc3qt1n7"
                    },
                    "8xl": {
                        conditions: {
                            mobile: "gvc3qt1na",
                            tablet: "gvc3qt1nb",
                            desktop: "gvc3qt1nc"
                        },
                        defaultClass: "gvc3qt1na"
                    },
                    "9xl": {
                        conditions: {
                            mobile: "gvc3qt1nd",
                            tablet: "gvc3qt1ne",
                            desktop: "gvc3qt1nf"
                        },
                        defaultClass: "gvc3qt1nd"
                    },
                    "10xl": {
                        conditions: {
                            mobile: "gvc3qt1ng",
                            tablet: "gvc3qt1nh",
                            desktop: "gvc3qt1ni"
                        },
                        defaultClass: "gvc3qt1ng"
                    },
                    "11xl": {
                        conditions: {
                            mobile: "gvc3qt1nj",
                            tablet: "gvc3qt1nk",
                            desktop: "gvc3qt1nl"
                        },
                        defaultClass: "gvc3qt1nj"
                    },
                    "12xl": {
                        conditions: {
                            mobile: "gvc3qt1nm",
                            tablet: "gvc3qt1nn",
                            desktop: "gvc3qt1no"
                        },
                        defaultClass: "gvc3qt1nm"
                    },
                    "13xl": {
                        conditions: {
                            mobile: "gvc3qt1np",
                            tablet: "gvc3qt1nq",
                            desktop: "gvc3qt1nr"
                        },
                        defaultClass: "gvc3qt1np"
                    },
                    "14xl": {
                        conditions: {
                            mobile: "gvc3qt1ns",
                            tablet: "gvc3qt1nt",
                            desktop: "gvc3qt1nu"
                        },
                        defaultClass: "gvc3qt1ns"
                    },
                    "15xl": {
                        conditions: {
                            mobile: "gvc3qt1nv",
                            tablet: "gvc3qt1nw",
                            desktop: "gvc3qt1nx"
                        },
                        defaultClass: "gvc3qt1nv"
                    },
                    inherit: {
                        conditions: {
                            mobile: "gvc3qt1ny",
                            tablet: "gvc3qt1nz",
                            desktop: "gvc3qt1o0"
                        },
                        defaultClass: "gvc3qt1ny"
                    }
                },
                responsiveArray: undefined
            },
            fontWeight: {
                values: {
                    hairline: {
                        conditions: {
                            mobile: "gvc3qt1o1",
                            tablet: "gvc3qt1o2",
                            desktop: "gvc3qt1o3"
                        },
                        defaultClass: "gvc3qt1o1"
                    },
                    thin: {
                        conditions: {
                            mobile: "gvc3qt1o4",
                            tablet: "gvc3qt1o5",
                            desktop: "gvc3qt1o6"
                        },
                        defaultClass: "gvc3qt1o4"
                    },
                    light: {
                        conditions: {
                            mobile: "gvc3qt1o7",
                            tablet: "gvc3qt1o8",
                            desktop: "gvc3qt1o9"
                        },
                        defaultClass: "gvc3qt1o7"
                    },
                    normal: {
                        conditions: {
                            mobile: "gvc3qt1oa",
                            tablet: "gvc3qt1ob",
                            desktop: "gvc3qt1oc"
                        },
                        defaultClass: "gvc3qt1oa"
                    },
                    medium: {
                        conditions: {
                            mobile: "gvc3qt1od",
                            tablet: "gvc3qt1oe",
                            desktop: "gvc3qt1of"
                        },
                        defaultClass: "gvc3qt1od"
                    },
                    semibold: {
                        conditions: {
                            mobile: "gvc3qt1og",
                            tablet: "gvc3qt1oh",
                            desktop: "gvc3qt1oi"
                        },
                        defaultClass: "gvc3qt1og"
                    },
                    bold: {
                        conditions: {
                            mobile: "gvc3qt1oj",
                            tablet: "gvc3qt1ok",
                            desktop: "gvc3qt1ol"
                        },
                        defaultClass: "gvc3qt1oj"
                    },
                    extrabold: {
                        conditions: {
                            mobile: "gvc3qt1om",
                            tablet: "gvc3qt1on",
                            desktop: "gvc3qt1oo"
                        },
                        defaultClass: "gvc3qt1om"
                    },
                    black: {
                        conditions: {
                            mobile: "gvc3qt1op",
                            tablet: "gvc3qt1oq",
                            desktop: "gvc3qt1or"
                        },
                        defaultClass: "gvc3qt1op"
                    }
                },
                responsiveArray: undefined
            },
            gap: {
                values: {
                    "0": {
                        conditions: {
                            mobile: "gvc3qt1os",
                            tablet: "gvc3qt1ot",
                            desktop: "gvc3qt1ou"
                        },
                        defaultClass: "gvc3qt1os"
                    },
                    "1": {
                        conditions: {
                            mobile: "gvc3qt1ov",
                            tablet: "gvc3qt1ow",
                            desktop: "gvc3qt1ox"
                        },
                        defaultClass: "gvc3qt1ov"
                    },
                    "2": {
                        conditions: {
                            mobile: "gvc3qt1oy",
                            tablet: "gvc3qt1oz",
                            desktop: "gvc3qt1p0"
                        },
                        defaultClass: "gvc3qt1oy"
                    },
                    "3": {
                        conditions: {
                            mobile: "gvc3qt1p1",
                            tablet: "gvc3qt1p2",
                            desktop: "gvc3qt1p3"
                        },
                        defaultClass: "gvc3qt1p1"
                    },
                    "4": {
                        conditions: {
                            mobile: "gvc3qt1p4",
                            tablet: "gvc3qt1p5",
                            desktop: "gvc3qt1p6"
                        },
                        defaultClass: "gvc3qt1p4"
                    },
                    "5": {
                        conditions: {
                            mobile: "gvc3qt1p7",
                            tablet: "gvc3qt1p8",
                            desktop: "gvc3qt1p9"
                        },
                        defaultClass: "gvc3qt1p7"
                    },
                    "6": {
                        conditions: {
                            mobile: "gvc3qt1pa",
                            tablet: "gvc3qt1pb",
                            desktop: "gvc3qt1pc"
                        },
                        defaultClass: "gvc3qt1pa"
                    },
                    "7": {
                        conditions: {
                            mobile: "gvc3qt1pd",
                            tablet: "gvc3qt1pe",
                            desktop: "gvc3qt1pf"
                        },
                        defaultClass: "gvc3qt1pd"
                    },
                    "8": {
                        conditions: {
                            mobile: "gvc3qt1pg",
                            tablet: "gvc3qt1ph",
                            desktop: "gvc3qt1pi"
                        },
                        defaultClass: "gvc3qt1pg"
                    },
                    "9": {
                        conditions: {
                            mobile: "gvc3qt1pj",
                            tablet: "gvc3qt1pk",
                            desktop: "gvc3qt1pl"
                        },
                        defaultClass: "gvc3qt1pj"
                    },
                    "10": {
                        conditions: {
                            mobile: "gvc3qt1pm",
                            tablet: "gvc3qt1pn",
                            desktop: "gvc3qt1po"
                        },
                        defaultClass: "gvc3qt1pm"
                    },
                    "11": {
                        conditions: {
                            mobile: "gvc3qt1pp",
                            tablet: "gvc3qt1pq",
                            desktop: "gvc3qt1pr"
                        },
                        defaultClass: "gvc3qt1pp"
                    },
                    "12": {
                        conditions: {
                            mobile: "gvc3qt1ps",
                            tablet: "gvc3qt1pt",
                            desktop: "gvc3qt1pu"
                        },
                        defaultClass: "gvc3qt1ps"
                    },
                    "13": {
                        conditions: {
                            mobile: "gvc3qt1pv",
                            tablet: "gvc3qt1pw",
                            desktop: "gvc3qt1px"
                        },
                        defaultClass: "gvc3qt1pv"
                    },
                    "14": {
                        conditions: {
                            mobile: "gvc3qt1py",
                            tablet: "gvc3qt1pz",
                            desktop: "gvc3qt1q0"
                        },
                        defaultClass: "gvc3qt1py"
                    },
                    "15": {
                        conditions: {
                            mobile: "gvc3qt1q1",
                            tablet: "gvc3qt1q2",
                            desktop: "gvc3qt1q3"
                        },
                        defaultClass: "gvc3qt1q1"
                    },
                    "16": {
                        conditions: {
                            mobile: "gvc3qt1q4",
                            tablet: "gvc3qt1q5",
                            desktop: "gvc3qt1q6"
                        },
                        defaultClass: "gvc3qt1q4"
                    },
                    "17": {
                        conditions: {
                            mobile: "gvc3qt1q7",
                            tablet: "gvc3qt1q8",
                            desktop: "gvc3qt1q9"
                        },
                        defaultClass: "gvc3qt1q7"
                    },
                    "18": {
                        conditions: {
                            mobile: "gvc3qt1qa",
                            tablet: "gvc3qt1qb",
                            desktop: "gvc3qt1qc"
                        },
                        defaultClass: "gvc3qt1qa"
                    },
                    "19": {
                        conditions: {
                            mobile: "gvc3qt1qd",
                            tablet: "gvc3qt1qe",
                            desktop: "gvc3qt1qf"
                        },
                        defaultClass: "gvc3qt1qd"
                    },
                    "20": {
                        conditions: {
                            mobile: "gvc3qt1qg",
                            tablet: "gvc3qt1qh",
                            desktop: "gvc3qt1qi"
                        },
                        defaultClass: "gvc3qt1qg"
                    },
                    "21": {
                        conditions: {
                            mobile: "gvc3qt1qj",
                            tablet: "gvc3qt1qk",
                            desktop: "gvc3qt1ql"
                        },
                        defaultClass: "gvc3qt1qj"
                    },
                    "22": {
                        conditions: {
                            mobile: "gvc3qt1qm",
                            tablet: "gvc3qt1qn",
                            desktop: "gvc3qt1qo"
                        },
                        defaultClass: "gvc3qt1qm"
                    },
                    "23": {
                        conditions: {
                            mobile: "gvc3qt1qp",
                            tablet: "gvc3qt1qq",
                            desktop: "gvc3qt1qr"
                        },
                        defaultClass: "gvc3qt1qp"
                    },
                    "24": {
                        conditions: {
                            mobile: "gvc3qt1qs",
                            tablet: "gvc3qt1qt",
                            desktop: "gvc3qt1qu"
                        },
                        defaultClass: "gvc3qt1qs"
                    },
                    "25": {
                        conditions: {
                            mobile: "gvc3qt1qv",
                            tablet: "gvc3qt1qw",
                            desktop: "gvc3qt1qx"
                        },
                        defaultClass: "gvc3qt1qv"
                    },
                    "26": {
                        conditions: {
                            mobile: "gvc3qt1qy",
                            tablet: "gvc3qt1qz",
                            desktop: "gvc3qt1r0"
                        },
                        defaultClass: "gvc3qt1qy"
                    },
                    "27": {
                        conditions: {
                            mobile: "gvc3qt1r1",
                            tablet: "gvc3qt1r2",
                            desktop: "gvc3qt1r3"
                        },
                        defaultClass: "gvc3qt1r1"
                    },
                    "28": {
                        conditions: {
                            mobile: "gvc3qt1r4",
                            tablet: "gvc3qt1r5",
                            desktop: "gvc3qt1r6"
                        },
                        defaultClass: "gvc3qt1r4"
                    },
                    "29": {
                        conditions: {
                            mobile: "gvc3qt1r7",
                            tablet: "gvc3qt1r8",
                            desktop: "gvc3qt1r9"
                        },
                        defaultClass: "gvc3qt1r7"
                    },
                    "30": {
                        conditions: {
                            mobile: "gvc3qt1ra",
                            tablet: "gvc3qt1rb",
                            desktop: "gvc3qt1rc"
                        },
                        defaultClass: "gvc3qt1ra"
                    },
                    auto: {
                        conditions: {
                            mobile: "gvc3qt1rd",
                            tablet: "gvc3qt1re",
                            desktop: "gvc3qt1rf"
                        },
                        defaultClass: "gvc3qt1rd"
                    },
                    full: {
                        conditions: {
                            mobile: "gvc3qt1rg",
                            tablet: "gvc3qt1rh",
                            desktop: "gvc3qt1ri"
                        },
                        defaultClass: "gvc3qt1rg"
                    },
                    fit: {
                        conditions: {
                            mobile: "gvc3qt1rj",
                            tablet: "gvc3qt1rk",
                            desktop: "gvc3qt1rl"
                        },
                        defaultClass: "gvc3qt1rj"
                    },
                    max: {
                        conditions: {
                            mobile: "gvc3qt1rm",
                            tablet: "gvc3qt1rn",
                            desktop: "gvc3qt1ro"
                        },
                        defaultClass: "gvc3qt1rm"
                    },
                    min: {
                        conditions: {
                            mobile: "gvc3qt1rp",
                            tablet: "gvc3qt1rq",
                            desktop: "gvc3qt1rr"
                        },
                        defaultClass: "gvc3qt1rp"
                    },
                    viewHeight: {
                        conditions: {
                            mobile: "gvc3qt1rs",
                            tablet: "gvc3qt1rt",
                            desktop: "gvc3qt1ru"
                        },
                        defaultClass: "gvc3qt1rs"
                    },
                    viewWidth: {
                        conditions: {
                            mobile: "gvc3qt1rv",
                            tablet: "gvc3qt1rw",
                            desktop: "gvc3qt1rx"
                        },
                        defaultClass: "gvc3qt1rv"
                    },
                    none: {
                        conditions: {
                            mobile: "gvc3qt1ry",
                            tablet: "gvc3qt1rz",
                            desktop: "gvc3qt1s0"
                        },
                        defaultClass: "gvc3qt1ry"
                    }
                },
                responsiveArray: undefined
            },
            height: {
                values: {
                    "0": {
                        conditions: {
                            mobile: "gvc3qt1s1",
                            tablet: "gvc3qt1s2",
                            desktop: "gvc3qt1s3"
                        },
                        defaultClass: "gvc3qt1s1"
                    },
                    "1": {
                        conditions: {
                            mobile: "gvc3qt1s4",
                            tablet: "gvc3qt1s5",
                            desktop: "gvc3qt1s6"
                        },
                        defaultClass: "gvc3qt1s4"
                    },
                    "2": {
                        conditions: {
                            mobile: "gvc3qt1s7",
                            tablet: "gvc3qt1s8",
                            desktop: "gvc3qt1s9"
                        },
                        defaultClass: "gvc3qt1s7"
                    },
                    "3": {
                        conditions: {
                            mobile: "gvc3qt1sa",
                            tablet: "gvc3qt1sb",
                            desktop: "gvc3qt1sc"
                        },
                        defaultClass: "gvc3qt1sa"
                    },
                    "4": {
                        conditions: {
                            mobile: "gvc3qt1sd",
                            tablet: "gvc3qt1se",
                            desktop: "gvc3qt1sf"
                        },
                        defaultClass: "gvc3qt1sd"
                    },
                    "5": {
                        conditions: {
                            mobile: "gvc3qt1sg",
                            tablet: "gvc3qt1sh",
                            desktop: "gvc3qt1si"
                        },
                        defaultClass: "gvc3qt1sg"
                    },
                    "6": {
                        conditions: {
                            mobile: "gvc3qt1sj",
                            tablet: "gvc3qt1sk",
                            desktop: "gvc3qt1sl"
                        },
                        defaultClass: "gvc3qt1sj"
                    },
                    "7": {
                        conditions: {
                            mobile: "gvc3qt1sm",
                            tablet: "gvc3qt1sn",
                            desktop: "gvc3qt1so"
                        },
                        defaultClass: "gvc3qt1sm"
                    },
                    "8": {
                        conditions: {
                            mobile: "gvc3qt1sp",
                            tablet: "gvc3qt1sq",
                            desktop: "gvc3qt1sr"
                        },
                        defaultClass: "gvc3qt1sp"
                    },
                    "9": {
                        conditions: {
                            mobile: "gvc3qt1ss",
                            tablet: "gvc3qt1st",
                            desktop: "gvc3qt1su"
                        },
                        defaultClass: "gvc3qt1ss"
                    },
                    "10": {
                        conditions: {
                            mobile: "gvc3qt1sv",
                            tablet: "gvc3qt1sw",
                            desktop: "gvc3qt1sx"
                        },
                        defaultClass: "gvc3qt1sv"
                    },
                    "11": {
                        conditions: {
                            mobile: "gvc3qt1sy",
                            tablet: "gvc3qt1sz",
                            desktop: "gvc3qt1t0"
                        },
                        defaultClass: "gvc3qt1sy"
                    },
                    "12": {
                        conditions: {
                            mobile: "gvc3qt1t1",
                            tablet: "gvc3qt1t2",
                            desktop: "gvc3qt1t3"
                        },
                        defaultClass: "gvc3qt1t1"
                    },
                    "13": {
                        conditions: {
                            mobile: "gvc3qt1t4",
                            tablet: "gvc3qt1t5",
                            desktop: "gvc3qt1t6"
                        },
                        defaultClass: "gvc3qt1t4"
                    },
                    "14": {
                        conditions: {
                            mobile: "gvc3qt1t7",
                            tablet: "gvc3qt1t8",
                            desktop: "gvc3qt1t9"
                        },
                        defaultClass: "gvc3qt1t7"
                    },
                    "15": {
                        conditions: {
                            mobile: "gvc3qt1ta",
                            tablet: "gvc3qt1tb",
                            desktop: "gvc3qt1tc"
                        },
                        defaultClass: "gvc3qt1ta"
                    },
                    "16": {
                        conditions: {
                            mobile: "gvc3qt1td",
                            tablet: "gvc3qt1te",
                            desktop: "gvc3qt1tf"
                        },
                        defaultClass: "gvc3qt1td"
                    },
                    "17": {
                        conditions: {
                            mobile: "gvc3qt1tg",
                            tablet: "gvc3qt1th",
                            desktop: "gvc3qt1ti"
                        },
                        defaultClass: "gvc3qt1tg"
                    },
                    "18": {
                        conditions: {
                            mobile: "gvc3qt1tj",
                            tablet: "gvc3qt1tk",
                            desktop: "gvc3qt1tl"
                        },
                        defaultClass: "gvc3qt1tj"
                    },
                    "19": {
                        conditions: {
                            mobile: "gvc3qt1tm",
                            tablet: "gvc3qt1tn",
                            desktop: "gvc3qt1to"
                        },
                        defaultClass: "gvc3qt1tm"
                    },
                    "20": {
                        conditions: {
                            mobile: "gvc3qt1tp",
                            tablet: "gvc3qt1tq",
                            desktop: "gvc3qt1tr"
                        },
                        defaultClass: "gvc3qt1tp"
                    },
                    "21": {
                        conditions: {
                            mobile: "gvc3qt1ts",
                            tablet: "gvc3qt1tt",
                            desktop: "gvc3qt1tu"
                        },
                        defaultClass: "gvc3qt1ts"
                    },
                    "22": {
                        conditions: {
                            mobile: "gvc3qt1tv",
                            tablet: "gvc3qt1tw",
                            desktop: "gvc3qt1tx"
                        },
                        defaultClass: "gvc3qt1tv"
                    },
                    "23": {
                        conditions: {
                            mobile: "gvc3qt1ty",
                            tablet: "gvc3qt1tz",
                            desktop: "gvc3qt1u0"
                        },
                        defaultClass: "gvc3qt1ty"
                    },
                    "24": {
                        conditions: {
                            mobile: "gvc3qt1u1",
                            tablet: "gvc3qt1u2",
                            desktop: "gvc3qt1u3"
                        },
                        defaultClass: "gvc3qt1u1"
                    },
                    "25": {
                        conditions: {
                            mobile: "gvc3qt1u4",
                            tablet: "gvc3qt1u5",
                            desktop: "gvc3qt1u6"
                        },
                        defaultClass: "gvc3qt1u4"
                    },
                    "26": {
                        conditions: {
                            mobile: "gvc3qt1u7",
                            tablet: "gvc3qt1u8",
                            desktop: "gvc3qt1u9"
                        },
                        defaultClass: "gvc3qt1u7"
                    },
                    "27": {
                        conditions: {
                            mobile: "gvc3qt1ua",
                            tablet: "gvc3qt1ub",
                            desktop: "gvc3qt1uc"
                        },
                        defaultClass: "gvc3qt1ua"
                    },
                    "28": {
                        conditions: {
                            mobile: "gvc3qt1ud",
                            tablet: "gvc3qt1ue",
                            desktop: "gvc3qt1uf"
                        },
                        defaultClass: "gvc3qt1ud"
                    },
                    "29": {
                        conditions: {
                            mobile: "gvc3qt1ug",
                            tablet: "gvc3qt1uh",
                            desktop: "gvc3qt1ui"
                        },
                        defaultClass: "gvc3qt1ug"
                    },
                    "30": {
                        conditions: {
                            mobile: "gvc3qt1uj",
                            tablet: "gvc3qt1uk",
                            desktop: "gvc3qt1ul"
                        },
                        defaultClass: "gvc3qt1uj"
                    },
                    auto: {
                        conditions: {
                            mobile: "gvc3qt1um",
                            tablet: "gvc3qt1un",
                            desktop: "gvc3qt1uo"
                        },
                        defaultClass: "gvc3qt1um"
                    },
                    full: {
                        conditions: {
                            mobile: "gvc3qt1up",
                            tablet: "gvc3qt1uq",
                            desktop: "gvc3qt1ur"
                        },
                        defaultClass: "gvc3qt1up"
                    },
                    fit: {
                        conditions: {
                            mobile: "gvc3qt1us",
                            tablet: "gvc3qt1ut",
                            desktop: "gvc3qt1uu"
                        },
                        defaultClass: "gvc3qt1us"
                    },
                    max: {
                        conditions: {
                            mobile: "gvc3qt1uv",
                            tablet: "gvc3qt1uw",
                            desktop: "gvc3qt1ux"
                        },
                        defaultClass: "gvc3qt1uv"
                    },
                    min: {
                        conditions: {
                            mobile: "gvc3qt1uy",
                            tablet: "gvc3qt1uz",
                            desktop: "gvc3qt1v0"
                        },
                        defaultClass: "gvc3qt1uy"
                    },
                    viewHeight: {
                        conditions: {
                            mobile: "gvc3qt1v1",
                            tablet: "gvc3qt1v2",
                            desktop: "gvc3qt1v3"
                        },
                        defaultClass: "gvc3qt1v1"
                    },
                    viewWidth: {
                        conditions: {
                            mobile: "gvc3qt1v4",
                            tablet: "gvc3qt1v5",
                            desktop: "gvc3qt1v6"
                        },
                        defaultClass: "gvc3qt1v4"
                    },
                    none: {
                        conditions: {
                            mobile: "gvc3qt1v7",
                            tablet: "gvc3qt1v8",
                            desktop: "gvc3qt1v9"
                        },
                        defaultClass: "gvc3qt1v7"
                    }
                },
                responsiveArray: undefined
            },
            inset: {
                values: {
                    "0": {
                        conditions: {
                            mobile: "gvc3qt1va",
                            tablet: "gvc3qt1vb",
                            desktop: "gvc3qt1vc"
                        },
                        defaultClass: "gvc3qt1va"
                    },
                    "1": {
                        conditions: {
                            mobile: "gvc3qt1vd",
                            tablet: "gvc3qt1ve",
                            desktop: "gvc3qt1vf"
                        },
                        defaultClass: "gvc3qt1vd"
                    },
                    "2": {
                        conditions: {
                            mobile: "gvc3qt1vg",
                            tablet: "gvc3qt1vh",
                            desktop: "gvc3qt1vi"
                        },
                        defaultClass: "gvc3qt1vg"
                    },
                    "3": {
                        conditions: {
                            mobile: "gvc3qt1vj",
                            tablet: "gvc3qt1vk",
                            desktop: "gvc3qt1vl"
                        },
                        defaultClass: "gvc3qt1vj"
                    },
                    "4": {
                        conditions: {
                            mobile: "gvc3qt1vm",
                            tablet: "gvc3qt1vn",
                            desktop: "gvc3qt1vo"
                        },
                        defaultClass: "gvc3qt1vm"
                    },
                    "5": {
                        conditions: {
                            mobile: "gvc3qt1vp",
                            tablet: "gvc3qt1vq",
                            desktop: "gvc3qt1vr"
                        },
                        defaultClass: "gvc3qt1vp"
                    },
                    "6": {
                        conditions: {
                            mobile: "gvc3qt1vs",
                            tablet: "gvc3qt1vt",
                            desktop: "gvc3qt1vu"
                        },
                        defaultClass: "gvc3qt1vs"
                    },
                    "7": {
                        conditions: {
                            mobile: "gvc3qt1vv",
                            tablet: "gvc3qt1vw",
                            desktop: "gvc3qt1vx"
                        },
                        defaultClass: "gvc3qt1vv"
                    },
                    "8": {
                        conditions: {
                            mobile: "gvc3qt1vy",
                            tablet: "gvc3qt1vz",
                            desktop: "gvc3qt1w0"
                        },
                        defaultClass: "gvc3qt1vy"
                    },
                    "9": {
                        conditions: {
                            mobile: "gvc3qt1w1",
                            tablet: "gvc3qt1w2",
                            desktop: "gvc3qt1w3"
                        },
                        defaultClass: "gvc3qt1w1"
                    },
                    "10": {
                        conditions: {
                            mobile: "gvc3qt1w4",
                            tablet: "gvc3qt1w5",
                            desktop: "gvc3qt1w6"
                        },
                        defaultClass: "gvc3qt1w4"
                    },
                    "11": {
                        conditions: {
                            mobile: "gvc3qt1w7",
                            tablet: "gvc3qt1w8",
                            desktop: "gvc3qt1w9"
                        },
                        defaultClass: "gvc3qt1w7"
                    },
                    "12": {
                        conditions: {
                            mobile: "gvc3qt1wa",
                            tablet: "gvc3qt1wb",
                            desktop: "gvc3qt1wc"
                        },
                        defaultClass: "gvc3qt1wa"
                    },
                    "13": {
                        conditions: {
                            mobile: "gvc3qt1wd",
                            tablet: "gvc3qt1we",
                            desktop: "gvc3qt1wf"
                        },
                        defaultClass: "gvc3qt1wd"
                    },
                    "14": {
                        conditions: {
                            mobile: "gvc3qt1wg",
                            tablet: "gvc3qt1wh",
                            desktop: "gvc3qt1wi"
                        },
                        defaultClass: "gvc3qt1wg"
                    },
                    "15": {
                        conditions: {
                            mobile: "gvc3qt1wj",
                            tablet: "gvc3qt1wk",
                            desktop: "gvc3qt1wl"
                        },
                        defaultClass: "gvc3qt1wj"
                    },
                    "16": {
                        conditions: {
                            mobile: "gvc3qt1wm",
                            tablet: "gvc3qt1wn",
                            desktop: "gvc3qt1wo"
                        },
                        defaultClass: "gvc3qt1wm"
                    },
                    "17": {
                        conditions: {
                            mobile: "gvc3qt1wp",
                            tablet: "gvc3qt1wq",
                            desktop: "gvc3qt1wr"
                        },
                        defaultClass: "gvc3qt1wp"
                    },
                    "18": {
                        conditions: {
                            mobile: "gvc3qt1ws",
                            tablet: "gvc3qt1wt",
                            desktop: "gvc3qt1wu"
                        },
                        defaultClass: "gvc3qt1ws"
                    },
                    "19": {
                        conditions: {
                            mobile: "gvc3qt1wv",
                            tablet: "gvc3qt1ww",
                            desktop: "gvc3qt1wx"
                        },
                        defaultClass: "gvc3qt1wv"
                    },
                    "20": {
                        conditions: {
                            mobile: "gvc3qt1wy",
                            tablet: "gvc3qt1wz",
                            desktop: "gvc3qt1x0"
                        },
                        defaultClass: "gvc3qt1wy"
                    },
                    "21": {
                        conditions: {
                            mobile: "gvc3qt1x1",
                            tablet: "gvc3qt1x2",
                            desktop: "gvc3qt1x3"
                        },
                        defaultClass: "gvc3qt1x1"
                    },
                    "22": {
                        conditions: {
                            mobile: "gvc3qt1x4",
                            tablet: "gvc3qt1x5",
                            desktop: "gvc3qt1x6"
                        },
                        defaultClass: "gvc3qt1x4"
                    },
                    "23": {
                        conditions: {
                            mobile: "gvc3qt1x7",
                            tablet: "gvc3qt1x8",
                            desktop: "gvc3qt1x9"
                        },
                        defaultClass: "gvc3qt1x7"
                    },
                    "24": {
                        conditions: {
                            mobile: "gvc3qt1xa",
                            tablet: "gvc3qt1xb",
                            desktop: "gvc3qt1xc"
                        },
                        defaultClass: "gvc3qt1xa"
                    },
                    "25": {
                        conditions: {
                            mobile: "gvc3qt1xd",
                            tablet: "gvc3qt1xe",
                            desktop: "gvc3qt1xf"
                        },
                        defaultClass: "gvc3qt1xd"
                    },
                    "26": {
                        conditions: {
                            mobile: "gvc3qt1xg",
                            tablet: "gvc3qt1xh",
                            desktop: "gvc3qt1xi"
                        },
                        defaultClass: "gvc3qt1xg"
                    },
                    "27": {
                        conditions: {
                            mobile: "gvc3qt1xj",
                            tablet: "gvc3qt1xk",
                            desktop: "gvc3qt1xl"
                        },
                        defaultClass: "gvc3qt1xj"
                    },
                    "28": {
                        conditions: {
                            mobile: "gvc3qt1xm",
                            tablet: "gvc3qt1xn",
                            desktop: "gvc3qt1xo"
                        },
                        defaultClass: "gvc3qt1xm"
                    },
                    "29": {
                        conditions: {
                            mobile: "gvc3qt1xp",
                            tablet: "gvc3qt1xq",
                            desktop: "gvc3qt1xr"
                        },
                        defaultClass: "gvc3qt1xp"
                    },
                    "30": {
                        conditions: {
                            mobile: "gvc3qt1xs",
                            tablet: "gvc3qt1xt",
                            desktop: "gvc3qt1xu"
                        },
                        defaultClass: "gvc3qt1xs"
                    },
                    auto: {
                        conditions: {
                            mobile: "gvc3qt1xv",
                            tablet: "gvc3qt1xw",
                            desktop: "gvc3qt1xx"
                        },
                        defaultClass: "gvc3qt1xv"
                    },
                    full: {
                        conditions: {
                            mobile: "gvc3qt1xy",
                            tablet: "gvc3qt1xz",
                            desktop: "gvc3qt1y0"
                        },
                        defaultClass: "gvc3qt1xy"
                    },
                    fit: {
                        conditions: {
                            mobile: "gvc3qt1y1",
                            tablet: "gvc3qt1y2",
                            desktop: "gvc3qt1y3"
                        },
                        defaultClass: "gvc3qt1y1"
                    },
                    max: {
                        conditions: {
                            mobile: "gvc3qt1y4",
                            tablet: "gvc3qt1y5",
                            desktop: "gvc3qt1y6"
                        },
                        defaultClass: "gvc3qt1y4"
                    },
                    min: {
                        conditions: {
                            mobile: "gvc3qt1y7",
                            tablet: "gvc3qt1y8",
                            desktop: "gvc3qt1y9"
                        },
                        defaultClass: "gvc3qt1y7"
                    },
                    viewHeight: {
                        conditions: {
                            mobile: "gvc3qt1ya",
                            tablet: "gvc3qt1yb",
                            desktop: "gvc3qt1yc"
                        },
                        defaultClass: "gvc3qt1ya"
                    },
                    viewWidth: {
                        conditions: {
                            mobile: "gvc3qt1yd",
                            tablet: "gvc3qt1ye",
                            desktop: "gvc3qt1yf"
                        },
                        defaultClass: "gvc3qt1yd"
                    },
                    none: {
                        conditions: {
                            mobile: "gvc3qt1yg",
                            tablet: "gvc3qt1yh",
                            desktop: "gvc3qt1yi"
                        },
                        defaultClass: "gvc3qt1yg"
                    }
                },
                responsiveArray: undefined
            },
            justifyContent: {
                values: {
                    "flex-start": {
                        conditions: {
                            mobile: "gvc3qt1yj",
                            tablet: "gvc3qt1yk",
                            desktop: "gvc3qt1yl"
                        },
                        defaultClass: "gvc3qt1yj"
                    },
                    "flex-end": {
                        conditions: {
                            mobile: "gvc3qt1ym",
                            tablet: "gvc3qt1yn",
                            desktop: "gvc3qt1yo"
                        },
                        defaultClass: "gvc3qt1ym"
                    },
                    center: {
                        conditions: {
                            mobile: "gvc3qt1yp",
                            tablet: "gvc3qt1yq",
                            desktop: "gvc3qt1yr"
                        },
                        defaultClass: "gvc3qt1yp"
                    },
                    stretch: {
                        conditions: {
                            mobile: "gvc3qt1ys",
                            tablet: "gvc3qt1yt",
                            desktop: "gvc3qt1yu"
                        },
                        defaultClass: "gvc3qt1ys"
                    },
                    "space-around": {
                        conditions: {
                            mobile: "gvc3qt1yv",
                            tablet: "gvc3qt1yw",
                            desktop: "gvc3qt1yx"
                        },
                        defaultClass: "gvc3qt1yv"
                    },
                    "space-between": {
                        conditions: {
                            mobile: "gvc3qt1yy",
                            tablet: "gvc3qt1yz",
                            desktop: "gvc3qt1z0"
                        },
                        defaultClass: "gvc3qt1yy"
                    }
                },
                responsiveArray: undefined
            },
            justifySelf: {
                values: {
                    "flex-start": {
                        conditions: {
                            mobile: "gvc3qt1z1",
                            tablet: "gvc3qt1z2",
                            desktop: "gvc3qt1z3"
                        },
                        defaultClass: "gvc3qt1z1"
                    },
                    "flex-end": {
                        conditions: {
                            mobile: "gvc3qt1z4",
                            tablet: "gvc3qt1z5",
                            desktop: "gvc3qt1z6"
                        },
                        defaultClass: "gvc3qt1z4"
                    },
                    center: {
                        conditions: {
                            mobile: "gvc3qt1z7",
                            tablet: "gvc3qt1z8",
                            desktop: "gvc3qt1z9"
                        },
                        defaultClass: "gvc3qt1z7"
                    },
                    stretch: {
                        conditions: {
                            mobile: "gvc3qt1za",
                            tablet: "gvc3qt1zb",
                            desktop: "gvc3qt1zc"
                        },
                        defaultClass: "gvc3qt1za"
                    }
                },
                responsiveArray: undefined
            },
            left: {
                values: {
                    "0": {
                        conditions: {
                            mobile: "gvc3qt1zd",
                            tablet: "gvc3qt1ze",
                            desktop: "gvc3qt1zf"
                        },
                        defaultClass: "gvc3qt1zd"
                    },
                    "1": {
                        conditions: {
                            mobile: "gvc3qt1zg",
                            tablet: "gvc3qt1zh",
                            desktop: "gvc3qt1zi"
                        },
                        defaultClass: "gvc3qt1zg"
                    },
                    "2": {
                        conditions: {
                            mobile: "gvc3qt1zj",
                            tablet: "gvc3qt1zk",
                            desktop: "gvc3qt1zl"
                        },
                        defaultClass: "gvc3qt1zj"
                    },
                    "3": {
                        conditions: {
                            mobile: "gvc3qt1zm",
                            tablet: "gvc3qt1zn",
                            desktop: "gvc3qt1zo"
                        },
                        defaultClass: "gvc3qt1zm"
                    },
                    "4": {
                        conditions: {
                            mobile: "gvc3qt1zp",
                            tablet: "gvc3qt1zq",
                            desktop: "gvc3qt1zr"
                        },
                        defaultClass: "gvc3qt1zp"
                    },
                    "5": {
                        conditions: {
                            mobile: "gvc3qt1zs",
                            tablet: "gvc3qt1zt",
                            desktop: "gvc3qt1zu"
                        },
                        defaultClass: "gvc3qt1zs"
                    },
                    "6": {
                        conditions: {
                            mobile: "gvc3qt1zv",
                            tablet: "gvc3qt1zw",
                            desktop: "gvc3qt1zx"
                        },
                        defaultClass: "gvc3qt1zv"
                    },
                    "7": {
                        conditions: {
                            mobile: "gvc3qt1zy",
                            tablet: "gvc3qt1zz",
                            desktop: "gvc3qt200"
                        },
                        defaultClass: "gvc3qt1zy"
                    },
                    "8": {
                        conditions: {
                            mobile: "gvc3qt201",
                            tablet: "gvc3qt202",
                            desktop: "gvc3qt203"
                        },
                        defaultClass: "gvc3qt201"
                    },
                    "9": {
                        conditions: {
                            mobile: "gvc3qt204",
                            tablet: "gvc3qt205",
                            desktop: "gvc3qt206"
                        },
                        defaultClass: "gvc3qt204"
                    },
                    "10": {
                        conditions: {
                            mobile: "gvc3qt207",
                            tablet: "gvc3qt208",
                            desktop: "gvc3qt209"
                        },
                        defaultClass: "gvc3qt207"
                    },
                    "11": {
                        conditions: {
                            mobile: "gvc3qt20a",
                            tablet: "gvc3qt20b",
                            desktop: "gvc3qt20c"
                        },
                        defaultClass: "gvc3qt20a"
                    },
                    "12": {
                        conditions: {
                            mobile: "gvc3qt20d",
                            tablet: "gvc3qt20e",
                            desktop: "gvc3qt20f"
                        },
                        defaultClass: "gvc3qt20d"
                    },
                    "13": {
                        conditions: {
                            mobile: "gvc3qt20g",
                            tablet: "gvc3qt20h",
                            desktop: "gvc3qt20i"
                        },
                        defaultClass: "gvc3qt20g"
                    },
                    "14": {
                        conditions: {
                            mobile: "gvc3qt20j",
                            tablet: "gvc3qt20k",
                            desktop: "gvc3qt20l"
                        },
                        defaultClass: "gvc3qt20j"
                    },
                    "15": {
                        conditions: {
                            mobile: "gvc3qt20m",
                            tablet: "gvc3qt20n",
                            desktop: "gvc3qt20o"
                        },
                        defaultClass: "gvc3qt20m"
                    },
                    "16": {
                        conditions: {
                            mobile: "gvc3qt20p",
                            tablet: "gvc3qt20q",
                            desktop: "gvc3qt20r"
                        },
                        defaultClass: "gvc3qt20p"
                    },
                    "17": {
                        conditions: {
                            mobile: "gvc3qt20s",
                            tablet: "gvc3qt20t",
                            desktop: "gvc3qt20u"
                        },
                        defaultClass: "gvc3qt20s"
                    },
                    "18": {
                        conditions: {
                            mobile: "gvc3qt20v",
                            tablet: "gvc3qt20w",
                            desktop: "gvc3qt20x"
                        },
                        defaultClass: "gvc3qt20v"
                    },
                    "19": {
                        conditions: {
                            mobile: "gvc3qt20y",
                            tablet: "gvc3qt20z",
                            desktop: "gvc3qt210"
                        },
                        defaultClass: "gvc3qt20y"
                    },
                    "20": {
                        conditions: {
                            mobile: "gvc3qt211",
                            tablet: "gvc3qt212",
                            desktop: "gvc3qt213"
                        },
                        defaultClass: "gvc3qt211"
                    },
                    "21": {
                        conditions: {
                            mobile: "gvc3qt214",
                            tablet: "gvc3qt215",
                            desktop: "gvc3qt216"
                        },
                        defaultClass: "gvc3qt214"
                    },
                    "22": {
                        conditions: {
                            mobile: "gvc3qt217",
                            tablet: "gvc3qt218",
                            desktop: "gvc3qt219"
                        },
                        defaultClass: "gvc3qt217"
                    },
                    "23": {
                        conditions: {
                            mobile: "gvc3qt21a",
                            tablet: "gvc3qt21b",
                            desktop: "gvc3qt21c"
                        },
                        defaultClass: "gvc3qt21a"
                    },
                    "24": {
                        conditions: {
                            mobile: "gvc3qt21d",
                            tablet: "gvc3qt21e",
                            desktop: "gvc3qt21f"
                        },
                        defaultClass: "gvc3qt21d"
                    },
                    "25": {
                        conditions: {
                            mobile: "gvc3qt21g",
                            tablet: "gvc3qt21h",
                            desktop: "gvc3qt21i"
                        },
                        defaultClass: "gvc3qt21g"
                    },
                    "26": {
                        conditions: {
                            mobile: "gvc3qt21j",
                            tablet: "gvc3qt21k",
                            desktop: "gvc3qt21l"
                        },
                        defaultClass: "gvc3qt21j"
                    },
                    "27": {
                        conditions: {
                            mobile: "gvc3qt21m",
                            tablet: "gvc3qt21n",
                            desktop: "gvc3qt21o"
                        },
                        defaultClass: "gvc3qt21m"
                    },
                    "28": {
                        conditions: {
                            mobile: "gvc3qt21p",
                            tablet: "gvc3qt21q",
                            desktop: "gvc3qt21r"
                        },
                        defaultClass: "gvc3qt21p"
                    },
                    "29": {
                        conditions: {
                            mobile: "gvc3qt21s",
                            tablet: "gvc3qt21t",
                            desktop: "gvc3qt21u"
                        },
                        defaultClass: "gvc3qt21s"
                    },
                    "30": {
                        conditions: {
                            mobile: "gvc3qt21v",
                            tablet: "gvc3qt21w",
                            desktop: "gvc3qt21x"
                        },
                        defaultClass: "gvc3qt21v"
                    },
                    auto: {
                        conditions: {
                            mobile: "gvc3qt21y",
                            tablet: "gvc3qt21z",
                            desktop: "gvc3qt220"
                        },
                        defaultClass: "gvc3qt21y"
                    },
                    full: {
                        conditions: {
                            mobile: "gvc3qt221",
                            tablet: "gvc3qt222",
                            desktop: "gvc3qt223"
                        },
                        defaultClass: "gvc3qt221"
                    },
                    fit: {
                        conditions: {
                            mobile: "gvc3qt224",
                            tablet: "gvc3qt225",
                            desktop: "gvc3qt226"
                        },
                        defaultClass: "gvc3qt224"
                    },
                    max: {
                        conditions: {
                            mobile: "gvc3qt227",
                            tablet: "gvc3qt228",
                            desktop: "gvc3qt229"
                        },
                        defaultClass: "gvc3qt227"
                    },
                    min: {
                        conditions: {
                            mobile: "gvc3qt22a",
                            tablet: "gvc3qt22b",
                            desktop: "gvc3qt22c"
                        },
                        defaultClass: "gvc3qt22a"
                    },
                    viewHeight: {
                        conditions: {
                            mobile: "gvc3qt22d",
                            tablet: "gvc3qt22e",
                            desktop: "gvc3qt22f"
                        },
                        defaultClass: "gvc3qt22d"
                    },
                    viewWidth: {
                        conditions: {
                            mobile: "gvc3qt22g",
                            tablet: "gvc3qt22h",
                            desktop: "gvc3qt22i"
                        },
                        defaultClass: "gvc3qt22g"
                    },
                    none: {
                        conditions: {
                            mobile: "gvc3qt22j",
                            tablet: "gvc3qt22k",
                            desktop: "gvc3qt22l"
                        },
                        defaultClass: "gvc3qt22j"
                    }
                },
                responsiveArray: undefined
            },
            letterSpacing: {
                values: {
                    tighter: {
                        conditions: {
                            mobile: "gvc3qt22m",
                            tablet: "gvc3qt22n",
                            desktop: "gvc3qt22o"
                        },
                        defaultClass: "gvc3qt22m"
                    },
                    tight: {
                        conditions: {
                            mobile: "gvc3qt22p",
                            tablet: "gvc3qt22q",
                            desktop: "gvc3qt22r"
                        },
                        defaultClass: "gvc3qt22p"
                    },
                    normal: {
                        conditions: {
                            mobile: "gvc3qt22s",
                            tablet: "gvc3qt22t",
                            desktop: "gvc3qt22u"
                        },
                        defaultClass: "gvc3qt22s"
                    },
                    wide: {
                        conditions: {
                            mobile: "gvc3qt22v",
                            tablet: "gvc3qt22w",
                            desktop: "gvc3qt22x"
                        },
                        defaultClass: "gvc3qt22v"
                    },
                    wider: {
                        conditions: {
                            mobile: "gvc3qt22y",
                            tablet: "gvc3qt22z",
                            desktop: "gvc3qt230"
                        },
                        defaultClass: "gvc3qt22y"
                    },
                    widest: {
                        conditions: {
                            mobile: "gvc3qt231",
                            tablet: "gvc3qt232",
                            desktop: "gvc3qt233"
                        },
                        defaultClass: "gvc3qt231"
                    }
                },
                responsiveArray: undefined
            },
            lineHeight: {
                values: {
                    normal: {
                        conditions: {
                            mobile: "gvc3qt234",
                            tablet: "gvc3qt235",
                            desktop: "gvc3qt236"
                        },
                        defaultClass: "gvc3qt234"
                    },
                    none: {
                        conditions: {
                            mobile: "gvc3qt237",
                            tablet: "gvc3qt238",
                            desktop: "gvc3qt239"
                        },
                        defaultClass: "gvc3qt237"
                    },
                    shorter: {
                        conditions: {
                            mobile: "gvc3qt23a",
                            tablet: "gvc3qt23b",
                            desktop: "gvc3qt23c"
                        },
                        defaultClass: "gvc3qt23a"
                    },
                    "short": {
                        conditions: {
                            mobile: "gvc3qt23d",
                            tablet: "gvc3qt23e",
                            desktop: "gvc3qt23f"
                        },
                        defaultClass: "gvc3qt23d"
                    },
                    base: {
                        conditions: {
                            mobile: "gvc3qt23g",
                            tablet: "gvc3qt23h",
                            desktop: "gvc3qt23i"
                        },
                        defaultClass: "gvc3qt23g"
                    },
                    tall: {
                        conditions: {
                            mobile: "gvc3qt23j",
                            tablet: "gvc3qt23k",
                            desktop: "gvc3qt23l"
                        },
                        defaultClass: "gvc3qt23j"
                    },
                    taller: {
                        conditions: {
                            mobile: "gvc3qt23m",
                            tablet: "gvc3qt23n",
                            desktop: "gvc3qt23o"
                        },
                        defaultClass: "gvc3qt23m"
                    }
                },
                responsiveArray: undefined
            },
            marginBottom: {
                values: {
                    "0": {
                        conditions: {
                            mobile: "gvc3qt23p",
                            tablet: "gvc3qt23q",
                            desktop: "gvc3qt23r"
                        },
                        defaultClass: "gvc3qt23p"
                    },
                    "1": {
                        conditions: {
                            mobile: "gvc3qt23s",
                            tablet: "gvc3qt23t",
                            desktop: "gvc3qt23u"
                        },
                        defaultClass: "gvc3qt23s"
                    },
                    "2": {
                        conditions: {
                            mobile: "gvc3qt23v",
                            tablet: "gvc3qt23w",
                            desktop: "gvc3qt23x"
                        },
                        defaultClass: "gvc3qt23v"
                    },
                    "3": {
                        conditions: {
                            mobile: "gvc3qt23y",
                            tablet: "gvc3qt23z",
                            desktop: "gvc3qt240"
                        },
                        defaultClass: "gvc3qt23y"
                    },
                    "4": {
                        conditions: {
                            mobile: "gvc3qt241",
                            tablet: "gvc3qt242",
                            desktop: "gvc3qt243"
                        },
                        defaultClass: "gvc3qt241"
                    },
                    "5": {
                        conditions: {
                            mobile: "gvc3qt244",
                            tablet: "gvc3qt245",
                            desktop: "gvc3qt246"
                        },
                        defaultClass: "gvc3qt244"
                    },
                    "6": {
                        conditions: {
                            mobile: "gvc3qt247",
                            tablet: "gvc3qt248",
                            desktop: "gvc3qt249"
                        },
                        defaultClass: "gvc3qt247"
                    },
                    "7": {
                        conditions: {
                            mobile: "gvc3qt24a",
                            tablet: "gvc3qt24b",
                            desktop: "gvc3qt24c"
                        },
                        defaultClass: "gvc3qt24a"
                    },
                    "8": {
                        conditions: {
                            mobile: "gvc3qt24d",
                            tablet: "gvc3qt24e",
                            desktop: "gvc3qt24f"
                        },
                        defaultClass: "gvc3qt24d"
                    },
                    "9": {
                        conditions: {
                            mobile: "gvc3qt24g",
                            tablet: "gvc3qt24h",
                            desktop: "gvc3qt24i"
                        },
                        defaultClass: "gvc3qt24g"
                    },
                    "10": {
                        conditions: {
                            mobile: "gvc3qt24j",
                            tablet: "gvc3qt24k",
                            desktop: "gvc3qt24l"
                        },
                        defaultClass: "gvc3qt24j"
                    },
                    "11": {
                        conditions: {
                            mobile: "gvc3qt24m",
                            tablet: "gvc3qt24n",
                            desktop: "gvc3qt24o"
                        },
                        defaultClass: "gvc3qt24m"
                    },
                    "12": {
                        conditions: {
                            mobile: "gvc3qt24p",
                            tablet: "gvc3qt24q",
                            desktop: "gvc3qt24r"
                        },
                        defaultClass: "gvc3qt24p"
                    },
                    "13": {
                        conditions: {
                            mobile: "gvc3qt24s",
                            tablet: "gvc3qt24t",
                            desktop: "gvc3qt24u"
                        },
                        defaultClass: "gvc3qt24s"
                    },
                    "14": {
                        conditions: {
                            mobile: "gvc3qt24v",
                            tablet: "gvc3qt24w",
                            desktop: "gvc3qt24x"
                        },
                        defaultClass: "gvc3qt24v"
                    },
                    "15": {
                        conditions: {
                            mobile: "gvc3qt24y",
                            tablet: "gvc3qt24z",
                            desktop: "gvc3qt250"
                        },
                        defaultClass: "gvc3qt24y"
                    },
                    "16": {
                        conditions: {
                            mobile: "gvc3qt251",
                            tablet: "gvc3qt252",
                            desktop: "gvc3qt253"
                        },
                        defaultClass: "gvc3qt251"
                    },
                    "17": {
                        conditions: {
                            mobile: "gvc3qt254",
                            tablet: "gvc3qt255",
                            desktop: "gvc3qt256"
                        },
                        defaultClass: "gvc3qt254"
                    },
                    "18": {
                        conditions: {
                            mobile: "gvc3qt257",
                            tablet: "gvc3qt258",
                            desktop: "gvc3qt259"
                        },
                        defaultClass: "gvc3qt257"
                    },
                    "19": {
                        conditions: {
                            mobile: "gvc3qt25a",
                            tablet: "gvc3qt25b",
                            desktop: "gvc3qt25c"
                        },
                        defaultClass: "gvc3qt25a"
                    },
                    "20": {
                        conditions: {
                            mobile: "gvc3qt25d",
                            tablet: "gvc3qt25e",
                            desktop: "gvc3qt25f"
                        },
                        defaultClass: "gvc3qt25d"
                    },
                    "21": {
                        conditions: {
                            mobile: "gvc3qt25g",
                            tablet: "gvc3qt25h",
                            desktop: "gvc3qt25i"
                        },
                        defaultClass: "gvc3qt25g"
                    },
                    "22": {
                        conditions: {
                            mobile: "gvc3qt25j",
                            tablet: "gvc3qt25k",
                            desktop: "gvc3qt25l"
                        },
                        defaultClass: "gvc3qt25j"
                    },
                    "23": {
                        conditions: {
                            mobile: "gvc3qt25m",
                            tablet: "gvc3qt25n",
                            desktop: "gvc3qt25o"
                        },
                        defaultClass: "gvc3qt25m"
                    },
                    "24": {
                        conditions: {
                            mobile: "gvc3qt25p",
                            tablet: "gvc3qt25q",
                            desktop: "gvc3qt25r"
                        },
                        defaultClass: "gvc3qt25p"
                    },
                    "25": {
                        conditions: {
                            mobile: "gvc3qt25s",
                            tablet: "gvc3qt25t",
                            desktop: "gvc3qt25u"
                        },
                        defaultClass: "gvc3qt25s"
                    },
                    "26": {
                        conditions: {
                            mobile: "gvc3qt25v",
                            tablet: "gvc3qt25w",
                            desktop: "gvc3qt25x"
                        },
                        defaultClass: "gvc3qt25v"
                    },
                    "27": {
                        conditions: {
                            mobile: "gvc3qt25y",
                            tablet: "gvc3qt25z",
                            desktop: "gvc3qt260"
                        },
                        defaultClass: "gvc3qt25y"
                    },
                    "28": {
                        conditions: {
                            mobile: "gvc3qt261",
                            tablet: "gvc3qt262",
                            desktop: "gvc3qt263"
                        },
                        defaultClass: "gvc3qt261"
                    },
                    "29": {
                        conditions: {
                            mobile: "gvc3qt264",
                            tablet: "gvc3qt265",
                            desktop: "gvc3qt266"
                        },
                        defaultClass: "gvc3qt264"
                    },
                    "30": {
                        conditions: {
                            mobile: "gvc3qt267",
                            tablet: "gvc3qt268",
                            desktop: "gvc3qt269"
                        },
                        defaultClass: "gvc3qt267"
                    },
                    auto: {
                        conditions: {
                            mobile: "gvc3qt26a",
                            tablet: "gvc3qt26b",
                            desktop: "gvc3qt26c"
                        },
                        defaultClass: "gvc3qt26a"
                    },
                    full: {
                        conditions: {
                            mobile: "gvc3qt26d",
                            tablet: "gvc3qt26e",
                            desktop: "gvc3qt26f"
                        },
                        defaultClass: "gvc3qt26d"
                    },
                    fit: {
                        conditions: {
                            mobile: "gvc3qt26g",
                            tablet: "gvc3qt26h",
                            desktop: "gvc3qt26i"
                        },
                        defaultClass: "gvc3qt26g"
                    },
                    max: {
                        conditions: {
                            mobile: "gvc3qt26j",
                            tablet: "gvc3qt26k",
                            desktop: "gvc3qt26l"
                        },
                        defaultClass: "gvc3qt26j"
                    },
                    min: {
                        conditions: {
                            mobile: "gvc3qt26m",
                            tablet: "gvc3qt26n",
                            desktop: "gvc3qt26o"
                        },
                        defaultClass: "gvc3qt26m"
                    },
                    viewHeight: {
                        conditions: {
                            mobile: "gvc3qt26p",
                            tablet: "gvc3qt26q",
                            desktop: "gvc3qt26r"
                        },
                        defaultClass: "gvc3qt26p"
                    },
                    viewWidth: {
                        conditions: {
                            mobile: "gvc3qt26s",
                            tablet: "gvc3qt26t",
                            desktop: "gvc3qt26u"
                        },
                        defaultClass: "gvc3qt26s"
                    },
                    none: {
                        conditions: {
                            mobile: "gvc3qt26v",
                            tablet: "gvc3qt26w",
                            desktop: "gvc3qt26x"
                        },
                        defaultClass: "gvc3qt26v"
                    },
                    "-px": {
                        conditions: {
                            mobile: "gvc3qt26y",
                            tablet: "gvc3qt26z",
                            desktop: "gvc3qt270"
                        },
                        defaultClass: "gvc3qt26y"
                    },
                    "-1": {
                        conditions: {
                            mobile: "gvc3qt271",
                            tablet: "gvc3qt272",
                            desktop: "gvc3qt273"
                        },
                        defaultClass: "gvc3qt271"
                    },
                    "-2": {
                        conditions: {
                            mobile: "gvc3qt274",
                            tablet: "gvc3qt275",
                            desktop: "gvc3qt276"
                        },
                        defaultClass: "gvc3qt274"
                    },
                    "-3": {
                        conditions: {
                            mobile: "gvc3qt277",
                            tablet: "gvc3qt278",
                            desktop: "gvc3qt279"
                        },
                        defaultClass: "gvc3qt277"
                    },
                    "-4": {
                        conditions: {
                            mobile: "gvc3qt27a",
                            tablet: "gvc3qt27b",
                            desktop: "gvc3qt27c"
                        },
                        defaultClass: "gvc3qt27a"
                    },
                    "-5": {
                        conditions: {
                            mobile: "gvc3qt27d",
                            tablet: "gvc3qt27e",
                            desktop: "gvc3qt27f"
                        },
                        defaultClass: "gvc3qt27d"
                    },
                    "-6": {
                        conditions: {
                            mobile: "gvc3qt27g",
                            tablet: "gvc3qt27h",
                            desktop: "gvc3qt27i"
                        },
                        defaultClass: "gvc3qt27g"
                    }
                },
                responsiveArray: undefined
            },
            marginLeft: {
                values: {
                    "0": {
                        conditions: {
                            mobile: "gvc3qt27j",
                            tablet: "gvc3qt27k",
                            desktop: "gvc3qt27l"
                        },
                        defaultClass: "gvc3qt27j"
                    },
                    "1": {
                        conditions: {
                            mobile: "gvc3qt27m",
                            tablet: "gvc3qt27n",
                            desktop: "gvc3qt27o"
                        },
                        defaultClass: "gvc3qt27m"
                    },
                    "2": {
                        conditions: {
                            mobile: "gvc3qt27p",
                            tablet: "gvc3qt27q",
                            desktop: "gvc3qt27r"
                        },
                        defaultClass: "gvc3qt27p"
                    },
                    "3": {
                        conditions: {
                            mobile: "gvc3qt27s",
                            tablet: "gvc3qt27t",
                            desktop: "gvc3qt27u"
                        },
                        defaultClass: "gvc3qt27s"
                    },
                    "4": {
                        conditions: {
                            mobile: "gvc3qt27v",
                            tablet: "gvc3qt27w",
                            desktop: "gvc3qt27x"
                        },
                        defaultClass: "gvc3qt27v"
                    },
                    "5": {
                        conditions: {
                            mobile: "gvc3qt27y",
                            tablet: "gvc3qt27z",
                            desktop: "gvc3qt280"
                        },
                        defaultClass: "gvc3qt27y"
                    },
                    "6": {
                        conditions: {
                            mobile: "gvc3qt281",
                            tablet: "gvc3qt282",
                            desktop: "gvc3qt283"
                        },
                        defaultClass: "gvc3qt281"
                    },
                    "7": {
                        conditions: {
                            mobile: "gvc3qt284",
                            tablet: "gvc3qt285",
                            desktop: "gvc3qt286"
                        },
                        defaultClass: "gvc3qt284"
                    },
                    "8": {
                        conditions: {
                            mobile: "gvc3qt287",
                            tablet: "gvc3qt288",
                            desktop: "gvc3qt289"
                        },
                        defaultClass: "gvc3qt287"
                    },
                    "9": {
                        conditions: {
                            mobile: "gvc3qt28a",
                            tablet: "gvc3qt28b",
                            desktop: "gvc3qt28c"
                        },
                        defaultClass: "gvc3qt28a"
                    },
                    "10": {
                        conditions: {
                            mobile: "gvc3qt28d",
                            tablet: "gvc3qt28e",
                            desktop: "gvc3qt28f"
                        },
                        defaultClass: "gvc3qt28d"
                    },
                    "11": {
                        conditions: {
                            mobile: "gvc3qt28g",
                            tablet: "gvc3qt28h",
                            desktop: "gvc3qt28i"
                        },
                        defaultClass: "gvc3qt28g"
                    },
                    "12": {
                        conditions: {
                            mobile: "gvc3qt28j",
                            tablet: "gvc3qt28k",
                            desktop: "gvc3qt28l"
                        },
                        defaultClass: "gvc3qt28j"
                    },
                    "13": {
                        conditions: {
                            mobile: "gvc3qt28m",
                            tablet: "gvc3qt28n",
                            desktop: "gvc3qt28o"
                        },
                        defaultClass: "gvc3qt28m"
                    },
                    "14": {
                        conditions: {
                            mobile: "gvc3qt28p",
                            tablet: "gvc3qt28q",
                            desktop: "gvc3qt28r"
                        },
                        defaultClass: "gvc3qt28p"
                    },
                    "15": {
                        conditions: {
                            mobile: "gvc3qt28s",
                            tablet: "gvc3qt28t",
                            desktop: "gvc3qt28u"
                        },
                        defaultClass: "gvc3qt28s"
                    },
                    "16": {
                        conditions: {
                            mobile: "gvc3qt28v",
                            tablet: "gvc3qt28w",
                            desktop: "gvc3qt28x"
                        },
                        defaultClass: "gvc3qt28v"
                    },
                    "17": {
                        conditions: {
                            mobile: "gvc3qt28y",
                            tablet: "gvc3qt28z",
                            desktop: "gvc3qt290"
                        },
                        defaultClass: "gvc3qt28y"
                    },
                    "18": {
                        conditions: {
                            mobile: "gvc3qt291",
                            tablet: "gvc3qt292",
                            desktop: "gvc3qt293"
                        },
                        defaultClass: "gvc3qt291"
                    },
                    "19": {
                        conditions: {
                            mobile: "gvc3qt294",
                            tablet: "gvc3qt295",
                            desktop: "gvc3qt296"
                        },
                        defaultClass: "gvc3qt294"
                    },
                    "20": {
                        conditions: {
                            mobile: "gvc3qt297",
                            tablet: "gvc3qt298",
                            desktop: "gvc3qt299"
                        },
                        defaultClass: "gvc3qt297"
                    },
                    "21": {
                        conditions: {
                            mobile: "gvc3qt29a",
                            tablet: "gvc3qt29b",
                            desktop: "gvc3qt29c"
                        },
                        defaultClass: "gvc3qt29a"
                    },
                    "22": {
                        conditions: {
                            mobile: "gvc3qt29d",
                            tablet: "gvc3qt29e",
                            desktop: "gvc3qt29f"
                        },
                        defaultClass: "gvc3qt29d"
                    },
                    "23": {
                        conditions: {
                            mobile: "gvc3qt29g",
                            tablet: "gvc3qt29h",
                            desktop: "gvc3qt29i"
                        },
                        defaultClass: "gvc3qt29g"
                    },
                    "24": {
                        conditions: {
                            mobile: "gvc3qt29j",
                            tablet: "gvc3qt29k",
                            desktop: "gvc3qt29l"
                        },
                        defaultClass: "gvc3qt29j"
                    },
                    "25": {
                        conditions: {
                            mobile: "gvc3qt29m",
                            tablet: "gvc3qt29n",
                            desktop: "gvc3qt29o"
                        },
                        defaultClass: "gvc3qt29m"
                    },
                    "26": {
                        conditions: {
                            mobile: "gvc3qt29p",
                            tablet: "gvc3qt29q",
                            desktop: "gvc3qt29r"
                        },
                        defaultClass: "gvc3qt29p"
                    },
                    "27": {
                        conditions: {
                            mobile: "gvc3qt29s",
                            tablet: "gvc3qt29t",
                            desktop: "gvc3qt29u"
                        },
                        defaultClass: "gvc3qt29s"
                    },
                    "28": {
                        conditions: {
                            mobile: "gvc3qt29v",
                            tablet: "gvc3qt29w",
                            desktop: "gvc3qt29x"
                        },
                        defaultClass: "gvc3qt29v"
                    },
                    "29": {
                        conditions: {
                            mobile: "gvc3qt29y",
                            tablet: "gvc3qt29z",
                            desktop: "gvc3qt2a0"
                        },
                        defaultClass: "gvc3qt29y"
                    },
                    "30": {
                        conditions: {
                            mobile: "gvc3qt2a1",
                            tablet: "gvc3qt2a2",
                            desktop: "gvc3qt2a3"
                        },
                        defaultClass: "gvc3qt2a1"
                    },
                    auto: {
                        conditions: {
                            mobile: "gvc3qt2a4",
                            tablet: "gvc3qt2a5",
                            desktop: "gvc3qt2a6"
                        },
                        defaultClass: "gvc3qt2a4"
                    },
                    full: {
                        conditions: {
                            mobile: "gvc3qt2a7",
                            tablet: "gvc3qt2a8",
                            desktop: "gvc3qt2a9"
                        },
                        defaultClass: "gvc3qt2a7"
                    },
                    fit: {
                        conditions: {
                            mobile: "gvc3qt2aa",
                            tablet: "gvc3qt2ab",
                            desktop: "gvc3qt2ac"
                        },
                        defaultClass: "gvc3qt2aa"
                    },
                    max: {
                        conditions: {
                            mobile: "gvc3qt2ad",
                            tablet: "gvc3qt2ae",
                            desktop: "gvc3qt2af"
                        },
                        defaultClass: "gvc3qt2ad"
                    },
                    min: {
                        conditions: {
                            mobile: "gvc3qt2ag",
                            tablet: "gvc3qt2ah",
                            desktop: "gvc3qt2ai"
                        },
                        defaultClass: "gvc3qt2ag"
                    },
                    viewHeight: {
                        conditions: {
                            mobile: "gvc3qt2aj",
                            tablet: "gvc3qt2ak",
                            desktop: "gvc3qt2al"
                        },
                        defaultClass: "gvc3qt2aj"
                    },
                    viewWidth: {
                        conditions: {
                            mobile: "gvc3qt2am",
                            tablet: "gvc3qt2an",
                            desktop: "gvc3qt2ao"
                        },
                        defaultClass: "gvc3qt2am"
                    },
                    none: {
                        conditions: {
                            mobile: "gvc3qt2ap",
                            tablet: "gvc3qt2aq",
                            desktop: "gvc3qt2ar"
                        },
                        defaultClass: "gvc3qt2ap"
                    },
                    "-px": {
                        conditions: {
                            mobile: "gvc3qt2as",
                            tablet: "gvc3qt2at",
                            desktop: "gvc3qt2au"
                        },
                        defaultClass: "gvc3qt2as"
                    },
                    "-1": {
                        conditions: {
                            mobile: "gvc3qt2av",
                            tablet: "gvc3qt2aw",
                            desktop: "gvc3qt2ax"
                        },
                        defaultClass: "gvc3qt2av"
                    },
                    "-2": {
                        conditions: {
                            mobile: "gvc3qt2ay",
                            tablet: "gvc3qt2az",
                            desktop: "gvc3qt2b0"
                        },
                        defaultClass: "gvc3qt2ay"
                    },
                    "-3": {
                        conditions: {
                            mobile: "gvc3qt2b1",
                            tablet: "gvc3qt2b2",
                            desktop: "gvc3qt2b3"
                        },
                        defaultClass: "gvc3qt2b1"
                    },
                    "-4": {
                        conditions: {
                            mobile: "gvc3qt2b4",
                            tablet: "gvc3qt2b5",
                            desktop: "gvc3qt2b6"
                        },
                        defaultClass: "gvc3qt2b4"
                    },
                    "-5": {
                        conditions: {
                            mobile: "gvc3qt2b7",
                            tablet: "gvc3qt2b8",
                            desktop: "gvc3qt2b9"
                        },
                        defaultClass: "gvc3qt2b7"
                    },
                    "-6": {
                        conditions: {
                            mobile: "gvc3qt2ba",
                            tablet: "gvc3qt2bb",
                            desktop: "gvc3qt2bc"
                        },
                        defaultClass: "gvc3qt2ba"
                    }
                },
                responsiveArray: undefined
            },
            marginRight: {
                values: {
                    "0": {
                        conditions: {
                            mobile: "gvc3qt2bd",
                            tablet: "gvc3qt2be",
                            desktop: "gvc3qt2bf"
                        },
                        defaultClass: "gvc3qt2bd"
                    },
                    "1": {
                        conditions: {
                            mobile: "gvc3qt2bg",
                            tablet: "gvc3qt2bh",
                            desktop: "gvc3qt2bi"
                        },
                        defaultClass: "gvc3qt2bg"
                    },
                    "2": {
                        conditions: {
                            mobile: "gvc3qt2bj",
                            tablet: "gvc3qt2bk",
                            desktop: "gvc3qt2bl"
                        },
                        defaultClass: "gvc3qt2bj"
                    },
                    "3": {
                        conditions: {
                            mobile: "gvc3qt2bm",
                            tablet: "gvc3qt2bn",
                            desktop: "gvc3qt2bo"
                        },
                        defaultClass: "gvc3qt2bm"
                    },
                    "4": {
                        conditions: {
                            mobile: "gvc3qt2bp",
                            tablet: "gvc3qt2bq",
                            desktop: "gvc3qt2br"
                        },
                        defaultClass: "gvc3qt2bp"
                    },
                    "5": {
                        conditions: {
                            mobile: "gvc3qt2bs",
                            tablet: "gvc3qt2bt",
                            desktop: "gvc3qt2bu"
                        },
                        defaultClass: "gvc3qt2bs"
                    },
                    "6": {
                        conditions: {
                            mobile: "gvc3qt2bv",
                            tablet: "gvc3qt2bw",
                            desktop: "gvc3qt2bx"
                        },
                        defaultClass: "gvc3qt2bv"
                    },
                    "7": {
                        conditions: {
                            mobile: "gvc3qt2by",
                            tablet: "gvc3qt2bz",
                            desktop: "gvc3qt2c0"
                        },
                        defaultClass: "gvc3qt2by"
                    },
                    "8": {
                        conditions: {
                            mobile: "gvc3qt2c1",
                            tablet: "gvc3qt2c2",
                            desktop: "gvc3qt2c3"
                        },
                        defaultClass: "gvc3qt2c1"
                    },
                    "9": {
                        conditions: {
                            mobile: "gvc3qt2c4",
                            tablet: "gvc3qt2c5",
                            desktop: "gvc3qt2c6"
                        },
                        defaultClass: "gvc3qt2c4"
                    },
                    "10": {
                        conditions: {
                            mobile: "gvc3qt2c7",
                            tablet: "gvc3qt2c8",
                            desktop: "gvc3qt2c9"
                        },
                        defaultClass: "gvc3qt2c7"
                    },
                    "11": {
                        conditions: {
                            mobile: "gvc3qt2ca",
                            tablet: "gvc3qt2cb",
                            desktop: "gvc3qt2cc"
                        },
                        defaultClass: "gvc3qt2ca"
                    },
                    "12": {
                        conditions: {
                            mobile: "gvc3qt2cd",
                            tablet: "gvc3qt2ce",
                            desktop: "gvc3qt2cf"
                        },
                        defaultClass: "gvc3qt2cd"
                    },
                    "13": {
                        conditions: {
                            mobile: "gvc3qt2cg",
                            tablet: "gvc3qt2ch",
                            desktop: "gvc3qt2ci"
                        },
                        defaultClass: "gvc3qt2cg"
                    },
                    "14": {
                        conditions: {
                            mobile: "gvc3qt2cj",
                            tablet: "gvc3qt2ck",
                            desktop: "gvc3qt2cl"
                        },
                        defaultClass: "gvc3qt2cj"
                    },
                    "15": {
                        conditions: {
                            mobile: "gvc3qt2cm",
                            tablet: "gvc3qt2cn",
                            desktop: "gvc3qt2co"
                        },
                        defaultClass: "gvc3qt2cm"
                    },
                    "16": {
                        conditions: {
                            mobile: "gvc3qt2cp",
                            tablet: "gvc3qt2cq",
                            desktop: "gvc3qt2cr"
                        },
                        defaultClass: "gvc3qt2cp"
                    },
                    "17": {
                        conditions: {
                            mobile: "gvc3qt2cs",
                            tablet: "gvc3qt2ct",
                            desktop: "gvc3qt2cu"
                        },
                        defaultClass: "gvc3qt2cs"
                    },
                    "18": {
                        conditions: {
                            mobile: "gvc3qt2cv",
                            tablet: "gvc3qt2cw",
                            desktop: "gvc3qt2cx"
                        },
                        defaultClass: "gvc3qt2cv"
                    },
                    "19": {
                        conditions: {
                            mobile: "gvc3qt2cy",
                            tablet: "gvc3qt2cz",
                            desktop: "gvc3qt2d0"
                        },
                        defaultClass: "gvc3qt2cy"
                    },
                    "20": {
                        conditions: {
                            mobile: "gvc3qt2d1",
                            tablet: "gvc3qt2d2",
                            desktop: "gvc3qt2d3"
                        },
                        defaultClass: "gvc3qt2d1"
                    },
                    "21": {
                        conditions: {
                            mobile: "gvc3qt2d4",
                            tablet: "gvc3qt2d5",
                            desktop: "gvc3qt2d6"
                        },
                        defaultClass: "gvc3qt2d4"
                    },
                    "22": {
                        conditions: {
                            mobile: "gvc3qt2d7",
                            tablet: "gvc3qt2d8",
                            desktop: "gvc3qt2d9"
                        },
                        defaultClass: "gvc3qt2d7"
                    },
                    "23": {
                        conditions: {
                            mobile: "gvc3qt2da",
                            tablet: "gvc3qt2db",
                            desktop: "gvc3qt2dc"
                        },
                        defaultClass: "gvc3qt2da"
                    },
                    "24": {
                        conditions: {
                            mobile: "gvc3qt2dd",
                            tablet: "gvc3qt2de",
                            desktop: "gvc3qt2df"
                        },
                        defaultClass: "gvc3qt2dd"
                    },
                    "25": {
                        conditions: {
                            mobile: "gvc3qt2dg",
                            tablet: "gvc3qt2dh",
                            desktop: "gvc3qt2di"
                        },
                        defaultClass: "gvc3qt2dg"
                    },
                    "26": {
                        conditions: {
                            mobile: "gvc3qt2dj",
                            tablet: "gvc3qt2dk",
                            desktop: "gvc3qt2dl"
                        },
                        defaultClass: "gvc3qt2dj"
                    },
                    "27": {
                        conditions: {
                            mobile: "gvc3qt2dm",
                            tablet: "gvc3qt2dn",
                            desktop: "gvc3qt2do"
                        },
                        defaultClass: "gvc3qt2dm"
                    },
                    "28": {
                        conditions: {
                            mobile: "gvc3qt2dp",
                            tablet: "gvc3qt2dq",
                            desktop: "gvc3qt2dr"
                        },
                        defaultClass: "gvc3qt2dp"
                    },
                    "29": {
                        conditions: {
                            mobile: "gvc3qt2ds",
                            tablet: "gvc3qt2dt",
                            desktop: "gvc3qt2du"
                        },
                        defaultClass: "gvc3qt2ds"
                    },
                    "30": {
                        conditions: {
                            mobile: "gvc3qt2dv",
                            tablet: "gvc3qt2dw",
                            desktop: "gvc3qt2dx"
                        },
                        defaultClass: "gvc3qt2dv"
                    },
                    auto: {
                        conditions: {
                            mobile: "gvc3qt2dy",
                            tablet: "gvc3qt2dz",
                            desktop: "gvc3qt2e0"
                        },
                        defaultClass: "gvc3qt2dy"
                    },
                    full: {
                        conditions: {
                            mobile: "gvc3qt2e1",
                            tablet: "gvc3qt2e2",
                            desktop: "gvc3qt2e3"
                        },
                        defaultClass: "gvc3qt2e1"
                    },
                    fit: {
                        conditions: {
                            mobile: "gvc3qt2e4",
                            tablet: "gvc3qt2e5",
                            desktop: "gvc3qt2e6"
                        },
                        defaultClass: "gvc3qt2e4"
                    },
                    max: {
                        conditions: {
                            mobile: "gvc3qt2e7",
                            tablet: "gvc3qt2e8",
                            desktop: "gvc3qt2e9"
                        },
                        defaultClass: "gvc3qt2e7"
                    },
                    min: {
                        conditions: {
                            mobile: "gvc3qt2ea",
                            tablet: "gvc3qt2eb",
                            desktop: "gvc3qt2ec"
                        },
                        defaultClass: "gvc3qt2ea"
                    },
                    viewHeight: {
                        conditions: {
                            mobile: "gvc3qt2ed",
                            tablet: "gvc3qt2ee",
                            desktop: "gvc3qt2ef"
                        },
                        defaultClass: "gvc3qt2ed"
                    },
                    viewWidth: {
                        conditions: {
                            mobile: "gvc3qt2eg",
                            tablet: "gvc3qt2eh",
                            desktop: "gvc3qt2ei"
                        },
                        defaultClass: "gvc3qt2eg"
                    },
                    none: {
                        conditions: {
                            mobile: "gvc3qt2ej",
                            tablet: "gvc3qt2ek",
                            desktop: "gvc3qt2el"
                        },
                        defaultClass: "gvc3qt2ej"
                    },
                    "-px": {
                        conditions: {
                            mobile: "gvc3qt2em",
                            tablet: "gvc3qt2en",
                            desktop: "gvc3qt2eo"
                        },
                        defaultClass: "gvc3qt2em"
                    },
                    "-1": {
                        conditions: {
                            mobile: "gvc3qt2ep",
                            tablet: "gvc3qt2eq",
                            desktop: "gvc3qt2er"
                        },
                        defaultClass: "gvc3qt2ep"
                    },
                    "-2": {
                        conditions: {
                            mobile: "gvc3qt2es",
                            tablet: "gvc3qt2et",
                            desktop: "gvc3qt2eu"
                        },
                        defaultClass: "gvc3qt2es"
                    },
                    "-3": {
                        conditions: {
                            mobile: "gvc3qt2ev",
                            tablet: "gvc3qt2ew",
                            desktop: "gvc3qt2ex"
                        },
                        defaultClass: "gvc3qt2ev"
                    },
                    "-4": {
                        conditions: {
                            mobile: "gvc3qt2ey",
                            tablet: "gvc3qt2ez",
                            desktop: "gvc3qt2f0"
                        },
                        defaultClass: "gvc3qt2ey"
                    },
                    "-5": {
                        conditions: {
                            mobile: "gvc3qt2f1",
                            tablet: "gvc3qt2f2",
                            desktop: "gvc3qt2f3"
                        },
                        defaultClass: "gvc3qt2f1"
                    },
                    "-6": {
                        conditions: {
                            mobile: "gvc3qt2f4",
                            tablet: "gvc3qt2f5",
                            desktop: "gvc3qt2f6"
                        },
                        defaultClass: "gvc3qt2f4"
                    }
                },
                responsiveArray: undefined
            },
            marginTop: {
                values: {
                    "0": {
                        conditions: {
                            mobile: "gvc3qt2f7",
                            tablet: "gvc3qt2f8",
                            desktop: "gvc3qt2f9"
                        },
                        defaultClass: "gvc3qt2f7"
                    },
                    "1": {
                        conditions: {
                            mobile: "gvc3qt2fa",
                            tablet: "gvc3qt2fb",
                            desktop: "gvc3qt2fc"
                        },
                        defaultClass: "gvc3qt2fa"
                    },
                    "2": {
                        conditions: {
                            mobile: "gvc3qt2fd",
                            tablet: "gvc3qt2fe",
                            desktop: "gvc3qt2ff"
                        },
                        defaultClass: "gvc3qt2fd"
                    },
                    "3": {
                        conditions: {
                            mobile: "gvc3qt2fg",
                            tablet: "gvc3qt2fh",
                            desktop: "gvc3qt2fi"
                        },
                        defaultClass: "gvc3qt2fg"
                    },
                    "4": {
                        conditions: {
                            mobile: "gvc3qt2fj",
                            tablet: "gvc3qt2fk",
                            desktop: "gvc3qt2fl"
                        },
                        defaultClass: "gvc3qt2fj"
                    },
                    "5": {
                        conditions: {
                            mobile: "gvc3qt2fm",
                            tablet: "gvc3qt2fn",
                            desktop: "gvc3qt2fo"
                        },
                        defaultClass: "gvc3qt2fm"
                    },
                    "6": {
                        conditions: {
                            mobile: "gvc3qt2fp",
                            tablet: "gvc3qt2fq",
                            desktop: "gvc3qt2fr"
                        },
                        defaultClass: "gvc3qt2fp"
                    },
                    "7": {
                        conditions: {
                            mobile: "gvc3qt2fs",
                            tablet: "gvc3qt2ft",
                            desktop: "gvc3qt2fu"
                        },
                        defaultClass: "gvc3qt2fs"
                    },
                    "8": {
                        conditions: {
                            mobile: "gvc3qt2fv",
                            tablet: "gvc3qt2fw",
                            desktop: "gvc3qt2fx"
                        },
                        defaultClass: "gvc3qt2fv"
                    },
                    "9": {
                        conditions: {
                            mobile: "gvc3qt2fy",
                            tablet: "gvc3qt2fz",
                            desktop: "gvc3qt2g0"
                        },
                        defaultClass: "gvc3qt2fy"
                    },
                    "10": {
                        conditions: {
                            mobile: "gvc3qt2g1",
                            tablet: "gvc3qt2g2",
                            desktop: "gvc3qt2g3"
                        },
                        defaultClass: "gvc3qt2g1"
                    },
                    "11": {
                        conditions: {
                            mobile: "gvc3qt2g4",
                            tablet: "gvc3qt2g5",
                            desktop: "gvc3qt2g6"
                        },
                        defaultClass: "gvc3qt2g4"
                    },
                    "12": {
                        conditions: {
                            mobile: "gvc3qt2g7",
                            tablet: "gvc3qt2g8",
                            desktop: "gvc3qt2g9"
                        },
                        defaultClass: "gvc3qt2g7"
                    },
                    "13": {
                        conditions: {
                            mobile: "gvc3qt2ga",
                            tablet: "gvc3qt2gb",
                            desktop: "gvc3qt2gc"
                        },
                        defaultClass: "gvc3qt2ga"
                    },
                    "14": {
                        conditions: {
                            mobile: "gvc3qt2gd",
                            tablet: "gvc3qt2ge",
                            desktop: "gvc3qt2gf"
                        },
                        defaultClass: "gvc3qt2gd"
                    },
                    "15": {
                        conditions: {
                            mobile: "gvc3qt2gg",
                            tablet: "gvc3qt2gh",
                            desktop: "gvc3qt2gi"
                        },
                        defaultClass: "gvc3qt2gg"
                    },
                    "16": {
                        conditions: {
                            mobile: "gvc3qt2gj",
                            tablet: "gvc3qt2gk",
                            desktop: "gvc3qt2gl"
                        },
                        defaultClass: "gvc3qt2gj"
                    },
                    "17": {
                        conditions: {
                            mobile: "gvc3qt2gm",
                            tablet: "gvc3qt2gn",
                            desktop: "gvc3qt2go"
                        },
                        defaultClass: "gvc3qt2gm"
                    },
                    "18": {
                        conditions: {
                            mobile: "gvc3qt2gp",
                            tablet: "gvc3qt2gq",
                            desktop: "gvc3qt2gr"
                        },
                        defaultClass: "gvc3qt2gp"
                    },
                    "19": {
                        conditions: {
                            mobile: "gvc3qt2gs",
                            tablet: "gvc3qt2gt",
                            desktop: "gvc3qt2gu"
                        },
                        defaultClass: "gvc3qt2gs"
                    },
                    "20": {
                        conditions: {
                            mobile: "gvc3qt2gv",
                            tablet: "gvc3qt2gw",
                            desktop: "gvc3qt2gx"
                        },
                        defaultClass: "gvc3qt2gv"
                    },
                    "21": {
                        conditions: {
                            mobile: "gvc3qt2gy",
                            tablet: "gvc3qt2gz",
                            desktop: "gvc3qt2h0"
                        },
                        defaultClass: "gvc3qt2gy"
                    },
                    "22": {
                        conditions: {
                            mobile: "gvc3qt2h1",
                            tablet: "gvc3qt2h2",
                            desktop: "gvc3qt2h3"
                        },
                        defaultClass: "gvc3qt2h1"
                    },
                    "23": {
                        conditions: {
                            mobile: "gvc3qt2h4",
                            tablet: "gvc3qt2h5",
                            desktop: "gvc3qt2h6"
                        },
                        defaultClass: "gvc3qt2h4"
                    },
                    "24": {
                        conditions: {
                            mobile: "gvc3qt2h7",
                            tablet: "gvc3qt2h8",
                            desktop: "gvc3qt2h9"
                        },
                        defaultClass: "gvc3qt2h7"
                    },
                    "25": {
                        conditions: {
                            mobile: "gvc3qt2ha",
                            tablet: "gvc3qt2hb",
                            desktop: "gvc3qt2hc"
                        },
                        defaultClass: "gvc3qt2ha"
                    },
                    "26": {
                        conditions: {
                            mobile: "gvc3qt2hd",
                            tablet: "gvc3qt2he",
                            desktop: "gvc3qt2hf"
                        },
                        defaultClass: "gvc3qt2hd"
                    },
                    "27": {
                        conditions: {
                            mobile: "gvc3qt2hg",
                            tablet: "gvc3qt2hh",
                            desktop: "gvc3qt2hi"
                        },
                        defaultClass: "gvc3qt2hg"
                    },
                    "28": {
                        conditions: {
                            mobile: "gvc3qt2hj",
                            tablet: "gvc3qt2hk",
                            desktop: "gvc3qt2hl"
                        },
                        defaultClass: "gvc3qt2hj"
                    },
                    "29": {
                        conditions: {
                            mobile: "gvc3qt2hm",
                            tablet: "gvc3qt2hn",
                            desktop: "gvc3qt2ho"
                        },
                        defaultClass: "gvc3qt2hm"
                    },
                    "30": {
                        conditions: {
                            mobile: "gvc3qt2hp",
                            tablet: "gvc3qt2hq",
                            desktop: "gvc3qt2hr"
                        },
                        defaultClass: "gvc3qt2hp"
                    },
                    auto: {
                        conditions: {
                            mobile: "gvc3qt2hs",
                            tablet: "gvc3qt2ht",
                            desktop: "gvc3qt2hu"
                        },
                        defaultClass: "gvc3qt2hs"
                    },
                    full: {
                        conditions: {
                            mobile: "gvc3qt2hv",
                            tablet: "gvc3qt2hw",
                            desktop: "gvc3qt2hx"
                        },
                        defaultClass: "gvc3qt2hv"
                    },
                    fit: {
                        conditions: {
                            mobile: "gvc3qt2hy",
                            tablet: "gvc3qt2hz",
                            desktop: "gvc3qt2i0"
                        },
                        defaultClass: "gvc3qt2hy"
                    },
                    max: {
                        conditions: {
                            mobile: "gvc3qt2i1",
                            tablet: "gvc3qt2i2",
                            desktop: "gvc3qt2i3"
                        },
                        defaultClass: "gvc3qt2i1"
                    },
                    min: {
                        conditions: {
                            mobile: "gvc3qt2i4",
                            tablet: "gvc3qt2i5",
                            desktop: "gvc3qt2i6"
                        },
                        defaultClass: "gvc3qt2i4"
                    },
                    viewHeight: {
                        conditions: {
                            mobile: "gvc3qt2i7",
                            tablet: "gvc3qt2i8",
                            desktop: "gvc3qt2i9"
                        },
                        defaultClass: "gvc3qt2i7"
                    },
                    viewWidth: {
                        conditions: {
                            mobile: "gvc3qt2ia",
                            tablet: "gvc3qt2ib",
                            desktop: "gvc3qt2ic"
                        },
                        defaultClass: "gvc3qt2ia"
                    },
                    none: {
                        conditions: {
                            mobile: "gvc3qt2id",
                            tablet: "gvc3qt2ie",
                            desktop: "gvc3qt2if"
                        },
                        defaultClass: "gvc3qt2id"
                    },
                    "-px": {
                        conditions: {
                            mobile: "gvc3qt2ig",
                            tablet: "gvc3qt2ih",
                            desktop: "gvc3qt2ii"
                        },
                        defaultClass: "gvc3qt2ig"
                    },
                    "-1": {
                        conditions: {
                            mobile: "gvc3qt2ij",
                            tablet: "gvc3qt2ik",
                            desktop: "gvc3qt2il"
                        },
                        defaultClass: "gvc3qt2ij"
                    },
                    "-2": {
                        conditions: {
                            mobile: "gvc3qt2im",
                            tablet: "gvc3qt2in",
                            desktop: "gvc3qt2io"
                        },
                        defaultClass: "gvc3qt2im"
                    },
                    "-3": {
                        conditions: {
                            mobile: "gvc3qt2ip",
                            tablet: "gvc3qt2iq",
                            desktop: "gvc3qt2ir"
                        },
                        defaultClass: "gvc3qt2ip"
                    },
                    "-4": {
                        conditions: {
                            mobile: "gvc3qt2is",
                            tablet: "gvc3qt2it",
                            desktop: "gvc3qt2iu"
                        },
                        defaultClass: "gvc3qt2is"
                    },
                    "-5": {
                        conditions: {
                            mobile: "gvc3qt2iv",
                            tablet: "gvc3qt2iw",
                            desktop: "gvc3qt2ix"
                        },
                        defaultClass: "gvc3qt2iv"
                    },
                    "-6": {
                        conditions: {
                            mobile: "gvc3qt2iy",
                            tablet: "gvc3qt2iz",
                            desktop: "gvc3qt2j0"
                        },
                        defaultClass: "gvc3qt2iy"
                    }
                },
                responsiveArray: undefined
            },
            maxHeight: {
                values: {
                    "0": {
                        conditions: {
                            mobile: "gvc3qt2j1",
                            tablet: "gvc3qt2j2",
                            desktop: "gvc3qt2j3"
                        },
                        defaultClass: "gvc3qt2j1"
                    },
                    "1": {
                        conditions: {
                            mobile: "gvc3qt2j4",
                            tablet: "gvc3qt2j5",
                            desktop: "gvc3qt2j6"
                        },
                        defaultClass: "gvc3qt2j4"
                    },
                    "2": {
                        conditions: {
                            mobile: "gvc3qt2j7",
                            tablet: "gvc3qt2j8",
                            desktop: "gvc3qt2j9"
                        },
                        defaultClass: "gvc3qt2j7"
                    },
                    "3": {
                        conditions: {
                            mobile: "gvc3qt2ja",
                            tablet: "gvc3qt2jb",
                            desktop: "gvc3qt2jc"
                        },
                        defaultClass: "gvc3qt2ja"
                    },
                    "4": {
                        conditions: {
                            mobile: "gvc3qt2jd",
                            tablet: "gvc3qt2je",
                            desktop: "gvc3qt2jf"
                        },
                        defaultClass: "gvc3qt2jd"
                    },
                    "5": {
                        conditions: {
                            mobile: "gvc3qt2jg",
                            tablet: "gvc3qt2jh",
                            desktop: "gvc3qt2ji"
                        },
                        defaultClass: "gvc3qt2jg"
                    },
                    "6": {
                        conditions: {
                            mobile: "gvc3qt2jj",
                            tablet: "gvc3qt2jk",
                            desktop: "gvc3qt2jl"
                        },
                        defaultClass: "gvc3qt2jj"
                    },
                    "7": {
                        conditions: {
                            mobile: "gvc3qt2jm",
                            tablet: "gvc3qt2jn",
                            desktop: "gvc3qt2jo"
                        },
                        defaultClass: "gvc3qt2jm"
                    },
                    "8": {
                        conditions: {
                            mobile: "gvc3qt2jp",
                            tablet: "gvc3qt2jq",
                            desktop: "gvc3qt2jr"
                        },
                        defaultClass: "gvc3qt2jp"
                    },
                    "9": {
                        conditions: {
                            mobile: "gvc3qt2js",
                            tablet: "gvc3qt2jt",
                            desktop: "gvc3qt2ju"
                        },
                        defaultClass: "gvc3qt2js"
                    },
                    "10": {
                        conditions: {
                            mobile: "gvc3qt2jv",
                            tablet: "gvc3qt2jw",
                            desktop: "gvc3qt2jx"
                        },
                        defaultClass: "gvc3qt2jv"
                    },
                    "11": {
                        conditions: {
                            mobile: "gvc3qt2jy",
                            tablet: "gvc3qt2jz",
                            desktop: "gvc3qt2k0"
                        },
                        defaultClass: "gvc3qt2jy"
                    },
                    "12": {
                        conditions: {
                            mobile: "gvc3qt2k1",
                            tablet: "gvc3qt2k2",
                            desktop: "gvc3qt2k3"
                        },
                        defaultClass: "gvc3qt2k1"
                    },
                    "13": {
                        conditions: {
                            mobile: "gvc3qt2k4",
                            tablet: "gvc3qt2k5",
                            desktop: "gvc3qt2k6"
                        },
                        defaultClass: "gvc3qt2k4"
                    },
                    "14": {
                        conditions: {
                            mobile: "gvc3qt2k7",
                            tablet: "gvc3qt2k8",
                            desktop: "gvc3qt2k9"
                        },
                        defaultClass: "gvc3qt2k7"
                    },
                    "15": {
                        conditions: {
                            mobile: "gvc3qt2ka",
                            tablet: "gvc3qt2kb",
                            desktop: "gvc3qt2kc"
                        },
                        defaultClass: "gvc3qt2ka"
                    },
                    "16": {
                        conditions: {
                            mobile: "gvc3qt2kd",
                            tablet: "gvc3qt2ke",
                            desktop: "gvc3qt2kf"
                        },
                        defaultClass: "gvc3qt2kd"
                    },
                    "17": {
                        conditions: {
                            mobile: "gvc3qt2kg",
                            tablet: "gvc3qt2kh",
                            desktop: "gvc3qt2ki"
                        },
                        defaultClass: "gvc3qt2kg"
                    },
                    "18": {
                        conditions: {
                            mobile: "gvc3qt2kj",
                            tablet: "gvc3qt2kk",
                            desktop: "gvc3qt2kl"
                        },
                        defaultClass: "gvc3qt2kj"
                    },
                    "19": {
                        conditions: {
                            mobile: "gvc3qt2km",
                            tablet: "gvc3qt2kn",
                            desktop: "gvc3qt2ko"
                        },
                        defaultClass: "gvc3qt2km"
                    },
                    "20": {
                        conditions: {
                            mobile: "gvc3qt2kp",
                            tablet: "gvc3qt2kq",
                            desktop: "gvc3qt2kr"
                        },
                        defaultClass: "gvc3qt2kp"
                    },
                    "21": {
                        conditions: {
                            mobile: "gvc3qt2ks",
                            tablet: "gvc3qt2kt",
                            desktop: "gvc3qt2ku"
                        },
                        defaultClass: "gvc3qt2ks"
                    },
                    "22": {
                        conditions: {
                            mobile: "gvc3qt2kv",
                            tablet: "gvc3qt2kw",
                            desktop: "gvc3qt2kx"
                        },
                        defaultClass: "gvc3qt2kv"
                    },
                    "23": {
                        conditions: {
                            mobile: "gvc3qt2ky",
                            tablet: "gvc3qt2kz",
                            desktop: "gvc3qt2l0"
                        },
                        defaultClass: "gvc3qt2ky"
                    },
                    "24": {
                        conditions: {
                            mobile: "gvc3qt2l1",
                            tablet: "gvc3qt2l2",
                            desktop: "gvc3qt2l3"
                        },
                        defaultClass: "gvc3qt2l1"
                    },
                    "25": {
                        conditions: {
                            mobile: "gvc3qt2l4",
                            tablet: "gvc3qt2l5",
                            desktop: "gvc3qt2l6"
                        },
                        defaultClass: "gvc3qt2l4"
                    },
                    "26": {
                        conditions: {
                            mobile: "gvc3qt2l7",
                            tablet: "gvc3qt2l8",
                            desktop: "gvc3qt2l9"
                        },
                        defaultClass: "gvc3qt2l7"
                    },
                    "27": {
                        conditions: {
                            mobile: "gvc3qt2la",
                            tablet: "gvc3qt2lb",
                            desktop: "gvc3qt2lc"
                        },
                        defaultClass: "gvc3qt2la"
                    },
                    "28": {
                        conditions: {
                            mobile: "gvc3qt2ld",
                            tablet: "gvc3qt2le",
                            desktop: "gvc3qt2lf"
                        },
                        defaultClass: "gvc3qt2ld"
                    },
                    "29": {
                        conditions: {
                            mobile: "gvc3qt2lg",
                            tablet: "gvc3qt2lh",
                            desktop: "gvc3qt2li"
                        },
                        defaultClass: "gvc3qt2lg"
                    },
                    "30": {
                        conditions: {
                            mobile: "gvc3qt2lj",
                            tablet: "gvc3qt2lk",
                            desktop: "gvc3qt2ll"
                        },
                        defaultClass: "gvc3qt2lj"
                    },
                    auto: {
                        conditions: {
                            mobile: "gvc3qt2lm",
                            tablet: "gvc3qt2ln",
                            desktop: "gvc3qt2lo"
                        },
                        defaultClass: "gvc3qt2lm"
                    },
                    full: {
                        conditions: {
                            mobile: "gvc3qt2lp",
                            tablet: "gvc3qt2lq",
                            desktop: "gvc3qt2lr"
                        },
                        defaultClass: "gvc3qt2lp"
                    },
                    fit: {
                        conditions: {
                            mobile: "gvc3qt2ls",
                            tablet: "gvc3qt2lt",
                            desktop: "gvc3qt2lu"
                        },
                        defaultClass: "gvc3qt2ls"
                    },
                    max: {
                        conditions: {
                            mobile: "gvc3qt2lv",
                            tablet: "gvc3qt2lw",
                            desktop: "gvc3qt2lx"
                        },
                        defaultClass: "gvc3qt2lv"
                    },
                    min: {
                        conditions: {
                            mobile: "gvc3qt2ly",
                            tablet: "gvc3qt2lz",
                            desktop: "gvc3qt2m0"
                        },
                        defaultClass: "gvc3qt2ly"
                    },
                    viewHeight: {
                        conditions: {
                            mobile: "gvc3qt2m1",
                            tablet: "gvc3qt2m2",
                            desktop: "gvc3qt2m3"
                        },
                        defaultClass: "gvc3qt2m1"
                    },
                    viewWidth: {
                        conditions: {
                            mobile: "gvc3qt2m4",
                            tablet: "gvc3qt2m5",
                            desktop: "gvc3qt2m6"
                        },
                        defaultClass: "gvc3qt2m4"
                    },
                    none: {
                        conditions: {
                            mobile: "gvc3qt2m7",
                            tablet: "gvc3qt2m8",
                            desktop: "gvc3qt2m9"
                        },
                        defaultClass: "gvc3qt2m7"
                    },
                    "1/5": {
                        conditions: {
                            mobile: "gvc3qt2ma",
                            tablet: "gvc3qt2mb",
                            desktop: "gvc3qt2mc"
                        },
                        defaultClass: "gvc3qt2ma"
                    },
                    "1/4": {
                        conditions: {
                            mobile: "gvc3qt2md",
                            tablet: "gvc3qt2me",
                            desktop: "gvc3qt2mf"
                        },
                        defaultClass: "gvc3qt2md"
                    },
                    "1/3": {
                        conditions: {
                            mobile: "gvc3qt2mg",
                            tablet: "gvc3qt2mh",
                            desktop: "gvc3qt2mi"
                        },
                        defaultClass: "gvc3qt2mg"
                    },
                    "1/2": {
                        conditions: {
                            mobile: "gvc3qt2mj",
                            tablet: "gvc3qt2mk",
                            desktop: "gvc3qt2ml"
                        },
                        defaultClass: "gvc3qt2mj"
                    },
                    "2/3": {
                        conditions: {
                            mobile: "gvc3qt2mm",
                            tablet: "gvc3qt2mn",
                            desktop: "gvc3qt2mo"
                        },
                        defaultClass: "gvc3qt2mm"
                    },
                    "3/4": {
                        conditions: {
                            mobile: "gvc3qt2mp",
                            tablet: "gvc3qt2mq",
                            desktop: "gvc3qt2mr"
                        },
                        defaultClass: "gvc3qt2mp"
                    }
                },
                responsiveArray: undefined
            },
            maxWidth: {
                values: {
                    "0": {
                        conditions: {
                            mobile: "gvc3qt2ms",
                            tablet: "gvc3qt2mt",
                            desktop: "gvc3qt2mu"
                        },
                        defaultClass: "gvc3qt2ms"
                    },
                    "1": {
                        conditions: {
                            mobile: "gvc3qt2mv",
                            tablet: "gvc3qt2mw",
                            desktop: "gvc3qt2mx"
                        },
                        defaultClass: "gvc3qt2mv"
                    },
                    "2": {
                        conditions: {
                            mobile: "gvc3qt2my",
                            tablet: "gvc3qt2mz",
                            desktop: "gvc3qt2n0"
                        },
                        defaultClass: "gvc3qt2my"
                    },
                    "3": {
                        conditions: {
                            mobile: "gvc3qt2n1",
                            tablet: "gvc3qt2n2",
                            desktop: "gvc3qt2n3"
                        },
                        defaultClass: "gvc3qt2n1"
                    },
                    "4": {
                        conditions: {
                            mobile: "gvc3qt2n4",
                            tablet: "gvc3qt2n5",
                            desktop: "gvc3qt2n6"
                        },
                        defaultClass: "gvc3qt2n4"
                    },
                    "5": {
                        conditions: {
                            mobile: "gvc3qt2n7",
                            tablet: "gvc3qt2n8",
                            desktop: "gvc3qt2n9"
                        },
                        defaultClass: "gvc3qt2n7"
                    },
                    "6": {
                        conditions: {
                            mobile: "gvc3qt2na",
                            tablet: "gvc3qt2nb",
                            desktop: "gvc3qt2nc"
                        },
                        defaultClass: "gvc3qt2na"
                    },
                    "7": {
                        conditions: {
                            mobile: "gvc3qt2nd",
                            tablet: "gvc3qt2ne",
                            desktop: "gvc3qt2nf"
                        },
                        defaultClass: "gvc3qt2nd"
                    },
                    "8": {
                        conditions: {
                            mobile: "gvc3qt2ng",
                            tablet: "gvc3qt2nh",
                            desktop: "gvc3qt2ni"
                        },
                        defaultClass: "gvc3qt2ng"
                    },
                    "9": {
                        conditions: {
                            mobile: "gvc3qt2nj",
                            tablet: "gvc3qt2nk",
                            desktop: "gvc3qt2nl"
                        },
                        defaultClass: "gvc3qt2nj"
                    },
                    "10": {
                        conditions: {
                            mobile: "gvc3qt2nm",
                            tablet: "gvc3qt2nn",
                            desktop: "gvc3qt2no"
                        },
                        defaultClass: "gvc3qt2nm"
                    },
                    "11": {
                        conditions: {
                            mobile: "gvc3qt2np",
                            tablet: "gvc3qt2nq",
                            desktop: "gvc3qt2nr"
                        },
                        defaultClass: "gvc3qt2np"
                    },
                    "12": {
                        conditions: {
                            mobile: "gvc3qt2ns",
                            tablet: "gvc3qt2nt",
                            desktop: "gvc3qt2nu"
                        },
                        defaultClass: "gvc3qt2ns"
                    },
                    "13": {
                        conditions: {
                            mobile: "gvc3qt2nv",
                            tablet: "gvc3qt2nw",
                            desktop: "gvc3qt2nx"
                        },
                        defaultClass: "gvc3qt2nv"
                    },
                    "14": {
                        conditions: {
                            mobile: "gvc3qt2ny",
                            tablet: "gvc3qt2nz",
                            desktop: "gvc3qt2o0"
                        },
                        defaultClass: "gvc3qt2ny"
                    },
                    "15": {
                        conditions: {
                            mobile: "gvc3qt2o1",
                            tablet: "gvc3qt2o2",
                            desktop: "gvc3qt2o3"
                        },
                        defaultClass: "gvc3qt2o1"
                    },
                    "16": {
                        conditions: {
                            mobile: "gvc3qt2o4",
                            tablet: "gvc3qt2o5",
                            desktop: "gvc3qt2o6"
                        },
                        defaultClass: "gvc3qt2o4"
                    },
                    "17": {
                        conditions: {
                            mobile: "gvc3qt2o7",
                            tablet: "gvc3qt2o8",
                            desktop: "gvc3qt2o9"
                        },
                        defaultClass: "gvc3qt2o7"
                    },
                    "18": {
                        conditions: {
                            mobile: "gvc3qt2oa",
                            tablet: "gvc3qt2ob",
                            desktop: "gvc3qt2oc"
                        },
                        defaultClass: "gvc3qt2oa"
                    },
                    "19": {
                        conditions: {
                            mobile: "gvc3qt2od",
                            tablet: "gvc3qt2oe",
                            desktop: "gvc3qt2of"
                        },
                        defaultClass: "gvc3qt2od"
                    },
                    "20": {
                        conditions: {
                            mobile: "gvc3qt2og",
                            tablet: "gvc3qt2oh",
                            desktop: "gvc3qt2oi"
                        },
                        defaultClass: "gvc3qt2og"
                    },
                    "21": {
                        conditions: {
                            mobile: "gvc3qt2oj",
                            tablet: "gvc3qt2ok",
                            desktop: "gvc3qt2ol"
                        },
                        defaultClass: "gvc3qt2oj"
                    },
                    "22": {
                        conditions: {
                            mobile: "gvc3qt2om",
                            tablet: "gvc3qt2on",
                            desktop: "gvc3qt2oo"
                        },
                        defaultClass: "gvc3qt2om"
                    },
                    "23": {
                        conditions: {
                            mobile: "gvc3qt2op",
                            tablet: "gvc3qt2oq",
                            desktop: "gvc3qt2or"
                        },
                        defaultClass: "gvc3qt2op"
                    },
                    "24": {
                        conditions: {
                            mobile: "gvc3qt2os",
                            tablet: "gvc3qt2ot",
                            desktop: "gvc3qt2ou"
                        },
                        defaultClass: "gvc3qt2os"
                    },
                    "25": {
                        conditions: {
                            mobile: "gvc3qt2ov",
                            tablet: "gvc3qt2ow",
                            desktop: "gvc3qt2ox"
                        },
                        defaultClass: "gvc3qt2ov"
                    },
                    "26": {
                        conditions: {
                            mobile: "gvc3qt2oy",
                            tablet: "gvc3qt2oz",
                            desktop: "gvc3qt2p0"
                        },
                        defaultClass: "gvc3qt2oy"
                    },
                    "27": {
                        conditions: {
                            mobile: "gvc3qt2p1",
                            tablet: "gvc3qt2p2",
                            desktop: "gvc3qt2p3"
                        },
                        defaultClass: "gvc3qt2p1"
                    },
                    "28": {
                        conditions: {
                            mobile: "gvc3qt2p4",
                            tablet: "gvc3qt2p5",
                            desktop: "gvc3qt2p6"
                        },
                        defaultClass: "gvc3qt2p4"
                    },
                    "29": {
                        conditions: {
                            mobile: "gvc3qt2p7",
                            tablet: "gvc3qt2p8",
                            desktop: "gvc3qt2p9"
                        },
                        defaultClass: "gvc3qt2p7"
                    },
                    "30": {
                        conditions: {
                            mobile: "gvc3qt2pa",
                            tablet: "gvc3qt2pb",
                            desktop: "gvc3qt2pc"
                        },
                        defaultClass: "gvc3qt2pa"
                    },
                    auto: {
                        conditions: {
                            mobile: "gvc3qt2pd",
                            tablet: "gvc3qt2pe",
                            desktop: "gvc3qt2pf"
                        },
                        defaultClass: "gvc3qt2pd"
                    },
                    full: {
                        conditions: {
                            mobile: "gvc3qt2pg",
                            tablet: "gvc3qt2ph",
                            desktop: "gvc3qt2pi"
                        },
                        defaultClass: "gvc3qt2pg"
                    },
                    fit: {
                        conditions: {
                            mobile: "gvc3qt2pj",
                            tablet: "gvc3qt2pk",
                            desktop: "gvc3qt2pl"
                        },
                        defaultClass: "gvc3qt2pj"
                    },
                    max: {
                        conditions: {
                            mobile: "gvc3qt2pm",
                            tablet: "gvc3qt2pn",
                            desktop: "gvc3qt2po"
                        },
                        defaultClass: "gvc3qt2pm"
                    },
                    min: {
                        conditions: {
                            mobile: "gvc3qt2pp",
                            tablet: "gvc3qt2pq",
                            desktop: "gvc3qt2pr"
                        },
                        defaultClass: "gvc3qt2pp"
                    },
                    viewHeight: {
                        conditions: {
                            mobile: "gvc3qt2ps",
                            tablet: "gvc3qt2pt",
                            desktop: "gvc3qt2pu"
                        },
                        defaultClass: "gvc3qt2ps"
                    },
                    viewWidth: {
                        conditions: {
                            mobile: "gvc3qt2pv",
                            tablet: "gvc3qt2pw",
                            desktop: "gvc3qt2px"
                        },
                        defaultClass: "gvc3qt2pv"
                    },
                    none: {
                        conditions: {
                            mobile: "gvc3qt2py",
                            tablet: "gvc3qt2pz",
                            desktop: "gvc3qt2q0"
                        },
                        defaultClass: "gvc3qt2py"
                    },
                    "1/5": {
                        conditions: {
                            mobile: "gvc3qt2q1",
                            tablet: "gvc3qt2q2",
                            desktop: "gvc3qt2q3"
                        },
                        defaultClass: "gvc3qt2q1"
                    },
                    "1/4": {
                        conditions: {
                            mobile: "gvc3qt2q4",
                            tablet: "gvc3qt2q5",
                            desktop: "gvc3qt2q6"
                        },
                        defaultClass: "gvc3qt2q4"
                    },
                    "1/3": {
                        conditions: {
                            mobile: "gvc3qt2q7",
                            tablet: "gvc3qt2q8",
                            desktop: "gvc3qt2q9"
                        },
                        defaultClass: "gvc3qt2q7"
                    },
                    "1/2": {
                        conditions: {
                            mobile: "gvc3qt2qa",
                            tablet: "gvc3qt2qb",
                            desktop: "gvc3qt2qc"
                        },
                        defaultClass: "gvc3qt2qa"
                    },
                    "2/3": {
                        conditions: {
                            mobile: "gvc3qt2qd",
                            tablet: "gvc3qt2qe",
                            desktop: "gvc3qt2qf"
                        },
                        defaultClass: "gvc3qt2qd"
                    },
                    "3/4": {
                        conditions: {
                            mobile: "gvc3qt2qg",
                            tablet: "gvc3qt2qh",
                            desktop: "gvc3qt2qi"
                        },
                        defaultClass: "gvc3qt2qg"
                    }
                },
                responsiveArray: undefined
            },
            width: {
                values: {
                    "0": {
                        conditions: {
                            mobile: "gvc3qt2qj",
                            tablet: "gvc3qt2qk",
                            desktop: "gvc3qt2ql"
                        },
                        defaultClass: "gvc3qt2qj"
                    },
                    "1": {
                        conditions: {
                            mobile: "gvc3qt2qm",
                            tablet: "gvc3qt2qn",
                            desktop: "gvc3qt2qo"
                        },
                        defaultClass: "gvc3qt2qm"
                    },
                    "2": {
                        conditions: {
                            mobile: "gvc3qt2qp",
                            tablet: "gvc3qt2qq",
                            desktop: "gvc3qt2qr"
                        },
                        defaultClass: "gvc3qt2qp"
                    },
                    "3": {
                        conditions: {
                            mobile: "gvc3qt2qs",
                            tablet: "gvc3qt2qt",
                            desktop: "gvc3qt2qu"
                        },
                        defaultClass: "gvc3qt2qs"
                    },
                    "4": {
                        conditions: {
                            mobile: "gvc3qt2qv",
                            tablet: "gvc3qt2qw",
                            desktop: "gvc3qt2qx"
                        },
                        defaultClass: "gvc3qt2qv"
                    },
                    "5": {
                        conditions: {
                            mobile: "gvc3qt2qy",
                            tablet: "gvc3qt2qz",
                            desktop: "gvc3qt2r0"
                        },
                        defaultClass: "gvc3qt2qy"
                    },
                    "6": {
                        conditions: {
                            mobile: "gvc3qt2r1",
                            tablet: "gvc3qt2r2",
                            desktop: "gvc3qt2r3"
                        },
                        defaultClass: "gvc3qt2r1"
                    },
                    "7": {
                        conditions: {
                            mobile: "gvc3qt2r4",
                            tablet: "gvc3qt2r5",
                            desktop: "gvc3qt2r6"
                        },
                        defaultClass: "gvc3qt2r4"
                    },
                    "8": {
                        conditions: {
                            mobile: "gvc3qt2r7",
                            tablet: "gvc3qt2r8",
                            desktop: "gvc3qt2r9"
                        },
                        defaultClass: "gvc3qt2r7"
                    },
                    "9": {
                        conditions: {
                            mobile: "gvc3qt2ra",
                            tablet: "gvc3qt2rb",
                            desktop: "gvc3qt2rc"
                        },
                        defaultClass: "gvc3qt2ra"
                    },
                    "10": {
                        conditions: {
                            mobile: "gvc3qt2rd",
                            tablet: "gvc3qt2re",
                            desktop: "gvc3qt2rf"
                        },
                        defaultClass: "gvc3qt2rd"
                    },
                    "11": {
                        conditions: {
                            mobile: "gvc3qt2rg",
                            tablet: "gvc3qt2rh",
                            desktop: "gvc3qt2ri"
                        },
                        defaultClass: "gvc3qt2rg"
                    },
                    "12": {
                        conditions: {
                            mobile: "gvc3qt2rj",
                            tablet: "gvc3qt2rk",
                            desktop: "gvc3qt2rl"
                        },
                        defaultClass: "gvc3qt2rj"
                    },
                    "13": {
                        conditions: {
                            mobile: "gvc3qt2rm",
                            tablet: "gvc3qt2rn",
                            desktop: "gvc3qt2ro"
                        },
                        defaultClass: "gvc3qt2rm"
                    },
                    "14": {
                        conditions: {
                            mobile: "gvc3qt2rp",
                            tablet: "gvc3qt2rq",
                            desktop: "gvc3qt2rr"
                        },
                        defaultClass: "gvc3qt2rp"
                    },
                    "15": {
                        conditions: {
                            mobile: "gvc3qt2rs",
                            tablet: "gvc3qt2rt",
                            desktop: "gvc3qt2ru"
                        },
                        defaultClass: "gvc3qt2rs"
                    },
                    "16": {
                        conditions: {
                            mobile: "gvc3qt2rv",
                            tablet: "gvc3qt2rw",
                            desktop: "gvc3qt2rx"
                        },
                        defaultClass: "gvc3qt2rv"
                    },
                    "17": {
                        conditions: {
                            mobile: "gvc3qt2ry",
                            tablet: "gvc3qt2rz",
                            desktop: "gvc3qt2s0"
                        },
                        defaultClass: "gvc3qt2ry"
                    },
                    "18": {
                        conditions: {
                            mobile: "gvc3qt2s1",
                            tablet: "gvc3qt2s2",
                            desktop: "gvc3qt2s3"
                        },
                        defaultClass: "gvc3qt2s1"
                    },
                    "19": {
                        conditions: {
                            mobile: "gvc3qt2s4",
                            tablet: "gvc3qt2s5",
                            desktop: "gvc3qt2s6"
                        },
                        defaultClass: "gvc3qt2s4"
                    },
                    "20": {
                        conditions: {
                            mobile: "gvc3qt2s7",
                            tablet: "gvc3qt2s8",
                            desktop: "gvc3qt2s9"
                        },
                        defaultClass: "gvc3qt2s7"
                    },
                    "21": {
                        conditions: {
                            mobile: "gvc3qt2sa",
                            tablet: "gvc3qt2sb",
                            desktop: "gvc3qt2sc"
                        },
                        defaultClass: "gvc3qt2sa"
                    },
                    "22": {
                        conditions: {
                            mobile: "gvc3qt2sd",
                            tablet: "gvc3qt2se",
                            desktop: "gvc3qt2sf"
                        },
                        defaultClass: "gvc3qt2sd"
                    },
                    "23": {
                        conditions: {
                            mobile: "gvc3qt2sg",
                            tablet: "gvc3qt2sh",
                            desktop: "gvc3qt2si"
                        },
                        defaultClass: "gvc3qt2sg"
                    },
                    "24": {
                        conditions: {
                            mobile: "gvc3qt2sj",
                            tablet: "gvc3qt2sk",
                            desktop: "gvc3qt2sl"
                        },
                        defaultClass: "gvc3qt2sj"
                    },
                    "25": {
                        conditions: {
                            mobile: "gvc3qt2sm",
                            tablet: "gvc3qt2sn",
                            desktop: "gvc3qt2so"
                        },
                        defaultClass: "gvc3qt2sm"
                    },
                    "26": {
                        conditions: {
                            mobile: "gvc3qt2sp",
                            tablet: "gvc3qt2sq",
                            desktop: "gvc3qt2sr"
                        },
                        defaultClass: "gvc3qt2sp"
                    },
                    "27": {
                        conditions: {
                            mobile: "gvc3qt2ss",
                            tablet: "gvc3qt2st",
                            desktop: "gvc3qt2su"
                        },
                        defaultClass: "gvc3qt2ss"
                    },
                    "28": {
                        conditions: {
                            mobile: "gvc3qt2sv",
                            tablet: "gvc3qt2sw",
                            desktop: "gvc3qt2sx"
                        },
                        defaultClass: "gvc3qt2sv"
                    },
                    "29": {
                        conditions: {
                            mobile: "gvc3qt2sy",
                            tablet: "gvc3qt2sz",
                            desktop: "gvc3qt2t0"
                        },
                        defaultClass: "gvc3qt2sy"
                    },
                    "30": {
                        conditions: {
                            mobile: "gvc3qt2t1",
                            tablet: "gvc3qt2t2",
                            desktop: "gvc3qt2t3"
                        },
                        defaultClass: "gvc3qt2t1"
                    },
                    auto: {
                        conditions: {
                            mobile: "gvc3qt2t4",
                            tablet: "gvc3qt2t5",
                            desktop: "gvc3qt2t6"
                        },
                        defaultClass: "gvc3qt2t4"
                    },
                    full: {
                        conditions: {
                            mobile: "gvc3qt2t7",
                            tablet: "gvc3qt2t8",
                            desktop: "gvc3qt2t9"
                        },
                        defaultClass: "gvc3qt2t7"
                    },
                    fit: {
                        conditions: {
                            mobile: "gvc3qt2ta",
                            tablet: "gvc3qt2tb",
                            desktop: "gvc3qt2tc"
                        },
                        defaultClass: "gvc3qt2ta"
                    },
                    max: {
                        conditions: {
                            mobile: "gvc3qt2td",
                            tablet: "gvc3qt2te",
                            desktop: "gvc3qt2tf"
                        },
                        defaultClass: "gvc3qt2td"
                    },
                    min: {
                        conditions: {
                            mobile: "gvc3qt2tg",
                            tablet: "gvc3qt2th",
                            desktop: "gvc3qt2ti"
                        },
                        defaultClass: "gvc3qt2tg"
                    },
                    viewHeight: {
                        conditions: {
                            mobile: "gvc3qt2tj",
                            tablet: "gvc3qt2tk",
                            desktop: "gvc3qt2tl"
                        },
                        defaultClass: "gvc3qt2tj"
                    },
                    viewWidth: {
                        conditions: {
                            mobile: "gvc3qt2tm",
                            tablet: "gvc3qt2tn",
                            desktop: "gvc3qt2to"
                        },
                        defaultClass: "gvc3qt2tm"
                    },
                    none: {
                        conditions: {
                            mobile: "gvc3qt2tp",
                            tablet: "gvc3qt2tq",
                            desktop: "gvc3qt2tr"
                        },
                        defaultClass: "gvc3qt2tp"
                    },
                    "1/5": {
                        conditions: {
                            mobile: "gvc3qt2ts",
                            tablet: "gvc3qt2tt",
                            desktop: "gvc3qt2tu"
                        },
                        defaultClass: "gvc3qt2ts"
                    },
                    "1/4": {
                        conditions: {
                            mobile: "gvc3qt2tv",
                            tablet: "gvc3qt2tw",
                            desktop: "gvc3qt2tx"
                        },
                        defaultClass: "gvc3qt2tv"
                    },
                    "1/3": {
                        conditions: {
                            mobile: "gvc3qt2ty",
                            tablet: "gvc3qt2tz",
                            desktop: "gvc3qt2u0"
                        },
                        defaultClass: "gvc3qt2ty"
                    },
                    "1/2": {
                        conditions: {
                            mobile: "gvc3qt2u1",
                            tablet: "gvc3qt2u2",
                            desktop: "gvc3qt2u3"
                        },
                        defaultClass: "gvc3qt2u1"
                    },
                    "2/3": {
                        conditions: {
                            mobile: "gvc3qt2u4",
                            tablet: "gvc3qt2u5",
                            desktop: "gvc3qt2u6"
                        },
                        defaultClass: "gvc3qt2u4"
                    },
                    "3/4": {
                        conditions: {
                            mobile: "gvc3qt2u7",
                            tablet: "gvc3qt2u8",
                            desktop: "gvc3qt2u9"
                        },
                        defaultClass: "gvc3qt2u7"
                    }
                },
                responsiveArray: undefined
            },
            minHeight: {
                values: {
                    "0": {
                        conditions: {
                            mobile: "gvc3qt2ua",
                            tablet: "gvc3qt2ub",
                            desktop: "gvc3qt2uc"
                        },
                        defaultClass: "gvc3qt2ua"
                    },
                    "1": {
                        conditions: {
                            mobile: "gvc3qt2ud",
                            tablet: "gvc3qt2ue",
                            desktop: "gvc3qt2uf"
                        },
                        defaultClass: "gvc3qt2ud"
                    },
                    "2": {
                        conditions: {
                            mobile: "gvc3qt2ug",
                            tablet: "gvc3qt2uh",
                            desktop: "gvc3qt2ui"
                        },
                        defaultClass: "gvc3qt2ug"
                    },
                    "3": {
                        conditions: {
                            mobile: "gvc3qt2uj",
                            tablet: "gvc3qt2uk",
                            desktop: "gvc3qt2ul"
                        },
                        defaultClass: "gvc3qt2uj"
                    },
                    "4": {
                        conditions: {
                            mobile: "gvc3qt2um",
                            tablet: "gvc3qt2un",
                            desktop: "gvc3qt2uo"
                        },
                        defaultClass: "gvc3qt2um"
                    },
                    "5": {
                        conditions: {
                            mobile: "gvc3qt2up",
                            tablet: "gvc3qt2uq",
                            desktop: "gvc3qt2ur"
                        },
                        defaultClass: "gvc3qt2up"
                    },
                    "6": {
                        conditions: {
                            mobile: "gvc3qt2us",
                            tablet: "gvc3qt2ut",
                            desktop: "gvc3qt2uu"
                        },
                        defaultClass: "gvc3qt2us"
                    },
                    "7": {
                        conditions: {
                            mobile: "gvc3qt2uv",
                            tablet: "gvc3qt2uw",
                            desktop: "gvc3qt2ux"
                        },
                        defaultClass: "gvc3qt2uv"
                    },
                    "8": {
                        conditions: {
                            mobile: "gvc3qt2uy",
                            tablet: "gvc3qt2uz",
                            desktop: "gvc3qt2v0"
                        },
                        defaultClass: "gvc3qt2uy"
                    },
                    "9": {
                        conditions: {
                            mobile: "gvc3qt2v1",
                            tablet: "gvc3qt2v2",
                            desktop: "gvc3qt2v3"
                        },
                        defaultClass: "gvc3qt2v1"
                    },
                    "10": {
                        conditions: {
                            mobile: "gvc3qt2v4",
                            tablet: "gvc3qt2v5",
                            desktop: "gvc3qt2v6"
                        },
                        defaultClass: "gvc3qt2v4"
                    },
                    "11": {
                        conditions: {
                            mobile: "gvc3qt2v7",
                            tablet: "gvc3qt2v8",
                            desktop: "gvc3qt2v9"
                        },
                        defaultClass: "gvc3qt2v7"
                    },
                    "12": {
                        conditions: {
                            mobile: "gvc3qt2va",
                            tablet: "gvc3qt2vb",
                            desktop: "gvc3qt2vc"
                        },
                        defaultClass: "gvc3qt2va"
                    },
                    "13": {
                        conditions: {
                            mobile: "gvc3qt2vd",
                            tablet: "gvc3qt2ve",
                            desktop: "gvc3qt2vf"
                        },
                        defaultClass: "gvc3qt2vd"
                    },
                    "14": {
                        conditions: {
                            mobile: "gvc3qt2vg",
                            tablet: "gvc3qt2vh",
                            desktop: "gvc3qt2vi"
                        },
                        defaultClass: "gvc3qt2vg"
                    },
                    "15": {
                        conditions: {
                            mobile: "gvc3qt2vj",
                            tablet: "gvc3qt2vk",
                            desktop: "gvc3qt2vl"
                        },
                        defaultClass: "gvc3qt2vj"
                    },
                    "16": {
                        conditions: {
                            mobile: "gvc3qt2vm",
                            tablet: "gvc3qt2vn",
                            desktop: "gvc3qt2vo"
                        },
                        defaultClass: "gvc3qt2vm"
                    },
                    "17": {
                        conditions: {
                            mobile: "gvc3qt2vp",
                            tablet: "gvc3qt2vq",
                            desktop: "gvc3qt2vr"
                        },
                        defaultClass: "gvc3qt2vp"
                    },
                    "18": {
                        conditions: {
                            mobile: "gvc3qt2vs",
                            tablet: "gvc3qt2vt",
                            desktop: "gvc3qt2vu"
                        },
                        defaultClass: "gvc3qt2vs"
                    },
                    "19": {
                        conditions: {
                            mobile: "gvc3qt2vv",
                            tablet: "gvc3qt2vw",
                            desktop: "gvc3qt2vx"
                        },
                        defaultClass: "gvc3qt2vv"
                    },
                    "20": {
                        conditions: {
                            mobile: "gvc3qt2vy",
                            tablet: "gvc3qt2vz",
                            desktop: "gvc3qt2w0"
                        },
                        defaultClass: "gvc3qt2vy"
                    },
                    "21": {
                        conditions: {
                            mobile: "gvc3qt2w1",
                            tablet: "gvc3qt2w2",
                            desktop: "gvc3qt2w3"
                        },
                        defaultClass: "gvc3qt2w1"
                    },
                    "22": {
                        conditions: {
                            mobile: "gvc3qt2w4",
                            tablet: "gvc3qt2w5",
                            desktop: "gvc3qt2w6"
                        },
                        defaultClass: "gvc3qt2w4"
                    },
                    "23": {
                        conditions: {
                            mobile: "gvc3qt2w7",
                            tablet: "gvc3qt2w8",
                            desktop: "gvc3qt2w9"
                        },
                        defaultClass: "gvc3qt2w7"
                    },
                    "24": {
                        conditions: {
                            mobile: "gvc3qt2wa",
                            tablet: "gvc3qt2wb",
                            desktop: "gvc3qt2wc"
                        },
                        defaultClass: "gvc3qt2wa"
                    },
                    "25": {
                        conditions: {
                            mobile: "gvc3qt2wd",
                            tablet: "gvc3qt2we",
                            desktop: "gvc3qt2wf"
                        },
                        defaultClass: "gvc3qt2wd"
                    },
                    "26": {
                        conditions: {
                            mobile: "gvc3qt2wg",
                            tablet: "gvc3qt2wh",
                            desktop: "gvc3qt2wi"
                        },
                        defaultClass: "gvc3qt2wg"
                    },
                    "27": {
                        conditions: {
                            mobile: "gvc3qt2wj",
                            tablet: "gvc3qt2wk",
                            desktop: "gvc3qt2wl"
                        },
                        defaultClass: "gvc3qt2wj"
                    },
                    "28": {
                        conditions: {
                            mobile: "gvc3qt2wm",
                            tablet: "gvc3qt2wn",
                            desktop: "gvc3qt2wo"
                        },
                        defaultClass: "gvc3qt2wm"
                    },
                    "29": {
                        conditions: {
                            mobile: "gvc3qt2wp",
                            tablet: "gvc3qt2wq",
                            desktop: "gvc3qt2wr"
                        },
                        defaultClass: "gvc3qt2wp"
                    },
                    "30": {
                        conditions: {
                            mobile: "gvc3qt2ws",
                            tablet: "gvc3qt2wt",
                            desktop: "gvc3qt2wu"
                        },
                        defaultClass: "gvc3qt2ws"
                    },
                    auto: {
                        conditions: {
                            mobile: "gvc3qt2wv",
                            tablet: "gvc3qt2ww",
                            desktop: "gvc3qt2wx"
                        },
                        defaultClass: "gvc3qt2wv"
                    },
                    full: {
                        conditions: {
                            mobile: "gvc3qt2wy",
                            tablet: "gvc3qt2wz",
                            desktop: "gvc3qt2x0"
                        },
                        defaultClass: "gvc3qt2wy"
                    },
                    fit: {
                        conditions: {
                            mobile: "gvc3qt2x1",
                            tablet: "gvc3qt2x2",
                            desktop: "gvc3qt2x3"
                        },
                        defaultClass: "gvc3qt2x1"
                    },
                    max: {
                        conditions: {
                            mobile: "gvc3qt2x4",
                            tablet: "gvc3qt2x5",
                            desktop: "gvc3qt2x6"
                        },
                        defaultClass: "gvc3qt2x4"
                    },
                    min: {
                        conditions: {
                            mobile: "gvc3qt2x7",
                            tablet: "gvc3qt2x8",
                            desktop: "gvc3qt2x9"
                        },
                        defaultClass: "gvc3qt2x7"
                    },
                    viewHeight: {
                        conditions: {
                            mobile: "gvc3qt2xa",
                            tablet: "gvc3qt2xb",
                            desktop: "gvc3qt2xc"
                        },
                        defaultClass: "gvc3qt2xa"
                    },
                    viewWidth: {
                        conditions: {
                            mobile: "gvc3qt2xd",
                            tablet: "gvc3qt2xe",
                            desktop: "gvc3qt2xf"
                        },
                        defaultClass: "gvc3qt2xd"
                    },
                    none: {
                        conditions: {
                            mobile: "gvc3qt2xg",
                            tablet: "gvc3qt2xh",
                            desktop: "gvc3qt2xi"
                        },
                        defaultClass: "gvc3qt2xg"
                    }
                },
                responsiveArray: undefined
            },
            minWidth: {
                values: {
                    "0": {
                        conditions: {
                            mobile: "gvc3qt2xj",
                            tablet: "gvc3qt2xk",
                            desktop: "gvc3qt2xl"
                        },
                        defaultClass: "gvc3qt2xj"
                    },
                    "1": {
                        conditions: {
                            mobile: "gvc3qt2xm",
                            tablet: "gvc3qt2xn",
                            desktop: "gvc3qt2xo"
                        },
                        defaultClass: "gvc3qt2xm"
                    },
                    "2": {
                        conditions: {
                            mobile: "gvc3qt2xp",
                            tablet: "gvc3qt2xq",
                            desktop: "gvc3qt2xr"
                        },
                        defaultClass: "gvc3qt2xp"
                    },
                    "3": {
                        conditions: {
                            mobile: "gvc3qt2xs",
                            tablet: "gvc3qt2xt",
                            desktop: "gvc3qt2xu"
                        },
                        defaultClass: "gvc3qt2xs"
                    },
                    "4": {
                        conditions: {
                            mobile: "gvc3qt2xv",
                            tablet: "gvc3qt2xw",
                            desktop: "gvc3qt2xx"
                        },
                        defaultClass: "gvc3qt2xv"
                    },
                    "5": {
                        conditions: {
                            mobile: "gvc3qt2xy",
                            tablet: "gvc3qt2xz",
                            desktop: "gvc3qt2y0"
                        },
                        defaultClass: "gvc3qt2xy"
                    },
                    "6": {
                        conditions: {
                            mobile: "gvc3qt2y1",
                            tablet: "gvc3qt2y2",
                            desktop: "gvc3qt2y3"
                        },
                        defaultClass: "gvc3qt2y1"
                    },
                    "7": {
                        conditions: {
                            mobile: "gvc3qt2y4",
                            tablet: "gvc3qt2y5",
                            desktop: "gvc3qt2y6"
                        },
                        defaultClass: "gvc3qt2y4"
                    },
                    "8": {
                        conditions: {
                            mobile: "gvc3qt2y7",
                            tablet: "gvc3qt2y8",
                            desktop: "gvc3qt2y9"
                        },
                        defaultClass: "gvc3qt2y7"
                    },
                    "9": {
                        conditions: {
                            mobile: "gvc3qt2ya",
                            tablet: "gvc3qt2yb",
                            desktop: "gvc3qt2yc"
                        },
                        defaultClass: "gvc3qt2ya"
                    },
                    "10": {
                        conditions: {
                            mobile: "gvc3qt2yd",
                            tablet: "gvc3qt2ye",
                            desktop: "gvc3qt2yf"
                        },
                        defaultClass: "gvc3qt2yd"
                    },
                    "11": {
                        conditions: {
                            mobile: "gvc3qt2yg",
                            tablet: "gvc3qt2yh",
                            desktop: "gvc3qt2yi"
                        },
                        defaultClass: "gvc3qt2yg"
                    },
                    "12": {
                        conditions: {
                            mobile: "gvc3qt2yj",
                            tablet: "gvc3qt2yk",
                            desktop: "gvc3qt2yl"
                        },
                        defaultClass: "gvc3qt2yj"
                    },
                    "13": {
                        conditions: {
                            mobile: "gvc3qt2ym",
                            tablet: "gvc3qt2yn",
                            desktop: "gvc3qt2yo"
                        },
                        defaultClass: "gvc3qt2ym"
                    },
                    "14": {
                        conditions: {
                            mobile: "gvc3qt2yp",
                            tablet: "gvc3qt2yq",
                            desktop: "gvc3qt2yr"
                        },
                        defaultClass: "gvc3qt2yp"
                    },
                    "15": {
                        conditions: {
                            mobile: "gvc3qt2ys",
                            tablet: "gvc3qt2yt",
                            desktop: "gvc3qt2yu"
                        },
                        defaultClass: "gvc3qt2ys"
                    },
                    "16": {
                        conditions: {
                            mobile: "gvc3qt2yv",
                            tablet: "gvc3qt2yw",
                            desktop: "gvc3qt2yx"
                        },
                        defaultClass: "gvc3qt2yv"
                    },
                    "17": {
                        conditions: {
                            mobile: "gvc3qt2yy",
                            tablet: "gvc3qt2yz",
                            desktop: "gvc3qt2z0"
                        },
                        defaultClass: "gvc3qt2yy"
                    },
                    "18": {
                        conditions: {
                            mobile: "gvc3qt2z1",
                            tablet: "gvc3qt2z2",
                            desktop: "gvc3qt2z3"
                        },
                        defaultClass: "gvc3qt2z1"
                    },
                    "19": {
                        conditions: {
                            mobile: "gvc3qt2z4",
                            tablet: "gvc3qt2z5",
                            desktop: "gvc3qt2z6"
                        },
                        defaultClass: "gvc3qt2z4"
                    },
                    "20": {
                        conditions: {
                            mobile: "gvc3qt2z7",
                            tablet: "gvc3qt2z8",
                            desktop: "gvc3qt2z9"
                        },
                        defaultClass: "gvc3qt2z7"
                    },
                    "21": {
                        conditions: {
                            mobile: "gvc3qt2za",
                            tablet: "gvc3qt2zb",
                            desktop: "gvc3qt2zc"
                        },
                        defaultClass: "gvc3qt2za"
                    },
                    "22": {
                        conditions: {
                            mobile: "gvc3qt2zd",
                            tablet: "gvc3qt2ze",
                            desktop: "gvc3qt2zf"
                        },
                        defaultClass: "gvc3qt2zd"
                    },
                    "23": {
                        conditions: {
                            mobile: "gvc3qt2zg",
                            tablet: "gvc3qt2zh",
                            desktop: "gvc3qt2zi"
                        },
                        defaultClass: "gvc3qt2zg"
                    },
                    "24": {
                        conditions: {
                            mobile: "gvc3qt2zj",
                            tablet: "gvc3qt2zk",
                            desktop: "gvc3qt2zl"
                        },
                        defaultClass: "gvc3qt2zj"
                    },
                    "25": {
                        conditions: {
                            mobile: "gvc3qt2zm",
                            tablet: "gvc3qt2zn",
                            desktop: "gvc3qt2zo"
                        },
                        defaultClass: "gvc3qt2zm"
                    },
                    "26": {
                        conditions: {
                            mobile: "gvc3qt2zp",
                            tablet: "gvc3qt2zq",
                            desktop: "gvc3qt2zr"
                        },
                        defaultClass: "gvc3qt2zp"
                    },
                    "27": {
                        conditions: {
                            mobile: "gvc3qt2zs",
                            tablet: "gvc3qt2zt",
                            desktop: "gvc3qt2zu"
                        },
                        defaultClass: "gvc3qt2zs"
                    },
                    "28": {
                        conditions: {
                            mobile: "gvc3qt2zv",
                            tablet: "gvc3qt2zw",
                            desktop: "gvc3qt2zx"
                        },
                        defaultClass: "gvc3qt2zv"
                    },
                    "29": {
                        conditions: {
                            mobile: "gvc3qt2zy",
                            tablet: "gvc3qt2zz",
                            desktop: "gvc3qt300"
                        },
                        defaultClass: "gvc3qt2zy"
                    },
                    "30": {
                        conditions: {
                            mobile: "gvc3qt301",
                            tablet: "gvc3qt302",
                            desktop: "gvc3qt303"
                        },
                        defaultClass: "gvc3qt301"
                    },
                    auto: {
                        conditions: {
                            mobile: "gvc3qt304",
                            tablet: "gvc3qt305",
                            desktop: "gvc3qt306"
                        },
                        defaultClass: "gvc3qt304"
                    },
                    full: {
                        conditions: {
                            mobile: "gvc3qt307",
                            tablet: "gvc3qt308",
                            desktop: "gvc3qt309"
                        },
                        defaultClass: "gvc3qt307"
                    },
                    fit: {
                        conditions: {
                            mobile: "gvc3qt30a",
                            tablet: "gvc3qt30b",
                            desktop: "gvc3qt30c"
                        },
                        defaultClass: "gvc3qt30a"
                    },
                    max: {
                        conditions: {
                            mobile: "gvc3qt30d",
                            tablet: "gvc3qt30e",
                            desktop: "gvc3qt30f"
                        },
                        defaultClass: "gvc3qt30d"
                    },
                    min: {
                        conditions: {
                            mobile: "gvc3qt30g",
                            tablet: "gvc3qt30h",
                            desktop: "gvc3qt30i"
                        },
                        defaultClass: "gvc3qt30g"
                    },
                    viewHeight: {
                        conditions: {
                            mobile: "gvc3qt30j",
                            tablet: "gvc3qt30k",
                            desktop: "gvc3qt30l"
                        },
                        defaultClass: "gvc3qt30j"
                    },
                    viewWidth: {
                        conditions: {
                            mobile: "gvc3qt30m",
                            tablet: "gvc3qt30n",
                            desktop: "gvc3qt30o"
                        },
                        defaultClass: "gvc3qt30m"
                    },
                    none: {
                        conditions: {
                            mobile: "gvc3qt30p",
                            tablet: "gvc3qt30q",
                            desktop: "gvc3qt30r"
                        },
                        defaultClass: "gvc3qt30p"
                    }
                },
                responsiveArray: undefined
            },
            paddingBottom: {
                values: {
                    "0": {
                        conditions: {
                            mobile: "gvc3qt30s",
                            tablet: "gvc3qt30t",
                            desktop: "gvc3qt30u"
                        },
                        defaultClass: "gvc3qt30s"
                    },
                    "1": {
                        conditions: {
                            mobile: "gvc3qt30v",
                            tablet: "gvc3qt30w",
                            desktop: "gvc3qt30x"
                        },
                        defaultClass: "gvc3qt30v"
                    },
                    "2": {
                        conditions: {
                            mobile: "gvc3qt30y",
                            tablet: "gvc3qt30z",
                            desktop: "gvc3qt310"
                        },
                        defaultClass: "gvc3qt30y"
                    },
                    "3": {
                        conditions: {
                            mobile: "gvc3qt311",
                            tablet: "gvc3qt312",
                            desktop: "gvc3qt313"
                        },
                        defaultClass: "gvc3qt311"
                    },
                    "4": {
                        conditions: {
                            mobile: "gvc3qt314",
                            tablet: "gvc3qt315",
                            desktop: "gvc3qt316"
                        },
                        defaultClass: "gvc3qt314"
                    },
                    "5": {
                        conditions: {
                            mobile: "gvc3qt317",
                            tablet: "gvc3qt318",
                            desktop: "gvc3qt319"
                        },
                        defaultClass: "gvc3qt317"
                    },
                    "6": {
                        conditions: {
                            mobile: "gvc3qt31a",
                            tablet: "gvc3qt31b",
                            desktop: "gvc3qt31c"
                        },
                        defaultClass: "gvc3qt31a"
                    },
                    "7": {
                        conditions: {
                            mobile: "gvc3qt31d",
                            tablet: "gvc3qt31e",
                            desktop: "gvc3qt31f"
                        },
                        defaultClass: "gvc3qt31d"
                    },
                    "8": {
                        conditions: {
                            mobile: "gvc3qt31g",
                            tablet: "gvc3qt31h",
                            desktop: "gvc3qt31i"
                        },
                        defaultClass: "gvc3qt31g"
                    },
                    "9": {
                        conditions: {
                            mobile: "gvc3qt31j",
                            tablet: "gvc3qt31k",
                            desktop: "gvc3qt31l"
                        },
                        defaultClass: "gvc3qt31j"
                    },
                    "10": {
                        conditions: {
                            mobile: "gvc3qt31m",
                            tablet: "gvc3qt31n",
                            desktop: "gvc3qt31o"
                        },
                        defaultClass: "gvc3qt31m"
                    },
                    "11": {
                        conditions: {
                            mobile: "gvc3qt31p",
                            tablet: "gvc3qt31q",
                            desktop: "gvc3qt31r"
                        },
                        defaultClass: "gvc3qt31p"
                    },
                    "12": {
                        conditions: {
                            mobile: "gvc3qt31s",
                            tablet: "gvc3qt31t",
                            desktop: "gvc3qt31u"
                        },
                        defaultClass: "gvc3qt31s"
                    },
                    "13": {
                        conditions: {
                            mobile: "gvc3qt31v",
                            tablet: "gvc3qt31w",
                            desktop: "gvc3qt31x"
                        },
                        defaultClass: "gvc3qt31v"
                    },
                    "14": {
                        conditions: {
                            mobile: "gvc3qt31y",
                            tablet: "gvc3qt31z",
                            desktop: "gvc3qt320"
                        },
                        defaultClass: "gvc3qt31y"
                    },
                    "15": {
                        conditions: {
                            mobile: "gvc3qt321",
                            tablet: "gvc3qt322",
                            desktop: "gvc3qt323"
                        },
                        defaultClass: "gvc3qt321"
                    },
                    "16": {
                        conditions: {
                            mobile: "gvc3qt324",
                            tablet: "gvc3qt325",
                            desktop: "gvc3qt326"
                        },
                        defaultClass: "gvc3qt324"
                    },
                    "17": {
                        conditions: {
                            mobile: "gvc3qt327",
                            tablet: "gvc3qt328",
                            desktop: "gvc3qt329"
                        },
                        defaultClass: "gvc3qt327"
                    },
                    "18": {
                        conditions: {
                            mobile: "gvc3qt32a",
                            tablet: "gvc3qt32b",
                            desktop: "gvc3qt32c"
                        },
                        defaultClass: "gvc3qt32a"
                    },
                    "19": {
                        conditions: {
                            mobile: "gvc3qt32d",
                            tablet: "gvc3qt32e",
                            desktop: "gvc3qt32f"
                        },
                        defaultClass: "gvc3qt32d"
                    },
                    "20": {
                        conditions: {
                            mobile: "gvc3qt32g",
                            tablet: "gvc3qt32h",
                            desktop: "gvc3qt32i"
                        },
                        defaultClass: "gvc3qt32g"
                    },
                    "21": {
                        conditions: {
                            mobile: "gvc3qt32j",
                            tablet: "gvc3qt32k",
                            desktop: "gvc3qt32l"
                        },
                        defaultClass: "gvc3qt32j"
                    },
                    "22": {
                        conditions: {
                            mobile: "gvc3qt32m",
                            tablet: "gvc3qt32n",
                            desktop: "gvc3qt32o"
                        },
                        defaultClass: "gvc3qt32m"
                    },
                    "23": {
                        conditions: {
                            mobile: "gvc3qt32p",
                            tablet: "gvc3qt32q",
                            desktop: "gvc3qt32r"
                        },
                        defaultClass: "gvc3qt32p"
                    },
                    "24": {
                        conditions: {
                            mobile: "gvc3qt32s",
                            tablet: "gvc3qt32t",
                            desktop: "gvc3qt32u"
                        },
                        defaultClass: "gvc3qt32s"
                    },
                    "25": {
                        conditions: {
                            mobile: "gvc3qt32v",
                            tablet: "gvc3qt32w",
                            desktop: "gvc3qt32x"
                        },
                        defaultClass: "gvc3qt32v"
                    },
                    "26": {
                        conditions: {
                            mobile: "gvc3qt32y",
                            tablet: "gvc3qt32z",
                            desktop: "gvc3qt330"
                        },
                        defaultClass: "gvc3qt32y"
                    },
                    "27": {
                        conditions: {
                            mobile: "gvc3qt331",
                            tablet: "gvc3qt332",
                            desktop: "gvc3qt333"
                        },
                        defaultClass: "gvc3qt331"
                    },
                    "28": {
                        conditions: {
                            mobile: "gvc3qt334",
                            tablet: "gvc3qt335",
                            desktop: "gvc3qt336"
                        },
                        defaultClass: "gvc3qt334"
                    },
                    "29": {
                        conditions: {
                            mobile: "gvc3qt337",
                            tablet: "gvc3qt338",
                            desktop: "gvc3qt339"
                        },
                        defaultClass: "gvc3qt337"
                    },
                    "30": {
                        conditions: {
                            mobile: "gvc3qt33a",
                            tablet: "gvc3qt33b",
                            desktop: "gvc3qt33c"
                        },
                        defaultClass: "gvc3qt33a"
                    },
                    auto: {
                        conditions: {
                            mobile: "gvc3qt33d",
                            tablet: "gvc3qt33e",
                            desktop: "gvc3qt33f"
                        },
                        defaultClass: "gvc3qt33d"
                    },
                    full: {
                        conditions: {
                            mobile: "gvc3qt33g",
                            tablet: "gvc3qt33h",
                            desktop: "gvc3qt33i"
                        },
                        defaultClass: "gvc3qt33g"
                    },
                    fit: {
                        conditions: {
                            mobile: "gvc3qt33j",
                            tablet: "gvc3qt33k",
                            desktop: "gvc3qt33l"
                        },
                        defaultClass: "gvc3qt33j"
                    },
                    max: {
                        conditions: {
                            mobile: "gvc3qt33m",
                            tablet: "gvc3qt33n",
                            desktop: "gvc3qt33o"
                        },
                        defaultClass: "gvc3qt33m"
                    },
                    min: {
                        conditions: {
                            mobile: "gvc3qt33p",
                            tablet: "gvc3qt33q",
                            desktop: "gvc3qt33r"
                        },
                        defaultClass: "gvc3qt33p"
                    },
                    viewHeight: {
                        conditions: {
                            mobile: "gvc3qt33s",
                            tablet: "gvc3qt33t",
                            desktop: "gvc3qt33u"
                        },
                        defaultClass: "gvc3qt33s"
                    },
                    viewWidth: {
                        conditions: {
                            mobile: "gvc3qt33v",
                            tablet: "gvc3qt33w",
                            desktop: "gvc3qt33x"
                        },
                        defaultClass: "gvc3qt33v"
                    },
                    none: {
                        conditions: {
                            mobile: "gvc3qt33y",
                            tablet: "gvc3qt33z",
                            desktop: "gvc3qt340"
                        },
                        defaultClass: "gvc3qt33y"
                    }
                },
                responsiveArray: undefined
            },
            paddingLeft: {
                values: {
                    "0": {
                        conditions: {
                            mobile: "gvc3qt341",
                            tablet: "gvc3qt342",
                            desktop: "gvc3qt343"
                        },
                        defaultClass: "gvc3qt341"
                    },
                    "1": {
                        conditions: {
                            mobile: "gvc3qt344",
                            tablet: "gvc3qt345",
                            desktop: "gvc3qt346"
                        },
                        defaultClass: "gvc3qt344"
                    },
                    "2": {
                        conditions: {
                            mobile: "gvc3qt347",
                            tablet: "gvc3qt348",
                            desktop: "gvc3qt349"
                        },
                        defaultClass: "gvc3qt347"
                    },
                    "3": {
                        conditions: {
                            mobile: "gvc3qt34a",
                            tablet: "gvc3qt34b",
                            desktop: "gvc3qt34c"
                        },
                        defaultClass: "gvc3qt34a"
                    },
                    "4": {
                        conditions: {
                            mobile: "gvc3qt34d",
                            tablet: "gvc3qt34e",
                            desktop: "gvc3qt34f"
                        },
                        defaultClass: "gvc3qt34d"
                    },
                    "5": {
                        conditions: {
                            mobile: "gvc3qt34g",
                            tablet: "gvc3qt34h",
                            desktop: "gvc3qt34i"
                        },
                        defaultClass: "gvc3qt34g"
                    },
                    "6": {
                        conditions: {
                            mobile: "gvc3qt34j",
                            tablet: "gvc3qt34k",
                            desktop: "gvc3qt34l"
                        },
                        defaultClass: "gvc3qt34j"
                    },
                    "7": {
                        conditions: {
                            mobile: "gvc3qt34m",
                            tablet: "gvc3qt34n",
                            desktop: "gvc3qt34o"
                        },
                        defaultClass: "gvc3qt34m"
                    },
                    "8": {
                        conditions: {
                            mobile: "gvc3qt34p",
                            tablet: "gvc3qt34q",
                            desktop: "gvc3qt34r"
                        },
                        defaultClass: "gvc3qt34p"
                    },
                    "9": {
                        conditions: {
                            mobile: "gvc3qt34s",
                            tablet: "gvc3qt34t",
                            desktop: "gvc3qt34u"
                        },
                        defaultClass: "gvc3qt34s"
                    },
                    "10": {
                        conditions: {
                            mobile: "gvc3qt34v",
                            tablet: "gvc3qt34w",
                            desktop: "gvc3qt34x"
                        },
                        defaultClass: "gvc3qt34v"
                    },
                    "11": {
                        conditions: {
                            mobile: "gvc3qt34y",
                            tablet: "gvc3qt34z",
                            desktop: "gvc3qt350"
                        },
                        defaultClass: "gvc3qt34y"
                    },
                    "12": {
                        conditions: {
                            mobile: "gvc3qt351",
                            tablet: "gvc3qt352",
                            desktop: "gvc3qt353"
                        },
                        defaultClass: "gvc3qt351"
                    },
                    "13": {
                        conditions: {
                            mobile: "gvc3qt354",
                            tablet: "gvc3qt355",
                            desktop: "gvc3qt356"
                        },
                        defaultClass: "gvc3qt354"
                    },
                    "14": {
                        conditions: {
                            mobile: "gvc3qt357",
                            tablet: "gvc3qt358",
                            desktop: "gvc3qt359"
                        },
                        defaultClass: "gvc3qt357"
                    },
                    "15": {
                        conditions: {
                            mobile: "gvc3qt35a",
                            tablet: "gvc3qt35b",
                            desktop: "gvc3qt35c"
                        },
                        defaultClass: "gvc3qt35a"
                    },
                    "16": {
                        conditions: {
                            mobile: "gvc3qt35d",
                            tablet: "gvc3qt35e",
                            desktop: "gvc3qt35f"
                        },
                        defaultClass: "gvc3qt35d"
                    },
                    "17": {
                        conditions: {
                            mobile: "gvc3qt35g",
                            tablet: "gvc3qt35h",
                            desktop: "gvc3qt35i"
                        },
                        defaultClass: "gvc3qt35g"
                    },
                    "18": {
                        conditions: {
                            mobile: "gvc3qt35j",
                            tablet: "gvc3qt35k",
                            desktop: "gvc3qt35l"
                        },
                        defaultClass: "gvc3qt35j"
                    },
                    "19": {
                        conditions: {
                            mobile: "gvc3qt35m",
                            tablet: "gvc3qt35n",
                            desktop: "gvc3qt35o"
                        },
                        defaultClass: "gvc3qt35m"
                    },
                    "20": {
                        conditions: {
                            mobile: "gvc3qt35p",
                            tablet: "gvc3qt35q",
                            desktop: "gvc3qt35r"
                        },
                        defaultClass: "gvc3qt35p"
                    },
                    "21": {
                        conditions: {
                            mobile: "gvc3qt35s",
                            tablet: "gvc3qt35t",
                            desktop: "gvc3qt35u"
                        },
                        defaultClass: "gvc3qt35s"
                    },
                    "22": {
                        conditions: {
                            mobile: "gvc3qt35v",
                            tablet: "gvc3qt35w",
                            desktop: "gvc3qt35x"
                        },
                        defaultClass: "gvc3qt35v"
                    },
                    "23": {
                        conditions: {
                            mobile: "gvc3qt35y",
                            tablet: "gvc3qt35z",
                            desktop: "gvc3qt360"
                        },
                        defaultClass: "gvc3qt35y"
                    },
                    "24": {
                        conditions: {
                            mobile: "gvc3qt361",
                            tablet: "gvc3qt362",
                            desktop: "gvc3qt363"
                        },
                        defaultClass: "gvc3qt361"
                    },
                    "25": {
                        conditions: {
                            mobile: "gvc3qt364",
                            tablet: "gvc3qt365",
                            desktop: "gvc3qt366"
                        },
                        defaultClass: "gvc3qt364"
                    },
                    "26": {
                        conditions: {
                            mobile: "gvc3qt367",
                            tablet: "gvc3qt368",
                            desktop: "gvc3qt369"
                        },
                        defaultClass: "gvc3qt367"
                    },
                    "27": {
                        conditions: {
                            mobile: "gvc3qt36a",
                            tablet: "gvc3qt36b",
                            desktop: "gvc3qt36c"
                        },
                        defaultClass: "gvc3qt36a"
                    },
                    "28": {
                        conditions: {
                            mobile: "gvc3qt36d",
                            tablet: "gvc3qt36e",
                            desktop: "gvc3qt36f"
                        },
                        defaultClass: "gvc3qt36d"
                    },
                    "29": {
                        conditions: {
                            mobile: "gvc3qt36g",
                            tablet: "gvc3qt36h",
                            desktop: "gvc3qt36i"
                        },
                        defaultClass: "gvc3qt36g"
                    },
                    "30": {
                        conditions: {
                            mobile: "gvc3qt36j",
                            tablet: "gvc3qt36k",
                            desktop: "gvc3qt36l"
                        },
                        defaultClass: "gvc3qt36j"
                    },
                    auto: {
                        conditions: {
                            mobile: "gvc3qt36m",
                            tablet: "gvc3qt36n",
                            desktop: "gvc3qt36o"
                        },
                        defaultClass: "gvc3qt36m"
                    },
                    full: {
                        conditions: {
                            mobile: "gvc3qt36p",
                            tablet: "gvc3qt36q",
                            desktop: "gvc3qt36r"
                        },
                        defaultClass: "gvc3qt36p"
                    },
                    fit: {
                        conditions: {
                            mobile: "gvc3qt36s",
                            tablet: "gvc3qt36t",
                            desktop: "gvc3qt36u"
                        },
                        defaultClass: "gvc3qt36s"
                    },
                    max: {
                        conditions: {
                            mobile: "gvc3qt36v",
                            tablet: "gvc3qt36w",
                            desktop: "gvc3qt36x"
                        },
                        defaultClass: "gvc3qt36v"
                    },
                    min: {
                        conditions: {
                            mobile: "gvc3qt36y",
                            tablet: "gvc3qt36z",
                            desktop: "gvc3qt370"
                        },
                        defaultClass: "gvc3qt36y"
                    },
                    viewHeight: {
                        conditions: {
                            mobile: "gvc3qt371",
                            tablet: "gvc3qt372",
                            desktop: "gvc3qt373"
                        },
                        defaultClass: "gvc3qt371"
                    },
                    viewWidth: {
                        conditions: {
                            mobile: "gvc3qt374",
                            tablet: "gvc3qt375",
                            desktop: "gvc3qt376"
                        },
                        defaultClass: "gvc3qt374"
                    },
                    none: {
                        conditions: {
                            mobile: "gvc3qt377",
                            tablet: "gvc3qt378",
                            desktop: "gvc3qt379"
                        },
                        defaultClass: "gvc3qt377"
                    }
                },
                responsiveArray: undefined
            },
            paddingRight: {
                values: {
                    "0": {
                        conditions: {
                            mobile: "gvc3qt37a",
                            tablet: "gvc3qt37b",
                            desktop: "gvc3qt37c"
                        },
                        defaultClass: "gvc3qt37a"
                    },
                    "1": {
                        conditions: {
                            mobile: "gvc3qt37d",
                            tablet: "gvc3qt37e",
                            desktop: "gvc3qt37f"
                        },
                        defaultClass: "gvc3qt37d"
                    },
                    "2": {
                        conditions: {
                            mobile: "gvc3qt37g",
                            tablet: "gvc3qt37h",
                            desktop: "gvc3qt37i"
                        },
                        defaultClass: "gvc3qt37g"
                    },
                    "3": {
                        conditions: {
                            mobile: "gvc3qt37j",
                            tablet: "gvc3qt37k",
                            desktop: "gvc3qt37l"
                        },
                        defaultClass: "gvc3qt37j"
                    },
                    "4": {
                        conditions: {
                            mobile: "gvc3qt37m",
                            tablet: "gvc3qt37n",
                            desktop: "gvc3qt37o"
                        },
                        defaultClass: "gvc3qt37m"
                    },
                    "5": {
                        conditions: {
                            mobile: "gvc3qt37p",
                            tablet: "gvc3qt37q",
                            desktop: "gvc3qt37r"
                        },
                        defaultClass: "gvc3qt37p"
                    },
                    "6": {
                        conditions: {
                            mobile: "gvc3qt37s",
                            tablet: "gvc3qt37t",
                            desktop: "gvc3qt37u"
                        },
                        defaultClass: "gvc3qt37s"
                    },
                    "7": {
                        conditions: {
                            mobile: "gvc3qt37v",
                            tablet: "gvc3qt37w",
                            desktop: "gvc3qt37x"
                        },
                        defaultClass: "gvc3qt37v"
                    },
                    "8": {
                        conditions: {
                            mobile: "gvc3qt37y",
                            tablet: "gvc3qt37z",
                            desktop: "gvc3qt380"
                        },
                        defaultClass: "gvc3qt37y"
                    },
                    "9": {
                        conditions: {
                            mobile: "gvc3qt381",
                            tablet: "gvc3qt382",
                            desktop: "gvc3qt383"
                        },
                        defaultClass: "gvc3qt381"
                    },
                    "10": {
                        conditions: {
                            mobile: "gvc3qt384",
                            tablet: "gvc3qt385",
                            desktop: "gvc3qt386"
                        },
                        defaultClass: "gvc3qt384"
                    },
                    "11": {
                        conditions: {
                            mobile: "gvc3qt387",
                            tablet: "gvc3qt388",
                            desktop: "gvc3qt389"
                        },
                        defaultClass: "gvc3qt387"
                    },
                    "12": {
                        conditions: {
                            mobile: "gvc3qt38a",
                            tablet: "gvc3qt38b",
                            desktop: "gvc3qt38c"
                        },
                        defaultClass: "gvc3qt38a"
                    },
                    "13": {
                        conditions: {
                            mobile: "gvc3qt38d",
                            tablet: "gvc3qt38e",
                            desktop: "gvc3qt38f"
                        },
                        defaultClass: "gvc3qt38d"
                    },
                    "14": {
                        conditions: {
                            mobile: "gvc3qt38g",
                            tablet: "gvc3qt38h",
                            desktop: "gvc3qt38i"
                        },
                        defaultClass: "gvc3qt38g"
                    },
                    "15": {
                        conditions: {
                            mobile: "gvc3qt38j",
                            tablet: "gvc3qt38k",
                            desktop: "gvc3qt38l"
                        },
                        defaultClass: "gvc3qt38j"
                    },
                    "16": {
                        conditions: {
                            mobile: "gvc3qt38m",
                            tablet: "gvc3qt38n",
                            desktop: "gvc3qt38o"
                        },
                        defaultClass: "gvc3qt38m"
                    },
                    "17": {
                        conditions: {
                            mobile: "gvc3qt38p",
                            tablet: "gvc3qt38q",
                            desktop: "gvc3qt38r"
                        },
                        defaultClass: "gvc3qt38p"
                    },
                    "18": {
                        conditions: {
                            mobile: "gvc3qt38s",
                            tablet: "gvc3qt38t",
                            desktop: "gvc3qt38u"
                        },
                        defaultClass: "gvc3qt38s"
                    },
                    "19": {
                        conditions: {
                            mobile: "gvc3qt38v",
                            tablet: "gvc3qt38w",
                            desktop: "gvc3qt38x"
                        },
                        defaultClass: "gvc3qt38v"
                    },
                    "20": {
                        conditions: {
                            mobile: "gvc3qt38y",
                            tablet: "gvc3qt38z",
                            desktop: "gvc3qt390"
                        },
                        defaultClass: "gvc3qt38y"
                    },
                    "21": {
                        conditions: {
                            mobile: "gvc3qt391",
                            tablet: "gvc3qt392",
                            desktop: "gvc3qt393"
                        },
                        defaultClass: "gvc3qt391"
                    },
                    "22": {
                        conditions: {
                            mobile: "gvc3qt394",
                            tablet: "gvc3qt395",
                            desktop: "gvc3qt396"
                        },
                        defaultClass: "gvc3qt394"
                    },
                    "23": {
                        conditions: {
                            mobile: "gvc3qt397",
                            tablet: "gvc3qt398",
                            desktop: "gvc3qt399"
                        },
                        defaultClass: "gvc3qt397"
                    },
                    "24": {
                        conditions: {
                            mobile: "gvc3qt39a",
                            tablet: "gvc3qt39b",
                            desktop: "gvc3qt39c"
                        },
                        defaultClass: "gvc3qt39a"
                    },
                    "25": {
                        conditions: {
                            mobile: "gvc3qt39d",
                            tablet: "gvc3qt39e",
                            desktop: "gvc3qt39f"
                        },
                        defaultClass: "gvc3qt39d"
                    },
                    "26": {
                        conditions: {
                            mobile: "gvc3qt39g",
                            tablet: "gvc3qt39h",
                            desktop: "gvc3qt39i"
                        },
                        defaultClass: "gvc3qt39g"
                    },
                    "27": {
                        conditions: {
                            mobile: "gvc3qt39j",
                            tablet: "gvc3qt39k",
                            desktop: "gvc3qt39l"
                        },
                        defaultClass: "gvc3qt39j"
                    },
                    "28": {
                        conditions: {
                            mobile: "gvc3qt39m",
                            tablet: "gvc3qt39n",
                            desktop: "gvc3qt39o"
                        },
                        defaultClass: "gvc3qt39m"
                    },
                    "29": {
                        conditions: {
                            mobile: "gvc3qt39p",
                            tablet: "gvc3qt39q",
                            desktop: "gvc3qt39r"
                        },
                        defaultClass: "gvc3qt39p"
                    },
                    "30": {
                        conditions: {
                            mobile: "gvc3qt39s",
                            tablet: "gvc3qt39t",
                            desktop: "gvc3qt39u"
                        },
                        defaultClass: "gvc3qt39s"
                    },
                    auto: {
                        conditions: {
                            mobile: "gvc3qt39v",
                            tablet: "gvc3qt39w",
                            desktop: "gvc3qt39x"
                        },
                        defaultClass: "gvc3qt39v"
                    },
                    full: {
                        conditions: {
                            mobile: "gvc3qt39y",
                            tablet: "gvc3qt39z",
                            desktop: "gvc3qt3a0"
                        },
                        defaultClass: "gvc3qt39y"
                    },
                    fit: {
                        conditions: {
                            mobile: "gvc3qt3a1",
                            tablet: "gvc3qt3a2",
                            desktop: "gvc3qt3a3"
                        },
                        defaultClass: "gvc3qt3a1"
                    },
                    max: {
                        conditions: {
                            mobile: "gvc3qt3a4",
                            tablet: "gvc3qt3a5",
                            desktop: "gvc3qt3a6"
                        },
                        defaultClass: "gvc3qt3a4"
                    },
                    min: {
                        conditions: {
                            mobile: "gvc3qt3a7",
                            tablet: "gvc3qt3a8",
                            desktop: "gvc3qt3a9"
                        },
                        defaultClass: "gvc3qt3a7"
                    },
                    viewHeight: {
                        conditions: {
                            mobile: "gvc3qt3aa",
                            tablet: "gvc3qt3ab",
                            desktop: "gvc3qt3ac"
                        },
                        defaultClass: "gvc3qt3aa"
                    },
                    viewWidth: {
                        conditions: {
                            mobile: "gvc3qt3ad",
                            tablet: "gvc3qt3ae",
                            desktop: "gvc3qt3af"
                        },
                        defaultClass: "gvc3qt3ad"
                    },
                    none: {
                        conditions: {
                            mobile: "gvc3qt3ag",
                            tablet: "gvc3qt3ah",
                            desktop: "gvc3qt3ai"
                        },
                        defaultClass: "gvc3qt3ag"
                    }
                },
                responsiveArray: undefined
            },
            paddingTop: {
                values: {
                    "0": {
                        conditions: {
                            mobile: "gvc3qt3aj",
                            tablet: "gvc3qt3ak",
                            desktop: "gvc3qt3al"
                        },
                        defaultClass: "gvc3qt3aj"
                    },
                    "1": {
                        conditions: {
                            mobile: "gvc3qt3am",
                            tablet: "gvc3qt3an",
                            desktop: "gvc3qt3ao"
                        },
                        defaultClass: "gvc3qt3am"
                    },
                    "2": {
                        conditions: {
                            mobile: "gvc3qt3ap",
                            tablet: "gvc3qt3aq",
                            desktop: "gvc3qt3ar"
                        },
                        defaultClass: "gvc3qt3ap"
                    },
                    "3": {
                        conditions: {
                            mobile: "gvc3qt3as",
                            tablet: "gvc3qt3at",
                            desktop: "gvc3qt3au"
                        },
                        defaultClass: "gvc3qt3as"
                    },
                    "4": {
                        conditions: {
                            mobile: "gvc3qt3av",
                            tablet: "gvc3qt3aw",
                            desktop: "gvc3qt3ax"
                        },
                        defaultClass: "gvc3qt3av"
                    },
                    "5": {
                        conditions: {
                            mobile: "gvc3qt3ay",
                            tablet: "gvc3qt3az",
                            desktop: "gvc3qt3b0"
                        },
                        defaultClass: "gvc3qt3ay"
                    },
                    "6": {
                        conditions: {
                            mobile: "gvc3qt3b1",
                            tablet: "gvc3qt3b2",
                            desktop: "gvc3qt3b3"
                        },
                        defaultClass: "gvc3qt3b1"
                    },
                    "7": {
                        conditions: {
                            mobile: "gvc3qt3b4",
                            tablet: "gvc3qt3b5",
                            desktop: "gvc3qt3b6"
                        },
                        defaultClass: "gvc3qt3b4"
                    },
                    "8": {
                        conditions: {
                            mobile: "gvc3qt3b7",
                            tablet: "gvc3qt3b8",
                            desktop: "gvc3qt3b9"
                        },
                        defaultClass: "gvc3qt3b7"
                    },
                    "9": {
                        conditions: {
                            mobile: "gvc3qt3ba",
                            tablet: "gvc3qt3bb",
                            desktop: "gvc3qt3bc"
                        },
                        defaultClass: "gvc3qt3ba"
                    },
                    "10": {
                        conditions: {
                            mobile: "gvc3qt3bd",
                            tablet: "gvc3qt3be",
                            desktop: "gvc3qt3bf"
                        },
                        defaultClass: "gvc3qt3bd"
                    },
                    "11": {
                        conditions: {
                            mobile: "gvc3qt3bg",
                            tablet: "gvc3qt3bh",
                            desktop: "gvc3qt3bi"
                        },
                        defaultClass: "gvc3qt3bg"
                    },
                    "12": {
                        conditions: {
                            mobile: "gvc3qt3bj",
                            tablet: "gvc3qt3bk",
                            desktop: "gvc3qt3bl"
                        },
                        defaultClass: "gvc3qt3bj"
                    },
                    "13": {
                        conditions: {
                            mobile: "gvc3qt3bm",
                            tablet: "gvc3qt3bn",
                            desktop: "gvc3qt3bo"
                        },
                        defaultClass: "gvc3qt3bm"
                    },
                    "14": {
                        conditions: {
                            mobile: "gvc3qt3bp",
                            tablet: "gvc3qt3bq",
                            desktop: "gvc3qt3br"
                        },
                        defaultClass: "gvc3qt3bp"
                    },
                    "15": {
                        conditions: {
                            mobile: "gvc3qt3bs",
                            tablet: "gvc3qt3bt",
                            desktop: "gvc3qt3bu"
                        },
                        defaultClass: "gvc3qt3bs"
                    },
                    "16": {
                        conditions: {
                            mobile: "gvc3qt3bv",
                            tablet: "gvc3qt3bw",
                            desktop: "gvc3qt3bx"
                        },
                        defaultClass: "gvc3qt3bv"
                    },
                    "17": {
                        conditions: {
                            mobile: "gvc3qt3by",
                            tablet: "gvc3qt3bz",
                            desktop: "gvc3qt3c0"
                        },
                        defaultClass: "gvc3qt3by"
                    },
                    "18": {
                        conditions: {
                            mobile: "gvc3qt3c1",
                            tablet: "gvc3qt3c2",
                            desktop: "gvc3qt3c3"
                        },
                        defaultClass: "gvc3qt3c1"
                    },
                    "19": {
                        conditions: {
                            mobile: "gvc3qt3c4",
                            tablet: "gvc3qt3c5",
                            desktop: "gvc3qt3c6"
                        },
                        defaultClass: "gvc3qt3c4"
                    },
                    "20": {
                        conditions: {
                            mobile: "gvc3qt3c7",
                            tablet: "gvc3qt3c8",
                            desktop: "gvc3qt3c9"
                        },
                        defaultClass: "gvc3qt3c7"
                    },
                    "21": {
                        conditions: {
                            mobile: "gvc3qt3ca",
                            tablet: "gvc3qt3cb",
                            desktop: "gvc3qt3cc"
                        },
                        defaultClass: "gvc3qt3ca"
                    },
                    "22": {
                        conditions: {
                            mobile: "gvc3qt3cd",
                            tablet: "gvc3qt3ce",
                            desktop: "gvc3qt3cf"
                        },
                        defaultClass: "gvc3qt3cd"
                    },
                    "23": {
                        conditions: {
                            mobile: "gvc3qt3cg",
                            tablet: "gvc3qt3ch",
                            desktop: "gvc3qt3ci"
                        },
                        defaultClass: "gvc3qt3cg"
                    },
                    "24": {
                        conditions: {
                            mobile: "gvc3qt3cj",
                            tablet: "gvc3qt3ck",
                            desktop: "gvc3qt3cl"
                        },
                        defaultClass: "gvc3qt3cj"
                    },
                    "25": {
                        conditions: {
                            mobile: "gvc3qt3cm",
                            tablet: "gvc3qt3cn",
                            desktop: "gvc3qt3co"
                        },
                        defaultClass: "gvc3qt3cm"
                    },
                    "26": {
                        conditions: {
                            mobile: "gvc3qt3cp",
                            tablet: "gvc3qt3cq",
                            desktop: "gvc3qt3cr"
                        },
                        defaultClass: "gvc3qt3cp"
                    },
                    "27": {
                        conditions: {
                            mobile: "gvc3qt3cs",
                            tablet: "gvc3qt3ct",
                            desktop: "gvc3qt3cu"
                        },
                        defaultClass: "gvc3qt3cs"
                    },
                    "28": {
                        conditions: {
                            mobile: "gvc3qt3cv",
                            tablet: "gvc3qt3cw",
                            desktop: "gvc3qt3cx"
                        },
                        defaultClass: "gvc3qt3cv"
                    },
                    "29": {
                        conditions: {
                            mobile: "gvc3qt3cy",
                            tablet: "gvc3qt3cz",
                            desktop: "gvc3qt3d0"
                        },
                        defaultClass: "gvc3qt3cy"
                    },
                    "30": {
                        conditions: {
                            mobile: "gvc3qt3d1",
                            tablet: "gvc3qt3d2",
                            desktop: "gvc3qt3d3"
                        },
                        defaultClass: "gvc3qt3d1"
                    },
                    auto: {
                        conditions: {
                            mobile: "gvc3qt3d4",
                            tablet: "gvc3qt3d5",
                            desktop: "gvc3qt3d6"
                        },
                        defaultClass: "gvc3qt3d4"
                    },
                    full: {
                        conditions: {
                            mobile: "gvc3qt3d7",
                            tablet: "gvc3qt3d8",
                            desktop: "gvc3qt3d9"
                        },
                        defaultClass: "gvc3qt3d7"
                    },
                    fit: {
                        conditions: {
                            mobile: "gvc3qt3da",
                            tablet: "gvc3qt3db",
                            desktop: "gvc3qt3dc"
                        },
                        defaultClass: "gvc3qt3da"
                    },
                    max: {
                        conditions: {
                            mobile: "gvc3qt3dd",
                            tablet: "gvc3qt3de",
                            desktop: "gvc3qt3df"
                        },
                        defaultClass: "gvc3qt3dd"
                    },
                    min: {
                        conditions: {
                            mobile: "gvc3qt3dg",
                            tablet: "gvc3qt3dh",
                            desktop: "gvc3qt3di"
                        },
                        defaultClass: "gvc3qt3dg"
                    },
                    viewHeight: {
                        conditions: {
                            mobile: "gvc3qt3dj",
                            tablet: "gvc3qt3dk",
                            desktop: "gvc3qt3dl"
                        },
                        defaultClass: "gvc3qt3dj"
                    },
                    viewWidth: {
                        conditions: {
                            mobile: "gvc3qt3dm",
                            tablet: "gvc3qt3dn",
                            desktop: "gvc3qt3do"
                        },
                        defaultClass: "gvc3qt3dm"
                    },
                    none: {
                        conditions: {
                            mobile: "gvc3qt3dp",
                            tablet: "gvc3qt3dq",
                            desktop: "gvc3qt3dr"
                        },
                        defaultClass: "gvc3qt3dp"
                    }
                },
                responsiveArray: undefined
            },
            position: {
                values: {
                    absolute: {
                        conditions: {
                            mobile: "gvc3qt3ds",
                            tablet: "gvc3qt3dt",
                            desktop: "gvc3qt3du"
                        },
                        defaultClass: "gvc3qt3ds"
                    },
                    fixed: {
                        conditions: {
                            mobile: "gvc3qt3dv",
                            tablet: "gvc3qt3dw",
                            desktop: "gvc3qt3dx"
                        },
                        defaultClass: "gvc3qt3dv"
                    },
                    relative: {
                        conditions: {
                            mobile: "gvc3qt3dy",
                            tablet: "gvc3qt3dz",
                            desktop: "gvc3qt3e0"
                        },
                        defaultClass: "gvc3qt3dy"
                    },
                    sticky: {
                        conditions: {
                            mobile: "gvc3qt3e1",
                            tablet: "gvc3qt3e2",
                            desktop: "gvc3qt3e3"
                        },
                        defaultClass: "gvc3qt3e1"
                    }
                },
                responsiveArray: undefined
            },
            right: {
                values: {
                    "0": {
                        conditions: {
                            mobile: "gvc3qt3e4",
                            tablet: "gvc3qt3e5",
                            desktop: "gvc3qt3e6"
                        },
                        defaultClass: "gvc3qt3e4"
                    },
                    "1": {
                        conditions: {
                            mobile: "gvc3qt3e7",
                            tablet: "gvc3qt3e8",
                            desktop: "gvc3qt3e9"
                        },
                        defaultClass: "gvc3qt3e7"
                    },
                    "2": {
                        conditions: {
                            mobile: "gvc3qt3ea",
                            tablet: "gvc3qt3eb",
                            desktop: "gvc3qt3ec"
                        },
                        defaultClass: "gvc3qt3ea"
                    },
                    "3": {
                        conditions: {
                            mobile: "gvc3qt3ed",
                            tablet: "gvc3qt3ee",
                            desktop: "gvc3qt3ef"
                        },
                        defaultClass: "gvc3qt3ed"
                    },
                    "4": {
                        conditions: {
                            mobile: "gvc3qt3eg",
                            tablet: "gvc3qt3eh",
                            desktop: "gvc3qt3ei"
                        },
                        defaultClass: "gvc3qt3eg"
                    },
                    "5": {
                        conditions: {
                            mobile: "gvc3qt3ej",
                            tablet: "gvc3qt3ek",
                            desktop: "gvc3qt3el"
                        },
                        defaultClass: "gvc3qt3ej"
                    },
                    "6": {
                        conditions: {
                            mobile: "gvc3qt3em",
                            tablet: "gvc3qt3en",
                            desktop: "gvc3qt3eo"
                        },
                        defaultClass: "gvc3qt3em"
                    },
                    "7": {
                        conditions: {
                            mobile: "gvc3qt3ep",
                            tablet: "gvc3qt3eq",
                            desktop: "gvc3qt3er"
                        },
                        defaultClass: "gvc3qt3ep"
                    },
                    "8": {
                        conditions: {
                            mobile: "gvc3qt3es",
                            tablet: "gvc3qt3et",
                            desktop: "gvc3qt3eu"
                        },
                        defaultClass: "gvc3qt3es"
                    },
                    "9": {
                        conditions: {
                            mobile: "gvc3qt3ev",
                            tablet: "gvc3qt3ew",
                            desktop: "gvc3qt3ex"
                        },
                        defaultClass: "gvc3qt3ev"
                    },
                    "10": {
                        conditions: {
                            mobile: "gvc3qt3ey",
                            tablet: "gvc3qt3ez",
                            desktop: "gvc3qt3f0"
                        },
                        defaultClass: "gvc3qt3ey"
                    },
                    "11": {
                        conditions: {
                            mobile: "gvc3qt3f1",
                            tablet: "gvc3qt3f2",
                            desktop: "gvc3qt3f3"
                        },
                        defaultClass: "gvc3qt3f1"
                    },
                    "12": {
                        conditions: {
                            mobile: "gvc3qt3f4",
                            tablet: "gvc3qt3f5",
                            desktop: "gvc3qt3f6"
                        },
                        defaultClass: "gvc3qt3f4"
                    },
                    "13": {
                        conditions: {
                            mobile: "gvc3qt3f7",
                            tablet: "gvc3qt3f8",
                            desktop: "gvc3qt3f9"
                        },
                        defaultClass: "gvc3qt3f7"
                    },
                    "14": {
                        conditions: {
                            mobile: "gvc3qt3fa",
                            tablet: "gvc3qt3fb",
                            desktop: "gvc3qt3fc"
                        },
                        defaultClass: "gvc3qt3fa"
                    },
                    "15": {
                        conditions: {
                            mobile: "gvc3qt3fd",
                            tablet: "gvc3qt3fe",
                            desktop: "gvc3qt3ff"
                        },
                        defaultClass: "gvc3qt3fd"
                    },
                    "16": {
                        conditions: {
                            mobile: "gvc3qt3fg",
                            tablet: "gvc3qt3fh",
                            desktop: "gvc3qt3fi"
                        },
                        defaultClass: "gvc3qt3fg"
                    },
                    "17": {
                        conditions: {
                            mobile: "gvc3qt3fj",
                            tablet: "gvc3qt3fk",
                            desktop: "gvc3qt3fl"
                        },
                        defaultClass: "gvc3qt3fj"
                    },
                    "18": {
                        conditions: {
                            mobile: "gvc3qt3fm",
                            tablet: "gvc3qt3fn",
                            desktop: "gvc3qt3fo"
                        },
                        defaultClass: "gvc3qt3fm"
                    },
                    "19": {
                        conditions: {
                            mobile: "gvc3qt3fp",
                            tablet: "gvc3qt3fq",
                            desktop: "gvc3qt3fr"
                        },
                        defaultClass: "gvc3qt3fp"
                    },
                    "20": {
                        conditions: {
                            mobile: "gvc3qt3fs",
                            tablet: "gvc3qt3ft",
                            desktop: "gvc3qt3fu"
                        },
                        defaultClass: "gvc3qt3fs"
                    },
                    "21": {
                        conditions: {
                            mobile: "gvc3qt3fv",
                            tablet: "gvc3qt3fw",
                            desktop: "gvc3qt3fx"
                        },
                        defaultClass: "gvc3qt3fv"
                    },
                    "22": {
                        conditions: {
                            mobile: "gvc3qt3fy",
                            tablet: "gvc3qt3fz",
                            desktop: "gvc3qt3g0"
                        },
                        defaultClass: "gvc3qt3fy"
                    },
                    "23": {
                        conditions: {
                            mobile: "gvc3qt3g1",
                            tablet: "gvc3qt3g2",
                            desktop: "gvc3qt3g3"
                        },
                        defaultClass: "gvc3qt3g1"
                    },
                    "24": {
                        conditions: {
                            mobile: "gvc3qt3g4",
                            tablet: "gvc3qt3g5",
                            desktop: "gvc3qt3g6"
                        },
                        defaultClass: "gvc3qt3g4"
                    },
                    "25": {
                        conditions: {
                            mobile: "gvc3qt3g7",
                            tablet: "gvc3qt3g8",
                            desktop: "gvc3qt3g9"
                        },
                        defaultClass: "gvc3qt3g7"
                    },
                    "26": {
                        conditions: {
                            mobile: "gvc3qt3ga",
                            tablet: "gvc3qt3gb",
                            desktop: "gvc3qt3gc"
                        },
                        defaultClass: "gvc3qt3ga"
                    },
                    "27": {
                        conditions: {
                            mobile: "gvc3qt3gd",
                            tablet: "gvc3qt3ge",
                            desktop: "gvc3qt3gf"
                        },
                        defaultClass: "gvc3qt3gd"
                    },
                    "28": {
                        conditions: {
                            mobile: "gvc3qt3gg",
                            tablet: "gvc3qt3gh",
                            desktop: "gvc3qt3gi"
                        },
                        defaultClass: "gvc3qt3gg"
                    },
                    "29": {
                        conditions: {
                            mobile: "gvc3qt3gj",
                            tablet: "gvc3qt3gk",
                            desktop: "gvc3qt3gl"
                        },
                        defaultClass: "gvc3qt3gj"
                    },
                    "30": {
                        conditions: {
                            mobile: "gvc3qt3gm",
                            tablet: "gvc3qt3gn",
                            desktop: "gvc3qt3go"
                        },
                        defaultClass: "gvc3qt3gm"
                    },
                    auto: {
                        conditions: {
                            mobile: "gvc3qt3gp",
                            tablet: "gvc3qt3gq",
                            desktop: "gvc3qt3gr"
                        },
                        defaultClass: "gvc3qt3gp"
                    },
                    full: {
                        conditions: {
                            mobile: "gvc3qt3gs",
                            tablet: "gvc3qt3gt",
                            desktop: "gvc3qt3gu"
                        },
                        defaultClass: "gvc3qt3gs"
                    },
                    fit: {
                        conditions: {
                            mobile: "gvc3qt3gv",
                            tablet: "gvc3qt3gw",
                            desktop: "gvc3qt3gx"
                        },
                        defaultClass: "gvc3qt3gv"
                    },
                    max: {
                        conditions: {
                            mobile: "gvc3qt3gy",
                            tablet: "gvc3qt3gz",
                            desktop: "gvc3qt3h0"
                        },
                        defaultClass: "gvc3qt3gy"
                    },
                    min: {
                        conditions: {
                            mobile: "gvc3qt3h1",
                            tablet: "gvc3qt3h2",
                            desktop: "gvc3qt3h3"
                        },
                        defaultClass: "gvc3qt3h1"
                    },
                    viewHeight: {
                        conditions: {
                            mobile: "gvc3qt3h4",
                            tablet: "gvc3qt3h5",
                            desktop: "gvc3qt3h6"
                        },
                        defaultClass: "gvc3qt3h4"
                    },
                    viewWidth: {
                        conditions: {
                            mobile: "gvc3qt3h7",
                            tablet: "gvc3qt3h8",
                            desktop: "gvc3qt3h9"
                        },
                        defaultClass: "gvc3qt3h7"
                    },
                    none: {
                        conditions: {
                            mobile: "gvc3qt3ha",
                            tablet: "gvc3qt3hb",
                            desktop: "gvc3qt3hc"
                        },
                        defaultClass: "gvc3qt3ha"
                    }
                },
                responsiveArray: undefined
            },
            textAlign: {
                values: {
                    center: {
                        conditions: {
                            mobile: "gvc3qt3hd",
                            tablet: "gvc3qt3he",
                            desktop: "gvc3qt3hf"
                        },
                        defaultClass: "gvc3qt3hd"
                    },
                    left: {
                        conditions: {
                            mobile: "gvc3qt3hg",
                            tablet: "gvc3qt3hh",
                            desktop: "gvc3qt3hi"
                        },
                        defaultClass: "gvc3qt3hg"
                    },
                    right: {
                        conditions: {
                            mobile: "gvc3qt3hj",
                            tablet: "gvc3qt3hk",
                            desktop: "gvc3qt3hl"
                        },
                        defaultClass: "gvc3qt3hj"
                    }
                },
                responsiveArray: undefined
            },
            top: {
                values: {
                    "0": {
                        conditions: {
                            mobile: "gvc3qt3hm",
                            tablet: "gvc3qt3hn",
                            desktop: "gvc3qt3ho"
                        },
                        defaultClass: "gvc3qt3hm"
                    },
                    "1": {
                        conditions: {
                            mobile: "gvc3qt3hp",
                            tablet: "gvc3qt3hq",
                            desktop: "gvc3qt3hr"
                        },
                        defaultClass: "gvc3qt3hp"
                    },
                    "2": {
                        conditions: {
                            mobile: "gvc3qt3hs",
                            tablet: "gvc3qt3ht",
                            desktop: "gvc3qt3hu"
                        },
                        defaultClass: "gvc3qt3hs"
                    },
                    "3": {
                        conditions: {
                            mobile: "gvc3qt3hv",
                            tablet: "gvc3qt3hw",
                            desktop: "gvc3qt3hx"
                        },
                        defaultClass: "gvc3qt3hv"
                    },
                    "4": {
                        conditions: {
                            mobile: "gvc3qt3hy",
                            tablet: "gvc3qt3hz",
                            desktop: "gvc3qt3i0"
                        },
                        defaultClass: "gvc3qt3hy"
                    },
                    "5": {
                        conditions: {
                            mobile: "gvc3qt3i1",
                            tablet: "gvc3qt3i2",
                            desktop: "gvc3qt3i3"
                        },
                        defaultClass: "gvc3qt3i1"
                    },
                    "6": {
                        conditions: {
                            mobile: "gvc3qt3i4",
                            tablet: "gvc3qt3i5",
                            desktop: "gvc3qt3i6"
                        },
                        defaultClass: "gvc3qt3i4"
                    },
                    "7": {
                        conditions: {
                            mobile: "gvc3qt3i7",
                            tablet: "gvc3qt3i8",
                            desktop: "gvc3qt3i9"
                        },
                        defaultClass: "gvc3qt3i7"
                    },
                    "8": {
                        conditions: {
                            mobile: "gvc3qt3ia",
                            tablet: "gvc3qt3ib",
                            desktop: "gvc3qt3ic"
                        },
                        defaultClass: "gvc3qt3ia"
                    },
                    "9": {
                        conditions: {
                            mobile: "gvc3qt3id",
                            tablet: "gvc3qt3ie",
                            desktop: "gvc3qt3if"
                        },
                        defaultClass: "gvc3qt3id"
                    },
                    "10": {
                        conditions: {
                            mobile: "gvc3qt3ig",
                            tablet: "gvc3qt3ih",
                            desktop: "gvc3qt3ii"
                        },
                        defaultClass: "gvc3qt3ig"
                    },
                    "11": {
                        conditions: {
                            mobile: "gvc3qt3ij",
                            tablet: "gvc3qt3ik",
                            desktop: "gvc3qt3il"
                        },
                        defaultClass: "gvc3qt3ij"
                    },
                    "12": {
                        conditions: {
                            mobile: "gvc3qt3im",
                            tablet: "gvc3qt3in",
                            desktop: "gvc3qt3io"
                        },
                        defaultClass: "gvc3qt3im"
                    },
                    "13": {
                        conditions: {
                            mobile: "gvc3qt3ip",
                            tablet: "gvc3qt3iq",
                            desktop: "gvc3qt3ir"
                        },
                        defaultClass: "gvc3qt3ip"
                    },
                    "14": {
                        conditions: {
                            mobile: "gvc3qt3is",
                            tablet: "gvc3qt3it",
                            desktop: "gvc3qt3iu"
                        },
                        defaultClass: "gvc3qt3is"
                    },
                    "15": {
                        conditions: {
                            mobile: "gvc3qt3iv",
                            tablet: "gvc3qt3iw",
                            desktop: "gvc3qt3ix"
                        },
                        defaultClass: "gvc3qt3iv"
                    },
                    "16": {
                        conditions: {
                            mobile: "gvc3qt3iy",
                            tablet: "gvc3qt3iz",
                            desktop: "gvc3qt3j0"
                        },
                        defaultClass: "gvc3qt3iy"
                    },
                    "17": {
                        conditions: {
                            mobile: "gvc3qt3j1",
                            tablet: "gvc3qt3j2",
                            desktop: "gvc3qt3j3"
                        },
                        defaultClass: "gvc3qt3j1"
                    },
                    "18": {
                        conditions: {
                            mobile: "gvc3qt3j4",
                            tablet: "gvc3qt3j5",
                            desktop: "gvc3qt3j6"
                        },
                        defaultClass: "gvc3qt3j4"
                    },
                    "19": {
                        conditions: {
                            mobile: "gvc3qt3j7",
                            tablet: "gvc3qt3j8",
                            desktop: "gvc3qt3j9"
                        },
                        defaultClass: "gvc3qt3j7"
                    },
                    "20": {
                        conditions: {
                            mobile: "gvc3qt3ja",
                            tablet: "gvc3qt3jb",
                            desktop: "gvc3qt3jc"
                        },
                        defaultClass: "gvc3qt3ja"
                    },
                    "21": {
                        conditions: {
                            mobile: "gvc3qt3jd",
                            tablet: "gvc3qt3je",
                            desktop: "gvc3qt3jf"
                        },
                        defaultClass: "gvc3qt3jd"
                    },
                    "22": {
                        conditions: {
                            mobile: "gvc3qt3jg",
                            tablet: "gvc3qt3jh",
                            desktop: "gvc3qt3ji"
                        },
                        defaultClass: "gvc3qt3jg"
                    },
                    "23": {
                        conditions: {
                            mobile: "gvc3qt3jj",
                            tablet: "gvc3qt3jk",
                            desktop: "gvc3qt3jl"
                        },
                        defaultClass: "gvc3qt3jj"
                    },
                    "24": {
                        conditions: {
                            mobile: "gvc3qt3jm",
                            tablet: "gvc3qt3jn",
                            desktop: "gvc3qt3jo"
                        },
                        defaultClass: "gvc3qt3jm"
                    },
                    "25": {
                        conditions: {
                            mobile: "gvc3qt3jp",
                            tablet: "gvc3qt3jq",
                            desktop: "gvc3qt3jr"
                        },
                        defaultClass: "gvc3qt3jp"
                    },
                    "26": {
                        conditions: {
                            mobile: "gvc3qt3js",
                            tablet: "gvc3qt3jt",
                            desktop: "gvc3qt3ju"
                        },
                        defaultClass: "gvc3qt3js"
                    },
                    "27": {
                        conditions: {
                            mobile: "gvc3qt3jv",
                            tablet: "gvc3qt3jw",
                            desktop: "gvc3qt3jx"
                        },
                        defaultClass: "gvc3qt3jv"
                    },
                    "28": {
                        conditions: {
                            mobile: "gvc3qt3jy",
                            tablet: "gvc3qt3jz",
                            desktop: "gvc3qt3k0"
                        },
                        defaultClass: "gvc3qt3jy"
                    },
                    "29": {
                        conditions: {
                            mobile: "gvc3qt3k1",
                            tablet: "gvc3qt3k2",
                            desktop: "gvc3qt3k3"
                        },
                        defaultClass: "gvc3qt3k1"
                    },
                    "30": {
                        conditions: {
                            mobile: "gvc3qt3k4",
                            tablet: "gvc3qt3k5",
                            desktop: "gvc3qt3k6"
                        },
                        defaultClass: "gvc3qt3k4"
                    },
                    auto: {
                        conditions: {
                            mobile: "gvc3qt3k7",
                            tablet: "gvc3qt3k8",
                            desktop: "gvc3qt3k9"
                        },
                        defaultClass: "gvc3qt3k7"
                    },
                    full: {
                        conditions: {
                            mobile: "gvc3qt3ka",
                            tablet: "gvc3qt3kb",
                            desktop: "gvc3qt3kc"
                        },
                        defaultClass: "gvc3qt3ka"
                    },
                    fit: {
                        conditions: {
                            mobile: "gvc3qt3kd",
                            tablet: "gvc3qt3ke",
                            desktop: "gvc3qt3kf"
                        },
                        defaultClass: "gvc3qt3kd"
                    },
                    max: {
                        conditions: {
                            mobile: "gvc3qt3kg",
                            tablet: "gvc3qt3kh",
                            desktop: "gvc3qt3ki"
                        },
                        defaultClass: "gvc3qt3kg"
                    },
                    min: {
                        conditions: {
                            mobile: "gvc3qt3kj",
                            tablet: "gvc3qt3kk",
                            desktop: "gvc3qt3kl"
                        },
                        defaultClass: "gvc3qt3kj"
                    },
                    viewHeight: {
                        conditions: {
                            mobile: "gvc3qt3km",
                            tablet: "gvc3qt3kn",
                            desktop: "gvc3qt3ko"
                        },
                        defaultClass: "gvc3qt3km"
                    },
                    viewWidth: {
                        conditions: {
                            mobile: "gvc3qt3kp",
                            tablet: "gvc3qt3kq",
                            desktop: "gvc3qt3kr"
                        },
                        defaultClass: "gvc3qt3kp"
                    },
                    none: {
                        conditions: {
                            mobile: "gvc3qt3ks",
                            tablet: "gvc3qt3kt",
                            desktop: "gvc3qt3ku"
                        },
                        defaultClass: "gvc3qt3ks"
                    }
                },
                responsiveArray: undefined
            }
        }
    };
    x.styles.alignItems.responsiveArray = x.conditions.responsiveArray;
    x.styles.alignSelf.responsiveArray = x.conditions.responsiveArray;
    x.styles.borderWidth.responsiveArray = x.conditions.responsiveArray;
    x.styles.borderBottomWidth.responsiveArray = x.conditions.responsiveArray;
    x.styles.borderLeftWidth.responsiveArray = x.conditions.responsiveArray;
    x.styles.borderRightWidth.responsiveArray = x.conditions.responsiveArray;
    x.styles.borderTopWidth.responsiveArray = x.conditions.responsiveArray;
    x.styles.borderRadius.responsiveArray = x.conditions.responsiveArray;
    x.styles.borderBottomLeftRadius.responsiveArray = x.conditions.responsiveArray;
    x.styles.borderBottomRightRadius.responsiveArray = x.conditions.responsiveArray;
    x.styles.borderTopLeftRadius.responsiveArray = x.conditions.responsiveArray;
    x.styles.borderTopRightRadius.responsiveArray = x.conditions.responsiveArray;
    x.styles.bottom.responsiveArray = x.conditions.responsiveArray;
    x.styles.display.responsiveArray = x.conditions.responsiveArray;
    x.styles.flex.responsiveArray = x.conditions.responsiveArray;
    x.styles.flexBasis.responsiveArray = x.conditions.responsiveArray;
    x.styles.flexDirection.responsiveArray = x.conditions.responsiveArray;
    x.styles.flexWrap.responsiveArray = x.conditions.responsiveArray;
    x.styles.fontSize.responsiveArray = x.conditions.responsiveArray;
    x.styles.fontWeight.responsiveArray = x.conditions.responsiveArray;
    x.styles.gap.responsiveArray = x.conditions.responsiveArray;
    x.styles.height.responsiveArray = x.conditions.responsiveArray;
    x.styles.inset.responsiveArray = x.conditions.responsiveArray;
    x.styles.justifyContent.responsiveArray = x.conditions.responsiveArray;
    x.styles.justifySelf.responsiveArray = x.conditions.responsiveArray;
    x.styles.left.responsiveArray = x.conditions.responsiveArray;
    x.styles.letterSpacing.responsiveArray = x.conditions.responsiveArray;
    x.styles.lineHeight.responsiveArray = x.conditions.responsiveArray;
    x.styles.marginBottom.responsiveArray = x.conditions.responsiveArray;
    x.styles.marginLeft.responsiveArray = x.conditions.responsiveArray;
    x.styles.marginRight.responsiveArray = x.conditions.responsiveArray;
    x.styles.marginTop.responsiveArray = x.conditions.responsiveArray;
    x.styles.maxHeight.responsiveArray = x.conditions.responsiveArray;
    x.styles.maxWidth.responsiveArray = x.conditions.responsiveArray;
    x.styles.width.responsiveArray = x.conditions.responsiveArray;
    x.styles.minHeight.responsiveArray = x.conditions.responsiveArray;
    x.styles.minWidth.responsiveArray = x.conditions.responsiveArray;
    x.styles.paddingBottom.responsiveArray = x.conditions.responsiveArray;
    x.styles.paddingLeft.responsiveArray = x.conditions.responsiveArray;
    x.styles.paddingRight.responsiveArray = x.conditions.responsiveArray;
    x.styles.paddingTop.responsiveArray = x.conditions.responsiveArray;
    x.styles.position.responsiveArray = x.conditions.responsiveArray;
    x.styles.right.responsiveArray = x.conditions.responsiveArray;
    x.styles.textAlign.responsiveArray = x.conditions.responsiveArray;
    x.styles.top.responsiveArray = x.conditions.responsiveArray;
    return x;
}(), {
    conditions: {
        defaultCondition: [
            "light",
            "dark"
        ],
        conditionNames: [
            "light",
            "dark",
            "hover",
            "focus"
        ],
        responsiveArray: undefined
    },
    styles: {
        color: {
            values: {
                primary: {
                    conditions: {
                        light: "gvc3qt31",
                        dark: "gvc3qt32",
                        hover: "gvc3qt33",
                        focus: "gvc3qt34"
                    },
                    defaultClass: "gvc3qt31 gvc3qt32"
                },
                body: {
                    conditions: {
                        light: "gvc3qt35",
                        dark: "gvc3qt36",
                        hover: "gvc3qt37",
                        focus: "gvc3qt38"
                    },
                    defaultClass: "gvc3qt35 gvc3qt36"
                },
                background: {
                    conditions: {
                        light: "gvc3qt39",
                        dark: "gvc3qt3a",
                        hover: "gvc3qt3b",
                        focus: "gvc3qt3c"
                    },
                    defaultClass: "gvc3qt39 gvc3qt3a"
                },
                link: {
                    conditions: {
                        light: "gvc3qt3d",
                        dark: "gvc3qt3e",
                        hover: "gvc3qt3f",
                        focus: "gvc3qt3g"
                    },
                    defaultClass: "gvc3qt3d gvc3qt3e"
                },
                linkHover: {
                    conditions: {
                        light: "gvc3qt3h",
                        dark: "gvc3qt3i",
                        hover: "gvc3qt3j",
                        focus: "gvc3qt3k"
                    },
                    defaultClass: "gvc3qt3h gvc3qt3i"
                },
                text: {
                    conditions: {
                        light: "gvc3qt3l",
                        dark: "gvc3qt3m",
                        hover: "gvc3qt3n",
                        focus: "gvc3qt3o"
                    },
                    defaultClass: "gvc3qt3l gvc3qt3m"
                },
                textSecondary: {
                    conditions: {
                        light: "gvc3qt3p",
                        dark: "gvc3qt3q",
                        hover: "gvc3qt3r",
                        focus: "gvc3qt3s"
                    },
                    defaultClass: "gvc3qt3p gvc3qt3q"
                },
                textDanger: {
                    conditions: {
                        light: "gvc3qt3t",
                        dark: "gvc3qt3u",
                        hover: "gvc3qt3v",
                        focus: "gvc3qt3w"
                    },
                    defaultClass: "gvc3qt3t gvc3qt3u"
                },
                textWarning: {
                    conditions: {
                        light: "gvc3qt3x",
                        dark: "gvc3qt3y",
                        hover: "gvc3qt3z",
                        focus: "gvc3qt40"
                    },
                    defaultClass: "gvc3qt3x gvc3qt3y"
                },
                rewardBg: {
                    conditions: {
                        light: "gvc3qt41",
                        dark: "gvc3qt42",
                        hover: "gvc3qt43",
                        focus: "gvc3qt44"
                    },
                    defaultClass: "gvc3qt41 gvc3qt42"
                },
                rewardContent: {
                    conditions: {
                        light: "gvc3qt45",
                        dark: "gvc3qt46",
                        hover: "gvc3qt47",
                        focus: "gvc3qt48"
                    },
                    defaultClass: "gvc3qt45 gvc3qt46"
                },
                cardBg: {
                    conditions: {
                        light: "gvc3qt49",
                        dark: "gvc3qt4a",
                        hover: "gvc3qt4b",
                        focus: "gvc3qt4c"
                    },
                    defaultClass: "gvc3qt49 gvc3qt4a"
                },
                inputBorder: {
                    conditions: {
                        light: "gvc3qt4d",
                        dark: "gvc3qt4e",
                        hover: "gvc3qt4f",
                        focus: "gvc3qt4g"
                    },
                    defaultClass: "gvc3qt4d gvc3qt4e"
                },
                progressBg: {
                    conditions: {
                        light: "gvc3qt4h",
                        dark: "gvc3qt4i",
                        hover: "gvc3qt4j",
                        focus: "gvc3qt4k"
                    },
                    defaultClass: "gvc3qt4h gvc3qt4i"
                },
                progressValue: {
                    conditions: {
                        light: "gvc3qt4l",
                        dark: "gvc3qt4m",
                        hover: "gvc3qt4n",
                        focus: "gvc3qt4o"
                    },
                    defaultClass: "gvc3qt4l gvc3qt4m"
                },
                progressCursor: {
                    conditions: {
                        light: "gvc3qt4p",
                        dark: "gvc3qt4q",
                        hover: "gvc3qt4r",
                        focus: "gvc3qt4s"
                    },
                    defaultClass: "gvc3qt4p gvc3qt4q"
                },
                black: {
                    conditions: {
                        light: "gvc3qt4t",
                        dark: "gvc3qt4u",
                        hover: "gvc3qt4v",
                        focus: "gvc3qt4w"
                    },
                    defaultClass: "gvc3qt4t gvc3qt4u"
                },
                white: {
                    conditions: {
                        light: "gvc3qt4x",
                        dark: "gvc3qt4y",
                        hover: "gvc3qt4z",
                        focus: "gvc3qt50"
                    },
                    defaultClass: "gvc3qt4x gvc3qt4y"
                },
                transparent: {
                    conditions: {
                        light: "gvc3qt51",
                        dark: "gvc3qt52",
                        hover: "gvc3qt53",
                        focus: "gvc3qt54"
                    },
                    defaultClass: "gvc3qt51 gvc3qt52"
                },
                current: {
                    conditions: {
                        light: "gvc3qt55",
                        dark: "gvc3qt56",
                        hover: "gvc3qt57",
                        focus: "gvc3qt58"
                    },
                    defaultClass: "gvc3qt55 gvc3qt56"
                },
                whiteAlpha50: {
                    conditions: {
                        light: "gvc3qt59",
                        dark: "gvc3qt5a",
                        hover: "gvc3qt5b",
                        focus: "gvc3qt5c"
                    },
                    defaultClass: "gvc3qt59 gvc3qt5a"
                },
                whiteAlpha100: {
                    conditions: {
                        light: "gvc3qt5d",
                        dark: "gvc3qt5e",
                        hover: "gvc3qt5f",
                        focus: "gvc3qt5g"
                    },
                    defaultClass: "gvc3qt5d gvc3qt5e"
                },
                whiteAlpha200: {
                    conditions: {
                        light: "gvc3qt5h",
                        dark: "gvc3qt5i",
                        hover: "gvc3qt5j",
                        focus: "gvc3qt5k"
                    },
                    defaultClass: "gvc3qt5h gvc3qt5i"
                },
                whiteAlpha300: {
                    conditions: {
                        light: "gvc3qt5l",
                        dark: "gvc3qt5m",
                        hover: "gvc3qt5n",
                        focus: "gvc3qt5o"
                    },
                    defaultClass: "gvc3qt5l gvc3qt5m"
                },
                whiteAlpha400: {
                    conditions: {
                        light: "gvc3qt5p",
                        dark: "gvc3qt5q",
                        hover: "gvc3qt5r",
                        focus: "gvc3qt5s"
                    },
                    defaultClass: "gvc3qt5p gvc3qt5q"
                },
                whiteAlpha500: {
                    conditions: {
                        light: "gvc3qt5t",
                        dark: "gvc3qt5u",
                        hover: "gvc3qt5v",
                        focus: "gvc3qt5w"
                    },
                    defaultClass: "gvc3qt5t gvc3qt5u"
                },
                whiteAlpha600: {
                    conditions: {
                        light: "gvc3qt5x",
                        dark: "gvc3qt5y",
                        hover: "gvc3qt5z",
                        focus: "gvc3qt60"
                    },
                    defaultClass: "gvc3qt5x gvc3qt5y"
                },
                whiteAlpha700: {
                    conditions: {
                        light: "gvc3qt61",
                        dark: "gvc3qt62",
                        hover: "gvc3qt63",
                        focus: "gvc3qt64"
                    },
                    defaultClass: "gvc3qt61 gvc3qt62"
                },
                whiteAlpha800: {
                    conditions: {
                        light: "gvc3qt65",
                        dark: "gvc3qt66",
                        hover: "gvc3qt67",
                        focus: "gvc3qt68"
                    },
                    defaultClass: "gvc3qt65 gvc3qt66"
                },
                whiteAlpha900: {
                    conditions: {
                        light: "gvc3qt69",
                        dark: "gvc3qt6a",
                        hover: "gvc3qt6b",
                        focus: "gvc3qt6c"
                    },
                    defaultClass: "gvc3qt69 gvc3qt6a"
                },
                blackAlpha50: {
                    conditions: {
                        light: "gvc3qt6d",
                        dark: "gvc3qt6e",
                        hover: "gvc3qt6f",
                        focus: "gvc3qt6g"
                    },
                    defaultClass: "gvc3qt6d gvc3qt6e"
                },
                blackAlpha100: {
                    conditions: {
                        light: "gvc3qt6h",
                        dark: "gvc3qt6i",
                        hover: "gvc3qt6j",
                        focus: "gvc3qt6k"
                    },
                    defaultClass: "gvc3qt6h gvc3qt6i"
                },
                blackAlpha200: {
                    conditions: {
                        light: "gvc3qt6l",
                        dark: "gvc3qt6m",
                        hover: "gvc3qt6n",
                        focus: "gvc3qt6o"
                    },
                    defaultClass: "gvc3qt6l gvc3qt6m"
                },
                blackAlpha300: {
                    conditions: {
                        light: "gvc3qt6p",
                        dark: "gvc3qt6q",
                        hover: "gvc3qt6r",
                        focus: "gvc3qt6s"
                    },
                    defaultClass: "gvc3qt6p gvc3qt6q"
                },
                blackAlpha400: {
                    conditions: {
                        light: "gvc3qt6t",
                        dark: "gvc3qt6u",
                        hover: "gvc3qt6v",
                        focus: "gvc3qt6w"
                    },
                    defaultClass: "gvc3qt6t gvc3qt6u"
                },
                blackAlpha500: {
                    conditions: {
                        light: "gvc3qt6x",
                        dark: "gvc3qt6y",
                        hover: "gvc3qt6z",
                        focus: "gvc3qt70"
                    },
                    defaultClass: "gvc3qt6x gvc3qt6y"
                },
                blackAlpha600: {
                    conditions: {
                        light: "gvc3qt71",
                        dark: "gvc3qt72",
                        hover: "gvc3qt73",
                        focus: "gvc3qt74"
                    },
                    defaultClass: "gvc3qt71 gvc3qt72"
                },
                blackAlpha700: {
                    conditions: {
                        light: "gvc3qt75",
                        dark: "gvc3qt76",
                        hover: "gvc3qt77",
                        focus: "gvc3qt78"
                    },
                    defaultClass: "gvc3qt75 gvc3qt76"
                },
                blackAlpha800: {
                    conditions: {
                        light: "gvc3qt79",
                        dark: "gvc3qt7a",
                        hover: "gvc3qt7b",
                        focus: "gvc3qt7c"
                    },
                    defaultClass: "gvc3qt79 gvc3qt7a"
                },
                blackAlpha900: {
                    conditions: {
                        light: "gvc3qt7d",
                        dark: "gvc3qt7e",
                        hover: "gvc3qt7f",
                        focus: "gvc3qt7g"
                    },
                    defaultClass: "gvc3qt7d gvc3qt7e"
                },
                gray50: {
                    conditions: {
                        light: "gvc3qt7h",
                        dark: "gvc3qt7i",
                        hover: "gvc3qt7j",
                        focus: "gvc3qt7k"
                    },
                    defaultClass: "gvc3qt7h gvc3qt7i"
                },
                gray100: {
                    conditions: {
                        light: "gvc3qt7l",
                        dark: "gvc3qt7m",
                        hover: "gvc3qt7n",
                        focus: "gvc3qt7o"
                    },
                    defaultClass: "gvc3qt7l gvc3qt7m"
                },
                gray200: {
                    conditions: {
                        light: "gvc3qt7p",
                        dark: "gvc3qt7q",
                        hover: "gvc3qt7r",
                        focus: "gvc3qt7s"
                    },
                    defaultClass: "gvc3qt7p gvc3qt7q"
                },
                gray300: {
                    conditions: {
                        light: "gvc3qt7t",
                        dark: "gvc3qt7u",
                        hover: "gvc3qt7v",
                        focus: "gvc3qt7w"
                    },
                    defaultClass: "gvc3qt7t gvc3qt7u"
                },
                gray400: {
                    conditions: {
                        light: "gvc3qt7x",
                        dark: "gvc3qt7y",
                        hover: "gvc3qt7z",
                        focus: "gvc3qt80"
                    },
                    defaultClass: "gvc3qt7x gvc3qt7y"
                },
                gray500: {
                    conditions: {
                        light: "gvc3qt81",
                        dark: "gvc3qt82",
                        hover: "gvc3qt83",
                        focus: "gvc3qt84"
                    },
                    defaultClass: "gvc3qt81 gvc3qt82"
                },
                gray600: {
                    conditions: {
                        light: "gvc3qt85",
                        dark: "gvc3qt86",
                        hover: "gvc3qt87",
                        focus: "gvc3qt88"
                    },
                    defaultClass: "gvc3qt85 gvc3qt86"
                },
                gray700: {
                    conditions: {
                        light: "gvc3qt89",
                        dark: "gvc3qt8a",
                        hover: "gvc3qt8b",
                        focus: "gvc3qt8c"
                    },
                    defaultClass: "gvc3qt89 gvc3qt8a"
                },
                gray800: {
                    conditions: {
                        light: "gvc3qt8d",
                        dark: "gvc3qt8e",
                        hover: "gvc3qt8f",
                        focus: "gvc3qt8g"
                    },
                    defaultClass: "gvc3qt8d gvc3qt8e"
                },
                gray900: {
                    conditions: {
                        light: "gvc3qt8h",
                        dark: "gvc3qt8i",
                        hover: "gvc3qt8j",
                        focus: "gvc3qt8k"
                    },
                    defaultClass: "gvc3qt8h gvc3qt8i"
                },
                red50: {
                    conditions: {
                        light: "gvc3qt8l",
                        dark: "gvc3qt8m",
                        hover: "gvc3qt8n",
                        focus: "gvc3qt8o"
                    },
                    defaultClass: "gvc3qt8l gvc3qt8m"
                },
                red100: {
                    conditions: {
                        light: "gvc3qt8p",
                        dark: "gvc3qt8q",
                        hover: "gvc3qt8r",
                        focus: "gvc3qt8s"
                    },
                    defaultClass: "gvc3qt8p gvc3qt8q"
                },
                red200: {
                    conditions: {
                        light: "gvc3qt8t",
                        dark: "gvc3qt8u",
                        hover: "gvc3qt8v",
                        focus: "gvc3qt8w"
                    },
                    defaultClass: "gvc3qt8t gvc3qt8u"
                },
                red300: {
                    conditions: {
                        light: "gvc3qt8x",
                        dark: "gvc3qt8y",
                        hover: "gvc3qt8z",
                        focus: "gvc3qt90"
                    },
                    defaultClass: "gvc3qt8x gvc3qt8y"
                },
                red400: {
                    conditions: {
                        light: "gvc3qt91",
                        dark: "gvc3qt92",
                        hover: "gvc3qt93",
                        focus: "gvc3qt94"
                    },
                    defaultClass: "gvc3qt91 gvc3qt92"
                },
                red500: {
                    conditions: {
                        light: "gvc3qt95",
                        dark: "gvc3qt96",
                        hover: "gvc3qt97",
                        focus: "gvc3qt98"
                    },
                    defaultClass: "gvc3qt95 gvc3qt96"
                },
                red600: {
                    conditions: {
                        light: "gvc3qt99",
                        dark: "gvc3qt9a",
                        hover: "gvc3qt9b",
                        focus: "gvc3qt9c"
                    },
                    defaultClass: "gvc3qt99 gvc3qt9a"
                },
                red700: {
                    conditions: {
                        light: "gvc3qt9d",
                        dark: "gvc3qt9e",
                        hover: "gvc3qt9f",
                        focus: "gvc3qt9g"
                    },
                    defaultClass: "gvc3qt9d gvc3qt9e"
                },
                red800: {
                    conditions: {
                        light: "gvc3qt9h",
                        dark: "gvc3qt9i",
                        hover: "gvc3qt9j",
                        focus: "gvc3qt9k"
                    },
                    defaultClass: "gvc3qt9h gvc3qt9i"
                },
                red900: {
                    conditions: {
                        light: "gvc3qt9l",
                        dark: "gvc3qt9m",
                        hover: "gvc3qt9n",
                        focus: "gvc3qt9o"
                    },
                    defaultClass: "gvc3qt9l gvc3qt9m"
                },
                orange50: {
                    conditions: {
                        light: "gvc3qt9p",
                        dark: "gvc3qt9q",
                        hover: "gvc3qt9r",
                        focus: "gvc3qt9s"
                    },
                    defaultClass: "gvc3qt9p gvc3qt9q"
                },
                orange100: {
                    conditions: {
                        light: "gvc3qt9t",
                        dark: "gvc3qt9u",
                        hover: "gvc3qt9v",
                        focus: "gvc3qt9w"
                    },
                    defaultClass: "gvc3qt9t gvc3qt9u"
                },
                orange200: {
                    conditions: {
                        light: "gvc3qt9x",
                        dark: "gvc3qt9y",
                        hover: "gvc3qt9z",
                        focus: "gvc3qta0"
                    },
                    defaultClass: "gvc3qt9x gvc3qt9y"
                },
                orange300: {
                    conditions: {
                        light: "gvc3qta1",
                        dark: "gvc3qta2",
                        hover: "gvc3qta3",
                        focus: "gvc3qta4"
                    },
                    defaultClass: "gvc3qta1 gvc3qta2"
                },
                orange400: {
                    conditions: {
                        light: "gvc3qta5",
                        dark: "gvc3qta6",
                        hover: "gvc3qta7",
                        focus: "gvc3qta8"
                    },
                    defaultClass: "gvc3qta5 gvc3qta6"
                },
                orange500: {
                    conditions: {
                        light: "gvc3qta9",
                        dark: "gvc3qtaa",
                        hover: "gvc3qtab",
                        focus: "gvc3qtac"
                    },
                    defaultClass: "gvc3qta9 gvc3qtaa"
                },
                orange600: {
                    conditions: {
                        light: "gvc3qtad",
                        dark: "gvc3qtae",
                        hover: "gvc3qtaf",
                        focus: "gvc3qtag"
                    },
                    defaultClass: "gvc3qtad gvc3qtae"
                },
                orange700: {
                    conditions: {
                        light: "gvc3qtah",
                        dark: "gvc3qtai",
                        hover: "gvc3qtaj",
                        focus: "gvc3qtak"
                    },
                    defaultClass: "gvc3qtah gvc3qtai"
                },
                orange800: {
                    conditions: {
                        light: "gvc3qtal",
                        dark: "gvc3qtam",
                        hover: "gvc3qtan",
                        focus: "gvc3qtao"
                    },
                    defaultClass: "gvc3qtal gvc3qtam"
                },
                orange900: {
                    conditions: {
                        light: "gvc3qtap",
                        dark: "gvc3qtaq",
                        hover: "gvc3qtar",
                        focus: "gvc3qtas"
                    },
                    defaultClass: "gvc3qtap gvc3qtaq"
                },
                yellow50: {
                    conditions: {
                        light: "gvc3qtat",
                        dark: "gvc3qtau",
                        hover: "gvc3qtav",
                        focus: "gvc3qtaw"
                    },
                    defaultClass: "gvc3qtat gvc3qtau"
                },
                yellow100: {
                    conditions: {
                        light: "gvc3qtax",
                        dark: "gvc3qtay",
                        hover: "gvc3qtaz",
                        focus: "gvc3qtb0"
                    },
                    defaultClass: "gvc3qtax gvc3qtay"
                },
                yellow200: {
                    conditions: {
                        light: "gvc3qtb1",
                        dark: "gvc3qtb2",
                        hover: "gvc3qtb3",
                        focus: "gvc3qtb4"
                    },
                    defaultClass: "gvc3qtb1 gvc3qtb2"
                },
                yellow300: {
                    conditions: {
                        light: "gvc3qtb5",
                        dark: "gvc3qtb6",
                        hover: "gvc3qtb7",
                        focus: "gvc3qtb8"
                    },
                    defaultClass: "gvc3qtb5 gvc3qtb6"
                },
                yellow400: {
                    conditions: {
                        light: "gvc3qtb9",
                        dark: "gvc3qtba",
                        hover: "gvc3qtbb",
                        focus: "gvc3qtbc"
                    },
                    defaultClass: "gvc3qtb9 gvc3qtba"
                },
                yellow500: {
                    conditions: {
                        light: "gvc3qtbd",
                        dark: "gvc3qtbe",
                        hover: "gvc3qtbf",
                        focus: "gvc3qtbg"
                    },
                    defaultClass: "gvc3qtbd gvc3qtbe"
                },
                yellow600: {
                    conditions: {
                        light: "gvc3qtbh",
                        dark: "gvc3qtbi",
                        hover: "gvc3qtbj",
                        focus: "gvc3qtbk"
                    },
                    defaultClass: "gvc3qtbh gvc3qtbi"
                },
                yellow700: {
                    conditions: {
                        light: "gvc3qtbl",
                        dark: "gvc3qtbm",
                        hover: "gvc3qtbn",
                        focus: "gvc3qtbo"
                    },
                    defaultClass: "gvc3qtbl gvc3qtbm"
                },
                yellow800: {
                    conditions: {
                        light: "gvc3qtbp",
                        dark: "gvc3qtbq",
                        hover: "gvc3qtbr",
                        focus: "gvc3qtbs"
                    },
                    defaultClass: "gvc3qtbp gvc3qtbq"
                },
                yellow900: {
                    conditions: {
                        light: "gvc3qtbt",
                        dark: "gvc3qtbu",
                        hover: "gvc3qtbv",
                        focus: "gvc3qtbw"
                    },
                    defaultClass: "gvc3qtbt gvc3qtbu"
                },
                green50: {
                    conditions: {
                        light: "gvc3qtbx",
                        dark: "gvc3qtby",
                        hover: "gvc3qtbz",
                        focus: "gvc3qtc0"
                    },
                    defaultClass: "gvc3qtbx gvc3qtby"
                },
                green100: {
                    conditions: {
                        light: "gvc3qtc1",
                        dark: "gvc3qtc2",
                        hover: "gvc3qtc3",
                        focus: "gvc3qtc4"
                    },
                    defaultClass: "gvc3qtc1 gvc3qtc2"
                },
                green200: {
                    conditions: {
                        light: "gvc3qtc5",
                        dark: "gvc3qtc6",
                        hover: "gvc3qtc7",
                        focus: "gvc3qtc8"
                    },
                    defaultClass: "gvc3qtc5 gvc3qtc6"
                },
                green300: {
                    conditions: {
                        light: "gvc3qtc9",
                        dark: "gvc3qtca",
                        hover: "gvc3qtcb",
                        focus: "gvc3qtcc"
                    },
                    defaultClass: "gvc3qtc9 gvc3qtca"
                },
                green400: {
                    conditions: {
                        light: "gvc3qtcd",
                        dark: "gvc3qtce",
                        hover: "gvc3qtcf",
                        focus: "gvc3qtcg"
                    },
                    defaultClass: "gvc3qtcd gvc3qtce"
                },
                green500: {
                    conditions: {
                        light: "gvc3qtch",
                        dark: "gvc3qtci",
                        hover: "gvc3qtcj",
                        focus: "gvc3qtck"
                    },
                    defaultClass: "gvc3qtch gvc3qtci"
                },
                green600: {
                    conditions: {
                        light: "gvc3qtcl",
                        dark: "gvc3qtcm",
                        hover: "gvc3qtcn",
                        focus: "gvc3qtco"
                    },
                    defaultClass: "gvc3qtcl gvc3qtcm"
                },
                green700: {
                    conditions: {
                        light: "gvc3qtcp",
                        dark: "gvc3qtcq",
                        hover: "gvc3qtcr",
                        focus: "gvc3qtcs"
                    },
                    defaultClass: "gvc3qtcp gvc3qtcq"
                },
                green800: {
                    conditions: {
                        light: "gvc3qtct",
                        dark: "gvc3qtcu",
                        hover: "gvc3qtcv",
                        focus: "gvc3qtcw"
                    },
                    defaultClass: "gvc3qtct gvc3qtcu"
                },
                green900: {
                    conditions: {
                        light: "gvc3qtcx",
                        dark: "gvc3qtcy",
                        hover: "gvc3qtcz",
                        focus: "gvc3qtd0"
                    },
                    defaultClass: "gvc3qtcx gvc3qtcy"
                },
                blue50: {
                    conditions: {
                        light: "gvc3qtd1",
                        dark: "gvc3qtd2",
                        hover: "gvc3qtd3",
                        focus: "gvc3qtd4"
                    },
                    defaultClass: "gvc3qtd1 gvc3qtd2"
                },
                blue100: {
                    conditions: {
                        light: "gvc3qtd5",
                        dark: "gvc3qtd6",
                        hover: "gvc3qtd7",
                        focus: "gvc3qtd8"
                    },
                    defaultClass: "gvc3qtd5 gvc3qtd6"
                },
                blue200: {
                    conditions: {
                        light: "gvc3qtd9",
                        dark: "gvc3qtda",
                        hover: "gvc3qtdb",
                        focus: "gvc3qtdc"
                    },
                    defaultClass: "gvc3qtd9 gvc3qtda"
                },
                blue300: {
                    conditions: {
                        light: "gvc3qtdd",
                        dark: "gvc3qtde",
                        hover: "gvc3qtdf",
                        focus: "gvc3qtdg"
                    },
                    defaultClass: "gvc3qtdd gvc3qtde"
                },
                blue400: {
                    conditions: {
                        light: "gvc3qtdh",
                        dark: "gvc3qtdi",
                        hover: "gvc3qtdj",
                        focus: "gvc3qtdk"
                    },
                    defaultClass: "gvc3qtdh gvc3qtdi"
                },
                blue500: {
                    conditions: {
                        light: "gvc3qtdl",
                        dark: "gvc3qtdm",
                        hover: "gvc3qtdn",
                        focus: "gvc3qtdo"
                    },
                    defaultClass: "gvc3qtdl gvc3qtdm"
                },
                blue600: {
                    conditions: {
                        light: "gvc3qtdp",
                        dark: "gvc3qtdq",
                        hover: "gvc3qtdr",
                        focus: "gvc3qtds"
                    },
                    defaultClass: "gvc3qtdp gvc3qtdq"
                },
                blue700: {
                    conditions: {
                        light: "gvc3qtdt",
                        dark: "gvc3qtdu",
                        hover: "gvc3qtdv",
                        focus: "gvc3qtdw"
                    },
                    defaultClass: "gvc3qtdt gvc3qtdu"
                },
                blue800: {
                    conditions: {
                        light: "gvc3qtdx",
                        dark: "gvc3qtdy",
                        hover: "gvc3qtdz",
                        focus: "gvc3qte0"
                    },
                    defaultClass: "gvc3qtdx gvc3qtdy"
                },
                blue900: {
                    conditions: {
                        light: "gvc3qte1",
                        dark: "gvc3qte2",
                        hover: "gvc3qte3",
                        focus: "gvc3qte4"
                    },
                    defaultClass: "gvc3qte1 gvc3qte2"
                },
                primary50: {
                    conditions: {
                        light: "gvc3qte5",
                        dark: "gvc3qte6",
                        hover: "gvc3qte7",
                        focus: "gvc3qte8"
                    },
                    defaultClass: "gvc3qte5 gvc3qte6"
                },
                primary100: {
                    conditions: {
                        light: "gvc3qte9",
                        dark: "gvc3qtea",
                        hover: "gvc3qteb",
                        focus: "gvc3qtec"
                    },
                    defaultClass: "gvc3qte9 gvc3qtea"
                },
                primary200: {
                    conditions: {
                        light: "gvc3qted",
                        dark: "gvc3qtee",
                        hover: "gvc3qtef",
                        focus: "gvc3qteg"
                    },
                    defaultClass: "gvc3qted gvc3qtee"
                },
                primary300: {
                    conditions: {
                        light: "gvc3qteh",
                        dark: "gvc3qtei",
                        hover: "gvc3qtej",
                        focus: "gvc3qtek"
                    },
                    defaultClass: "gvc3qteh gvc3qtei"
                },
                primary400: {
                    conditions: {
                        light: "gvc3qtel",
                        dark: "gvc3qtem",
                        hover: "gvc3qten",
                        focus: "gvc3qteo"
                    },
                    defaultClass: "gvc3qtel gvc3qtem"
                },
                primary500: {
                    conditions: {
                        light: "gvc3qtep",
                        dark: "gvc3qteq",
                        hover: "gvc3qter",
                        focus: "gvc3qtes"
                    },
                    defaultClass: "gvc3qtep gvc3qteq"
                },
                primary600: {
                    conditions: {
                        light: "gvc3qtet",
                        dark: "gvc3qteu",
                        hover: "gvc3qtev",
                        focus: "gvc3qtew"
                    },
                    defaultClass: "gvc3qtet gvc3qteu"
                },
                primary700: {
                    conditions: {
                        light: "gvc3qtex",
                        dark: "gvc3qtey",
                        hover: "gvc3qtez",
                        focus: "gvc3qtf0"
                    },
                    defaultClass: "gvc3qtex gvc3qtey"
                },
                primary800: {
                    conditions: {
                        light: "gvc3qtf1",
                        dark: "gvc3qtf2",
                        hover: "gvc3qtf3",
                        focus: "gvc3qtf4"
                    },
                    defaultClass: "gvc3qtf1 gvc3qtf2"
                },
                primary900: {
                    conditions: {
                        light: "gvc3qtf5",
                        dark: "gvc3qtf6",
                        hover: "gvc3qtf7",
                        focus: "gvc3qtf8"
                    },
                    defaultClass: "gvc3qtf5 gvc3qtf6"
                },
                purple50: {
                    conditions: {
                        light: "gvc3qtf9",
                        dark: "gvc3qtfa",
                        hover: "gvc3qtfb",
                        focus: "gvc3qtfc"
                    },
                    defaultClass: "gvc3qtf9 gvc3qtfa"
                },
                purple100: {
                    conditions: {
                        light: "gvc3qtfd",
                        dark: "gvc3qtfe",
                        hover: "gvc3qtff",
                        focus: "gvc3qtfg"
                    },
                    defaultClass: "gvc3qtfd gvc3qtfe"
                },
                purple200: {
                    conditions: {
                        light: "gvc3qtfh",
                        dark: "gvc3qtfi",
                        hover: "gvc3qtfj",
                        focus: "gvc3qtfk"
                    },
                    defaultClass: "gvc3qtfh gvc3qtfi"
                },
                purple300: {
                    conditions: {
                        light: "gvc3qtfl",
                        dark: "gvc3qtfm",
                        hover: "gvc3qtfn",
                        focus: "gvc3qtfo"
                    },
                    defaultClass: "gvc3qtfl gvc3qtfm"
                },
                purple400: {
                    conditions: {
                        light: "gvc3qtfp",
                        dark: "gvc3qtfq",
                        hover: "gvc3qtfr",
                        focus: "gvc3qtfs"
                    },
                    defaultClass: "gvc3qtfp gvc3qtfq"
                },
                purple500: {
                    conditions: {
                        light: "gvc3qtft",
                        dark: "gvc3qtfu",
                        hover: "gvc3qtfv",
                        focus: "gvc3qtfw"
                    },
                    defaultClass: "gvc3qtft gvc3qtfu"
                },
                purple600: {
                    conditions: {
                        light: "gvc3qtfx",
                        dark: "gvc3qtfy",
                        hover: "gvc3qtfz",
                        focus: "gvc3qtg0"
                    },
                    defaultClass: "gvc3qtfx gvc3qtfy"
                },
                purple700: {
                    conditions: {
                        light: "gvc3qtg1",
                        dark: "gvc3qtg2",
                        hover: "gvc3qtg3",
                        focus: "gvc3qtg4"
                    },
                    defaultClass: "gvc3qtg1 gvc3qtg2"
                },
                purple800: {
                    conditions: {
                        light: "gvc3qtg5",
                        dark: "gvc3qtg6",
                        hover: "gvc3qtg7",
                        focus: "gvc3qtg8"
                    },
                    defaultClass: "gvc3qtg5 gvc3qtg6"
                },
                purple900: {
                    conditions: {
                        light: "gvc3qtg9",
                        dark: "gvc3qtga",
                        hover: "gvc3qtgb",
                        focus: "gvc3qtgc"
                    },
                    defaultClass: "gvc3qtg9 gvc3qtga"
                }
            }
        },
        backgroundColor: {
            values: {
                primary: {
                    conditions: {
                        light: "gvc3qtgd",
                        dark: "gvc3qtge",
                        hover: "gvc3qtgf",
                        focus: "gvc3qtgg"
                    },
                    defaultClass: "gvc3qtgd gvc3qtge"
                },
                body: {
                    conditions: {
                        light: "gvc3qtgh",
                        dark: "gvc3qtgi",
                        hover: "gvc3qtgj",
                        focus: "gvc3qtgk"
                    },
                    defaultClass: "gvc3qtgh gvc3qtgi"
                },
                background: {
                    conditions: {
                        light: "gvc3qtgl",
                        dark: "gvc3qtgm",
                        hover: "gvc3qtgn",
                        focus: "gvc3qtgo"
                    },
                    defaultClass: "gvc3qtgl gvc3qtgm"
                },
                link: {
                    conditions: {
                        light: "gvc3qtgp",
                        dark: "gvc3qtgq",
                        hover: "gvc3qtgr",
                        focus: "gvc3qtgs"
                    },
                    defaultClass: "gvc3qtgp gvc3qtgq"
                },
                linkHover: {
                    conditions: {
                        light: "gvc3qtgt",
                        dark: "gvc3qtgu",
                        hover: "gvc3qtgv",
                        focus: "gvc3qtgw"
                    },
                    defaultClass: "gvc3qtgt gvc3qtgu"
                },
                text: {
                    conditions: {
                        light: "gvc3qtgx",
                        dark: "gvc3qtgy",
                        hover: "gvc3qtgz",
                        focus: "gvc3qth0"
                    },
                    defaultClass: "gvc3qtgx gvc3qtgy"
                },
                textSecondary: {
                    conditions: {
                        light: "gvc3qth1",
                        dark: "gvc3qth2",
                        hover: "gvc3qth3",
                        focus: "gvc3qth4"
                    },
                    defaultClass: "gvc3qth1 gvc3qth2"
                },
                textDanger: {
                    conditions: {
                        light: "gvc3qth5",
                        dark: "gvc3qth6",
                        hover: "gvc3qth7",
                        focus: "gvc3qth8"
                    },
                    defaultClass: "gvc3qth5 gvc3qth6"
                },
                textWarning: {
                    conditions: {
                        light: "gvc3qth9",
                        dark: "gvc3qtha",
                        hover: "gvc3qthb",
                        focus: "gvc3qthc"
                    },
                    defaultClass: "gvc3qth9 gvc3qtha"
                },
                rewardBg: {
                    conditions: {
                        light: "gvc3qthd",
                        dark: "gvc3qthe",
                        hover: "gvc3qthf",
                        focus: "gvc3qthg"
                    },
                    defaultClass: "gvc3qthd gvc3qthe"
                },
                rewardContent: {
                    conditions: {
                        light: "gvc3qthh",
                        dark: "gvc3qthi",
                        hover: "gvc3qthj",
                        focus: "gvc3qthk"
                    },
                    defaultClass: "gvc3qthh gvc3qthi"
                },
                cardBg: {
                    conditions: {
                        light: "gvc3qthl",
                        dark: "gvc3qthm",
                        hover: "gvc3qthn",
                        focus: "gvc3qtho"
                    },
                    defaultClass: "gvc3qthl gvc3qthm"
                },
                inputBorder: {
                    conditions: {
                        light: "gvc3qthp",
                        dark: "gvc3qthq",
                        hover: "gvc3qthr",
                        focus: "gvc3qths"
                    },
                    defaultClass: "gvc3qthp gvc3qthq"
                },
                progressBg: {
                    conditions: {
                        light: "gvc3qtht",
                        dark: "gvc3qthu",
                        hover: "gvc3qthv",
                        focus: "gvc3qthw"
                    },
                    defaultClass: "gvc3qtht gvc3qthu"
                },
                progressValue: {
                    conditions: {
                        light: "gvc3qthx",
                        dark: "gvc3qthy",
                        hover: "gvc3qthz",
                        focus: "gvc3qti0"
                    },
                    defaultClass: "gvc3qthx gvc3qthy"
                },
                progressCursor: {
                    conditions: {
                        light: "gvc3qti1",
                        dark: "gvc3qti2",
                        hover: "gvc3qti3",
                        focus: "gvc3qti4"
                    },
                    defaultClass: "gvc3qti1 gvc3qti2"
                },
                black: {
                    conditions: {
                        light: "gvc3qti5",
                        dark: "gvc3qti6",
                        hover: "gvc3qti7",
                        focus: "gvc3qti8"
                    },
                    defaultClass: "gvc3qti5 gvc3qti6"
                },
                white: {
                    conditions: {
                        light: "gvc3qti9",
                        dark: "gvc3qtia",
                        hover: "gvc3qtib",
                        focus: "gvc3qtic"
                    },
                    defaultClass: "gvc3qti9 gvc3qtia"
                },
                transparent: {
                    conditions: {
                        light: "gvc3qtid",
                        dark: "gvc3qtie",
                        hover: "gvc3qtif",
                        focus: "gvc3qtig"
                    },
                    defaultClass: "gvc3qtid gvc3qtie"
                },
                current: {
                    conditions: {
                        light: "gvc3qtih",
                        dark: "gvc3qtii",
                        hover: "gvc3qtij",
                        focus: "gvc3qtik"
                    },
                    defaultClass: "gvc3qtih gvc3qtii"
                },
                whiteAlpha50: {
                    conditions: {
                        light: "gvc3qtil",
                        dark: "gvc3qtim",
                        hover: "gvc3qtin",
                        focus: "gvc3qtio"
                    },
                    defaultClass: "gvc3qtil gvc3qtim"
                },
                whiteAlpha100: {
                    conditions: {
                        light: "gvc3qtip",
                        dark: "gvc3qtiq",
                        hover: "gvc3qtir",
                        focus: "gvc3qtis"
                    },
                    defaultClass: "gvc3qtip gvc3qtiq"
                },
                whiteAlpha200: {
                    conditions: {
                        light: "gvc3qtit",
                        dark: "gvc3qtiu",
                        hover: "gvc3qtiv",
                        focus: "gvc3qtiw"
                    },
                    defaultClass: "gvc3qtit gvc3qtiu"
                },
                whiteAlpha300: {
                    conditions: {
                        light: "gvc3qtix",
                        dark: "gvc3qtiy",
                        hover: "gvc3qtiz",
                        focus: "gvc3qtj0"
                    },
                    defaultClass: "gvc3qtix gvc3qtiy"
                },
                whiteAlpha400: {
                    conditions: {
                        light: "gvc3qtj1",
                        dark: "gvc3qtj2",
                        hover: "gvc3qtj3",
                        focus: "gvc3qtj4"
                    },
                    defaultClass: "gvc3qtj1 gvc3qtj2"
                },
                whiteAlpha500: {
                    conditions: {
                        light: "gvc3qtj5",
                        dark: "gvc3qtj6",
                        hover: "gvc3qtj7",
                        focus: "gvc3qtj8"
                    },
                    defaultClass: "gvc3qtj5 gvc3qtj6"
                },
                whiteAlpha600: {
                    conditions: {
                        light: "gvc3qtj9",
                        dark: "gvc3qtja",
                        hover: "gvc3qtjb",
                        focus: "gvc3qtjc"
                    },
                    defaultClass: "gvc3qtj9 gvc3qtja"
                },
                whiteAlpha700: {
                    conditions: {
                        light: "gvc3qtjd",
                        dark: "gvc3qtje",
                        hover: "gvc3qtjf",
                        focus: "gvc3qtjg"
                    },
                    defaultClass: "gvc3qtjd gvc3qtje"
                },
                whiteAlpha800: {
                    conditions: {
                        light: "gvc3qtjh",
                        dark: "gvc3qtji",
                        hover: "gvc3qtjj",
                        focus: "gvc3qtjk"
                    },
                    defaultClass: "gvc3qtjh gvc3qtji"
                },
                whiteAlpha900: {
                    conditions: {
                        light: "gvc3qtjl",
                        dark: "gvc3qtjm",
                        hover: "gvc3qtjn",
                        focus: "gvc3qtjo"
                    },
                    defaultClass: "gvc3qtjl gvc3qtjm"
                },
                blackAlpha50: {
                    conditions: {
                        light: "gvc3qtjp",
                        dark: "gvc3qtjq",
                        hover: "gvc3qtjr",
                        focus: "gvc3qtjs"
                    },
                    defaultClass: "gvc3qtjp gvc3qtjq"
                },
                blackAlpha100: {
                    conditions: {
                        light: "gvc3qtjt",
                        dark: "gvc3qtju",
                        hover: "gvc3qtjv",
                        focus: "gvc3qtjw"
                    },
                    defaultClass: "gvc3qtjt gvc3qtju"
                },
                blackAlpha200: {
                    conditions: {
                        light: "gvc3qtjx",
                        dark: "gvc3qtjy",
                        hover: "gvc3qtjz",
                        focus: "gvc3qtk0"
                    },
                    defaultClass: "gvc3qtjx gvc3qtjy"
                },
                blackAlpha300: {
                    conditions: {
                        light: "gvc3qtk1",
                        dark: "gvc3qtk2",
                        hover: "gvc3qtk3",
                        focus: "gvc3qtk4"
                    },
                    defaultClass: "gvc3qtk1 gvc3qtk2"
                },
                blackAlpha400: {
                    conditions: {
                        light: "gvc3qtk5",
                        dark: "gvc3qtk6",
                        hover: "gvc3qtk7",
                        focus: "gvc3qtk8"
                    },
                    defaultClass: "gvc3qtk5 gvc3qtk6"
                },
                blackAlpha500: {
                    conditions: {
                        light: "gvc3qtk9",
                        dark: "gvc3qtka",
                        hover: "gvc3qtkb",
                        focus: "gvc3qtkc"
                    },
                    defaultClass: "gvc3qtk9 gvc3qtka"
                },
                blackAlpha600: {
                    conditions: {
                        light: "gvc3qtkd",
                        dark: "gvc3qtke",
                        hover: "gvc3qtkf",
                        focus: "gvc3qtkg"
                    },
                    defaultClass: "gvc3qtkd gvc3qtke"
                },
                blackAlpha700: {
                    conditions: {
                        light: "gvc3qtkh",
                        dark: "gvc3qtki",
                        hover: "gvc3qtkj",
                        focus: "gvc3qtkk"
                    },
                    defaultClass: "gvc3qtkh gvc3qtki"
                },
                blackAlpha800: {
                    conditions: {
                        light: "gvc3qtkl",
                        dark: "gvc3qtkm",
                        hover: "gvc3qtkn",
                        focus: "gvc3qtko"
                    },
                    defaultClass: "gvc3qtkl gvc3qtkm"
                },
                blackAlpha900: {
                    conditions: {
                        light: "gvc3qtkp",
                        dark: "gvc3qtkq",
                        hover: "gvc3qtkr",
                        focus: "gvc3qtks"
                    },
                    defaultClass: "gvc3qtkp gvc3qtkq"
                },
                gray50: {
                    conditions: {
                        light: "gvc3qtkt",
                        dark: "gvc3qtku",
                        hover: "gvc3qtkv",
                        focus: "gvc3qtkw"
                    },
                    defaultClass: "gvc3qtkt gvc3qtku"
                },
                gray100: {
                    conditions: {
                        light: "gvc3qtkx",
                        dark: "gvc3qtky",
                        hover: "gvc3qtkz",
                        focus: "gvc3qtl0"
                    },
                    defaultClass: "gvc3qtkx gvc3qtky"
                },
                gray200: {
                    conditions: {
                        light: "gvc3qtl1",
                        dark: "gvc3qtl2",
                        hover: "gvc3qtl3",
                        focus: "gvc3qtl4"
                    },
                    defaultClass: "gvc3qtl1 gvc3qtl2"
                },
                gray300: {
                    conditions: {
                        light: "gvc3qtl5",
                        dark: "gvc3qtl6",
                        hover: "gvc3qtl7",
                        focus: "gvc3qtl8"
                    },
                    defaultClass: "gvc3qtl5 gvc3qtl6"
                },
                gray400: {
                    conditions: {
                        light: "gvc3qtl9",
                        dark: "gvc3qtla",
                        hover: "gvc3qtlb",
                        focus: "gvc3qtlc"
                    },
                    defaultClass: "gvc3qtl9 gvc3qtla"
                },
                gray500: {
                    conditions: {
                        light: "gvc3qtld",
                        dark: "gvc3qtle",
                        hover: "gvc3qtlf",
                        focus: "gvc3qtlg"
                    },
                    defaultClass: "gvc3qtld gvc3qtle"
                },
                gray600: {
                    conditions: {
                        light: "gvc3qtlh",
                        dark: "gvc3qtli",
                        hover: "gvc3qtlj",
                        focus: "gvc3qtlk"
                    },
                    defaultClass: "gvc3qtlh gvc3qtli"
                },
                gray700: {
                    conditions: {
                        light: "gvc3qtll",
                        dark: "gvc3qtlm",
                        hover: "gvc3qtln",
                        focus: "gvc3qtlo"
                    },
                    defaultClass: "gvc3qtll gvc3qtlm"
                },
                gray800: {
                    conditions: {
                        light: "gvc3qtlp",
                        dark: "gvc3qtlq",
                        hover: "gvc3qtlr",
                        focus: "gvc3qtls"
                    },
                    defaultClass: "gvc3qtlp gvc3qtlq"
                },
                gray900: {
                    conditions: {
                        light: "gvc3qtlt",
                        dark: "gvc3qtlu",
                        hover: "gvc3qtlv",
                        focus: "gvc3qtlw"
                    },
                    defaultClass: "gvc3qtlt gvc3qtlu"
                },
                red50: {
                    conditions: {
                        light: "gvc3qtlx",
                        dark: "gvc3qtly",
                        hover: "gvc3qtlz",
                        focus: "gvc3qtm0"
                    },
                    defaultClass: "gvc3qtlx gvc3qtly"
                },
                red100: {
                    conditions: {
                        light: "gvc3qtm1",
                        dark: "gvc3qtm2",
                        hover: "gvc3qtm3",
                        focus: "gvc3qtm4"
                    },
                    defaultClass: "gvc3qtm1 gvc3qtm2"
                },
                red200: {
                    conditions: {
                        light: "gvc3qtm5",
                        dark: "gvc3qtm6",
                        hover: "gvc3qtm7",
                        focus: "gvc3qtm8"
                    },
                    defaultClass: "gvc3qtm5 gvc3qtm6"
                },
                red300: {
                    conditions: {
                        light: "gvc3qtm9",
                        dark: "gvc3qtma",
                        hover: "gvc3qtmb",
                        focus: "gvc3qtmc"
                    },
                    defaultClass: "gvc3qtm9 gvc3qtma"
                },
                red400: {
                    conditions: {
                        light: "gvc3qtmd",
                        dark: "gvc3qtme",
                        hover: "gvc3qtmf",
                        focus: "gvc3qtmg"
                    },
                    defaultClass: "gvc3qtmd gvc3qtme"
                },
                red500: {
                    conditions: {
                        light: "gvc3qtmh",
                        dark: "gvc3qtmi",
                        hover: "gvc3qtmj",
                        focus: "gvc3qtmk"
                    },
                    defaultClass: "gvc3qtmh gvc3qtmi"
                },
                red600: {
                    conditions: {
                        light: "gvc3qtml",
                        dark: "gvc3qtmm",
                        hover: "gvc3qtmn",
                        focus: "gvc3qtmo"
                    },
                    defaultClass: "gvc3qtml gvc3qtmm"
                },
                red700: {
                    conditions: {
                        light: "gvc3qtmp",
                        dark: "gvc3qtmq",
                        hover: "gvc3qtmr",
                        focus: "gvc3qtms"
                    },
                    defaultClass: "gvc3qtmp gvc3qtmq"
                },
                red800: {
                    conditions: {
                        light: "gvc3qtmt",
                        dark: "gvc3qtmu",
                        hover: "gvc3qtmv",
                        focus: "gvc3qtmw"
                    },
                    defaultClass: "gvc3qtmt gvc3qtmu"
                },
                red900: {
                    conditions: {
                        light: "gvc3qtmx",
                        dark: "gvc3qtmy",
                        hover: "gvc3qtmz",
                        focus: "gvc3qtn0"
                    },
                    defaultClass: "gvc3qtmx gvc3qtmy"
                },
                orange50: {
                    conditions: {
                        light: "gvc3qtn1",
                        dark: "gvc3qtn2",
                        hover: "gvc3qtn3",
                        focus: "gvc3qtn4"
                    },
                    defaultClass: "gvc3qtn1 gvc3qtn2"
                },
                orange100: {
                    conditions: {
                        light: "gvc3qtn5",
                        dark: "gvc3qtn6",
                        hover: "gvc3qtn7",
                        focus: "gvc3qtn8"
                    },
                    defaultClass: "gvc3qtn5 gvc3qtn6"
                },
                orange200: {
                    conditions: {
                        light: "gvc3qtn9",
                        dark: "gvc3qtna",
                        hover: "gvc3qtnb",
                        focus: "gvc3qtnc"
                    },
                    defaultClass: "gvc3qtn9 gvc3qtna"
                },
                orange300: {
                    conditions: {
                        light: "gvc3qtnd",
                        dark: "gvc3qtne",
                        hover: "gvc3qtnf",
                        focus: "gvc3qtng"
                    },
                    defaultClass: "gvc3qtnd gvc3qtne"
                },
                orange400: {
                    conditions: {
                        light: "gvc3qtnh",
                        dark: "gvc3qtni",
                        hover: "gvc3qtnj",
                        focus: "gvc3qtnk"
                    },
                    defaultClass: "gvc3qtnh gvc3qtni"
                },
                orange500: {
                    conditions: {
                        light: "gvc3qtnl",
                        dark: "gvc3qtnm",
                        hover: "gvc3qtnn",
                        focus: "gvc3qtno"
                    },
                    defaultClass: "gvc3qtnl gvc3qtnm"
                },
                orange600: {
                    conditions: {
                        light: "gvc3qtnp",
                        dark: "gvc3qtnq",
                        hover: "gvc3qtnr",
                        focus: "gvc3qtns"
                    },
                    defaultClass: "gvc3qtnp gvc3qtnq"
                },
                orange700: {
                    conditions: {
                        light: "gvc3qtnt",
                        dark: "gvc3qtnu",
                        hover: "gvc3qtnv",
                        focus: "gvc3qtnw"
                    },
                    defaultClass: "gvc3qtnt gvc3qtnu"
                },
                orange800: {
                    conditions: {
                        light: "gvc3qtnx",
                        dark: "gvc3qtny",
                        hover: "gvc3qtnz",
                        focus: "gvc3qto0"
                    },
                    defaultClass: "gvc3qtnx gvc3qtny"
                },
                orange900: {
                    conditions: {
                        light: "gvc3qto1",
                        dark: "gvc3qto2",
                        hover: "gvc3qto3",
                        focus: "gvc3qto4"
                    },
                    defaultClass: "gvc3qto1 gvc3qto2"
                },
                yellow50: {
                    conditions: {
                        light: "gvc3qto5",
                        dark: "gvc3qto6",
                        hover: "gvc3qto7",
                        focus: "gvc3qto8"
                    },
                    defaultClass: "gvc3qto5 gvc3qto6"
                },
                yellow100: {
                    conditions: {
                        light: "gvc3qto9",
                        dark: "gvc3qtoa",
                        hover: "gvc3qtob",
                        focus: "gvc3qtoc"
                    },
                    defaultClass: "gvc3qto9 gvc3qtoa"
                },
                yellow200: {
                    conditions: {
                        light: "gvc3qtod",
                        dark: "gvc3qtoe",
                        hover: "gvc3qtof",
                        focus: "gvc3qtog"
                    },
                    defaultClass: "gvc3qtod gvc3qtoe"
                },
                yellow300: {
                    conditions: {
                        light: "gvc3qtoh",
                        dark: "gvc3qtoi",
                        hover: "gvc3qtoj",
                        focus: "gvc3qtok"
                    },
                    defaultClass: "gvc3qtoh gvc3qtoi"
                },
                yellow400: {
                    conditions: {
                        light: "gvc3qtol",
                        dark: "gvc3qtom",
                        hover: "gvc3qton",
                        focus: "gvc3qtoo"
                    },
                    defaultClass: "gvc3qtol gvc3qtom"
                },
                yellow500: {
                    conditions: {
                        light: "gvc3qtop",
                        dark: "gvc3qtoq",
                        hover: "gvc3qtor",
                        focus: "gvc3qtos"
                    },
                    defaultClass: "gvc3qtop gvc3qtoq"
                },
                yellow600: {
                    conditions: {
                        light: "gvc3qtot",
                        dark: "gvc3qtou",
                        hover: "gvc3qtov",
                        focus: "gvc3qtow"
                    },
                    defaultClass: "gvc3qtot gvc3qtou"
                },
                yellow700: {
                    conditions: {
                        light: "gvc3qtox",
                        dark: "gvc3qtoy",
                        hover: "gvc3qtoz",
                        focus: "gvc3qtp0"
                    },
                    defaultClass: "gvc3qtox gvc3qtoy"
                },
                yellow800: {
                    conditions: {
                        light: "gvc3qtp1",
                        dark: "gvc3qtp2",
                        hover: "gvc3qtp3",
                        focus: "gvc3qtp4"
                    },
                    defaultClass: "gvc3qtp1 gvc3qtp2"
                },
                yellow900: {
                    conditions: {
                        light: "gvc3qtp5",
                        dark: "gvc3qtp6",
                        hover: "gvc3qtp7",
                        focus: "gvc3qtp8"
                    },
                    defaultClass: "gvc3qtp5 gvc3qtp6"
                },
                green50: {
                    conditions: {
                        light: "gvc3qtp9",
                        dark: "gvc3qtpa",
                        hover: "gvc3qtpb",
                        focus: "gvc3qtpc"
                    },
                    defaultClass: "gvc3qtp9 gvc3qtpa"
                },
                green100: {
                    conditions: {
                        light: "gvc3qtpd",
                        dark: "gvc3qtpe",
                        hover: "gvc3qtpf",
                        focus: "gvc3qtpg"
                    },
                    defaultClass: "gvc3qtpd gvc3qtpe"
                },
                green200: {
                    conditions: {
                        light: "gvc3qtph",
                        dark: "gvc3qtpi",
                        hover: "gvc3qtpj",
                        focus: "gvc3qtpk"
                    },
                    defaultClass: "gvc3qtph gvc3qtpi"
                },
                green300: {
                    conditions: {
                        light: "gvc3qtpl",
                        dark: "gvc3qtpm",
                        hover: "gvc3qtpn",
                        focus: "gvc3qtpo"
                    },
                    defaultClass: "gvc3qtpl gvc3qtpm"
                },
                green400: {
                    conditions: {
                        light: "gvc3qtpp",
                        dark: "gvc3qtpq",
                        hover: "gvc3qtpr",
                        focus: "gvc3qtps"
                    },
                    defaultClass: "gvc3qtpp gvc3qtpq"
                },
                green500: {
                    conditions: {
                        light: "gvc3qtpt",
                        dark: "gvc3qtpu",
                        hover: "gvc3qtpv",
                        focus: "gvc3qtpw"
                    },
                    defaultClass: "gvc3qtpt gvc3qtpu"
                },
                green600: {
                    conditions: {
                        light: "gvc3qtpx",
                        dark: "gvc3qtpy",
                        hover: "gvc3qtpz",
                        focus: "gvc3qtq0"
                    },
                    defaultClass: "gvc3qtpx gvc3qtpy"
                },
                green700: {
                    conditions: {
                        light: "gvc3qtq1",
                        dark: "gvc3qtq2",
                        hover: "gvc3qtq3",
                        focus: "gvc3qtq4"
                    },
                    defaultClass: "gvc3qtq1 gvc3qtq2"
                },
                green800: {
                    conditions: {
                        light: "gvc3qtq5",
                        dark: "gvc3qtq6",
                        hover: "gvc3qtq7",
                        focus: "gvc3qtq8"
                    },
                    defaultClass: "gvc3qtq5 gvc3qtq6"
                },
                green900: {
                    conditions: {
                        light: "gvc3qtq9",
                        dark: "gvc3qtqa",
                        hover: "gvc3qtqb",
                        focus: "gvc3qtqc"
                    },
                    defaultClass: "gvc3qtq9 gvc3qtqa"
                },
                blue50: {
                    conditions: {
                        light: "gvc3qtqd",
                        dark: "gvc3qtqe",
                        hover: "gvc3qtqf",
                        focus: "gvc3qtqg"
                    },
                    defaultClass: "gvc3qtqd gvc3qtqe"
                },
                blue100: {
                    conditions: {
                        light: "gvc3qtqh",
                        dark: "gvc3qtqi",
                        hover: "gvc3qtqj",
                        focus: "gvc3qtqk"
                    },
                    defaultClass: "gvc3qtqh gvc3qtqi"
                },
                blue200: {
                    conditions: {
                        light: "gvc3qtql",
                        dark: "gvc3qtqm",
                        hover: "gvc3qtqn",
                        focus: "gvc3qtqo"
                    },
                    defaultClass: "gvc3qtql gvc3qtqm"
                },
                blue300: {
                    conditions: {
                        light: "gvc3qtqp",
                        dark: "gvc3qtqq",
                        hover: "gvc3qtqr",
                        focus: "gvc3qtqs"
                    },
                    defaultClass: "gvc3qtqp gvc3qtqq"
                },
                blue400: {
                    conditions: {
                        light: "gvc3qtqt",
                        dark: "gvc3qtqu",
                        hover: "gvc3qtqv",
                        focus: "gvc3qtqw"
                    },
                    defaultClass: "gvc3qtqt gvc3qtqu"
                },
                blue500: {
                    conditions: {
                        light: "gvc3qtqx",
                        dark: "gvc3qtqy",
                        hover: "gvc3qtqz",
                        focus: "gvc3qtr0"
                    },
                    defaultClass: "gvc3qtqx gvc3qtqy"
                },
                blue600: {
                    conditions: {
                        light: "gvc3qtr1",
                        dark: "gvc3qtr2",
                        hover: "gvc3qtr3",
                        focus: "gvc3qtr4"
                    },
                    defaultClass: "gvc3qtr1 gvc3qtr2"
                },
                blue700: {
                    conditions: {
                        light: "gvc3qtr5",
                        dark: "gvc3qtr6",
                        hover: "gvc3qtr7",
                        focus: "gvc3qtr8"
                    },
                    defaultClass: "gvc3qtr5 gvc3qtr6"
                },
                blue800: {
                    conditions: {
                        light: "gvc3qtr9",
                        dark: "gvc3qtra",
                        hover: "gvc3qtrb",
                        focus: "gvc3qtrc"
                    },
                    defaultClass: "gvc3qtr9 gvc3qtra"
                },
                blue900: {
                    conditions: {
                        light: "gvc3qtrd",
                        dark: "gvc3qtre",
                        hover: "gvc3qtrf",
                        focus: "gvc3qtrg"
                    },
                    defaultClass: "gvc3qtrd gvc3qtre"
                },
                primary50: {
                    conditions: {
                        light: "gvc3qtrh",
                        dark: "gvc3qtri",
                        hover: "gvc3qtrj",
                        focus: "gvc3qtrk"
                    },
                    defaultClass: "gvc3qtrh gvc3qtri"
                },
                primary100: {
                    conditions: {
                        light: "gvc3qtrl",
                        dark: "gvc3qtrm",
                        hover: "gvc3qtrn",
                        focus: "gvc3qtro"
                    },
                    defaultClass: "gvc3qtrl gvc3qtrm"
                },
                primary200: {
                    conditions: {
                        light: "gvc3qtrp",
                        dark: "gvc3qtrq",
                        hover: "gvc3qtrr",
                        focus: "gvc3qtrs"
                    },
                    defaultClass: "gvc3qtrp gvc3qtrq"
                },
                primary300: {
                    conditions: {
                        light: "gvc3qtrt",
                        dark: "gvc3qtru",
                        hover: "gvc3qtrv",
                        focus: "gvc3qtrw"
                    },
                    defaultClass: "gvc3qtrt gvc3qtru"
                },
                primary400: {
                    conditions: {
                        light: "gvc3qtrx",
                        dark: "gvc3qtry",
                        hover: "gvc3qtrz",
                        focus: "gvc3qts0"
                    },
                    defaultClass: "gvc3qtrx gvc3qtry"
                },
                primary500: {
                    conditions: {
                        light: "gvc3qts1",
                        dark: "gvc3qts2",
                        hover: "gvc3qts3",
                        focus: "gvc3qts4"
                    },
                    defaultClass: "gvc3qts1 gvc3qts2"
                },
                primary600: {
                    conditions: {
                        light: "gvc3qts5",
                        dark: "gvc3qts6",
                        hover: "gvc3qts7",
                        focus: "gvc3qts8"
                    },
                    defaultClass: "gvc3qts5 gvc3qts6"
                },
                primary700: {
                    conditions: {
                        light: "gvc3qts9",
                        dark: "gvc3qtsa",
                        hover: "gvc3qtsb",
                        focus: "gvc3qtsc"
                    },
                    defaultClass: "gvc3qts9 gvc3qtsa"
                },
                primary800: {
                    conditions: {
                        light: "gvc3qtsd",
                        dark: "gvc3qtse",
                        hover: "gvc3qtsf",
                        focus: "gvc3qtsg"
                    },
                    defaultClass: "gvc3qtsd gvc3qtse"
                },
                primary900: {
                    conditions: {
                        light: "gvc3qtsh",
                        dark: "gvc3qtsi",
                        hover: "gvc3qtsj",
                        focus: "gvc3qtsk"
                    },
                    defaultClass: "gvc3qtsh gvc3qtsi"
                },
                purple50: {
                    conditions: {
                        light: "gvc3qtsl",
                        dark: "gvc3qtsm",
                        hover: "gvc3qtsn",
                        focus: "gvc3qtso"
                    },
                    defaultClass: "gvc3qtsl gvc3qtsm"
                },
                purple100: {
                    conditions: {
                        light: "gvc3qtsp",
                        dark: "gvc3qtsq",
                        hover: "gvc3qtsr",
                        focus: "gvc3qtss"
                    },
                    defaultClass: "gvc3qtsp gvc3qtsq"
                },
                purple200: {
                    conditions: {
                        light: "gvc3qtst",
                        dark: "gvc3qtsu",
                        hover: "gvc3qtsv",
                        focus: "gvc3qtsw"
                    },
                    defaultClass: "gvc3qtst gvc3qtsu"
                },
                purple300: {
                    conditions: {
                        light: "gvc3qtsx",
                        dark: "gvc3qtsy",
                        hover: "gvc3qtsz",
                        focus: "gvc3qtt0"
                    },
                    defaultClass: "gvc3qtsx gvc3qtsy"
                },
                purple400: {
                    conditions: {
                        light: "gvc3qtt1",
                        dark: "gvc3qtt2",
                        hover: "gvc3qtt3",
                        focus: "gvc3qtt4"
                    },
                    defaultClass: "gvc3qtt1 gvc3qtt2"
                },
                purple500: {
                    conditions: {
                        light: "gvc3qtt5",
                        dark: "gvc3qtt6",
                        hover: "gvc3qtt7",
                        focus: "gvc3qtt8"
                    },
                    defaultClass: "gvc3qtt5 gvc3qtt6"
                },
                purple600: {
                    conditions: {
                        light: "gvc3qtt9",
                        dark: "gvc3qtta",
                        hover: "gvc3qttb",
                        focus: "gvc3qttc"
                    },
                    defaultClass: "gvc3qtt9 gvc3qtta"
                },
                purple700: {
                    conditions: {
                        light: "gvc3qttd",
                        dark: "gvc3qtte",
                        hover: "gvc3qttf",
                        focus: "gvc3qttg"
                    },
                    defaultClass: "gvc3qttd gvc3qtte"
                },
                purple800: {
                    conditions: {
                        light: "gvc3qtth",
                        dark: "gvc3qtti",
                        hover: "gvc3qttj",
                        focus: "gvc3qttk"
                    },
                    defaultClass: "gvc3qtth gvc3qtti"
                },
                purple900: {
                    conditions: {
                        light: "gvc3qttl",
                        dark: "gvc3qttm",
                        hover: "gvc3qttn",
                        focus: "gvc3qtto"
                    },
                    defaultClass: "gvc3qttl gvc3qttm"
                }
            }
        },
        borderColor: {
            values: {
                primary: {
                    conditions: {
                        light: "gvc3qttp",
                        dark: "gvc3qttq",
                        hover: "gvc3qttr",
                        focus: "gvc3qtts"
                    },
                    defaultClass: "gvc3qttp gvc3qttq"
                },
                body: {
                    conditions: {
                        light: "gvc3qttt",
                        dark: "gvc3qttu",
                        hover: "gvc3qttv",
                        focus: "gvc3qttw"
                    },
                    defaultClass: "gvc3qttt gvc3qttu"
                },
                background: {
                    conditions: {
                        light: "gvc3qttx",
                        dark: "gvc3qtty",
                        hover: "gvc3qttz",
                        focus: "gvc3qtu0"
                    },
                    defaultClass: "gvc3qttx gvc3qtty"
                },
                link: {
                    conditions: {
                        light: "gvc3qtu1",
                        dark: "gvc3qtu2",
                        hover: "gvc3qtu3",
                        focus: "gvc3qtu4"
                    },
                    defaultClass: "gvc3qtu1 gvc3qtu2"
                },
                linkHover: {
                    conditions: {
                        light: "gvc3qtu5",
                        dark: "gvc3qtu6",
                        hover: "gvc3qtu7",
                        focus: "gvc3qtu8"
                    },
                    defaultClass: "gvc3qtu5 gvc3qtu6"
                },
                text: {
                    conditions: {
                        light: "gvc3qtu9",
                        dark: "gvc3qtua",
                        hover: "gvc3qtub",
                        focus: "gvc3qtuc"
                    },
                    defaultClass: "gvc3qtu9 gvc3qtua"
                },
                textSecondary: {
                    conditions: {
                        light: "gvc3qtud",
                        dark: "gvc3qtue",
                        hover: "gvc3qtuf",
                        focus: "gvc3qtug"
                    },
                    defaultClass: "gvc3qtud gvc3qtue"
                },
                textDanger: {
                    conditions: {
                        light: "gvc3qtuh",
                        dark: "gvc3qtui",
                        hover: "gvc3qtuj",
                        focus: "gvc3qtuk"
                    },
                    defaultClass: "gvc3qtuh gvc3qtui"
                },
                textWarning: {
                    conditions: {
                        light: "gvc3qtul",
                        dark: "gvc3qtum",
                        hover: "gvc3qtun",
                        focus: "gvc3qtuo"
                    },
                    defaultClass: "gvc3qtul gvc3qtum"
                },
                rewardBg: {
                    conditions: {
                        light: "gvc3qtup",
                        dark: "gvc3qtuq",
                        hover: "gvc3qtur",
                        focus: "gvc3qtus"
                    },
                    defaultClass: "gvc3qtup gvc3qtuq"
                },
                rewardContent: {
                    conditions: {
                        light: "gvc3qtut",
                        dark: "gvc3qtuu",
                        hover: "gvc3qtuv",
                        focus: "gvc3qtuw"
                    },
                    defaultClass: "gvc3qtut gvc3qtuu"
                },
                cardBg: {
                    conditions: {
                        light: "gvc3qtux",
                        dark: "gvc3qtuy",
                        hover: "gvc3qtuz",
                        focus: "gvc3qtv0"
                    },
                    defaultClass: "gvc3qtux gvc3qtuy"
                },
                inputBorder: {
                    conditions: {
                        light: "gvc3qtv1",
                        dark: "gvc3qtv2",
                        hover: "gvc3qtv3",
                        focus: "gvc3qtv4"
                    },
                    defaultClass: "gvc3qtv1 gvc3qtv2"
                },
                progressBg: {
                    conditions: {
                        light: "gvc3qtv5",
                        dark: "gvc3qtv6",
                        hover: "gvc3qtv7",
                        focus: "gvc3qtv8"
                    },
                    defaultClass: "gvc3qtv5 gvc3qtv6"
                },
                progressValue: {
                    conditions: {
                        light: "gvc3qtv9",
                        dark: "gvc3qtva",
                        hover: "gvc3qtvb",
                        focus: "gvc3qtvc"
                    },
                    defaultClass: "gvc3qtv9 gvc3qtva"
                },
                progressCursor: {
                    conditions: {
                        light: "gvc3qtvd",
                        dark: "gvc3qtve",
                        hover: "gvc3qtvf",
                        focus: "gvc3qtvg"
                    },
                    defaultClass: "gvc3qtvd gvc3qtve"
                },
                black: {
                    conditions: {
                        light: "gvc3qtvh",
                        dark: "gvc3qtvi",
                        hover: "gvc3qtvj",
                        focus: "gvc3qtvk"
                    },
                    defaultClass: "gvc3qtvh gvc3qtvi"
                },
                white: {
                    conditions: {
                        light: "gvc3qtvl",
                        dark: "gvc3qtvm",
                        hover: "gvc3qtvn",
                        focus: "gvc3qtvo"
                    },
                    defaultClass: "gvc3qtvl gvc3qtvm"
                },
                transparent: {
                    conditions: {
                        light: "gvc3qtvp",
                        dark: "gvc3qtvq",
                        hover: "gvc3qtvr",
                        focus: "gvc3qtvs"
                    },
                    defaultClass: "gvc3qtvp gvc3qtvq"
                },
                current: {
                    conditions: {
                        light: "gvc3qtvt",
                        dark: "gvc3qtvu",
                        hover: "gvc3qtvv",
                        focus: "gvc3qtvw"
                    },
                    defaultClass: "gvc3qtvt gvc3qtvu"
                },
                whiteAlpha50: {
                    conditions: {
                        light: "gvc3qtvx",
                        dark: "gvc3qtvy",
                        hover: "gvc3qtvz",
                        focus: "gvc3qtw0"
                    },
                    defaultClass: "gvc3qtvx gvc3qtvy"
                },
                whiteAlpha100: {
                    conditions: {
                        light: "gvc3qtw1",
                        dark: "gvc3qtw2",
                        hover: "gvc3qtw3",
                        focus: "gvc3qtw4"
                    },
                    defaultClass: "gvc3qtw1 gvc3qtw2"
                },
                whiteAlpha200: {
                    conditions: {
                        light: "gvc3qtw5",
                        dark: "gvc3qtw6",
                        hover: "gvc3qtw7",
                        focus: "gvc3qtw8"
                    },
                    defaultClass: "gvc3qtw5 gvc3qtw6"
                },
                whiteAlpha300: {
                    conditions: {
                        light: "gvc3qtw9",
                        dark: "gvc3qtwa",
                        hover: "gvc3qtwb",
                        focus: "gvc3qtwc"
                    },
                    defaultClass: "gvc3qtw9 gvc3qtwa"
                },
                whiteAlpha400: {
                    conditions: {
                        light: "gvc3qtwd",
                        dark: "gvc3qtwe",
                        hover: "gvc3qtwf",
                        focus: "gvc3qtwg"
                    },
                    defaultClass: "gvc3qtwd gvc3qtwe"
                },
                whiteAlpha500: {
                    conditions: {
                        light: "gvc3qtwh",
                        dark: "gvc3qtwi",
                        hover: "gvc3qtwj",
                        focus: "gvc3qtwk"
                    },
                    defaultClass: "gvc3qtwh gvc3qtwi"
                },
                whiteAlpha600: {
                    conditions: {
                        light: "gvc3qtwl",
                        dark: "gvc3qtwm",
                        hover: "gvc3qtwn",
                        focus: "gvc3qtwo"
                    },
                    defaultClass: "gvc3qtwl gvc3qtwm"
                },
                whiteAlpha700: {
                    conditions: {
                        light: "gvc3qtwp",
                        dark: "gvc3qtwq",
                        hover: "gvc3qtwr",
                        focus: "gvc3qtws"
                    },
                    defaultClass: "gvc3qtwp gvc3qtwq"
                },
                whiteAlpha800: {
                    conditions: {
                        light: "gvc3qtwt",
                        dark: "gvc3qtwu",
                        hover: "gvc3qtwv",
                        focus: "gvc3qtww"
                    },
                    defaultClass: "gvc3qtwt gvc3qtwu"
                },
                whiteAlpha900: {
                    conditions: {
                        light: "gvc3qtwx",
                        dark: "gvc3qtwy",
                        hover: "gvc3qtwz",
                        focus: "gvc3qtx0"
                    },
                    defaultClass: "gvc3qtwx gvc3qtwy"
                },
                blackAlpha50: {
                    conditions: {
                        light: "gvc3qtx1",
                        dark: "gvc3qtx2",
                        hover: "gvc3qtx3",
                        focus: "gvc3qtx4"
                    },
                    defaultClass: "gvc3qtx1 gvc3qtx2"
                },
                blackAlpha100: {
                    conditions: {
                        light: "gvc3qtx5",
                        dark: "gvc3qtx6",
                        hover: "gvc3qtx7",
                        focus: "gvc3qtx8"
                    },
                    defaultClass: "gvc3qtx5 gvc3qtx6"
                },
                blackAlpha200: {
                    conditions: {
                        light: "gvc3qtx9",
                        dark: "gvc3qtxa",
                        hover: "gvc3qtxb",
                        focus: "gvc3qtxc"
                    },
                    defaultClass: "gvc3qtx9 gvc3qtxa"
                },
                blackAlpha300: {
                    conditions: {
                        light: "gvc3qtxd",
                        dark: "gvc3qtxe",
                        hover: "gvc3qtxf",
                        focus: "gvc3qtxg"
                    },
                    defaultClass: "gvc3qtxd gvc3qtxe"
                },
                blackAlpha400: {
                    conditions: {
                        light: "gvc3qtxh",
                        dark: "gvc3qtxi",
                        hover: "gvc3qtxj",
                        focus: "gvc3qtxk"
                    },
                    defaultClass: "gvc3qtxh gvc3qtxi"
                },
                blackAlpha500: {
                    conditions: {
                        light: "gvc3qtxl",
                        dark: "gvc3qtxm",
                        hover: "gvc3qtxn",
                        focus: "gvc3qtxo"
                    },
                    defaultClass: "gvc3qtxl gvc3qtxm"
                },
                blackAlpha600: {
                    conditions: {
                        light: "gvc3qtxp",
                        dark: "gvc3qtxq",
                        hover: "gvc3qtxr",
                        focus: "gvc3qtxs"
                    },
                    defaultClass: "gvc3qtxp gvc3qtxq"
                },
                blackAlpha700: {
                    conditions: {
                        light: "gvc3qtxt",
                        dark: "gvc3qtxu",
                        hover: "gvc3qtxv",
                        focus: "gvc3qtxw"
                    },
                    defaultClass: "gvc3qtxt gvc3qtxu"
                },
                blackAlpha800: {
                    conditions: {
                        light: "gvc3qtxx",
                        dark: "gvc3qtxy",
                        hover: "gvc3qtxz",
                        focus: "gvc3qty0"
                    },
                    defaultClass: "gvc3qtxx gvc3qtxy"
                },
                blackAlpha900: {
                    conditions: {
                        light: "gvc3qty1",
                        dark: "gvc3qty2",
                        hover: "gvc3qty3",
                        focus: "gvc3qty4"
                    },
                    defaultClass: "gvc3qty1 gvc3qty2"
                },
                gray50: {
                    conditions: {
                        light: "gvc3qty5",
                        dark: "gvc3qty6",
                        hover: "gvc3qty7",
                        focus: "gvc3qty8"
                    },
                    defaultClass: "gvc3qty5 gvc3qty6"
                },
                gray100: {
                    conditions: {
                        light: "gvc3qty9",
                        dark: "gvc3qtya",
                        hover: "gvc3qtyb",
                        focus: "gvc3qtyc"
                    },
                    defaultClass: "gvc3qty9 gvc3qtya"
                },
                gray200: {
                    conditions: {
                        light: "gvc3qtyd",
                        dark: "gvc3qtye",
                        hover: "gvc3qtyf",
                        focus: "gvc3qtyg"
                    },
                    defaultClass: "gvc3qtyd gvc3qtye"
                },
                gray300: {
                    conditions: {
                        light: "gvc3qtyh",
                        dark: "gvc3qtyi",
                        hover: "gvc3qtyj",
                        focus: "gvc3qtyk"
                    },
                    defaultClass: "gvc3qtyh gvc3qtyi"
                },
                gray400: {
                    conditions: {
                        light: "gvc3qtyl",
                        dark: "gvc3qtym",
                        hover: "gvc3qtyn",
                        focus: "gvc3qtyo"
                    },
                    defaultClass: "gvc3qtyl gvc3qtym"
                },
                gray500: {
                    conditions: {
                        light: "gvc3qtyp",
                        dark: "gvc3qtyq",
                        hover: "gvc3qtyr",
                        focus: "gvc3qtys"
                    },
                    defaultClass: "gvc3qtyp gvc3qtyq"
                },
                gray600: {
                    conditions: {
                        light: "gvc3qtyt",
                        dark: "gvc3qtyu",
                        hover: "gvc3qtyv",
                        focus: "gvc3qtyw"
                    },
                    defaultClass: "gvc3qtyt gvc3qtyu"
                },
                gray700: {
                    conditions: {
                        light: "gvc3qtyx",
                        dark: "gvc3qtyy",
                        hover: "gvc3qtyz",
                        focus: "gvc3qtz0"
                    },
                    defaultClass: "gvc3qtyx gvc3qtyy"
                },
                gray800: {
                    conditions: {
                        light: "gvc3qtz1",
                        dark: "gvc3qtz2",
                        hover: "gvc3qtz3",
                        focus: "gvc3qtz4"
                    },
                    defaultClass: "gvc3qtz1 gvc3qtz2"
                },
                gray900: {
                    conditions: {
                        light: "gvc3qtz5",
                        dark: "gvc3qtz6",
                        hover: "gvc3qtz7",
                        focus: "gvc3qtz8"
                    },
                    defaultClass: "gvc3qtz5 gvc3qtz6"
                },
                red50: {
                    conditions: {
                        light: "gvc3qtz9",
                        dark: "gvc3qtza",
                        hover: "gvc3qtzb",
                        focus: "gvc3qtzc"
                    },
                    defaultClass: "gvc3qtz9 gvc3qtza"
                },
                red100: {
                    conditions: {
                        light: "gvc3qtzd",
                        dark: "gvc3qtze",
                        hover: "gvc3qtzf",
                        focus: "gvc3qtzg"
                    },
                    defaultClass: "gvc3qtzd gvc3qtze"
                },
                red200: {
                    conditions: {
                        light: "gvc3qtzh",
                        dark: "gvc3qtzi",
                        hover: "gvc3qtzj",
                        focus: "gvc3qtzk"
                    },
                    defaultClass: "gvc3qtzh gvc3qtzi"
                },
                red300: {
                    conditions: {
                        light: "gvc3qtzl",
                        dark: "gvc3qtzm",
                        hover: "gvc3qtzn",
                        focus: "gvc3qtzo"
                    },
                    defaultClass: "gvc3qtzl gvc3qtzm"
                },
                red400: {
                    conditions: {
                        light: "gvc3qtzp",
                        dark: "gvc3qtzq",
                        hover: "gvc3qtzr",
                        focus: "gvc3qtzs"
                    },
                    defaultClass: "gvc3qtzp gvc3qtzq"
                },
                red500: {
                    conditions: {
                        light: "gvc3qtzt",
                        dark: "gvc3qtzu",
                        hover: "gvc3qtzv",
                        focus: "gvc3qtzw"
                    },
                    defaultClass: "gvc3qtzt gvc3qtzu"
                },
                red600: {
                    conditions: {
                        light: "gvc3qtzx",
                        dark: "gvc3qtzy",
                        hover: "gvc3qtzz",
                        focus: "gvc3qt100"
                    },
                    defaultClass: "gvc3qtzx gvc3qtzy"
                },
                red700: {
                    conditions: {
                        light: "gvc3qt101",
                        dark: "gvc3qt102",
                        hover: "gvc3qt103",
                        focus: "gvc3qt104"
                    },
                    defaultClass: "gvc3qt101 gvc3qt102"
                },
                red800: {
                    conditions: {
                        light: "gvc3qt105",
                        dark: "gvc3qt106",
                        hover: "gvc3qt107",
                        focus: "gvc3qt108"
                    },
                    defaultClass: "gvc3qt105 gvc3qt106"
                },
                red900: {
                    conditions: {
                        light: "gvc3qt109",
                        dark: "gvc3qt10a",
                        hover: "gvc3qt10b",
                        focus: "gvc3qt10c"
                    },
                    defaultClass: "gvc3qt109 gvc3qt10a"
                },
                orange50: {
                    conditions: {
                        light: "gvc3qt10d",
                        dark: "gvc3qt10e",
                        hover: "gvc3qt10f",
                        focus: "gvc3qt10g"
                    },
                    defaultClass: "gvc3qt10d gvc3qt10e"
                },
                orange100: {
                    conditions: {
                        light: "gvc3qt10h",
                        dark: "gvc3qt10i",
                        hover: "gvc3qt10j",
                        focus: "gvc3qt10k"
                    },
                    defaultClass: "gvc3qt10h gvc3qt10i"
                },
                orange200: {
                    conditions: {
                        light: "gvc3qt10l",
                        dark: "gvc3qt10m",
                        hover: "gvc3qt10n",
                        focus: "gvc3qt10o"
                    },
                    defaultClass: "gvc3qt10l gvc3qt10m"
                },
                orange300: {
                    conditions: {
                        light: "gvc3qt10p",
                        dark: "gvc3qt10q",
                        hover: "gvc3qt10r",
                        focus: "gvc3qt10s"
                    },
                    defaultClass: "gvc3qt10p gvc3qt10q"
                },
                orange400: {
                    conditions: {
                        light: "gvc3qt10t",
                        dark: "gvc3qt10u",
                        hover: "gvc3qt10v",
                        focus: "gvc3qt10w"
                    },
                    defaultClass: "gvc3qt10t gvc3qt10u"
                },
                orange500: {
                    conditions: {
                        light: "gvc3qt10x",
                        dark: "gvc3qt10y",
                        hover: "gvc3qt10z",
                        focus: "gvc3qt110"
                    },
                    defaultClass: "gvc3qt10x gvc3qt10y"
                },
                orange600: {
                    conditions: {
                        light: "gvc3qt111",
                        dark: "gvc3qt112",
                        hover: "gvc3qt113",
                        focus: "gvc3qt114"
                    },
                    defaultClass: "gvc3qt111 gvc3qt112"
                },
                orange700: {
                    conditions: {
                        light: "gvc3qt115",
                        dark: "gvc3qt116",
                        hover: "gvc3qt117",
                        focus: "gvc3qt118"
                    },
                    defaultClass: "gvc3qt115 gvc3qt116"
                },
                orange800: {
                    conditions: {
                        light: "gvc3qt119",
                        dark: "gvc3qt11a",
                        hover: "gvc3qt11b",
                        focus: "gvc3qt11c"
                    },
                    defaultClass: "gvc3qt119 gvc3qt11a"
                },
                orange900: {
                    conditions: {
                        light: "gvc3qt11d",
                        dark: "gvc3qt11e",
                        hover: "gvc3qt11f",
                        focus: "gvc3qt11g"
                    },
                    defaultClass: "gvc3qt11d gvc3qt11e"
                },
                yellow50: {
                    conditions: {
                        light: "gvc3qt11h",
                        dark: "gvc3qt11i",
                        hover: "gvc3qt11j",
                        focus: "gvc3qt11k"
                    },
                    defaultClass: "gvc3qt11h gvc3qt11i"
                },
                yellow100: {
                    conditions: {
                        light: "gvc3qt11l",
                        dark: "gvc3qt11m",
                        hover: "gvc3qt11n",
                        focus: "gvc3qt11o"
                    },
                    defaultClass: "gvc3qt11l gvc3qt11m"
                },
                yellow200: {
                    conditions: {
                        light: "gvc3qt11p",
                        dark: "gvc3qt11q",
                        hover: "gvc3qt11r",
                        focus: "gvc3qt11s"
                    },
                    defaultClass: "gvc3qt11p gvc3qt11q"
                },
                yellow300: {
                    conditions: {
                        light: "gvc3qt11t",
                        dark: "gvc3qt11u",
                        hover: "gvc3qt11v",
                        focus: "gvc3qt11w"
                    },
                    defaultClass: "gvc3qt11t gvc3qt11u"
                },
                yellow400: {
                    conditions: {
                        light: "gvc3qt11x",
                        dark: "gvc3qt11y",
                        hover: "gvc3qt11z",
                        focus: "gvc3qt120"
                    },
                    defaultClass: "gvc3qt11x gvc3qt11y"
                },
                yellow500: {
                    conditions: {
                        light: "gvc3qt121",
                        dark: "gvc3qt122",
                        hover: "gvc3qt123",
                        focus: "gvc3qt124"
                    },
                    defaultClass: "gvc3qt121 gvc3qt122"
                },
                yellow600: {
                    conditions: {
                        light: "gvc3qt125",
                        dark: "gvc3qt126",
                        hover: "gvc3qt127",
                        focus: "gvc3qt128"
                    },
                    defaultClass: "gvc3qt125 gvc3qt126"
                },
                yellow700: {
                    conditions: {
                        light: "gvc3qt129",
                        dark: "gvc3qt12a",
                        hover: "gvc3qt12b",
                        focus: "gvc3qt12c"
                    },
                    defaultClass: "gvc3qt129 gvc3qt12a"
                },
                yellow800: {
                    conditions: {
                        light: "gvc3qt12d",
                        dark: "gvc3qt12e",
                        hover: "gvc3qt12f",
                        focus: "gvc3qt12g"
                    },
                    defaultClass: "gvc3qt12d gvc3qt12e"
                },
                yellow900: {
                    conditions: {
                        light: "gvc3qt12h",
                        dark: "gvc3qt12i",
                        hover: "gvc3qt12j",
                        focus: "gvc3qt12k"
                    },
                    defaultClass: "gvc3qt12h gvc3qt12i"
                },
                green50: {
                    conditions: {
                        light: "gvc3qt12l",
                        dark: "gvc3qt12m",
                        hover: "gvc3qt12n",
                        focus: "gvc3qt12o"
                    },
                    defaultClass: "gvc3qt12l gvc3qt12m"
                },
                green100: {
                    conditions: {
                        light: "gvc3qt12p",
                        dark: "gvc3qt12q",
                        hover: "gvc3qt12r",
                        focus: "gvc3qt12s"
                    },
                    defaultClass: "gvc3qt12p gvc3qt12q"
                },
                green200: {
                    conditions: {
                        light: "gvc3qt12t",
                        dark: "gvc3qt12u",
                        hover: "gvc3qt12v",
                        focus: "gvc3qt12w"
                    },
                    defaultClass: "gvc3qt12t gvc3qt12u"
                },
                green300: {
                    conditions: {
                        light: "gvc3qt12x",
                        dark: "gvc3qt12y",
                        hover: "gvc3qt12z",
                        focus: "gvc3qt130"
                    },
                    defaultClass: "gvc3qt12x gvc3qt12y"
                },
                green400: {
                    conditions: {
                        light: "gvc3qt131",
                        dark: "gvc3qt132",
                        hover: "gvc3qt133",
                        focus: "gvc3qt134"
                    },
                    defaultClass: "gvc3qt131 gvc3qt132"
                },
                green500: {
                    conditions: {
                        light: "gvc3qt135",
                        dark: "gvc3qt136",
                        hover: "gvc3qt137",
                        focus: "gvc3qt138"
                    },
                    defaultClass: "gvc3qt135 gvc3qt136"
                },
                green600: {
                    conditions: {
                        light: "gvc3qt139",
                        dark: "gvc3qt13a",
                        hover: "gvc3qt13b",
                        focus: "gvc3qt13c"
                    },
                    defaultClass: "gvc3qt139 gvc3qt13a"
                },
                green700: {
                    conditions: {
                        light: "gvc3qt13d",
                        dark: "gvc3qt13e",
                        hover: "gvc3qt13f",
                        focus: "gvc3qt13g"
                    },
                    defaultClass: "gvc3qt13d gvc3qt13e"
                },
                green800: {
                    conditions: {
                        light: "gvc3qt13h",
                        dark: "gvc3qt13i",
                        hover: "gvc3qt13j",
                        focus: "gvc3qt13k"
                    },
                    defaultClass: "gvc3qt13h gvc3qt13i"
                },
                green900: {
                    conditions: {
                        light: "gvc3qt13l",
                        dark: "gvc3qt13m",
                        hover: "gvc3qt13n",
                        focus: "gvc3qt13o"
                    },
                    defaultClass: "gvc3qt13l gvc3qt13m"
                },
                blue50: {
                    conditions: {
                        light: "gvc3qt13p",
                        dark: "gvc3qt13q",
                        hover: "gvc3qt13r",
                        focus: "gvc3qt13s"
                    },
                    defaultClass: "gvc3qt13p gvc3qt13q"
                },
                blue100: {
                    conditions: {
                        light: "gvc3qt13t",
                        dark: "gvc3qt13u",
                        hover: "gvc3qt13v",
                        focus: "gvc3qt13w"
                    },
                    defaultClass: "gvc3qt13t gvc3qt13u"
                },
                blue200: {
                    conditions: {
                        light: "gvc3qt13x",
                        dark: "gvc3qt13y",
                        hover: "gvc3qt13z",
                        focus: "gvc3qt140"
                    },
                    defaultClass: "gvc3qt13x gvc3qt13y"
                },
                blue300: {
                    conditions: {
                        light: "gvc3qt141",
                        dark: "gvc3qt142",
                        hover: "gvc3qt143",
                        focus: "gvc3qt144"
                    },
                    defaultClass: "gvc3qt141 gvc3qt142"
                },
                blue400: {
                    conditions: {
                        light: "gvc3qt145",
                        dark: "gvc3qt146",
                        hover: "gvc3qt147",
                        focus: "gvc3qt148"
                    },
                    defaultClass: "gvc3qt145 gvc3qt146"
                },
                blue500: {
                    conditions: {
                        light: "gvc3qt149",
                        dark: "gvc3qt14a",
                        hover: "gvc3qt14b",
                        focus: "gvc3qt14c"
                    },
                    defaultClass: "gvc3qt149 gvc3qt14a"
                },
                blue600: {
                    conditions: {
                        light: "gvc3qt14d",
                        dark: "gvc3qt14e",
                        hover: "gvc3qt14f",
                        focus: "gvc3qt14g"
                    },
                    defaultClass: "gvc3qt14d gvc3qt14e"
                },
                blue700: {
                    conditions: {
                        light: "gvc3qt14h",
                        dark: "gvc3qt14i",
                        hover: "gvc3qt14j",
                        focus: "gvc3qt14k"
                    },
                    defaultClass: "gvc3qt14h gvc3qt14i"
                },
                blue800: {
                    conditions: {
                        light: "gvc3qt14l",
                        dark: "gvc3qt14m",
                        hover: "gvc3qt14n",
                        focus: "gvc3qt14o"
                    },
                    defaultClass: "gvc3qt14l gvc3qt14m"
                },
                blue900: {
                    conditions: {
                        light: "gvc3qt14p",
                        dark: "gvc3qt14q",
                        hover: "gvc3qt14r",
                        focus: "gvc3qt14s"
                    },
                    defaultClass: "gvc3qt14p gvc3qt14q"
                },
                primary50: {
                    conditions: {
                        light: "gvc3qt14t",
                        dark: "gvc3qt14u",
                        hover: "gvc3qt14v",
                        focus: "gvc3qt14w"
                    },
                    defaultClass: "gvc3qt14t gvc3qt14u"
                },
                primary100: {
                    conditions: {
                        light: "gvc3qt14x",
                        dark: "gvc3qt14y",
                        hover: "gvc3qt14z",
                        focus: "gvc3qt150"
                    },
                    defaultClass: "gvc3qt14x gvc3qt14y"
                },
                primary200: {
                    conditions: {
                        light: "gvc3qt151",
                        dark: "gvc3qt152",
                        hover: "gvc3qt153",
                        focus: "gvc3qt154"
                    },
                    defaultClass: "gvc3qt151 gvc3qt152"
                },
                primary300: {
                    conditions: {
                        light: "gvc3qt155",
                        dark: "gvc3qt156",
                        hover: "gvc3qt157",
                        focus: "gvc3qt158"
                    },
                    defaultClass: "gvc3qt155 gvc3qt156"
                },
                primary400: {
                    conditions: {
                        light: "gvc3qt159",
                        dark: "gvc3qt15a",
                        hover: "gvc3qt15b",
                        focus: "gvc3qt15c"
                    },
                    defaultClass: "gvc3qt159 gvc3qt15a"
                },
                primary500: {
                    conditions: {
                        light: "gvc3qt15d",
                        dark: "gvc3qt15e",
                        hover: "gvc3qt15f",
                        focus: "gvc3qt15g"
                    },
                    defaultClass: "gvc3qt15d gvc3qt15e"
                },
                primary600: {
                    conditions: {
                        light: "gvc3qt15h",
                        dark: "gvc3qt15i",
                        hover: "gvc3qt15j",
                        focus: "gvc3qt15k"
                    },
                    defaultClass: "gvc3qt15h gvc3qt15i"
                },
                primary700: {
                    conditions: {
                        light: "gvc3qt15l",
                        dark: "gvc3qt15m",
                        hover: "gvc3qt15n",
                        focus: "gvc3qt15o"
                    },
                    defaultClass: "gvc3qt15l gvc3qt15m"
                },
                primary800: {
                    conditions: {
                        light: "gvc3qt15p",
                        dark: "gvc3qt15q",
                        hover: "gvc3qt15r",
                        focus: "gvc3qt15s"
                    },
                    defaultClass: "gvc3qt15p gvc3qt15q"
                },
                primary900: {
                    conditions: {
                        light: "gvc3qt15t",
                        dark: "gvc3qt15u",
                        hover: "gvc3qt15v",
                        focus: "gvc3qt15w"
                    },
                    defaultClass: "gvc3qt15t gvc3qt15u"
                },
                purple50: {
                    conditions: {
                        light: "gvc3qt15x",
                        dark: "gvc3qt15y",
                        hover: "gvc3qt15z",
                        focus: "gvc3qt160"
                    },
                    defaultClass: "gvc3qt15x gvc3qt15y"
                },
                purple100: {
                    conditions: {
                        light: "gvc3qt161",
                        dark: "gvc3qt162",
                        hover: "gvc3qt163",
                        focus: "gvc3qt164"
                    },
                    defaultClass: "gvc3qt161 gvc3qt162"
                },
                purple200: {
                    conditions: {
                        light: "gvc3qt165",
                        dark: "gvc3qt166",
                        hover: "gvc3qt167",
                        focus: "gvc3qt168"
                    },
                    defaultClass: "gvc3qt165 gvc3qt166"
                },
                purple300: {
                    conditions: {
                        light: "gvc3qt169",
                        dark: "gvc3qt16a",
                        hover: "gvc3qt16b",
                        focus: "gvc3qt16c"
                    },
                    defaultClass: "gvc3qt169 gvc3qt16a"
                },
                purple400: {
                    conditions: {
                        light: "gvc3qt16d",
                        dark: "gvc3qt16e",
                        hover: "gvc3qt16f",
                        focus: "gvc3qt16g"
                    },
                    defaultClass: "gvc3qt16d gvc3qt16e"
                },
                purple500: {
                    conditions: {
                        light: "gvc3qt16h",
                        dark: "gvc3qt16i",
                        hover: "gvc3qt16j",
                        focus: "gvc3qt16k"
                    },
                    defaultClass: "gvc3qt16h gvc3qt16i"
                },
                purple600: {
                    conditions: {
                        light: "gvc3qt16l",
                        dark: "gvc3qt16m",
                        hover: "gvc3qt16n",
                        focus: "gvc3qt16o"
                    },
                    defaultClass: "gvc3qt16l gvc3qt16m"
                },
                purple700: {
                    conditions: {
                        light: "gvc3qt16p",
                        dark: "gvc3qt16q",
                        hover: "gvc3qt16r",
                        focus: "gvc3qt16s"
                    },
                    defaultClass: "gvc3qt16p gvc3qt16q"
                },
                purple800: {
                    conditions: {
                        light: "gvc3qt16t",
                        dark: "gvc3qt16u",
                        hover: "gvc3qt16v",
                        focus: "gvc3qt16w"
                    },
                    defaultClass: "gvc3qt16t gvc3qt16u"
                },
                purple900: {
                    conditions: {
                        light: "gvc3qt16x",
                        dark: "gvc3qt16y",
                        hover: "gvc3qt16z",
                        focus: "gvc3qt170"
                    },
                    defaultClass: "gvc3qt16x gvc3qt16y"
                }
            }
        }
    }
}, {
    conditions: undefined,
    styles: {
        fontSize: {
            values: {
                "3xs": {
                    defaultClass: "gvc3qt0"
                },
                "2xs": {
                    defaultClass: "gvc3qt1"
                },
                xs: {
                    defaultClass: "gvc3qt2"
                },
                sm: {
                    defaultClass: "gvc3qt3"
                },
                md: {
                    defaultClass: "gvc3qt4"
                },
                lg: {
                    defaultClass: "gvc3qt5"
                },
                xl: {
                    defaultClass: "gvc3qt6"
                },
                "2xl": {
                    defaultClass: "gvc3qt7"
                },
                "3xl": {
                    defaultClass: "gvc3qt8"
                },
                "4xl": {
                    defaultClass: "gvc3qt9"
                },
                "5xl": {
                    defaultClass: "gvc3qta"
                },
                "6xl": {
                    defaultClass: "gvc3qtb"
                },
                "7xl": {
                    defaultClass: "gvc3qtc"
                },
                "8xl": {
                    defaultClass: "gvc3qtd"
                },
                "9xl": {
                    defaultClass: "gvc3qte"
                },
                "10xl": {
                    defaultClass: "gvc3qtf"
                },
                "11xl": {
                    defaultClass: "gvc3qtg"
                },
                "12xl": {
                    defaultClass: "gvc3qth"
                },
                "13xl": {
                    defaultClass: "gvc3qti"
                },
                "14xl": {
                    defaultClass: "gvc3qtj"
                },
                "15xl": {
                    defaultClass: "gvc3qtk"
                },
                inherit: {
                    defaultClass: "gvc3qtl"
                }
            }
        },
        fontFamily: {
            values: {
                body: {
                    defaultClass: "gvc3qtm"
                }
            }
        },
        textAlign: {
            values: {
                center: {
                    defaultClass: "gvc3qtn"
                },
                left: {
                    defaultClass: "gvc3qto"
                },
                right: {
                    defaultClass: "gvc3qtp"
                }
            }
        },
        textDecoration: {
            values: {
                none: {
                    defaultClass: "gvc3qtq"
                },
                underline: {
                    defaultClass: "gvc3qtr"
                }
            }
        },
        borderRadius: {
            values: {
                none: {
                    defaultClass: "gvc3qts"
                },
                sm: {
                    defaultClass: "gvc3qtt"
                },
                base: {
                    defaultClass: "gvc3qtu"
                },
                md: {
                    defaultClass: "gvc3qtv"
                },
                lg: {
                    defaultClass: "gvc3qtw"
                },
                xl: {
                    defaultClass: "gvc3qtx"
                },
                "2xl": {
                    defaultClass: "gvc3qty"
                },
                "3xl": {
                    defaultClass: "gvc3qtz"
                },
                "4xl": {
                    defaultClass: "gvc3qt10"
                },
                full: {
                    defaultClass: "gvc3qt11"
                }
            }
        },
        boxShadow: {
            values: {
                xs: {
                    defaultClass: "gvc3qt12"
                },
                sm: {
                    defaultClass: "gvc3qt13"
                },
                base: {
                    defaultClass: "gvc3qt14"
                },
                md: {
                    defaultClass: "gvc3qt15"
                },
                lg: {
                    defaultClass: "gvc3qt16"
                },
                xl: {
                    defaultClass: "gvc3qt17"
                },
                "2xl": {
                    defaultClass: "gvc3qt18"
                },
                inset: {
                    defaultClass: "gvc3qt19"
                },
                primaryOutline: {
                    defaultClass: "gvc3qt1a"
                },
                none: {
                    defaultClass: "gvc3qt1b"
                },
                "dark-lg": {
                    defaultClass: "gvc3qt1c"
                }
            }
        },
        aspectRatio: {
            values: {
                auto: {
                    defaultClass: "gvc3qt1d"
                },
                "1/1": {
                    defaultClass: "gvc3qt1e"
                },
                "2/1": {
                    defaultClass: "gvc3qt1f"
                },
                "4/1": {
                    defaultClass: "gvc3qt1g"
                },
                "4/3": {
                    defaultClass: "gvc3qt1h"
                },
                "16/9": {
                    defaultClass: "gvc3qt1i"
                }
            }
        },
        cursor: {
            values: {
                "default": {
                    defaultClass: "gvc3qt1j"
                },
                pointer: {
                    defaultClass: "gvc3qt1k"
                },
                "not-allowed": {
                    defaultClass: "gvc3qt1l"
                }
            }
        },
        isolation: {
            values: {
                isolate: {
                    defaultClass: "gvc3qt1m"
                }
            }
        },
        objectFit: {
            values: {
                contain: {
                    defaultClass: "gvc3qt1n"
                },
                cover: {
                    defaultClass: "gvc3qt1o"
                }
            }
        },
        pointerEvents: {
            values: {
                none: {
                    defaultClass: "gvc3qt1p"
                }
            }
        },
        strokeWidth: {
            values: {
                none: {
                    defaultClass: "gvc3qt1q"
                },
                sm: {
                    defaultClass: "gvc3qt1r"
                },
                base: {
                    defaultClass: "gvc3qt1s"
                },
                md: {
                    defaultClass: "gvc3qt1t"
                },
                lg: {
                    defaultClass: "gvc3qt1u"
                },
                xl: {
                    defaultClass: "gvc3qt1v"
                }
            }
        },
        textTransform: {
            values: {
                capitalize: {
                    defaultClass: "gvc3qt1w"
                },
                lowercase: {
                    defaultClass: "gvc3qt1x"
                },
                uppercase: {
                    defaultClass: "gvc3qt1y"
                }
            }
        },
        transitionProperty: {
            values: {
                none: {
                    defaultClass: "gvc3qt1z"
                },
                all: {
                    defaultClass: "gvc3qt20"
                },
                "default": {
                    defaultClass: "gvc3qt21"
                },
                colors: {
                    defaultClass: "gvc3qt22"
                },
                opacity: {
                    defaultClass: "gvc3qt23"
                },
                shadow: {
                    defaultClass: "gvc3qt24"
                },
                transform: {
                    defaultClass: "gvc3qt25"
                }
            }
        },
        transitionTimingFunction: {
            values: {
                linear: {
                    defaultClass: "gvc3qt26"
                },
                "in": {
                    defaultClass: "gvc3qt27"
                },
                out: {
                    defaultClass: "gvc3qt28"
                },
                inOut: {
                    defaultClass: "gvc3qt29"
                }
            }
        },
        overflow: {
            values: {
                auto: {
                    defaultClass: "gvc3qt2a"
                },
                hidden: {
                    defaultClass: "gvc3qt2b"
                },
                scroll: {
                    defaultClass: "gvc3qt2c"
                },
                unset: {
                    defaultClass: "gvc3qt2d"
                }
            }
        },
        visibility: {
            values: {
                hidden: {
                    defaultClass: "gvc3qt2e"
                },
                visible: {
                    defaultClass: "gvc3qt2f"
                }
            }
        },
        whiteSpace: {
            values: {
                normal: {
                    defaultClass: "gvc3qt2g"
                },
                nowrap: {
                    defaultClass: "gvc3qt2h"
                },
                pre: {
                    defaultClass: "gvc3qt2i"
                },
                "pre-line": {
                    defaultClass: "gvc3qt2j"
                },
                "pre-wrap": {
                    defaultClass: "gvc3qt2k"
                },
                initial: {
                    defaultClass: "gvc3qt2l"
                },
                inherit: {
                    defaultClass: "gvc3qt2m"
                }
            }
        },
        wordBreak: {
            values: {
                "break-word": {
                    defaultClass: "gvc3qt2n"
                }
            }
        },
        wordWrap: {
            values: {
                normal: {
                    defaultClass: "gvc3qt2o"
                },
                "break-word": {
                    defaultClass: "gvc3qt2p"
                },
                initial: {
                    defaultClass: "gvc3qt2q"
                },
                inherit: {
                    defaultClass: "gvc3qt2r"
                }
            }
        },
        zIndex: {
            values: {
                "0": {
                    defaultClass: "gvc3qt2s"
                },
                "10": {
                    defaultClass: "gvc3qt2t"
                },
                "20": {
                    defaultClass: "gvc3qt2u"
                },
                "30": {
                    defaultClass: "gvc3qt2v"
                },
                "40": {
                    defaultClass: "gvc3qt2w"
                },
                "50": {
                    defaultClass: "gvc3qt2x"
                },
                "75": {
                    defaultClass: "gvc3qt2y"
                },
                "100": {
                    defaultClass: "gvc3qt2z"
                },
                auto: {
                    defaultClass: "gvc3qt30"
                }
            }
        }
    }
});


var $be590b4b1de7c722$export$d7e66ef6999696cf = {
    as: "div"
};


var $c05182ab934fe0bd$var$__assign = undefined && undefined.__assign || function() {
    $c05182ab934fe0bd$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c05182ab934fe0bd$var$__assign.apply(this, arguments);
};
function $c05182ab934fe0bd$var$Box(props) {
    var _a = (0, $kyBEk$useState)(function() {
        return {};
    }), atomProps = _a[0], setAtomProps = _a[1];
    var _b = (0, $kyBEk$useState)(function() {
        return {};
    }), nativeProps = _b[0], setNativeProps = _b[1];
    var _c = (0, $kyBEk$useState)(function() {
        return "";
    }), className = _c[0], setClassName = _c[1];
    function calculateStyles() {
        var atoms = {};
        var natives = {};
        Object.keys(props).forEach(function(key) {
            // @ts-ignore
            if ((0, $47a3451e57ac14cf$export$9f2265a541a48bf2).properties.has(key)) atoms[key] = props[key];
            else natives[key] = props[key];
        });
        setAtomProps(atoms);
        setNativeProps(natives);
        setClassName((0, $kyBEk$clsx)((0, $47a3451e57ac14cf$export$9f2265a541a48bf2)(atoms), props.className));
    }
    (0, $kyBEk$useEffect)(function() {
        calculateStyles();
    }, []);
    (0, $kyBEk$useEffect)(function() {
        calculateStyles();
    }, [
        props
    ]);
    return (0, $kyBEk$jsx)(props.as, $c05182ab934fe0bd$var$__assign({}, props.attributes, {
        className: className,
        children: props.children
    }));
}
$c05182ab934fe0bd$var$Box.defaultProps = {
    as: (0, $be590b4b1de7c722$export$d7e66ef6999696cf).as
};
var $c05182ab934fe0bd$export$2e2bcd8739ae039 = $c05182ab934fe0bd$var$Box;




var $7718944390218472$exports = {};

$parcel$export($7718944390218472$exports, "default", function () { return $7718944390218472$export$2e2bcd8739ae039; }, function (v) { return $7718944390218472$export$2e2bcd8739ae039 = v; });



var $7718944390218472$var$__assign = undefined && undefined.__assign || function() {
    $7718944390218472$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $7718944390218472$var$__assign.apply(this, arguments);
};
function $7718944390218472$var$Stack(props) {
    return (0, $kyBEk$jsx)((0, $c05182ab934fe0bd$exports.default), $7718944390218472$var$__assign({
        display: "flex"
    }, props.attributes, {
        alignItems: props.align,
        as: props.as,
        flex: props.flex,
        flexDirection: props.direction,
        flexWrap: props.flexWrap,
        gap: props.space,
        justifyContent: props.justify,
        className: props.className,
        children: props.children
    }));
}
var $7718944390218472$export$2e2bcd8739ae039 = $7718944390218472$var$Stack;







var $52638007457ad9b5$exports = {};
$52638007457ad9b5$exports = new URL("icons.137fd2c0.svg", import.meta.url).toString();



function $a7df98dc81165fd3$var$Icon(props) {
    return (0, $kyBEk$jsxs)("svg", {
        width: "1em",
        height: "1em",
        fill: "currentColor",
        className: (0, $kyBEk$clsx)((0, $47a3451e57ac14cf$export$9f2265a541a48bf2)({
            fontSize: props.size,
            color: props.color
        }), props.className),
        children: [
            !!props.title ? (0, $kyBEk$jsx)((0, $kyBEk$Fragment), {
                children: (0, $kyBEk$jsx)("title", {
                    children: props.title
                })
            }) : null,
            (0, $kyBEk$jsx)("use", {
                xlinkHref: "".concat((0, (/*@__PURE__*/$parcel$interopDefault($52638007457ad9b5$exports))), "#").concat(props.name)
            })
        ]
    });
}
var $a7df98dc81165fd3$export$2e2bcd8739ae039 = $a7df98dc81165fd3$var$Icon;




var $41ede47214de3bdb$exports = {};

$parcel$export($41ede47214de3bdb$exports, "default", function () { return $41ede47214de3bdb$export$2e2bcd8739ae039; }, function (v) { return $41ede47214de3bdb$export$2e2bcd8739ae039 = v; });




var $10f46b741f72a0fc$export$e96da1e889d6dc74 = "gvc3qtm";
var $10f46b741f72a0fc$export$2f0084313b87d4cc = (0, $kyBEk$createRuntimeFn)({
    defaultClassName: "gvc3qtm",
    variantClassNames: {
        variant: {
            body: "gvc3qt3 gvc3qt1oa gvc3qt234",
            heading: "b9ktqw1"
        },
        ellipsis: {
            true: "b9ktqw3"
        },
        underline: {
            true: "b9ktqw4"
        }
    },
    defaultVariants: {
        variant: "body"
    },
    compoundVariants: []
});


var $41ede47214de3bdb$var$__assign = undefined && undefined.__assign || function() {
    $41ede47214de3bdb$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $41ede47214de3bdb$var$__assign.apply(this, arguments);
};
function $41ede47214de3bdb$var$Text(props) {
    return (0, $kyBEk$jsx)((0, $c05182ab934fe0bd$exports.default), $41ede47214de3bdb$var$__assign({}, props.attributes, {
        as: props.as,
        color: props.color,
        fontSize: props.size,
        fontWeight: props.weight,
        letterSpacing: props.letterSpacing,
        lineHeight: props.lineHeight,
        textAlign: props.align,
        textTransform: props.transform,
        whiteSpace: props.whiteSpace,
        wordBreak: props.wordBreak,
        className: "".concat((0, $10f46b741f72a0fc$export$2f0084313b87d4cc)({
            variant: props.variant,
            ellipsis: props.ellipsis ? true : undefined,
            underline: props.underline ? true : undefined
        }), " ").concat(props.className),
        children: props.children
    }));
}
$41ede47214de3bdb$var$Text.defaultProps = {
    size: "sm",
    color: "text",
    wordBreak: "break-word"
};
var $41ede47214de3bdb$export$2e2bcd8739ae039 = $41ede47214de3bdb$var$Text;




var $6aa42b028ae27f6d$exports = {};

$parcel$export($6aa42b028ae27f6d$exports, "default", function () { return $6aa42b028ae27f6d$export$2e2bcd8739ae039; }, function (v) { return $6aa42b028ae27f6d$export$2e2bcd8739ae039 = v; });





var $9036acce436a4eff$export$683472f6198a076e = {
    true: "_1vpyjkmd"
};
var $9036acce436a4eff$export$346677f925de839c = {
    xs: "gvc3qt34d gvc3qt37m gvc3qt2 gvc3qt1sv gvc3qt2yd",
    sm: "gvc3qt34j gvc3qt37s gvc3qt3 gvc3qt1t1 gvc3qt2yj",
    md: "gvc3qt34p gvc3qt37y gvc3qt4 gvc3qt1t7 gvc3qt2yp",
    lg: "gvc3qt34v gvc3qt384 gvc3qt5 gvc3qt1ta gvc3qt2ys"
};
var $9036acce436a4eff$export$2f0084313b87d4cc = (0, $kyBEk$createRuntimeFn)({
    defaultClassName: "_1vpyjkmi",
    variantClassNames: {
        variant: {
            solid: "_1vpyjkm4",
            outlined: "_1vpyjkm5",
            link: "_1vpyjkm6",
            ghost: "_1vpyjkm7",
            unstyled: "_1vpyjkm8"
        },
        intent: {
            primary: "_1vpyjkm9",
            secondary: "_1vpyjkma",
            tertiary: "_1vpyjkmb",
            text: "_1vpyjkmc"
        },
        disabled: {
            true: "_1vpyjkmd"
        },
        size: {
            xs: "gvc3qt34d gvc3qt37m gvc3qt2 gvc3qt1sv gvc3qt2yd",
            sm: "gvc3qt34j gvc3qt37s gvc3qt3 gvc3qt1t1 gvc3qt2yj",
            md: "gvc3qt34p gvc3qt37y gvc3qt4 gvc3qt1t7 gvc3qt2yp",
            lg: "gvc3qt34v gvc3qt384 gvc3qt5 gvc3qt1ta gvc3qt2ys"
        }
    },
    defaultVariants: {
        variant: "solid",
        intent: "primary",
        size: "md"
    },
    compoundVariants: [
        [
            {
                variant: "ghost",
                intent: "secondary"
            },
            "_1vpyjkmx"
        ],
        [
            {
                variant: "outlined",
                intent: "primary"
            },
            "_1vpyjkmy"
        ],
        [
            {
                variant: "outlined",
                intent: "tertiary"
            },
            "_1vpyjkmz"
        ],
        [
            {
                variant: "outlined",
                intent: "tertiary"
            },
            "_1vpyjkm10"
        ],
        [
            {
                variant: "unstyled",
                intent: "primary"
            },
            "_1vpyjkm11"
        ]
    ]
});






var $6aa42b028ae27f6d$var$__assign = undefined && undefined.__assign || function() {
    $6aa42b028ae27f6d$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $6aa42b028ae27f6d$var$__assign.apply(this, arguments);
};
function $6aa42b028ae27f6d$var$Button(props) {
    var cleanupRef = (0, $kyBEk$useRef)(null);
    var _a = (0, $kyBEk$useState)(function() {
        return false;
    }), loaded = _a[0], setLoaded = _a[1];
    var _b = (0, $kyBEk$useState)(function() {
        return "light";
    }), theme = _b[0], setTheme = _b[1];
    (0, $kyBEk$useEffect)(function() {
        setLoaded(true);
        setTheme((0, $65ee908e933b27be$export$6f57813fe9f31bf9).getState().theme);
        cleanupRef.current = (0, $65ee908e933b27be$export$6f57813fe9f31bf9).subscribe(function(newState, prevState) {
            setTheme(newState.theme);
        });
    }, []);
    (0, $kyBEk$useEffect)(function() {
        return function() {
            if (typeof cleanupRef.current === "function") cleanupRef.current();
        };
    }, []);
    return (0, $kyBEk$jsx)((0, $kyBEk$Fragment), {
        children: loaded ? (0, $kyBEk$jsx)((0, $kyBEk$Fragment), {
            children: (0, $kyBEk$jsxs)((0, $c05182ab934fe0bd$exports.default), $6aa42b028ae27f6d$var$__assign({
                as: "button"
            }, props.attributes, {
                attributes: {
                    onClick: function(event) {
                        var _a;
                        return (_a = props.onClick) === null || _a === void 0 ? void 0 : _a.call(props, event);
                    },
                    disabled: props.disabled
                },
                className: (0, $kyBEk$clsx)((0, $9036acce436a4eff$export$2f0084313b87d4cc)({
                    variant: props.variant,
                    size: props.size,
                    intent: props.intent,
                    disabled: props.disabled ? true : undefined
                }), props.className),
                children: [
                    !!props.leftIcon ? (0, $kyBEk$jsx)((0, $kyBEk$Fragment), {
                        children: (0, $kyBEk$jsx)((0, $a7df98dc81165fd3$export$2e2bcd8739ae039), {
                            name: props.leftIcon,
                            size: props.iconSize,
                            className: (0, $47a3451e57ac14cf$export$9f2265a541a48bf2)({
                                marginRight: !props.children ? "0" : "2"
                            })
                        })
                    }) : null,
                    props.children,
                    !!props.rightIcon ? (0, $kyBEk$jsx)((0, $kyBEk$Fragment), {
                        children: (0, $kyBEk$jsx)((0, $a7df98dc81165fd3$export$2e2bcd8739ae039), {
                            name: props.rightIcon,
                            size: props.iconSize,
                            className: (0, $47a3451e57ac14cf$export$9f2265a541a48bf2)({
                                marginLeft: !props.children ? "0" : "2"
                            })
                        })
                    }) : null
                ]
            }))
        }) : null
    });
}
var $6aa42b028ae27f6d$export$2e2bcd8739ae039 = $6aa42b028ae27f6d$var$Button;










var $72b03ebfb2d568c5$export$856b6de7fac89c7f = "_15r1rww1 gvc3qt3am gvc3qt30v gvc3qt2t7 gvc3qt1um gvc3qt2va gvc3qt11 gvc3qt3 gvc3qt1oa gvc3qt234 gvc3qtyd gvc3qtwa gvc3qt81 gvc3qt5y";
var $72b03ebfb2d568c5$export$dcc3981cc6efe940 = {
    idle: "_15r1rww5",
    copied: {
        light: "gvc3qtc9 gvc3qtca",
        dark: "gvc3qtcd gvc3qtce"
    }
};
var $72b03ebfb2d568c5$export$e156b0e4bc782edc = "_15r1rww3 gvc3qt2bp";
var $72b03ebfb2d568c5$export$7d077acfa6f5653d = "_15r1rww4";



function $42ff6571df854a54$export$f08da1a961158e78(addr, maxLength) {
    var midChar = "…";
    if (addr.length <= maxLength) return addr;
    // length of beginning part
    var left = Math.ceil(maxLength / 2);
    // start index of ending part
    var right = addr.length - Math.floor(maxLength / 2) + 1;
    return addr.substring(0, left) + midChar + addr.substring(right);
}


function $aad94d8c88c58f04$var$ClipboardCopyText(props) {
    var cleanupRef = (0, $kyBEk$useRef)(null);
    var _a = (0, $kyBEk$useState)(function() {
        return true;
    }), idle = _a[0], setIdle = _a[1];
    var _b = (0, $kyBEk$useState)(function() {
        return "light";
    }), theme = _b[0], setTheme = _b[1];
    function transform(text) {
        var _a;
        if (props.truncate === "middle") {
            var truncateLength = {
                lg: 14,
                md: 16,
                sm: 18
            };
            return (0, $42ff6571df854a54$export$f08da1a961158e78)(text, truncateLength[(_a = props.midTruncateLimit) !== null && _a !== void 0 ? _a : "md"]);
        }
        return text;
    }
    (0, $kyBEk$useEffect)(function() {
        setTheme((0, $65ee908e933b27be$export$6f57813fe9f31bf9).getState().theme);
        cleanupRef.current = (0, $65ee908e933b27be$export$6f57813fe9f31bf9).subscribe(function(newState) {
            setTheme(newState.theme);
        });
    }, []);
    (0, $kyBEk$useEffect)(function() {
        return function() {
            if (typeof cleanupRef.current === "function") cleanupRef.current();
        };
    }, []);
    return (0, $kyBEk$jsxs)("div", {
        onClick: function(event) {
            var _a;
            var success = (0, $kyBEk$copytoclipboard)(props.text);
            if (success) {
                (_a = props.onCopied) === null || _a === void 0 || _a.call(props);
                setIdle(false);
                setTimeout(function() {
                    setIdle(true);
                }, 1000);
            }
        },
        className: (0, $kyBEk$clsx)((0, $72b03ebfb2d568c5$export$856b6de7fac89c7f), props.className),
        children: [
            (0, $kyBEk$jsx)("p", {
                className: (0, $kyBEk$clsx)((0, $72b03ebfb2d568c5$export$e156b0e4bc782edc), props.truncate === "end" && (0, $72b03ebfb2d568c5$export$7d077acfa6f5653d)),
                children: transform(props.text)
            }),
            (0, $kyBEk$jsx)((0, $a7df98dc81165fd3$export$2e2bcd8739ae039), {
                size: "md",
                name: idle ? "copy" : "checkboxCircle",
                className: idle ? (0, $72b03ebfb2d568c5$export$dcc3981cc6efe940).idle : (0, $72b03ebfb2d568c5$export$dcc3981cc6efe940).copied[theme]
            })
        ]
    });
}
var $aad94d8c88c58f04$export$2e2bcd8739ae039 = $aad94d8c88c58f04$var$ClipboardCopyText;











function $b24d996ce2c2bd4a$var$ThemeProvider(props) {
    var cleanupRef = (0, $kyBEk$useRef)(null);
    var _a = (0, $kyBEk$useState)(function() {
        return null;
    }), preferredMode = _a[0], setPreferredMode = _a[1];
    var _b = (0, $kyBEk$useState)(function() {
        return false;
    }), isMounted = _b[0], setIsMounted = _b[1];
    function lightQuery() {
        var _a;
        if ((0, $3a23b7a7442a0ab3$export$48d7c418edadb60c)()) return null;
        return (_a = window === null || window === void 0 ? void 0 : window.matchMedia) === null || _a === void 0 ? void 0 : _a.call(window, (0, $dd30de1fdfe56750$export$79a8956d7e99dd16)("light"));
    }
    function darkQuery() {
        var _a;
        if ((0, $3a23b7a7442a0ab3$export$48d7c418edadb60c)()) return null;
        return (_a = window === null || window === void 0 ? void 0 : window.matchMedia) === null || _a === void 0 ? void 0 : _a.call(window, (0, $dd30de1fdfe56750$export$79a8956d7e99dd16)("dark"));
    }
    function isDark() {
        var _a;
        return !!((_a = darkQuery === null || darkQuery === void 0 ? void 0 : darkQuery()) === null || _a === void 0 ? void 0 : _a.matches);
    }
    function isLight() {
        var _a;
        return !!((_a = lightQuery === null || lightQuery === void 0 ? void 0 : lightQuery()) === null || _a === void 0 ? void 0 : _a.matches);
    }
    (0, $kyBEk$useEffect)(function() {
        (0, $dd30de1fdfe56750$export$de2f59649721f6be)(props.defaultTheme);
        setIsMounted(true);
        var darkListener = function(_a) {
            var matches = _a.matches;
            if (matches) setPreferredMode("dark");
        };
        var lightListener = function(_a) {
            var matches = _a.matches;
            if (matches) setPreferredMode("light");
        };
        darkQuery().addEventListener("change", darkListener);
        lightQuery().addEventListener("change", lightListener);
        cleanupRef.current = function() {
            darkQuery().removeEventListener("change", darkListener);
            lightQuery().removeEventListener("change", lightListener);
        };
    }, []);
    (0, $kyBEk$useEffect)(function() {
        if (!preferredMode || !isMounted) return;
        var themeMode = (0, $65ee908e933b27be$export$6f57813fe9f31bf9).getState().themeMode;
        if (themeMode === "system") return (0, $65ee908e933b27be$export$6f57813fe9f31bf9).getState().setThemeMode(themeMode);
    }, [
        preferredMode,
        (0, $65ee908e933b27be$export$6f57813fe9f31bf9).getState().theme,
        isMounted
    ]);
    (0, $kyBEk$useEffect)(function() {
        return function() {
            if (typeof cleanupRef.current === "function") cleanupRef.current();
        };
    }, []);
    return (0, $kyBEk$jsx)("div", {
        children: props.children
    });
}
var $b24d996ce2c2bd4a$export$2e2bcd8739ae039 = $b24d996ce2c2bd4a$var$ThemeProvider;








function $509770f1f99d27e1$var$FadeIn(props) {
    var fadeInAnimationRef = (0, $kyBEk$useRef)(null);
    var fadeOutAnimationRef = (0, $kyBEk$useRef)(null);
    var elementRef = (0, $kyBEk$useRef)(null);
    (0, $kyBEk$useEffect)(function() {
        var _a, _b;
        var delaySetting = props.delayMs || 100;
        var durationSetting = props.durationMs || 250;
        // Animation not init yet
        if (elementRef.current && !fadeInAnimationRef.current && !fadeOutAnimationRef.current) {
            fadeInAnimationRef.current = (0, $kyBEk$animejs)({
                targets: elementRef.current,
                opacity: [
                    0,
                    1
                ],
                delay: delaySetting,
                duration: durationSetting,
                direction: "alternate",
                loop: false,
                autoplay: false,
                easing: "spring(1, 80, 10, 0)"
            });
            fadeOutAnimationRef.current = (0, $kyBEk$animejs)({
                targets: elementRef.current,
                opacity: [
                    1,
                    0
                ],
                delay: delaySetting,
                duration: durationSetting,
                direction: "alternate",
                loop: false,
                autoplay: false,
                easing: "spring(1, 80, 10, 0)"
            });
        }
        if (props.isVisible) (_a = fadeInAnimationRef.current) === null || _a === void 0 || _a.restart();
        else (_b = fadeOutAnimationRef.current) === null || _b === void 0 || _b.restart();
    }, [
        props.delayMs,
        props.durationMs,
        props.isVisible
    ]);
    return (0, $kyBEk$jsx)("div", {
        ref: elementRef,
        children: props.children
    });
}
var $509770f1f99d27e1$export$2e2bcd8739ae039 = $509770f1f99d27e1$var$FadeIn;












var $c4b81dd9bcca2343$export$4ef6e89e54d1a2e4 = "_176xhz87 _176xhz82 gvc3qt34p gvc3qt37y gvc3qt3ba gvc3qt31j";
var $c4b81dd9bcca2343$export$34e0f9847d4c02dd = "_176xhz80";
var $c4b81dd9bcca2343$export$8fe35dc8637e3206 = "_176xhz86";
var $c4b81dd9bcca2343$export$fce79930bd73619a = "_176xhz8b gvc3qt37p";
var $c4b81dd9bcca2343$export$5c452ff88e35e47d = "_176xhz84";
var $c4b81dd9bcca2343$export$b0621356b698e91a = "_176xhz83";
var $c4b81dd9bcca2343$export$1668d8d7da6c797c = "_176xhz89";
var $c4b81dd9bcca2343$export$138f47649e2b9f1d = "_176xhz88 _176xhz82 gvc3qt34p gvc3qt37y gvc3qt3ba gvc3qt31j";
var $c4b81dd9bcca2343$export$63cc71e91144f45b = "_176xhz85";


function $4950aa983a2d5553$var$PoolsHeader(props) {
    var _a, _b;
    var cleanupRef = (0, $kyBEk$useRef)(null);
    var _c = (0, $kyBEk$useState)(function() {
        return "light";
    }), theme = _c[0], setTheme = _c[1];
    function Semocolon() {
        return (0, $kyBEk$jsx)((0, $41ede47214de3bdb$exports.default), {
            className: $c4b81dd9bcca2343$export$63cc71e91144f45b,
            as: "span",
            color: "textSecondary",
            weight: "semibold",
            size: "4xl",
            children: ":"
        });
    }
    (0, $kyBEk$useEffect)(function() {
        setTheme((0, $65ee908e933b27be$export$6f57813fe9f31bf9).getState().theme);
        cleanupRef.current = (0, $65ee908e933b27be$export$6f57813fe9f31bf9).subscribe(function(newState) {
            setTheme(newState.theme);
        });
    }, []);
    (0, $kyBEk$useEffect)(function() {
        return function() {
            if (typeof cleanupRef.current === "function") cleanupRef.current();
        };
    }, []);
    return (0, $kyBEk$jsxs)((0, $c05182ab934fe0bd$exports.default), {
        children: [
            (0, $kyBEk$jsx)((0, $41ede47214de3bdb$exports.default), {
                color: "text",
                size: "xl",
                weight: "semibold",
                children: "Liquidity Pools"
            }),
            (0, $kyBEk$jsxs)((0, $7718944390218472$exports.default), {
                space: "10",
                className: $c4b81dd9bcca2343$export$34e0f9847d4c02dd,
                children: [
                    (0, $kyBEk$jsx)((0, $c05182ab934fe0bd$exports.default), {
                        className: $c4b81dd9bcca2343$export$4ef6e89e54d1a2e4,
                        children: (0, $kyBEk$jsxs)((0, $7718944390218472$exports.default), {
                            align: "center",
                            className: (0, $47a3451e57ac14cf$export$9f2265a541a48bf2)({
                                overflow: "hidden"
                            }),
                            children: [
                                (0, $kyBEk$jsx)("img", {
                                    src: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/ion.svg",
                                    className: $c4b81dd9bcca2343$export$5c452ff88e35e47d
                                }),
                                (0, $kyBEk$jsxs)((0, $7718944390218472$exports.default), {
                                    direction: "column",
                                    justify: "center",
                                    lineHeight: "shorter",
                                    children: [
                                        (0, $kyBEk$jsx)((0, $41ede47214de3bdb$exports.default), {
                                            color: "textSecondary",
                                            weight: "semibold",
                                            className: $c4b81dd9bcca2343$export$b0621356b698e91a,
                                            children: "OSMO Price"
                                        }),
                                        (0, $kyBEk$jsxs)((0, $7718944390218472$exports.default), {
                                            align: "flex-end",
                                            children: [
                                                (0, $kyBEk$jsx)((0, $41ede47214de3bdb$exports.default), {
                                                    color: "text",
                                                    weight: "semibold",
                                                    lineHeight: "shorter",
                                                    className: $c4b81dd9bcca2343$export$8fe35dc8637e3206,
                                                    children: "$"
                                                }),
                                                (0, $kyBEk$jsx)((0, $41ede47214de3bdb$exports.default), {
                                                    color: "text",
                                                    size: "4xl",
                                                    weight: "semibold",
                                                    children: (_b = (_a = (0, $65ee908e933b27be$export$6f57813fe9f31bf9).getState()) === null || _a === void 0 ? void 0 : _a.formatNumber) === null || _b === void 0 ? void 0 : _b.call(_a, {
                                                        value: props.price
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    (0, $kyBEk$jsx)((0, $c05182ab934fe0bd$exports.default), {
                        className: $c4b81dd9bcca2343$export$4ef6e89e54d1a2e4,
                        children: (0, $kyBEk$jsxs)((0, $7718944390218472$exports.default), {
                            direction: "column",
                            justify: "center",
                            children: [
                                (0, $kyBEk$jsx)((0, $41ede47214de3bdb$exports.default), {
                                    color: "textSecondary",
                                    weight: "semibold",
                                    className: $c4b81dd9bcca2343$export$b0621356b698e91a,
                                    children: "Reward distribution in"
                                }),
                                (0, $kyBEk$jsxs)((0, $41ede47214de3bdb$exports.default), {
                                    color: "text",
                                    weight: "semibold",
                                    size: "4xl",
                                    children: [
                                        "12",
                                        (0, $kyBEk$jsx)(Semocolon, {}),
                                        "19",
                                        (0, $kyBEk$jsx)(Semocolon, {}),
                                        "48"
                                    ]
                                })
                            ]
                        })
                    }),
                    (0, $kyBEk$jsx)((0, $c05182ab934fe0bd$exports.default), {
                        className: $c4b81dd9bcca2343$export$138f47649e2b9f1d,
                        children: (0, $kyBEk$jsxs)((0, $7718944390218472$exports.default), {
                            direction: "column",
                            justify: "center",
                            children: [
                                (0, $kyBEk$jsx)((0, $41ede47214de3bdb$exports.default), {
                                    color: "rewardContent",
                                    weight: "semibold",
                                    className: $c4b81dd9bcca2343$export$b0621356b698e91a,
                                    children: "Yesterdays rewards"
                                }),
                                (0, $kyBEk$jsxs)((0, $7718944390218472$exports.default), {
                                    align: "flex-end",
                                    children: [
                                        (0, $kyBEk$jsx)((0, $41ede47214de3bdb$exports.default), {
                                            color: "rewardContent",
                                            size: "4xl",
                                            weight: "semibold",
                                            children: props.rewards
                                        }),
                                        (0, $kyBEk$jsx)((0, $41ede47214de3bdb$exports.default), {
                                            color: "rewardContent",
                                            weight: "semibold",
                                            className: $c4b81dd9bcca2343$export$1668d8d7da6c797c,
                                            children: "OSMO"
                                        }),
                                        (0, $kyBEk$jsx)((0, $41ede47214de3bdb$exports.default), {
                                            color: "rewardContent",
                                            className: $c4b81dd9bcca2343$export$b0621356b698e91a,
                                            children: props.$rewards
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
}
var $4950aa983a2d5553$export$2e2bcd8739ae039 = $4950aa983a2d5553$var$PoolsHeader;






















var $62e3a49af2d7aa26$export$9338cf6ae76db7e8 = "_15fdyo84 _15fdyo83 gvc3qt2rp gvc3qt1t7";
var $62e3a49af2d7aa26$export$fb4e5e38aa0c29c2 = "_15fdyo85 _15fdyo83 gvc3qt2rp gvc3qt1t7";
var $62e3a49af2d7aa26$export$517d4726d56152f4 = "_15fdyo81 gvc3qt2z1 gvc3qt1t7 gvc3qt2c1";
var $62e3a49af2d7aa26$export$1100c59bcd9cefe1 = "_15fdyo83 gvc3qt2rp gvc3qt1t7";
var $62e3a49af2d7aa26$export$fbc8bcd33b574fbc = "_15fdyo87";
var $62e3a49af2d7aa26$export$4fedd756b17cf1a9 = "gvc3qt2tu gvc3qt2ty";


function $935bfa7d43e40fd6$var$PoolName(props) {
    return (0, $kyBEk$jsxs)((0, $7718944390218472$exports.default), {
        className: props.className,
        children: [
            (0, $kyBEk$jsxs)((0, $c05182ab934fe0bd$exports.default), {
                className: $62e3a49af2d7aa26$export$517d4726d56152f4,
                children: [
                    (0, $kyBEk$jsx)("img", {
                        src: props.token1.imgSrc,
                        className: $62e3a49af2d7aa26$export$9338cf6ae76db7e8
                    }),
                    (0, $kyBEk$jsx)("img", {
                        src: props.token2.imgSrc,
                        className: $62e3a49af2d7aa26$export$fb4e5e38aa0c29c2
                    })
                ]
            }),
            (0, $kyBEk$jsxs)((0, $7718944390218472$exports.default), {
                direction: "column",
                justify: "center",
                children: [
                    (0, $kyBEk$jsxs)((0, $41ede47214de3bdb$exports.default), {
                        color: "text",
                        weight: "semibold",
                        attributes: {
                            marginBottom: "2"
                        },
                        children: [
                            props.token1.name,
                            "/",
                            props.token2.name
                        ]
                    }),
                    (0, $kyBEk$jsxs)((0, $41ede47214de3bdb$exports.default), {
                        color: "textSecondary",
                        children: [
                            "Pool #",
                            props.id
                        ]
                    })
                ]
            })
        ]
    });
}
var $935bfa7d43e40fd6$export$2e2bcd8739ae039 = $935bfa7d43e40fd6$var$PoolName;









function $61b12225d18e468d$var$APR(props) {
    return (0, $kyBEk$jsxs)((0, $7718944390218472$exports.default), {
        justify: "space-between",
        align: "center",
        className: props.className,
        children: [
            (0, $kyBEk$jsxs)((0, $41ede47214de3bdb$exports.default), {
                color: "text",
                weight: "semibold",
                attributes: {
                    marginRight: "4"
                },
                children: [
                    props.apr,
                    "%"
                ]
            }),
            (0, $kyBEk$jsx)((0, $7718944390218472$exports.default), {
                justify: "center",
                align: "center",
                className: props.innerClassName,
                children: (0, $kyBEk$jsx)((0, $a7df98dc81165fd3$export$2e2bcd8739ae039), {
                    name: "verticalMore",
                    color: "text"
                })
            })
        ]
    });
}
var $61b12225d18e468d$export$2e2bcd8739ae039 = $61b12225d18e468d$var$APR;








function $5e44e04b263044f0$var$CellWithTitle(props) {
    return (0, $kyBEk$jsxs)((0, $7718944390218472$exports.default), {
        direction: "column",
        justify: "center",
        className: props.className,
        children: [
            (0, $kyBEk$jsx)((0, $41ede47214de3bdb$exports.default), {
                color: "textSecondary",
                wordBreak: "break-word",
                attributes: {
                    marginRight: "4",
                    marginBottom: "2"
                },
                className: props.innerClassName,
                children: props.title
            }),
            props.children
        ]
    });
}
var $5e44e04b263044f0$export$2e2bcd8739ae039 = $5e44e04b263044f0$var$CellWithTitle;





var $5a0d75754da974e6$export$34e0f9847d4c02dd = "_10yyvgi1 gvc3qt24j gvc3qt2c4";
var $5a0d75754da974e6$export$8f981dffec84ba52 = "_10yyvgi2";
var $5a0d75754da974e6$export$acf4eaf431084f78 = {
    light: "_10yyvgii _10yyvgih gvc3qtu",
    dark: "_10yyvgij _10yyvgih gvc3qtu"
};
var $5a0d75754da974e6$export$9338cf6ae76db7e8 = "_10yyvgib _10yyvgia gvc3qt2rp gvc3qt1t7";
var $5a0d75754da974e6$export$fb4e5e38aa0c29c2 = "_10yyvgic _10yyvgia gvc3qt2rp gvc3qt1t7";
var $5a0d75754da974e6$export$517d4726d56152f4 = "_10yyvgi8 gvc3qt2z1 gvc3qt1t7 gvc3qt2c1";
var $5a0d75754da974e6$export$1100c59bcd9cefe1 = "_10yyvgia gvc3qt2rp gvc3qt1t7";
var $5a0d75754da974e6$export$18f062023d1f7927 = "_10yyvgie";
var $5a0d75754da974e6$export$3b9d909fcd39d8ae = "_10yyvgi6";
var $5a0d75754da974e6$export$5ce0f3e73495726d = "_10yyvgif";
var $5a0d75754da974e6$export$fbc8bcd33b574fbc = "_10yyvgi3";
var $5a0d75754da974e6$export$4fedd756b17cf1a9 = "gvc3qt2tu gvc3qt2ty";
var $5a0d75754da974e6$export$1b2f4ba3aee9cec9 = "_10yyvgid";


function $56109dfc633821a9$var$PoolListItem(props) {
    var cleanupRef = (0, $kyBEk$useRef)(null);
    var _a = (0, $kyBEk$useState)(function() {
        return "light";
    }), theme = _a[0], setTheme = _a[1];
    (0, $kyBEk$useEffect)(function() {
        setTheme((0, $65ee908e933b27be$export$6f57813fe9f31bf9).getState().theme);
        cleanupRef.current = (0, $65ee908e933b27be$export$6f57813fe9f31bf9).subscribe(function(newState) {
            setTheme(newState.theme);
        });
    }, []);
    (0, $kyBEk$useEffect)(function() {
        return function() {
            if (typeof cleanupRef.current === "function") cleanupRef.current();
        };
    }, []);
    return (0, $kyBEk$jsxs)((0, $7718944390218472$exports.default), {
        align: "center",
        className: $5a0d75754da974e6$export$34e0f9847d4c02dd,
        children: [
            (0, $kyBEk$jsx)((0, $935bfa7d43e40fd6$export$2e2bcd8739ae039), {
                id: props.id,
                token1: props.token1,
                token2: props.token2,
                className: $5a0d75754da974e6$export$3b9d909fcd39d8ae
            }),
            (0, $kyBEk$jsx)((0, $5e44e04b263044f0$export$2e2bcd8739ae039), {
                title: "APR",
                innerClassName: $5a0d75754da974e6$export$5ce0f3e73495726d,
                className: (0, $kyBEk$clsx)($5a0d75754da974e6$export$4fedd756b17cf1a9, $5a0d75754da974e6$export$5ce0f3e73495726d),
                children: (0, $kyBEk$jsx)((0, $61b12225d18e468d$export$2e2bcd8739ae039), {
                    apr: props.apr,
                    innerClassName: $5a0d75754da974e6$export$acf4eaf431084f78[theme],
                    className: $5a0d75754da974e6$export$5ce0f3e73495726d
                })
            }),
            (0, $kyBEk$jsx)((0, $c05182ab934fe0bd$exports.default), {
                width: "full",
                height: "9",
                className: $5a0d75754da974e6$export$5ce0f3e73495726d
            }),
            (0, $kyBEk$jsx)((0, $5e44e04b263044f0$export$2e2bcd8739ae039), {
                title: "Liquidity",
                innerClassName: $5a0d75754da974e6$export$5ce0f3e73495726d,
                className: $5a0d75754da974e6$export$4fedd756b17cf1a9,
                children: (0, $kyBEk$jsxs)((0, $41ede47214de3bdb$exports.default), {
                    color: "text",
                    weight: "semibold",
                    wordBreak: "break-word",
                    attributes: {
                        marginRight: "4"
                    },
                    children: [
                        "$",
                        props.poolLiquidity.toLocaleString()
                    ]
                })
            }),
            (0, $kyBEk$jsx)((0, $5e44e04b263044f0$export$2e2bcd8739ae039), {
                title: "24H Volume",
                innerClassName: $5a0d75754da974e6$export$5ce0f3e73495726d,
                className: $5a0d75754da974e6$export$4fedd756b17cf1a9,
                children: (0, $kyBEk$jsxs)((0, $41ede47214de3bdb$exports.default), {
                    color: "text",
                    weight: "semibold",
                    wordBreak: "break-word",
                    attributes: {
                        marginRight: "4"
                    },
                    children: [
                        "$",
                        props.volume.toLocaleString()
                    ]
                })
            }),
            (0, $kyBEk$jsx)((0, $5e44e04b263044f0$export$2e2bcd8739ae039), {
                title: "7D Fees",
                innerClassName: $5a0d75754da974e6$export$5ce0f3e73495726d,
                className: $5a0d75754da974e6$export$4fedd756b17cf1a9,
                children: (0, $kyBEk$jsxs)((0, $41ede47214de3bdb$exports.default), {
                    color: "text",
                    weight: "semibold",
                    wordBreak: "break-word",
                    attributes: {
                        marginRight: "4"
                    },
                    children: [
                        "$",
                        props.fees.toLocaleString()
                    ]
                })
            }),
            (0, $kyBEk$jsx)((0, $61b12225d18e468d$export$2e2bcd8739ae039), {
                apr: props.apr,
                innerClassName: $5a0d75754da974e6$export$acf4eaf431084f78[theme],
                className: (0, $kyBEk$clsx)($5a0d75754da974e6$export$4fedd756b17cf1a9, $5a0d75754da974e6$export$18f062023d1f7927)
            }),
            (0, $kyBEk$jsx)((0, $c05182ab934fe0bd$exports.default), {
                width: "full",
                height: "4",
                className: $5a0d75754da974e6$export$5ce0f3e73495726d
            })
        ]
    });
}
var $56109dfc633821a9$export$2e2bcd8739ae039 = $56109dfc633821a9$var$PoolListItem;




var $f6a6aba98dd5d75c$export$34e0f9847d4c02dd = "_1lszdzp1 gvc3qt3bd";
var $f6a6aba98dd5d75c$export$1b9b24bdbcc25a11 = "gvc3qt3b1 gvc3qt31a";
var $f6a6aba98dd5d75c$export$fb184b623420d9be = "gvc3qt2ts";
var $f6a6aba98dd5d75c$export$12948adc4d562794 = "_1lszdzp3 gvc3qt2fy gvc3qt24g";


function $e7fdf0e3b8813495$var$PoolList(props) {
    var _a;
    var _b = (0, $kyBEk$useState)(function() {
        return [
            "Pool",
            "Liquidity",
            "24H Volume",
            "7D Fees",
            "APR"
        ];
    }), titles = _b[0], setTitles = _b[1];
    return (0, $kyBEk$jsxs)((0, $c05182ab934fe0bd$exports.default), {
        className: $f6a6aba98dd5d75c$export$34e0f9847d4c02dd,
        children: [
            (0, $kyBEk$jsx)((0, $41ede47214de3bdb$exports.default), {
                color: "textSecondary",
                size: "xl",
                weight: "semibold",
                children: props.title
            }),
            (0, $kyBEk$jsx)((0, $7718944390218472$exports.default), {
                className: $f6a6aba98dd5d75c$export$12948adc4d562794,
                children: titles === null || titles === void 0 ? void 0 : titles.map(function(item, index) {
                    return (0, $kyBEk$jsx)((0, $41ede47214de3bdb$exports.default), {
                        color: "textSecondary",
                        className: $f6a6aba98dd5d75c$export$fb184b623420d9be,
                        children: item
                    }, index);
                })
            }),
            (0, $kyBEk$jsx)((0, $c05182ab934fe0bd$exports.default), {
                className: $f6a6aba98dd5d75c$export$1b9b24bdbcc25a11,
                children: (_a = props.list) === null || _a === void 0 ? void 0 : _a.map(function(item, index) {
                    return (0, $kyBEk$jsx)((0, $56109dfc633821a9$export$2e2bcd8739ae039), {
                        id: item.id,
                        token1: item.token1,
                        token2: item.token2,
                        poolLiquidity: item.poolLiquidity,
                        volume: item.volume,
                        fees: item.fees,
                        apr: item.apr
                    }, index);
                })
            })
        ]
    });
}
var $e7fdf0e3b8813495$export$2e2bcd8739ae039 = $e7fdf0e3b8813495$var$PoolList;













var $e66b06b91478d0b8$export$34e0f9847d4c02dd = "_15yp7zr1 gvc3qt3bd gvc3qt31m gvc3qt34v gvc3qt384 gvc3qthl gvc3qthm gvc3qtw";
var $e66b06b91478d0b8$export$e8c9778bf415dd08 = {
    light: "_15yp7zr2",
    dark: "_15yp7zr3"
};


function $3c3a4a172d9b3610$var$PoolCard(props) {
    var cleanupRef = (0, $kyBEk$useRef)(null);
    var _a = (0, $kyBEk$useState)(function() {
        return "light";
    }), theme = _a[0], setTheme = _a[1];
    (0, $kyBEk$useEffect)(function() {
        setTheme((0, $65ee908e933b27be$export$6f57813fe9f31bf9).getState().theme);
        cleanupRef.current = (0, $65ee908e933b27be$export$6f57813fe9f31bf9).subscribe(function(newState) {
            setTheme(newState.theme);
        });
    }, []);
    (0, $kyBEk$useEffect)(function() {
        return function() {
            if (typeof cleanupRef.current === "function") cleanupRef.current();
        };
    }, []);
    return (0, $kyBEk$jsxs)((0, $7718944390218472$exports.default), {
        space: "6",
        direction: "column",
        justify: "center",
        className: $e66b06b91478d0b8$export$34e0f9847d4c02dd,
        children: [
            (0, $kyBEk$jsx)((0, $935bfa7d43e40fd6$export$2e2bcd8739ae039), {
                id: props.id,
                token1: props.token1,
                token2: props.token2
            }),
            (0, $kyBEk$jsxs)((0, $7718944390218472$exports.default), {
                justify: "space-between",
                children: [
                    (0, $kyBEk$jsx)((0, $41ede47214de3bdb$exports.default), {
                        color: "text",
                        children: "APR"
                    }),
                    (0, $kyBEk$jsxs)((0, $41ede47214de3bdb$exports.default), {
                        color: "text",
                        size: "2xl",
                        weight: "semibold",
                        marginLeft: "4",
                        wordBreak: "break-word",
                        children: [
                            props.apr,
                            "%"
                        ]
                    })
                ]
            }),
            (0, $kyBEk$jsxs)((0, $7718944390218472$exports.default), {
                justify: "space-between",
                children: [
                    (0, $kyBEk$jsx)((0, $41ede47214de3bdb$exports.default), {
                        color: "textSecondary",
                        children: "Liquidity"
                    }),
                    (0, $kyBEk$jsxs)((0, $41ede47214de3bdb$exports.default), {
                        color: "text",
                        weight: "semibold",
                        marginLeft: "4",
                        wordBreak: "break-word",
                        children: [
                            "$",
                            props.poolLiquidity.toLocaleString()
                        ]
                    })
                ]
            }),
            (0, $kyBEk$jsxs)((0, $7718944390218472$exports.default), {
                justify: "space-between",
                children: [
                    (0, $kyBEk$jsx)((0, $41ede47214de3bdb$exports.default), {
                        color: "textSecondary",
                        children: "7D Fees"
                    }),
                    (0, $kyBEk$jsxs)((0, $41ede47214de3bdb$exports.default), {
                        color: "text",
                        weight: "semibold",
                        marginLeft: "4",
                        wordBreak: "break-word",
                        children: [
                            "$",
                            props.fees.toLocaleString()
                        ]
                    })
                ]
            }),
            (0, $kyBEk$jsx)((0, $c05182ab934fe0bd$exports.default), {
                width: "full",
                height: "1",
                className: $e66b06b91478d0b8$export$e8c9778bf415dd08[theme]
            }),
            (0, $kyBEk$jsxs)((0, $7718944390218472$exports.default), {
                justify: "space-between",
                children: [
                    (0, $kyBEk$jsx)((0, $41ede47214de3bdb$exports.default), {
                        color: "text",
                        children: "Your Liquidity"
                    }),
                    (0, $kyBEk$jsxs)((0, $41ede47214de3bdb$exports.default), {
                        color: "text",
                        weight: "semibold",
                        children: [
                            "$",
                            props.yourLiquidity.toLocaleString()
                        ]
                    })
                ]
            }),
            (0, $kyBEk$jsxs)((0, $7718944390218472$exports.default), {
                justify: "space-between",
                children: [
                    (0, $kyBEk$jsx)((0, $41ede47214de3bdb$exports.default), {
                        color: "text",
                        children: "Bonded"
                    }),
                    (0, $kyBEk$jsxs)((0, $41ede47214de3bdb$exports.default), {
                        color: "text",
                        weight: "semibold",
                        wordBreak: "break-word",
                        attributes: {
                            marginLeft: "4"
                        },
                        children: [
                            "$",
                            props.bonded.toLocaleString()
                        ]
                    })
                ]
            })
        ]
    });
}
var $3c3a4a172d9b3610$export$2e2bcd8739ae039 = $3c3a4a172d9b3610$var$PoolCard;










function $9125f1d960bc2f77$var$PoolCardList(props) {
    var _a;
    return (0, $kyBEk$jsxs)((0, $c05182ab934fe0bd$exports.default), {
        children: [
            (0, $kyBEk$jsx)((0, $41ede47214de3bdb$exports.default), {
                size: "lg",
                color: "textSecondary",
                weight: "semibold",
                attributes: {
                    marginBottom: "10"
                },
                children: "Highlighted Pools"
            }),
            (0, $kyBEk$jsx)((0, $7718944390218472$exports.default), {
                space: "10",
                flexWrap: "wrap",
                children: (_a = props.list) === null || _a === void 0 ? void 0 : _a.map(function(item, index) {
                    return (0, $kyBEk$jsx)((0, $3c3a4a172d9b3610$export$2e2bcd8739ae039), {
                        id: item.id,
                        token1: item.token1,
                        token2: item.token2,
                        poolLiquidity: item.poolLiquidity,
                        fees: item.fees,
                        apr: item.apr,
                        yourLiquidity: item.yourLiquidity,
                        bonded: item.bonded
                    }, index);
                })
            })
        ]
    });
}
var $9125f1d960bc2f77$export$2e2bcd8739ae039 = $9125f1d960bc2f77$var$PoolCardList;







/**
 * A set of all the parents currently being observe. This is the only non weak
 * registry.
 */ const $4c2d6a289088aa2b$var$parents = new Set();
/**
 * Element coordinates that is constantly kept up to date.
 */ const $4c2d6a289088aa2b$var$coords = new WeakMap();
/**
 * Siblings of elements that have been removed from the dom.
 */ const $4c2d6a289088aa2b$var$siblings = new WeakMap();
/**
 * Animations that are currently running.
 */ const $4c2d6a289088aa2b$var$animations = new WeakMap();
/**
 * A map of existing intersection observers used to track element movements.
 */ const $4c2d6a289088aa2b$var$intersections = new WeakMap();
/**
 * Intervals for automatically checking the position of elements occasionally.
 */ const $4c2d6a289088aa2b$var$intervals = new WeakMap();
/**
 * The configuration options for each group of elements.
 */ const $4c2d6a289088aa2b$var$options = new WeakMap();
/**
 * Debounce counters by id, used to debounce calls to update positions.
 */ const $4c2d6a289088aa2b$var$debounces = new WeakMap();
/**
 * All parents that are currently enabled are tracked here.
 */ const $4c2d6a289088aa2b$var$enabled = new WeakSet();
/**
 * The document used to calculate transitions.
 */ let $4c2d6a289088aa2b$var$root;
/**
 * Used to sign an element as the target.
 */ const $4c2d6a289088aa2b$var$TGT = "__aa_tgt";
/**
 * Used to sign an element as being part of a removal.
 */ const $4c2d6a289088aa2b$var$DEL = "__aa_del";
/**
 * Callback for handling all mutations.
 * @param mutations - A mutation list
 */ const $4c2d6a289088aa2b$var$handleMutations = (mutations)=>{
    const elements = $4c2d6a289088aa2b$var$getElements(mutations);
    // If elements is "false" that means this mutation that should be ignored.
    if (elements) elements.forEach((el)=>$4c2d6a289088aa2b$var$animate(el));
};
/**
 *
 * @param entries - Elements that have been resized.
 */ const $4c2d6a289088aa2b$var$handleResizes = (entries)=>{
    entries.forEach((entry)=>{
        if (entry.target === $4c2d6a289088aa2b$var$root) $4c2d6a289088aa2b$var$updateAllPos();
        if ($4c2d6a289088aa2b$var$coords.has(entry.target)) $4c2d6a289088aa2b$var$updatePos(entry.target);
    });
};
/**
 * Observe this elements position.
 * @param el - The element to observe the position of.
 */ function $4c2d6a289088aa2b$var$observePosition(el) {
    const oldObserver = $4c2d6a289088aa2b$var$intersections.get(el);
    oldObserver === null || oldObserver === void 0 || oldObserver.disconnect();
    let rect = $4c2d6a289088aa2b$var$coords.get(el);
    let invocations = 0;
    const buffer = 5;
    if (!rect) {
        rect = $4c2d6a289088aa2b$var$getCoords(el);
        $4c2d6a289088aa2b$var$coords.set(el, rect);
    }
    const { offsetWidth: offsetWidth , offsetHeight: offsetHeight  } = $4c2d6a289088aa2b$var$root;
    const rootMargins = [
        rect.top - buffer,
        offsetWidth - (rect.left + buffer + rect.width),
        offsetHeight - (rect.top + buffer + rect.height),
        rect.left - buffer
    ];
    const rootMargin = rootMargins.map((px)=>`${-1 * Math.floor(px)}px`).join(" ");
    const observer = new IntersectionObserver(()=>{
        ++invocations > 1 && $4c2d6a289088aa2b$var$updatePos(el);
    }, {
        root: $4c2d6a289088aa2b$var$root,
        threshold: 1,
        rootMargin: rootMargin
    });
    observer.observe(el);
    $4c2d6a289088aa2b$var$intersections.set(el, observer);
}
/**
 * Update the exact position of a given element.
 * @param el - An element to update the position of.
 */ function $4c2d6a289088aa2b$var$updatePos(el) {
    clearTimeout($4c2d6a289088aa2b$var$debounces.get(el));
    const optionsOrPlugin = $4c2d6a289088aa2b$var$getOptions(el);
    const delay = typeof optionsOrPlugin === "function" ? 500 : optionsOrPlugin.duration;
    $4c2d6a289088aa2b$var$debounces.set(el, setTimeout(async ()=>{
        const currentAnimation = $4c2d6a289088aa2b$var$animations.get(el);
        try {
            await (currentAnimation === null || currentAnimation === void 0 ? void 0 : currentAnimation.finished);
            $4c2d6a289088aa2b$var$coords.set(el, $4c2d6a289088aa2b$var$getCoords(el));
            $4c2d6a289088aa2b$var$observePosition(el);
        } catch  {
        // ignore errors as the `.finished` promise is rejected when animations were cancelled
        }
    }, delay));
}
/**
 * Updates all positions that are currently being tracked.
 */ function $4c2d6a289088aa2b$var$updateAllPos() {
    clearTimeout($4c2d6a289088aa2b$var$debounces.get($4c2d6a289088aa2b$var$root));
    $4c2d6a289088aa2b$var$debounces.set($4c2d6a289088aa2b$var$root, setTimeout(()=>{
        $4c2d6a289088aa2b$var$parents.forEach((parent)=>$4c2d6a289088aa2b$var$forEach(parent, (el)=>$4c2d6a289088aa2b$var$lowPriority(()=>$4c2d6a289088aa2b$var$updatePos(el))));
    }, 100));
}
/**
 * Its possible for a quick scroll or other fast events to get past the
 * intersection observer, so occasionally we need want "cold-poll" for the
 * latests and greatest position. We try to do this in the most non-disruptive
 * fashion possible. First we only do this ever couple seconds, staggard by a
 * random offset.
 * @param el - Element
 */ function $4c2d6a289088aa2b$var$poll(el) {
    setTimeout(()=>{
        $4c2d6a289088aa2b$var$intervals.set(el, setInterval(()=>$4c2d6a289088aa2b$var$lowPriority($4c2d6a289088aa2b$var$updatePos.bind(null, el)), 2000));
    }, Math.round(2000 * Math.random()));
}
/**
 * Perform some operation that is non critical at some point.
 * @param callback
 */ function $4c2d6a289088aa2b$var$lowPriority(callback) {
    if (typeof requestIdleCallback === "function") requestIdleCallback(()=>callback());
    else requestAnimationFrame(()=>callback());
}
/**
 * The mutation observer responsible for watching each root element.
 */ let $4c2d6a289088aa2b$var$mutations;
/**
 * A resize observer, responsible for recalculating elements on resize.
 */ let $4c2d6a289088aa2b$var$resize;
/**
 * If this is in a browser, initialize our Web APIs
 */ if (typeof window !== "undefined") {
    $4c2d6a289088aa2b$var$root = document.documentElement;
    $4c2d6a289088aa2b$var$mutations = new MutationObserver($4c2d6a289088aa2b$var$handleMutations);
    $4c2d6a289088aa2b$var$resize = new ResizeObserver($4c2d6a289088aa2b$var$handleResizes);
    $4c2d6a289088aa2b$var$resize.observe($4c2d6a289088aa2b$var$root);
}
/**
 * Retrieves all the elements that may have been affected by the last mutation
 * including ones that have been removed and are no longer in the DOM.
 * @param mutations - A mutation list.
 * @returns
 */ function $4c2d6a289088aa2b$var$getElements(mutations) {
    const observedNodes = mutations.reduce((nodes, mutation)=>{
        return [
            ...nodes,
            ...Array.from(mutation.addedNodes),
            ...Array.from(mutation.removedNodes)
        ];
    }, []);
    // Short circuit if _only_ comment nodes are observed
    const onlyCommentNodesObserved = observedNodes.every((node)=>node.nodeName === "#comment");
    if (onlyCommentNodesObserved) return false;
    return mutations.reduce((elements, mutation)=>{
        // Short circuit if we find a purposefully deleted node.
        if (elements === false) return false;
        if (mutation.target instanceof Element) {
            $4c2d6a289088aa2b$var$target(mutation.target);
            if (!elements.has(mutation.target)) {
                elements.add(mutation.target);
                for(let i = 0; i < mutation.target.children.length; i++){
                    const child = mutation.target.children.item(i);
                    if (!child) continue;
                    if ($4c2d6a289088aa2b$var$DEL in child) return false;
                    $4c2d6a289088aa2b$var$target(mutation.target, child);
                    elements.add(child);
                }
            }
            if (mutation.removedNodes.length) for(let i = 0; i < mutation.removedNodes.length; i++){
                const child = mutation.removedNodes[i];
                if ($4c2d6a289088aa2b$var$DEL in child) return false;
                if (child instanceof Element) {
                    elements.add(child);
                    $4c2d6a289088aa2b$var$target(mutation.target, child);
                    $4c2d6a289088aa2b$var$siblings.set(child, [
                        mutation.previousSibling,
                        mutation.nextSibling
                    ]);
                }
            }
        }
        return elements;
    }, new Set());
}
/**
 * Assign the target to an element.
 * @param el - The root element
 * @param child
 */ function $4c2d6a289088aa2b$var$target(el, child) {
    if (!child && !($4c2d6a289088aa2b$var$TGT in el)) Object.defineProperty(el, $4c2d6a289088aa2b$var$TGT, {
        value: el
    });
    else if (child && !($4c2d6a289088aa2b$var$TGT in child)) Object.defineProperty(child, $4c2d6a289088aa2b$var$TGT, {
        value: el
    });
}
/**
 * Determines what kind of change took place on the given element and then
 * performs the proper animation based on that.
 * @param el - The specific element to animate.
 */ function $4c2d6a289088aa2b$var$animate(el) {
    var _a;
    const isMounted = el.isConnected;
    const preExisting = $4c2d6a289088aa2b$var$coords.has(el);
    if (isMounted && $4c2d6a289088aa2b$var$siblings.has(el)) $4c2d6a289088aa2b$var$siblings.delete(el);
    if ($4c2d6a289088aa2b$var$animations.has(el)) (_a = $4c2d6a289088aa2b$var$animations.get(el)) === null || _a === void 0 || _a.cancel();
    if (preExisting && isMounted) $4c2d6a289088aa2b$var$remain(el);
    else if (preExisting && !isMounted) $4c2d6a289088aa2b$var$remove(el);
    else $4c2d6a289088aa2b$var$add(el);
}
/**
 * Removes all non-digits from a string and casts to a number.
 * @param str - A string containing a pixel value.
 * @returns
 */ function $4c2d6a289088aa2b$var$raw(str) {
    return Number(str.replace(/[^0-9.\-]/g, ""));
}
/**
 * Get the coordinates of elements adjusted for scroll position.
 * @param el - Element
 * @returns
 */ function $4c2d6a289088aa2b$var$getCoords(el) {
    const rect = el.getBoundingClientRect();
    return {
        top: rect.top + window.scrollY,
        left: rect.left + window.scrollX,
        width: rect.width,
        height: rect.height
    };
}
/**
 * Returns the width/height that the element should be transitioned between.
 * This takes into account box-sizing.
 * @param el - Element being animated
 * @param oldCoords - Old set of Coordinates coordinates
 * @param newCoords - New set of Coordinates coordinates
 * @returns
 */ function $4c2d6a289088aa2b$export$18b6425e11c8bb66(el, oldCoords, newCoords) {
    let widthFrom = oldCoords.width;
    let heightFrom = oldCoords.height;
    let widthTo = newCoords.width;
    let heightTo = newCoords.height;
    const styles = getComputedStyle(el);
    const sizing = styles.getPropertyValue("box-sizing");
    if (sizing === "content-box") {
        const paddingY = $4c2d6a289088aa2b$var$raw(styles.paddingTop) + $4c2d6a289088aa2b$var$raw(styles.paddingBottom) + $4c2d6a289088aa2b$var$raw(styles.borderTopWidth) + $4c2d6a289088aa2b$var$raw(styles.borderBottomWidth);
        const paddingX = $4c2d6a289088aa2b$var$raw(styles.paddingLeft) + $4c2d6a289088aa2b$var$raw(styles.paddingRight) + $4c2d6a289088aa2b$var$raw(styles.borderRightWidth) + $4c2d6a289088aa2b$var$raw(styles.borderLeftWidth);
        widthFrom -= paddingX;
        widthTo -= paddingX;
        heightFrom -= paddingY;
        heightTo -= paddingY;
    }
    return [
        widthFrom,
        widthTo,
        heightFrom,
        heightTo
    ].map(Math.round);
}
/**
 * Retrieves animation options for the current element.
 * @param el - Element to retrieve options for.
 * @returns
 */ function $4c2d6a289088aa2b$var$getOptions(el) {
    return $4c2d6a289088aa2b$var$TGT in el && $4c2d6a289088aa2b$var$options.has(el[$4c2d6a289088aa2b$var$TGT]) ? $4c2d6a289088aa2b$var$options.get(el[$4c2d6a289088aa2b$var$TGT]) : {
        duration: 250,
        easing: "ease-in-out"
    };
}
/**
 * Returns the target of a given animation (generally the parent).
 * @param el - An element to check for a target
 * @returns
 */ function $4c2d6a289088aa2b$var$getTarget(el) {
    if ($4c2d6a289088aa2b$var$TGT in el) return el[$4c2d6a289088aa2b$var$TGT];
    return undefined;
}
/**
 * Checks if animations are enabled or disabled for a given element.
 * @param el - Any element
 * @returns
 */ function $4c2d6a289088aa2b$var$isEnabled(el) {
    const target = $4c2d6a289088aa2b$var$getTarget(el);
    return target ? $4c2d6a289088aa2b$var$enabled.has(target) : false;
}
/**
 * Iterate over the children of a given parent.
 * @param parent - A parent element
 * @param callback - A callback
 */ function $4c2d6a289088aa2b$var$forEach(parent, ...callbacks) {
    callbacks.forEach((callback)=>callback(parent, $4c2d6a289088aa2b$var$options.has(parent)));
    for(let i = 0; i < parent.children.length; i++){
        const child = parent.children.item(i);
        if (child) callbacks.forEach((callback)=>callback(child, $4c2d6a289088aa2b$var$options.has(child)));
    }
}
/**
 * The element in question is remaining in the DOM.
 * @param el - Element to flip
 * @returns
 */ function $4c2d6a289088aa2b$var$remain(el) {
    const oldCoords = $4c2d6a289088aa2b$var$coords.get(el);
    const newCoords = $4c2d6a289088aa2b$var$getCoords(el);
    if (!$4c2d6a289088aa2b$var$isEnabled(el)) return $4c2d6a289088aa2b$var$coords.set(el, newCoords);
    let animation;
    if (!oldCoords) return;
    const pluginOrOptions = $4c2d6a289088aa2b$var$getOptions(el);
    if (typeof pluginOrOptions !== "function") {
        const deltaX = oldCoords.left - newCoords.left;
        const deltaY = oldCoords.top - newCoords.top;
        const [widthFrom, widthTo, heightFrom, heightTo] = $4c2d6a289088aa2b$export$18b6425e11c8bb66(el, oldCoords, newCoords);
        const start = {
            transform: `translate(${deltaX}px, ${deltaY}px)`
        };
        const end = {
            transform: `translate(0, 0)`
        };
        if (widthFrom !== widthTo) {
            start.width = `${widthFrom}px`;
            end.width = `${widthTo}px`;
        }
        if (heightFrom !== heightTo) {
            start.height = `${heightFrom}px`;
            end.height = `${heightTo}px`;
        }
        animation = el.animate([
            start,
            end
        ], {
            duration: pluginOrOptions.duration,
            easing: pluginOrOptions.easing
        });
    } else {
        animation = new Animation(pluginOrOptions(el, "remain", oldCoords, newCoords));
        animation.play();
    }
    $4c2d6a289088aa2b$var$animations.set(el, animation);
    $4c2d6a289088aa2b$var$coords.set(el, newCoords);
    animation.addEventListener("finish", $4c2d6a289088aa2b$var$updatePos.bind(null, el));
}
/**
 * Adds the element with a transition.
 * @param el - Animates the element being added.
 */ function $4c2d6a289088aa2b$var$add(el) {
    const newCoords = $4c2d6a289088aa2b$var$getCoords(el);
    $4c2d6a289088aa2b$var$coords.set(el, newCoords);
    const pluginOrOptions = $4c2d6a289088aa2b$var$getOptions(el);
    if (!$4c2d6a289088aa2b$var$isEnabled(el)) return;
    let animation;
    if (typeof pluginOrOptions !== "function") animation = el.animate([
        {
            transform: "scale(.98)",
            opacity: 0
        },
        {
            transform: "scale(0.98)",
            opacity: 0,
            offset: 0.5
        },
        {
            transform: "scale(1)",
            opacity: 1
        }
    ], {
        duration: pluginOrOptions.duration * 1.5,
        easing: "ease-in"
    });
    else {
        animation = new Animation(pluginOrOptions(el, "add", newCoords));
        animation.play();
    }
    $4c2d6a289088aa2b$var$animations.set(el, animation);
    animation.addEventListener("finish", $4c2d6a289088aa2b$var$updatePos.bind(null, el));
}
/**
 * Animates the removal of an element.
 * @param el - Element to remove
 */ function $4c2d6a289088aa2b$var$remove(el) {
    var _a;
    if (!$4c2d6a289088aa2b$var$siblings.has(el) || !$4c2d6a289088aa2b$var$coords.has(el)) return;
    const [prev, next] = $4c2d6a289088aa2b$var$siblings.get(el);
    Object.defineProperty(el, $4c2d6a289088aa2b$var$DEL, {
        value: true
    });
    if (next && next.parentNode && next.parentNode instanceof Element) next.parentNode.insertBefore(el, next);
    else if (prev && prev.parentNode) prev.parentNode.appendChild(el);
    else (_a = $4c2d6a289088aa2b$var$getTarget(el)) === null || _a === void 0 || _a.appendChild(el);
    function cleanUp() {
        var _a;
        el.remove();
        $4c2d6a289088aa2b$var$coords.delete(el);
        $4c2d6a289088aa2b$var$siblings.delete(el);
        $4c2d6a289088aa2b$var$animations.delete(el);
        (_a = $4c2d6a289088aa2b$var$intersections.get(el)) === null || _a === void 0 || _a.disconnect();
    }
    if (!$4c2d6a289088aa2b$var$isEnabled(el)) return cleanUp();
    const [top, left, width, height] = $4c2d6a289088aa2b$var$deletePosition(el);
    const optionsOrPlugin = $4c2d6a289088aa2b$var$getOptions(el);
    const oldCoords = $4c2d6a289088aa2b$var$coords.get(el);
    let animation;
    Object.assign(el.style, {
        position: "absolute",
        top: `${top}px`,
        left: `${left}px`,
        width: `${width}px`,
        height: `${height}px`,
        margin: 0,
        pointerEvents: "none",
        transformOrigin: "center",
        zIndex: 100
    });
    if (typeof optionsOrPlugin !== "function") animation = el.animate([
        {
            transform: "scale(1)",
            opacity: 1
        },
        {
            transform: "scale(.98)",
            opacity: 0
        }
    ], {
        duration: optionsOrPlugin.duration,
        easing: "ease-out"
    });
    else {
        animation = new Animation(optionsOrPlugin(el, "remove", oldCoords));
        animation.play();
    }
    $4c2d6a289088aa2b$var$animations.set(el, animation);
    animation.addEventListener("finish", cleanUp);
}
function $4c2d6a289088aa2b$var$deletePosition(el) {
    const oldCoords = $4c2d6a289088aa2b$var$coords.get(el);
    const [width, , height] = $4c2d6a289088aa2b$export$18b6425e11c8bb66(el, oldCoords, $4c2d6a289088aa2b$var$getCoords(el));
    let offsetParent = el.parentElement;
    while(offsetParent && (getComputedStyle(offsetParent).position === "static" || offsetParent instanceof HTMLBodyElement))offsetParent = offsetParent.parentElement;
    if (!offsetParent) offsetParent = document.body;
    const parentStyles = getComputedStyle(offsetParent);
    const parentCoords = $4c2d6a289088aa2b$var$coords.get(offsetParent) || $4c2d6a289088aa2b$var$getCoords(offsetParent);
    const top = Math.round(oldCoords.top - parentCoords.top) - $4c2d6a289088aa2b$var$raw(parentStyles.borderTopWidth);
    const left = Math.round(oldCoords.left - parentCoords.left) - $4c2d6a289088aa2b$var$raw(parentStyles.borderLeftWidth);
    return [
        top,
        left,
        width,
        height
    ];
}
/**
 * A function that automatically adds animation effects to itself and its
 * immediate children. Specifically it adds effects for adding, moving, and
 * removing DOM elements.
 * @param el - A parent element to add animations to.
 * @param options - An optional object of options.
 */ function $4c2d6a289088aa2b$export$2e2bcd8739ae039(el, config = {}) {
    if ($4c2d6a289088aa2b$var$mutations && $4c2d6a289088aa2b$var$resize) {
        const mediaQuery = window.matchMedia("(prefers-reduced-motion: reduce)");
        const isDisabledDueToReduceMotion = mediaQuery.matches && typeof config !== "function" && !config.disrespectUserMotionPreference;
        if (!isDisabledDueToReduceMotion) {
            $4c2d6a289088aa2b$var$enabled.add(el);
            if (getComputedStyle(el).position === "static") Object.assign(el.style, {
                position: "relative"
            });
            $4c2d6a289088aa2b$var$forEach(el, $4c2d6a289088aa2b$var$updatePos, $4c2d6a289088aa2b$var$poll, (element)=>$4c2d6a289088aa2b$var$resize === null || $4c2d6a289088aa2b$var$resize === void 0 ? void 0 : $4c2d6a289088aa2b$var$resize.observe(element));
            if (typeof config === "function") $4c2d6a289088aa2b$var$options.set(el, config);
            else $4c2d6a289088aa2b$var$options.set(el, {
                duration: 250,
                easing: "ease-in-out",
                ...config
            });
            $4c2d6a289088aa2b$var$mutations.observe(el, {
                childList: true
            });
            $4c2d6a289088aa2b$var$parents.add(el);
        }
    }
    return Object.freeze({
        parent: el,
        enable: ()=>{
            $4c2d6a289088aa2b$var$enabled.add(el);
        },
        disable: ()=>{
            $4c2d6a289088aa2b$var$enabled.delete(el);
        },
        isEnabled: ()=>$4c2d6a289088aa2b$var$enabled.has(el)
    });
}
/**
 * The vue directive.
 */ const $4c2d6a289088aa2b$export$6ff9d5cc9ef9d729 = {
    mounted: (el, binding)=>{
        $4c2d6a289088aa2b$export$2e2bcd8739ae039(el, binding.value || {});
    }
};




var $3318c5b4e80dce26$export$d02b84f51370b6ef = "var(--_1e4bk8z1)";
var $3318c5b4e80dce26$export$899d560653026824 = "var(--_1e4bk8z0)";
var $3318c5b4e80dce26$export$f8980ba2e6527093 = "_1e4bk8za gvc3qt34p gvc3qt37y gvc3qt3as gvc3qt31m";
var $3318c5b4e80dce26$export$add244bda2f9423c = {
    light: "_1e4bk8z5 _1e4bk8z2 gvc3qt1hv gvc3qt1lv gvc3qt1um gvc3qtx",
    dark: "_1e4bk8z6 _1e4bk8z2 gvc3qt1hv gvc3qt1lv gvc3qt1um gvc3qtx"
};


var $5ed443ae3726df7f$exports = {};

$parcel$export($5ed443ae3726df7f$exports, "default", function () { return $5ed443ae3726df7f$export$2e2bcd8739ae039; }, function (v) { return $5ed443ae3726df7f$export$2e2bcd8739ae039 = v; });








var $7f92defacf7b3cbf$export$2fb509f37aa2186a = "_1kqgvlg1";
var $7f92defacf7b3cbf$export$add7dd41a9d928a0 = "_1kqgvlg4";
var $7f92defacf7b3cbf$export$56c24f306bd986cf = "_1kqgvlg0";
var $7f92defacf7b3cbf$export$add244bda2f9423c = "_1kqgvlg2";
var $7f92defacf7b3cbf$export$3099d0daead893d3 = "_1kqgvlg3";


var $5ed443ae3726df7f$var$__assign = undefined && undefined.__assign || function() {
    $5ed443ae3726df7f$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5ed443ae3726df7f$var$__assign.apply(this, arguments);
};
var $5ed443ae3726df7f$var$useStore = (0, $kyBEk$create)((0, $65ee908e933b27be$export$6f57813fe9f31bf9));
var $5ed443ae3726df7f$var$Modal = /*#__PURE__*/ (0, $kyBEk$forwardRef)(function(props, forwardedRef) {
    var themeStore = $5ed443ae3726df7f$var$useStore(function(state) {
        return {
            theme: state.theme,
            themeClass: state.themeClass
        };
    });
    var isOpen = props.isOpen, onOpen = props.onOpen, onClose = props.onClose, children = props.children, trigger = props.trigger, header = props.header, initialFocusRef = props.initialFocusRef, _a = props.closeOnClickaway, closeOnClickaway = _a === void 0 ? true : _a, _b = props.preventScroll, preventScroll = _b === void 0 ? true : _b, _c = props.role, role = _c === void 0 ? "dialog" : _c, className = props.className, contentClassName = props.contentClassName, childrenClassName = props.childrenClassName;
    var id = (0, $kyBEk$useId)();
    var _d = (0, $kyBEk$useState)(isOpen), _internalOpen = _d[0], _setInternalOpen = _d[1];
    (0, $kyBEk$useEffect)(function() {
        if (props.isOpen) _setInternalOpen(true);
        else // Add an artificial delay for the close animation to show
        setTimeout(function() {
            _setInternalOpen(false);
        }, 300);
    }, [
        props.isOpen
    ]);
    var _e = (0, $kyBEk$useMachine)($kyBEk$machine({
        onOpen: onOpen,
        onClose: onClose,
        id: id,
        initialFocusEl: initialFocusRef === null || initialFocusRef === void 0 ? void 0 : initialFocusRef.current,
        closeOnOutsideClick: closeOnClickaway,
        preventScroll: preventScroll,
        role: role
    }), {
        context: (0, $kyBEk$useMemo)(function() {
            return {
                open: _internalOpen
            };
        }, [
            _internalOpen
        ])
    }), state = _e[0], send = _e[1];
    var api = $kyBEk$connect(state, send, (0, $kyBEk$normalizeProps));
    var onCloseButtonClick = function(event) {
        var _a, _b;
        _setInternalOpen(false);
        (_b = (_a = api.closeTriggerProps).onClick) === null || _b === void 0 || _b.call(_a, event);
        onClose === null || onClose === void 0 || onClose();
    };
    return (0, $kyBEk$jsxs)((0, $kyBEk$Fragment), {
        children: [
            trigger && /*#__PURE__*/ (0, $kyBEk$cloneElement)(trigger, api.triggerProps),
            api.isOpen && (0, $kyBEk$jsx)((0, $kyBEk$Portal), {
                children: (0, $kyBEk$jsx)("div", {
                    ref: forwardedRef,
                    className: (0, $kyBEk$clsx)(themeStore.themeClass, className),
                    style: {
                        position: "relative",
                        zIndex: 999
                    },
                    children: (0, $kyBEk$jsxs)((0, $509770f1f99d27e1$export$2e2bcd8739ae039), {
                        isVisible: api.isOpen,
                        children: [
                            (0, $kyBEk$jsx)("div", $5ed443ae3726df7f$var$__assign({}, api.backdropProps, {
                                className: $7f92defacf7b3cbf$export$2fb509f37aa2186a
                            })),
                            (0, $kyBEk$jsx)("div", $5ed443ae3726df7f$var$__assign({}, api.containerProps, {
                                className: $7f92defacf7b3cbf$export$56c24f306bd986cf,
                                children: (0, $kyBEk$jsxs)("div", $5ed443ae3726df7f$var$__assign({}, api.contentProps, {
                                    className: (0, $kyBEk$clsx)($7f92defacf7b3cbf$export$add244bda2f9423c, contentClassName),
                                    "data-modal-part": "content",
                                    style: {
                                        width: "fit-content",
                                        margin: "0 auto"
                                    },
                                    children: [
                                        header && /*#__PURE__*/ (0, $kyBEk$cloneElement)(header, {
                                            titleProps: api.titleProps,
                                            descriptionProps: api.descriptionProps,
                                            closeButtonProps: $5ed443ae3726df7f$var$__assign($5ed443ae3726df7f$var$__assign({}, api.closeTriggerProps), {
                                                onClick: onCloseButtonClick
                                            })
                                        }),
                                        (0, $kyBEk$jsx)("div", {
                                            className: childrenClassName,
                                            "data-modal-part": "children",
                                            children: children
                                        })
                                    ]
                                }))
                            }))
                        ]
                    })
                })
            })
        ]
    });
});
var $5ed443ae3726df7f$export$2e2bcd8739ae039 = $5ed443ae3726df7f$var$Modal;




function $10743afa76cdfee5$var$ConnectModal(props) {
    var cleanupRef = (0, $kyBEk$useRef)(null);
    var parentRef = (0, $kyBEk$useRef)(null);
    var _a = (0, $kyBEk$useState)(function() {
        return "light";
    }), theme = _a[0], setTheme = _a[1];
    (0, $kyBEk$useEffect)(function() {
        setTheme((0, $65ee908e933b27be$export$6f57813fe9f31bf9).getState().theme);
        cleanupRef.current = (0, $65ee908e933b27be$export$6f57813fe9f31bf9).subscribe(function(newState) {
            setTheme(newState.theme);
        });
    }, []);
    (0, $kyBEk$useEffect)(function() {
        if (parentRef.current) (0, $4c2d6a289088aa2b$export$2e2bcd8739ae039)(parentRef.current);
    }, [
        parentRef.current
    ]);
    (0, $kyBEk$useEffect)(function() {
        return function() {
            if (typeof cleanupRef.current === "function") cleanupRef.current();
        };
    }, []);
    return (0, $kyBEk$jsx)((0, $5ed443ae3726df7f$exports.default), {
        isOpen: props.isOpen,
        onOpen: function(event) {
            var _a;
            return (_a = props.onOpen) === null || _a === void 0 ? void 0 : _a.call(props);
        },
        onClose: function(event) {
            var _a;
            return (_a = props.onClose) === null || _a === void 0 ? void 0 : _a.call(props);
        },
        header: props.header,
        contentClassName: (0, $3318c5b4e80dce26$export$add244bda2f9423c)[theme],
        childrenClassName: (0, $3318c5b4e80dce26$export$f8980ba2e6527093),
        className: props.modalContainerClassName,
        children: (0, $kyBEk$jsx)("div", {
            ref: parentRef,
            className: (0, $47a3451e57ac14cf$export$9f2265a541a48bf2)({
                minHeight: "30"
            }),
            children: props.children
        })
    });
}
var $10743afa76cdfee5$export$2e2bcd8739ae039 = $10743afa76cdfee5$var$ConnectModal;




var $5910f4dbd1d8d9b6$exports = {};

$parcel$export($5910f4dbd1d8d9b6$exports, "default", function () { return $5910f4dbd1d8d9b6$export$2e2bcd8739ae039; }, function (v) { return $5910f4dbd1d8d9b6$export$2e2bcd8739ae039 = v; });







var $5c80e004072f54fb$export$45a15d3b7cdec480 = "eg4xdb8 gvc3qt27y";
var $5c80e004072f54fb$export$add7dd41a9d928a0 = "eg4xdba gvc3qt2bs";
var $5c80e004072f54fb$export$3099d0daead893d3 = "eg4xdb6 gvc3qt34p gvc3qt37y gvc3qt3b7 gvc3qt31g gvc3qtm";
var $5c80e004072f54fb$export$82f9748c97c13f20 = {
    light: "gvc3qt1hs gvc3qtn gvc3qt4 gvc3qt1og gvc3qt2t7 gvc3qt1up gvc3qt89 gvc3qt8a",
    dark: "gvc3qt1hs gvc3qtn gvc3qt4 gvc3qt1og gvc3qt2t7 gvc3qt1up gvc3qt69 gvc3qt6a"
};


var $5910f4dbd1d8d9b6$var$__assign = undefined && undefined.__assign || function() {
    $5910f4dbd1d8d9b6$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5910f4dbd1d8d9b6$var$__assign.apply(this, arguments);
};
function $5910f4dbd1d8d9b6$var$ConnectModalHead(props) {
    var cleanupRef = (0, $kyBEk$useRef)(null);
    var _a = (0, $kyBEk$useState)(function() {
        return "light";
    }), theme = _a[0], setTheme = _a[1];
    (0, $kyBEk$useEffect)(function() {
        setTheme((0, $65ee908e933b27be$export$6f57813fe9f31bf9).getState().theme);
        cleanupRef.current = (0, $65ee908e933b27be$export$6f57813fe9f31bf9).subscribe(function(newState) {
            setTheme(newState.theme);
        });
    }, []);
    (0, $kyBEk$useEffect)(function() {
        return function() {
            if (typeof cleanupRef.current === "function") cleanupRef.current();
        };
    }, []);
    return (0, $kyBEk$jsxs)("div", {
        className: (0, $kyBEk$clsx)($5c80e004072f54fb$export$3099d0daead893d3, props.className),
        children: [
            props.hasBackButton ? (0, $kyBEk$jsx)((0, $kyBEk$Fragment), {
                children: (0, $kyBEk$jsx)("div", {
                    className: (0, $kyBEk$clsx)($5c80e004072f54fb$export$45a15d3b7cdec480),
                    children: (0, $kyBEk$jsx)((0, $6aa42b028ae27f6d$exports.default), {
                        rightIcon: "arrowLeftSLine",
                        intent: "secondary",
                        variant: "ghost",
                        size: "sm",
                        iconSize: "xl",
                        onClick: function(e) {
                            var _a;
                            return (_a = props.onBack) === null || _a === void 0 ? void 0 : _a.call(props, e);
                        },
                        className: (0, $47a3451e57ac14cf$export$9f2265a541a48bf2)({
                            p: "0"
                        })
                    })
                })
            }) : null,
            (0, $kyBEk$jsx)("p", $5910f4dbd1d8d9b6$var$__assign({}, props.titleProps, {
                className: $5c80e004072f54fb$export$82f9748c97c13f20[theme],
                children: props.title
            })),
            props.hasCloseButton ? (0, $kyBEk$jsx)((0, $kyBEk$Fragment), {
                children: (0, $kyBEk$jsx)("div", {
                    className: (0, $kyBEk$clsx)($5c80e004072f54fb$export$add7dd41a9d928a0),
                    children: (0, $kyBEk$jsx)((0, $6aa42b028ae27f6d$exports.default), {
                        rightIcon: "closeFilled",
                        intent: "secondary",
                        variant: "ghost",
                        size: "sm",
                        iconSize: "xl",
                        onClick: function(e) {
                            var _a, _b;
                            return (_b = (_a = props.closeButtonProps) === null || _a === void 0 ? void 0 : _a.onClick) === null || _b === void 0 ? void 0 : _b.call(_a, e);
                        },
                        attributes: props.closeButtonProps,
                        className: (0, $47a3451e57ac14cf$export$9f2265a541a48bf2)({
                            p: "0"
                        })
                    })
                })
            }) : null
        ]
    });
}
$5910f4dbd1d8d9b6$var$ConnectModalHead.defaultProps = {
    hasBackButton: false,
    hasCloseButton: true
};
var $5910f4dbd1d8d9b6$export$2e2bcd8739ae039 = $5910f4dbd1d8d9b6$var$ConnectModalHead;













var $2cbe890a9cd634c7$export$531912852b37e174 = "_1n54y202";
var $2cbe890a9cd634c7$export$b6c1af41ce46177f = {
    light: "_1n54y203 _1n54y204",
    dark: "_1n54y203 _1n54y205"
};



function $b333ffce68f4dc6c$var$ConnectModalQrCodeSkeleton(props) {
    var cleanupRef = (0, $kyBEk$useRef)(null);
    var _a = (0, $kyBEk$useState)(function() {
        return "light";
    }), theme = _a[0], setTheme = _a[1];
    (0, $kyBEk$useEffect)(function() {
        setTheme((0, $65ee908e933b27be$export$6f57813fe9f31bf9).getState().theme);
        cleanupRef.current = (0, $65ee908e933b27be$export$6f57813fe9f31bf9).subscribe(function(newState) {
            setTheme(newState.theme);
        });
    }, []);
    (0, $kyBEk$useEffect)(function() {
        return function() {
            if (typeof cleanupRef.current === "function") cleanupRef.current();
        };
    }, []);
    return (0, $kyBEk$jsx)("div", {
        className: (0, $kyBEk$clsx)((0, $47a3451e57ac14cf$export$9f2265a541a48bf2)({
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            textAlign: "center",
            width: "full",
            px: "6"
        }), props.className),
        children: (0, $kyBEk$jsx)("div", {
            className: (0, $2cbe890a9cd634c7$export$b6c1af41ce46177f)[theme]
        })
    });
}
var $b333ffce68f4dc6c$export$2e2bcd8739ae039 = $b333ffce68f4dc6c$var$ConnectModalQrCodeSkeleton;









/**
 * @license QR Code generator library (TypeScript)
 * Copyright (c) Project Nayuki.
 * SPDX-License-Identifier: MIT
 */ "use strict";
var $efab925fc5f3f0a2$var$qrcodegen;
(function(qrcodegen) {
    /*---- QR Code symbol class ----*/ /*
     * A QR Code symbol, which is a type of two-dimension barcode.
     * Invented by Denso Wave and described in the ISO/IEC 18004 standard.
     * Instances of this class represent an immutable square grid of dark and light cells.
     * The class provides static factory functions to create a QR Code from text or binary data.
     * The class covers the QR Code Model 2 specification, supporting all versions (sizes)
     * from 1 to 40, all 4 error correction levels, and 4 character encoding modes.
     *
     * Ways to create a QR Code object:
     * - High level: Take the payload data and call QrCode.encodeText() or QrCode.encodeBinary().
     * - Mid level: Custom-make the list of segments and call QrCode.encodeSegments().
     * - Low level: Custom-make the array of data codeword bytes (including
     *   segment headers and final padding, excluding error correction codewords),
     *   supply the appropriate version number, and call the QrCode() constructor.
     * (Note that all ways require supplying the desired error correction level.)
     */ var QrCode = /** @class */ function() {
        /*-- Constructor (low level) and fields --*/ // Creates a new QR Code with the given version number,
        // error correction level, data codeword bytes, and mask number.
        // This is a low-level API that most users should not use directly.
        // A mid-level API is the encodeSegments() function.
        function QrCode(// The version number of this QR Code, which is between 1 and 40 (inclusive).
        // This determines the size of this barcode.
        version, // The error correction level used in this QR Code.
        errorCorrectionLevel, dataCodewords, msk) {
            this.version = version;
            this.errorCorrectionLevel = errorCorrectionLevel;
            // The modules of this QR Code (false = light, true = dark).
            // Immutable after constructor finishes. Accessed through getModule().
            this.modules = [];
            // Indicates function modules that are not subjected to masking. Discarded when constructor finishes.
            this.isFunction = [];
            // Check scalar arguments
            if (version < QrCode.MIN_VERSION || version > QrCode.MAX_VERSION) throw new RangeError("Version value out of range");
            if (msk < -1 || msk > 7) throw new RangeError("Mask value out of range");
            this.size = version * 4 + 17;
            // Initialize both grids to be size*size arrays of Boolean false
            var row = [];
            for(var i = 0; i < this.size; i++)row.push(false);
            for(var i = 0; i < this.size; i++){
                this.modules.push(row.slice()); // Initially all light
                this.isFunction.push(row.slice());
            }
            // Compute ECC, draw modules
            this.drawFunctionPatterns();
            var allCodewords = this.addEccAndInterleave(dataCodewords);
            this.drawCodewords(allCodewords);
            // Do masking
            if (msk == -1) {
                // Automatically choose best mask
                var minPenalty = 1000000000;
                for(var i = 0; i < 8; i++){
                    this.applyMask(i);
                    this.drawFormatBits(i);
                    var penalty = this.getPenaltyScore();
                    if (penalty < minPenalty) {
                        msk = i;
                        minPenalty = penalty;
                    }
                    this.applyMask(i); // Undoes the mask due to XOR
                }
            }
            assert(0 <= msk && msk <= 7);
            this.mask = msk;
            this.applyMask(msk); // Apply the final choice of mask
            this.drawFormatBits(msk); // Overwrite old format bits
            this.isFunction = [];
        }
        /*-- Static factory functions (high level) --*/ // Returns a QR Code representing the given Unicode text string at the given error correction level.
        // As a conservative upper bound, this function is guaranteed to succeed for strings that have 738 or fewer
        // Unicode code points (not UTF-16 code units) if the low error correction level is used. The smallest possible
        // QR Code version is automatically chosen for the output. The ECC level of the result may be higher than the
        // ecl argument if it can be done without increasing the version.
        QrCode.encodeText = function(text, ecl) {
            var segs = qrcodegen.QrSegment.makeSegments(text);
            return QrCode.encodeSegments(segs, ecl);
        };
        // Returns a QR Code representing the given binary data at the given error correction level.
        // This function always encodes using the binary segment mode, not any text mode. The maximum number of
        // bytes allowed is 2953. The smallest possible QR Code version is automatically chosen for the output.
        // The ECC level of the result may be higher than the ecl argument if it can be done without increasing the version.
        QrCode.encodeBinary = function(data, ecl) {
            var seg = qrcodegen.QrSegment.makeBytes(data);
            return QrCode.encodeSegments([
                seg
            ], ecl);
        };
        /*-- Static factory functions (mid level) --*/ // Returns a QR Code representing the given segments with the given encoding parameters.
        // The smallest possible QR Code version within the given range is automatically
        // chosen for the output. Iff boostEcl is true, then the ECC level of the result
        // may be higher than the ecl argument if it can be done without increasing the
        // version. The mask number is either between 0 to 7 (inclusive) to force that
        // mask, or -1 to automatically choose an appropriate mask (which may be slow).
        // This function allows the user to create a custom sequence of segments that switches
        // between modes (such as alphanumeric and byte) to encode text in less space.
        // This is a mid-level API; the high-level API is encodeText() and encodeBinary().
        QrCode.encodeSegments = function(segs, ecl, minVersion, maxVersion, mask, boostEcl) {
            if (minVersion === void 0) minVersion = 1;
            if (maxVersion === void 0) maxVersion = 40;
            if (mask === void 0) mask = -1;
            if (boostEcl === void 0) boostEcl = true;
            if (!(QrCode.MIN_VERSION <= minVersion && minVersion <= maxVersion && maxVersion <= QrCode.MAX_VERSION) || mask < -1 || mask > 7) throw new RangeError("Invalid value");
            // Find the minimal version number to use
            var version;
            var dataUsedBits;
            for(version = minVersion;; version++){
                var dataCapacityBits_1 = QrCode.getNumDataCodewords(version, ecl) * 8; // Number of data bits available
                var usedBits = QrSegment.getTotalBits(segs, version);
                if (usedBits <= dataCapacityBits_1) {
                    dataUsedBits = usedBits;
                    break; // This version number is found to be suitable
                }
                if (version >= maxVersion) // All versions in the range could not fit the given data
                throw new RangeError("Data too long");
            }
            // Increase the error correction level while the data still fits in the current version number
            for(var _i = 0, _a = [
                QrCode.Ecc.MEDIUM,
                QrCode.Ecc.QUARTILE,
                QrCode.Ecc.HIGH
            ]; _i < _a.length; _i++){
                var newEcl = _a[_i];
                // From low to high
                if (boostEcl && dataUsedBits <= QrCode.getNumDataCodewords(version, newEcl) * 8) ecl = newEcl;
            }
            // Concatenate all segments to create the data bit string
            var bb = [];
            for(var _b = 0, segs_1 = segs; _b < segs_1.length; _b++){
                var seg = segs_1[_b];
                appendBits(seg.mode.modeBits, 4, bb);
                appendBits(seg.numChars, seg.mode.numCharCountBits(version), bb);
                for(var _c = 0, _d = seg.getData(); _c < _d.length; _c++){
                    var b = _d[_c];
                    bb.push(b);
                }
            }
            assert(bb.length == dataUsedBits);
            // Add terminator and pad up to a byte if applicable
            var dataCapacityBits = QrCode.getNumDataCodewords(version, ecl) * 8;
            assert(bb.length <= dataCapacityBits);
            appendBits(0, Math.min(4, dataCapacityBits - bb.length), bb);
            appendBits(0, (8 - bb.length % 8) % 8, bb);
            assert(bb.length % 8 == 0);
            // Pad with alternating bytes until data capacity is reached
            for(var padByte = 0xec; bb.length < dataCapacityBits; padByte ^= 253)appendBits(padByte, 8, bb);
            // Pack bits into bytes in big endian
            var dataCodewords = [];
            while(dataCodewords.length * 8 < bb.length)dataCodewords.push(0);
            bb.forEach(function(b, i) {
                return dataCodewords[i >>> 3] |= b << 7 - (i & 7);
            });
            // Create the QR Code object
            return new QrCode(version, ecl, dataCodewords, mask);
        };
        /*-- Accessor methods --*/ // Returns the color of the module (pixel) at the given coordinates, which is false
        // for light or true for dark. The top left corner has the coordinates (x=0, y=0).
        // If the given coordinates are out of bounds, then false (light) is returned.
        QrCode.prototype.getModule = function(x, y) {
            return 0 <= x && x < this.size && 0 <= y && y < this.size && this.modules[y][x];
        };
        // Modified to expose modules for easy access
        QrCode.prototype.getModules = function() {
            return this.modules;
        };
        /*-- Private helper methods for constructor: Drawing function modules --*/ // Reads this object's version field, and draws and marks all function modules.
        QrCode.prototype.drawFunctionPatterns = function() {
            // Draw horizontal and vertical timing patterns
            for(var i = 0; i < this.size; i++){
                this.setFunctionModule(6, i, i % 2 == 0);
                this.setFunctionModule(i, 6, i % 2 == 0);
            }
            // Draw 3 finder patterns (all corners except bottom right; overwrites some timing modules)
            this.drawFinderPattern(3, 3);
            this.drawFinderPattern(this.size - 4, 3);
            this.drawFinderPattern(3, this.size - 4);
            // Draw numerous alignment patterns
            var alignPatPos = this.getAlignmentPatternPositions();
            var numAlign = alignPatPos.length;
            for(var i = 0; i < numAlign; i++){
                for(var j = 0; j < numAlign; j++)// Don't draw on the three finder corners
                if (!(i == 0 && j == 0 || i == 0 && j == numAlign - 1 || i == numAlign - 1 && j == 0)) this.drawAlignmentPattern(alignPatPos[i], alignPatPos[j]);
            }
            // Draw configuration data
            this.drawFormatBits(0); // Dummy mask value; overwritten later in the constructor
            this.drawVersion();
        };
        // Draws two copies of the format bits (with its own error correction code)
        // based on the given mask and this object's error correction level field.
        QrCode.prototype.drawFormatBits = function(mask) {
            // Calculate error correction code and pack bits
            var data = this.errorCorrectionLevel.formatBits << 3 | mask; // errCorrLvl is uint2, mask is uint3
            var rem = data;
            for(var i = 0; i < 10; i++)rem = rem << 1 ^ (rem >>> 9) * 0x537;
            var bits = (data << 10 | rem) ^ 0x5412; // uint15
            assert(bits >>> 15 == 0);
            // Draw first copy
            for(var i = 0; i <= 5; i++)this.setFunctionModule(8, i, getBit(bits, i));
            this.setFunctionModule(8, 7, getBit(bits, 6));
            this.setFunctionModule(8, 8, getBit(bits, 7));
            this.setFunctionModule(7, 8, getBit(bits, 8));
            for(var i = 9; i < 15; i++)this.setFunctionModule(14 - i, 8, getBit(bits, i));
            // Draw second copy
            for(var i = 0; i < 8; i++)this.setFunctionModule(this.size - 1 - i, 8, getBit(bits, i));
            for(var i = 8; i < 15; i++)this.setFunctionModule(8, this.size - 15 + i, getBit(bits, i));
            this.setFunctionModule(8, this.size - 8, true); // Always dark
        };
        // Draws two copies of the version bits (with its own error correction code),
        // based on this object's version field, iff 7 <= version <= 40.
        QrCode.prototype.drawVersion = function() {
            if (this.version < 7) return;
            // Calculate error correction code and pack bits
            var rem = this.version; // version is uint6, in the range [7, 40]
            for(var i = 0; i < 12; i++)rem = rem << 1 ^ (rem >>> 11) * 0x1f25;
            var bits = this.version << 12 | rem; // uint18
            assert(bits >>> 18 == 0);
            // Draw two copies
            for(var i = 0; i < 18; i++){
                var color = getBit(bits, i);
                var a = this.size - 11 + i % 3;
                var b = Math.floor(i / 3);
                this.setFunctionModule(a, b, color);
                this.setFunctionModule(b, a, color);
            }
        };
        // Draws a 9*9 finder pattern including the border separator,
        // with the center module at (x, y). Modules can be out of bounds.
        QrCode.prototype.drawFinderPattern = function(x, y) {
            for(var dy = -4; dy <= 4; dy++)for(var dx = -4; dx <= 4; dx++){
                var dist = Math.max(Math.abs(dx), Math.abs(dy)); // Chebyshev/infinity norm
                var xx = x + dx;
                var yy = y + dy;
                if (0 <= xx && xx < this.size && 0 <= yy && yy < this.size) this.setFunctionModule(xx, yy, dist != 2 && dist != 4);
            }
        };
        // Draws a 5*5 alignment pattern, with the center module
        // at (x, y). All modules must be in bounds.
        QrCode.prototype.drawAlignmentPattern = function(x, y) {
            for(var dy = -2; dy <= 2; dy++)for(var dx = -2; dx <= 2; dx++)this.setFunctionModule(x + dx, y + dy, Math.max(Math.abs(dx), Math.abs(dy)) != 1);
        };
        // Sets the color of a module and marks it as a function module.
        // Only used by the constructor. Coordinates must be in bounds.
        QrCode.prototype.setFunctionModule = function(x, y, isDark) {
            this.modules[y][x] = isDark;
            this.isFunction[y][x] = true;
        };
        /*-- Private helper methods for constructor: Codewords and masking --*/ // Returns a new byte string representing the given data with the appropriate error correction
        // codewords appended to it, based on this object's version and error correction level.
        QrCode.prototype.addEccAndInterleave = function(data) {
            var ver = this.version;
            var ecl = this.errorCorrectionLevel;
            if (data.length != QrCode.getNumDataCodewords(ver, ecl)) throw new RangeError("Invalid argument");
            // Calculate parameter numbers
            var numBlocks = QrCode.NUM_ERROR_CORRECTION_BLOCKS[ecl.ordinal][ver];
            var blockEccLen = QrCode.ECC_CODEWORDS_PER_BLOCK[ecl.ordinal][ver];
            var rawCodewords = Math.floor(QrCode.getNumRawDataModules(ver) / 8);
            var numShortBlocks = numBlocks - rawCodewords % numBlocks;
            var shortBlockLen = Math.floor(rawCodewords / numBlocks);
            // Split data into blocks and append ECC to each block
            var blocks = [];
            var rsDiv = QrCode.reedSolomonComputeDivisor(blockEccLen);
            for(var i = 0, k = 0; i < numBlocks; i++){
                var dat = data.slice(k, k + shortBlockLen - blockEccLen + (i < numShortBlocks ? 0 : 1));
                k += dat.length;
                var ecc = QrCode.reedSolomonComputeRemainder(dat, rsDiv);
                if (i < numShortBlocks) dat.push(0);
                blocks.push(dat.concat(ecc));
            }
            // Interleave (not concatenate) the bytes from every block into a single sequence
            var result = [];
            var _loop_1 = function(i) {
                blocks.forEach(function(block, j) {
                    // Skip the padding byte in short blocks
                    if (i != shortBlockLen - blockEccLen || j >= numShortBlocks) result.push(block[i]);
                });
            };
            for(var i = 0; i < blocks[0].length; i++)_loop_1(i);
            assert(result.length == rawCodewords);
            return result;
        };
        // Draws the given sequence of 8-bit codewords (data and error correction) onto the entire
        // data area of this QR Code. Function modules need to be marked off before this is called.
        QrCode.prototype.drawCodewords = function(data) {
            if (data.length != Math.floor(QrCode.getNumRawDataModules(this.version) / 8)) throw new RangeError("Invalid argument");
            var i = 0; // Bit index into the data
            // Do the funny zigzag scan
            for(var right = this.size - 1; right >= 1; right -= 2){
                // Index of right column in each column pair
                if (right == 6) right = 5;
                for(var vert = 0; vert < this.size; vert++)// Vertical counter
                for(var j = 0; j < 2; j++){
                    var x = right - j; // Actual x coordinate
                    var upward = (right + 1 & 2) == 0;
                    var y = upward ? this.size - 1 - vert : vert; // Actual y coordinate
                    if (!this.isFunction[y][x] && i < data.length * 8) {
                        this.modules[y][x] = getBit(data[i >>> 3], 7 - (i & 7));
                        i++;
                    }
                // If this QR Code has any remainder bits (0 to 7), they were assigned as
                // 0/false/light by the constructor and are left unchanged by this method
                }
            }
            assert(i == data.length * 8);
        };
        // XORs the codeword modules in this QR Code with the given mask pattern.
        // The function modules must be marked and the codeword bits must be drawn
        // before masking. Due to the arithmetic of XOR, calling applyMask() with
        // the same mask value a second time will undo the mask. A final well-formed
        // QR Code needs exactly one (not zero, two, etc.) mask applied.
        QrCode.prototype.applyMask = function(mask) {
            if (mask < 0 || mask > 7) throw new RangeError("Mask value out of range");
            for(var y = 0; y < this.size; y++)for(var x = 0; x < this.size; x++){
                var invert = void 0;
                switch(mask){
                    case 0:
                        invert = (x + y) % 2 == 0;
                        break;
                    case 1:
                        invert = y % 2 == 0;
                        break;
                    case 2:
                        invert = x % 3 == 0;
                        break;
                    case 3:
                        invert = (x + y) % 3 == 0;
                        break;
                    case 4:
                        invert = (Math.floor(x / 3) + Math.floor(y / 2)) % 2 == 0;
                        break;
                    case 5:
                        invert = x * y % 2 + x * y % 3 == 0;
                        break;
                    case 6:
                        invert = (x * y % 2 + x * y % 3) % 2 == 0;
                        break;
                    case 7:
                        invert = ((x + y) % 2 + x * y % 3) % 2 == 0;
                        break;
                    default:
                        throw new Error("Unreachable");
                }
                if (!this.isFunction[y][x] && invert) this.modules[y][x] = !this.modules[y][x];
            }
        };
        // Calculates and returns the penalty score based on state of this QR Code's current modules.
        // This is used by the automatic mask choice algorithm to find the mask pattern that yields the lowest score.
        QrCode.prototype.getPenaltyScore = function() {
            var result = 0;
            // Adjacent modules in row having same color, and finder-like patterns
            for(var y = 0; y < this.size; y++){
                var runColor = false;
                var runX = 0;
                var runHistory = [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ];
                for(var x = 0; x < this.size; x++)if (this.modules[y][x] == runColor) {
                    runX++;
                    if (runX == 5) result += QrCode.PENALTY_N1;
                    else if (runX > 5) result++;
                } else {
                    this.finderPenaltyAddHistory(runX, runHistory);
                    if (!runColor) result += this.finderPenaltyCountPatterns(runHistory) * QrCode.PENALTY_N3;
                    runColor = this.modules[y][x];
                    runX = 1;
                }
                result += this.finderPenaltyTerminateAndCount(runColor, runX, runHistory) * QrCode.PENALTY_N3;
            }
            // Adjacent modules in column having same color, and finder-like patterns
            for(var x = 0; x < this.size; x++){
                var runColor = false;
                var runY = 0;
                var runHistory = [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ];
                for(var y = 0; y < this.size; y++)if (this.modules[y][x] == runColor) {
                    runY++;
                    if (runY == 5) result += QrCode.PENALTY_N1;
                    else if (runY > 5) result++;
                } else {
                    this.finderPenaltyAddHistory(runY, runHistory);
                    if (!runColor) result += this.finderPenaltyCountPatterns(runHistory) * QrCode.PENALTY_N3;
                    runColor = this.modules[y][x];
                    runY = 1;
                }
                result += this.finderPenaltyTerminateAndCount(runColor, runY, runHistory) * QrCode.PENALTY_N3;
            }
            // 2*2 blocks of modules having same color
            for(var y = 0; y < this.size - 1; y++)for(var x = 0; x < this.size - 1; x++){
                var color = this.modules[y][x];
                if (color == this.modules[y][x + 1] && color == this.modules[y + 1][x] && color == this.modules[y + 1][x + 1]) result += QrCode.PENALTY_N2;
            }
            // Balance of dark and light modules
            var dark = 0;
            for(var _i = 0, _a = this.modules; _i < _a.length; _i++){
                var row = _a[_i];
                dark = row.reduce(function(sum, color) {
                    return sum + (color ? 1 : 0);
                }, dark);
            }
            var total = this.size * this.size; // Note that size is odd, so dark/total != 1/2
            // Compute the smallest integer k >= 0 such that (45-5k)% <= dark/total <= (55+5k)%
            var k = Math.ceil(Math.abs(dark * 20 - total * 10) / total) - 1;
            assert(0 <= k && k <= 9);
            result += k * QrCode.PENALTY_N4;
            assert(0 <= result && result <= 2568888); // Non-tight upper bound based on default values of PENALTY_N1, ..., N4
            return result;
        };
        /*-- Private helper functions --*/ // Returns an ascending list of positions of alignment patterns for this version number.
        // Each position is in the range [0,177), and are used on both the x and y axes.
        // This could be implemented as lookup table of 40 variable-length lists of integers.
        QrCode.prototype.getAlignmentPatternPositions = function() {
            if (this.version == 1) return [];
            else {
                var numAlign = Math.floor(this.version / 7) + 2;
                var step = this.version == 32 ? 26 : Math.ceil((this.version * 4 + 4) / (numAlign * 2 - 2)) * 2;
                var result = [
                    6
                ];
                for(var pos = this.size - 7; result.length < numAlign; pos -= step)result.splice(1, 0, pos);
                return result;
            }
        };
        // Returns the number of data bits that can be stored in a QR Code of the given version number, after
        // all function modules are excluded. This includes remainder bits, so it might not be a multiple of 8.
        // The result is in the range [208, 29648]. This could be implemented as a 40-entry lookup table.
        QrCode.getNumRawDataModules = function(ver) {
            if (ver < QrCode.MIN_VERSION || ver > QrCode.MAX_VERSION) throw new RangeError("Version number out of range");
            var result = (16 * ver + 128) * ver + 64;
            if (ver >= 2) {
                var numAlign = Math.floor(ver / 7) + 2;
                result -= (25 * numAlign - 10) * numAlign - 55;
                if (ver >= 7) result -= 36;
            }
            assert(208 <= result && result <= 29648);
            return result;
        };
        // Returns the number of 8-bit data (i.e. not error correction) codewords contained in any
        // QR Code of the given version number and error correction level, with remainder bits discarded.
        // This stateless pure function could be implemented as a (40*4)-cell lookup table.
        QrCode.getNumDataCodewords = function(ver, ecl) {
            return Math.floor(QrCode.getNumRawDataModules(ver) / 8) - QrCode.ECC_CODEWORDS_PER_BLOCK[ecl.ordinal][ver] * QrCode.NUM_ERROR_CORRECTION_BLOCKS[ecl.ordinal][ver];
        };
        // Returns a Reed-Solomon ECC generator polynomial for the given degree. This could be
        // implemented as a lookup table over all possible parameter values, instead of as an algorithm.
        QrCode.reedSolomonComputeDivisor = function(degree) {
            if (degree < 1 || degree > 255) throw new RangeError("Degree out of range");
            // Polynomial coefficients are stored from highest to lowest power, excluding the leading term which is always 1.
            // For example the polynomial x^3 + 255x^2 + 8x + 93 is stored as the uint8 array [255, 8, 93].
            var result = [];
            for(var i = 0; i < degree - 1; i++)result.push(0);
            result.push(1); // Start off with the monomial x^0
            // Compute the product polynomial (x - r^0) * (x - r^1) * (x - r^2) * ... * (x - r^{degree-1}),
            // and drop the highest monomial term which is always 1x^degree.
            // Note that r = 0x02, which is a generator element of this field GF(2^8/0x11D).
            var root = 1;
            for(var i = 0; i < degree; i++){
                // Multiply the current product by (x - r^i)
                for(var j = 0; j < result.length; j++){
                    result[j] = QrCode.reedSolomonMultiply(result[j], root);
                    if (j + 1 < result.length) result[j] ^= result[j + 1];
                }
                root = QrCode.reedSolomonMultiply(root, 0x02);
            }
            return result;
        };
        // Returns the Reed-Solomon error correction codeword for the given data and divisor polynomials.
        QrCode.reedSolomonComputeRemainder = function(data, divisor) {
            var result = divisor.map(function(_) {
                return 0;
            });
            var _loop_2 = function(b) {
                // Polynomial division
                var factor = b ^ result.shift();
                result.push(0);
                divisor.forEach(function(coef, i) {
                    return result[i] ^= QrCode.reedSolomonMultiply(coef, factor);
                });
            };
            for(var _i = 0, data_1 = data; _i < data_1.length; _i++){
                var b = data_1[_i];
                _loop_2(b);
            }
            return result;
        };
        // Returns the product of the two given field elements modulo GF(2^8/0x11D). The arguments and result
        // are unsigned 8-bit integers. This could be implemented as a lookup table of 256*256 entries of uint8.
        QrCode.reedSolomonMultiply = function(x, y) {
            if (x >>> 8 != 0 || y >>> 8 != 0) throw new RangeError("Byte out of range");
            // Russian peasant multiplication
            var z = 0;
            for(var i = 7; i >= 0; i--){
                z = z << 1 ^ (z >>> 7) * 0x11d;
                z ^= (y >>> i & 1) * x;
            }
            assert(z >>> 8 == 0);
            return z;
        };
        // Can only be called immediately after a light run is added, and
        // returns either 0, 1, or 2. A helper function for getPenaltyScore().
        QrCode.prototype.finderPenaltyCountPatterns = function(runHistory) {
            var n = runHistory[1];
            assert(n <= this.size * 3);
            var core = n > 0 && runHistory[2] == n && runHistory[3] == n * 3 && runHistory[4] == n && runHistory[5] == n;
            return (core && runHistory[0] >= n * 4 && runHistory[6] >= n ? 1 : 0) + (core && runHistory[6] >= n * 4 && runHistory[0] >= n ? 1 : 0);
        };
        // Must be called at the end of a line (row or column) of modules. A helper function for getPenaltyScore().
        QrCode.prototype.finderPenaltyTerminateAndCount = function(currentRunColor, currentRunLength, runHistory) {
            if (currentRunColor) {
                // Terminate dark run
                this.finderPenaltyAddHistory(currentRunLength, runHistory);
                currentRunLength = 0;
            }
            currentRunLength += this.size; // Add light border to final run
            this.finderPenaltyAddHistory(currentRunLength, runHistory);
            return this.finderPenaltyCountPatterns(runHistory);
        };
        // Pushes the given value to the front and drops the last value. A helper function for getPenaltyScore().
        QrCode.prototype.finderPenaltyAddHistory = function(currentRunLength, runHistory) {
            if (runHistory[0] == 0) currentRunLength += this.size; // Add light border to initial run
            runHistory.pop();
            runHistory.unshift(currentRunLength);
        };
        /*-- Constants and tables --*/ // The minimum version number supported in the QR Code Model 2 standard.
        QrCode.MIN_VERSION = 1;
        // The maximum version number supported in the QR Code Model 2 standard.
        QrCode.MAX_VERSION = 40;
        // For use in getPenaltyScore(), when evaluating which mask is best.
        QrCode.PENALTY_N1 = 3;
        QrCode.PENALTY_N2 = 3;
        QrCode.PENALTY_N3 = 40;
        QrCode.PENALTY_N4 = 10;
        QrCode.ECC_CODEWORDS_PER_BLOCK = [
            // Version: (note that index 0 is for padding, and is set to an illegal value)
            //0,  1,  2,  3,  4,  5,  6,  7,  8,  9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40    Error correction level
            [
                -1,
                7,
                10,
                15,
                20,
                26,
                18,
                20,
                24,
                30,
                18,
                20,
                24,
                26,
                30,
                22,
                24,
                28,
                30,
                28,
                28,
                28,
                28,
                30,
                30,
                26,
                28,
                30,
                30,
                30,
                30,
                30,
                30,
                30,
                30,
                30,
                30,
                30,
                30,
                30,
                30
            ],
            [
                -1,
                10,
                16,
                26,
                18,
                24,
                16,
                18,
                22,
                22,
                26,
                30,
                22,
                22,
                24,
                24,
                28,
                28,
                26,
                26,
                26,
                26,
                28,
                28,
                28,
                28,
                28,
                28,
                28,
                28,
                28,
                28,
                28,
                28,
                28,
                28,
                28,
                28,
                28,
                28,
                28
            ],
            [
                -1,
                13,
                22,
                18,
                26,
                18,
                24,
                18,
                22,
                20,
                24,
                28,
                26,
                24,
                20,
                30,
                24,
                28,
                28,
                26,
                30,
                28,
                30,
                30,
                30,
                30,
                28,
                30,
                30,
                30,
                30,
                30,
                30,
                30,
                30,
                30,
                30,
                30,
                30,
                30,
                30
            ],
            [
                -1,
                17,
                28,
                22,
                16,
                22,
                28,
                26,
                26,
                24,
                28,
                24,
                28,
                22,
                24,
                24,
                30,
                28,
                28,
                26,
                28,
                30,
                24,
                30,
                30,
                30,
                30,
                30,
                30,
                30,
                30,
                30,
                30,
                30,
                30,
                30,
                30,
                30,
                30,
                30,
                30
            ]
        ];
        QrCode.NUM_ERROR_CORRECTION_BLOCKS = [
            // Version: (note that index 0 is for padding, and is set to an illegal value)
            //0, 1, 2, 3, 4, 5, 6, 7, 8, 9,10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40    Error correction level
            [
                -1,
                1,
                1,
                1,
                1,
                1,
                2,
                2,
                2,
                2,
                4,
                4,
                4,
                4,
                4,
                6,
                6,
                6,
                6,
                7,
                8,
                8,
                9,
                9,
                10,
                12,
                12,
                12,
                13,
                14,
                15,
                16,
                17,
                18,
                19,
                19,
                20,
                21,
                22,
                24,
                25
            ],
            [
                -1,
                1,
                1,
                1,
                2,
                2,
                4,
                4,
                4,
                5,
                5,
                5,
                8,
                9,
                9,
                10,
                10,
                11,
                13,
                14,
                16,
                17,
                17,
                18,
                20,
                21,
                23,
                25,
                26,
                28,
                29,
                31,
                33,
                35,
                37,
                38,
                40,
                43,
                45,
                47,
                49
            ],
            [
                -1,
                1,
                1,
                2,
                2,
                4,
                4,
                6,
                6,
                8,
                8,
                8,
                10,
                12,
                16,
                12,
                17,
                16,
                18,
                21,
                20,
                23,
                23,
                25,
                27,
                29,
                34,
                34,
                35,
                38,
                40,
                43,
                45,
                48,
                51,
                53,
                56,
                59,
                62,
                65,
                68
            ],
            [
                -1,
                1,
                1,
                2,
                4,
                4,
                4,
                5,
                6,
                8,
                8,
                11,
                11,
                16,
                16,
                18,
                16,
                19,
                21,
                25,
                25,
                25,
                34,
                30,
                32,
                35,
                37,
                40,
                42,
                45,
                48,
                51,
                54,
                57,
                60,
                63,
                66,
                70,
                74,
                77,
                81
            ]
        ];
        return QrCode;
    }();
    qrcodegen.QrCode = QrCode;
    // Appends the given number of low-order bits of the given value
    // to the given buffer. Requires 0 <= len <= 31 and 0 <= val < 2^len.
    function appendBits(val, len, bb) {
        if (len < 0 || len > 31 || val >>> len != 0) throw new RangeError("Value out of range");
        for(var i = len - 1; i >= 0; i-- // Append bit by bit
        )bb.push(val >>> i & 1);
    }
    // Returns true iff the i'th bit of x is set to 1.
    function getBit(x, i) {
        return (x >>> i & 1) != 0;
    }
    // Throws an exception if the given condition is false.
    function assert(cond) {
        if (!cond) throw new Error("Assertion error");
    }
    /*---- Data segment class ----*/ /*
     * A segment of character/binary/control data in a QR Code symbol.
     * Instances of this class are immutable.
     * The mid-level way to create a segment is to take the payload data
     * and call a static factory function such as QrSegment.makeNumeric().
     * The low-level way to create a segment is to custom-make the bit buffer
     * and call the QrSegment() constructor with appropriate values.
     * This segment class imposes no length restrictions, but QR Codes have restrictions.
     * Even in the most favorable conditions, a QR Code can only hold 7089 characters of data.
     * Any segment longer than this is meaningless for the purpose of generating QR Codes.
     */ var QrSegment = /** @class */ function() {
        /*-- Constructor (low level) and fields --*/ // Creates a new QR Code segment with the given attributes and data.
        // The character count (numChars) must agree with the mode and the bit buffer length,
        // but the constraint isn't checked. The given bit buffer is cloned and stored.
        function QrSegment(// The mode indicator of this segment.
        mode, // The length of this segment's unencoded data. Measured in characters for
        // numeric/alphanumeric/kanji mode, bytes for byte mode, and 0 for ECI mode.
        // Always zero or positive. Not the same as the data's bit length.
        numChars, // The data bits of this segment. Accessed through getData().
        bitData) {
            this.mode = mode;
            this.numChars = numChars;
            this.bitData = bitData;
            if (numChars < 0) throw new RangeError("Invalid argument");
            this.bitData = bitData.slice(); // Make defensive copy
        }
        /*-- Static factory functions (mid level) --*/ // Returns a segment representing the given binary data encoded in
        // byte mode. All input byte arrays are acceptable. Any text string
        // can be converted to UTF-8 bytes and encoded as a byte mode segment.
        QrSegment.makeBytes = function(data) {
            var bb = [];
            for(var _i = 0, data_2 = data; _i < data_2.length; _i++){
                var b = data_2[_i];
                appendBits(b, 8, bb);
            }
            return new QrSegment(QrSegment.Mode.BYTE, data.length, bb);
        };
        // Returns a segment representing the given string of decimal digits encoded in numeric mode.
        QrSegment.makeNumeric = function(digits) {
            if (!QrSegment.isNumeric(digits)) throw new RangeError("String contains non-numeric characters");
            var bb = [];
            for(var i = 0; i < digits.length;){
                // Consume up to 3 digits per iteration
                var n = Math.min(digits.length - i, 3);
                appendBits(parseInt(digits.substring(i, i + n), 10), n * 3 + 1, bb);
                i += n;
            }
            return new QrSegment(QrSegment.Mode.NUMERIC, digits.length, bb);
        };
        // Returns a segment representing the given text string encoded in alphanumeric mode.
        // The characters allowed are: 0 to 9, A to Z (uppercase only), space,
        // dollar, percent, asterisk, plus, hyphen, period, slash, colon.
        QrSegment.makeAlphanumeric = function(text) {
            if (!QrSegment.isAlphanumeric(text)) throw new RangeError("String contains unencodable characters in alphanumeric mode");
            var bb = [];
            var i;
            for(i = 0; i + 2 <= text.length; i += 2){
                // Process groups of 2
                var temp = QrSegment.ALPHANUMERIC_CHARSET.indexOf(text.charAt(i)) * 45;
                temp += QrSegment.ALPHANUMERIC_CHARSET.indexOf(text.charAt(i + 1));
                appendBits(temp, 11, bb);
            }
            if (i < text.length) // 1 character remaining
            appendBits(QrSegment.ALPHANUMERIC_CHARSET.indexOf(text.charAt(i)), 6, bb);
            return new QrSegment(QrSegment.Mode.ALPHANUMERIC, text.length, bb);
        };
        // Returns a new mutable list of zero or more segments to represent the given Unicode text string.
        // The result may use various segment modes and switch modes to optimize the length of the bit stream.
        QrSegment.makeSegments = function(text) {
            // Select the most efficient segment encoding automatically
            if (text == "") return [];
            else if (QrSegment.isNumeric(text)) return [
                QrSegment.makeNumeric(text)
            ];
            else if (QrSegment.isAlphanumeric(text)) return [
                QrSegment.makeAlphanumeric(text)
            ];
            else return [
                QrSegment.makeBytes(QrSegment.toUtf8ByteArray(text))
            ];
        };
        // Returns a segment representing an Extended Channel Interpretation
        // (ECI) designator with the given assignment value.
        QrSegment.makeEci = function(assignVal) {
            var bb = [];
            if (assignVal < 0) throw new RangeError("ECI assignment value out of range");
            else if (assignVal < 128) appendBits(assignVal, 8, bb);
            else if (assignVal < 16384) {
                appendBits(2, 2, bb);
                appendBits(assignVal, 14, bb);
            } else if (assignVal < 1000000) {
                appendBits(6, 3, bb);
                appendBits(assignVal, 21, bb);
            } else throw new RangeError("ECI assignment value out of range");
            return new QrSegment(QrSegment.Mode.ECI, 0, bb);
        };
        // Tests whether the given string can be encoded as a segment in numeric mode.
        // A string is encodable iff each character is in the range 0 to 9.
        QrSegment.isNumeric = function(text) {
            return QrSegment.NUMERIC_REGEX.test(text);
        };
        // Tests whether the given string can be encoded as a segment in alphanumeric mode.
        // A string is encodable iff each character is in the following set: 0 to 9, A to Z
        // (uppercase only), space, dollar, percent, asterisk, plus, hyphen, period, slash, colon.
        QrSegment.isAlphanumeric = function(text) {
            return QrSegment.ALPHANUMERIC_REGEX.test(text);
        };
        /*-- Methods --*/ // Returns a new copy of the data bits of this segment.
        QrSegment.prototype.getData = function() {
            return this.bitData.slice(); // Make defensive copy
        };
        // (Package-private) Calculates and returns the number of bits needed to encode the given segments at
        // the given version. The result is infinity if a segment has too many characters to fit its length field.
        QrSegment.getTotalBits = function(segs, version) {
            var result = 0;
            for(var _i = 0, segs_2 = segs; _i < segs_2.length; _i++){
                var seg = segs_2[_i];
                var ccbits = seg.mode.numCharCountBits(version);
                if (seg.numChars >= 1 << ccbits) return Infinity; // The segment's length doesn't fit the field's bit width
                result += 4 + ccbits + seg.bitData.length;
            }
            return result;
        };
        // Returns a new array of bytes representing the given string encoded in UTF-8.
        QrSegment.toUtf8ByteArray = function(str) {
            str = encodeURI(str);
            var result = [];
            for(var i = 0; i < str.length; i++)if (str.charAt(i) != "%") result.push(str.charCodeAt(i));
            else {
                result.push(parseInt(str.substring(i + 1, i + 3), 16));
                i += 2;
            }
            return result;
        };
        /*-- Constants --*/ // Describes precisely all strings that are encodable in numeric mode.
        QrSegment.NUMERIC_REGEX = /^[0-9]*$/;
        // Describes precisely all strings that are encodable in alphanumeric mode.
        QrSegment.ALPHANUMERIC_REGEX = /^[A-Z0-9 $%*+.\/:-]*$/;
        // The set of all legal characters in alphanumeric mode,
        // where each character value maps to the index in the string.
        QrSegment.ALPHANUMERIC_CHARSET = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ $%*+-./:";
        return QrSegment;
    }();
    qrcodegen.QrSegment = QrSegment;
})($efab925fc5f3f0a2$var$qrcodegen || ($efab925fc5f3f0a2$var$qrcodegen = {}));
/*---- Public helper enumeration ----*/ (function(qrcodegen) {
    var QrCode;
    (function(QrCode) {
        /*
         * The error correction level in a QR Code symbol. Immutable.
         */ var Ecc = /** @class */ function() {
            /*-- Constructor and fields --*/ function Ecc(// In the range 0 to 3 (unsigned 2-bit integer).
            ordinal, // (Package-private) In the range 0 to 3 (unsigned 2-bit integer).
            formatBits) {
                this.ordinal = ordinal;
                this.formatBits = formatBits;
            }
            /*-- Constants --*/ Ecc.LOW = new Ecc(0, 1); // The QR Code can tolerate about  7% erroneous codewords
            Ecc.MEDIUM = new Ecc(1, 0); // The QR Code can tolerate about 15% erroneous codewords
            Ecc.QUARTILE = new Ecc(2, 3); // The QR Code can tolerate about 25% erroneous codewords
            Ecc.HIGH = new Ecc(3, 2); // The QR Code can tolerate about 30% erroneous codewords
            return Ecc;
        }();
        QrCode.Ecc = Ecc;
    })(QrCode = qrcodegen.QrCode || (qrcodegen.QrCode = {}));
})($efab925fc5f3f0a2$var$qrcodegen || ($efab925fc5f3f0a2$var$qrcodegen = {}));
/*---- Public helper enumeration ----*/ (function(qrcodegen) {
    var QrSegment;
    (function(QrSegment) {
        /*
         * Describes how a segment's data bits are interpreted. Immutable.
         */ var Mode = /** @class */ function() {
            /*-- Constructor and fields --*/ function Mode(// The mode indicator bits, which is a uint4 value (range 0 to 15).
            modeBits, // Number of character count bits for three different version ranges.
            numBitsCharCount) {
                this.modeBits = modeBits;
                this.numBitsCharCount = numBitsCharCount;
            }
            /*-- Method --*/ // (Package-private) Returns the bit width of the character count field for a segment in
            // this mode in a QR Code at the given version number. The result is in the range [0, 16].
            Mode.prototype.numCharCountBits = function(ver) {
                return this.numBitsCharCount[Math.floor((ver + 7) / 17)];
            };
            /*-- Constants --*/ Mode.NUMERIC = new Mode(0x1, [
                10,
                12,
                14
            ]);
            Mode.ALPHANUMERIC = new Mode(0x2, [
                9,
                11,
                13
            ]);
            Mode.BYTE = new Mode(0x4, [
                8,
                16,
                16
            ]);
            Mode.KANJI = new Mode(0x8, [
                8,
                10,
                12
            ]);
            Mode.ECI = new Mode(0x7, [
                0,
                0,
                0
            ]);
            return Mode;
        }();
        QrSegment.Mode = Mode;
    })(QrSegment = qrcodegen.QrSegment || (qrcodegen.QrSegment = {}));
})($efab925fc5f3f0a2$var$qrcodegen || ($efab925fc5f3f0a2$var$qrcodegen = {}));
var // Modification to export for actual use
$efab925fc5f3f0a2$export$2e2bcd8739ae039 = $efab925fc5f3f0a2$var$qrcodegen;



var $5a6d9b3e35da8b84$export$e4c0458e30711294 = 128;
var $5a6d9b3e35da8b84$export$480df663967f228c = "L";
var $5a6d9b3e35da8b84$export$b39f8333017c702f = "#FFFFFF";
var $5a6d9b3e35da8b84$export$67aa667c89b8639e = "#000000";
var $5a6d9b3e35da8b84$export$a2693684c16df853 = false;
var $5a6d9b3e35da8b84$export$d4eb2e6b3e7ab9b8 = 4;
var $5a6d9b3e35da8b84$export$ced36291a2733c72 = 0;
var $5a6d9b3e35da8b84$export$50ee015a607970b = 0.1;
var $5a6d9b3e35da8b84$export$e974b150016dae0b = {
    L: (0, $efab925fc5f3f0a2$export$2e2bcd8739ae039).QrCode.Ecc.LOW,
    M: (0, $efab925fc5f3f0a2$export$2e2bcd8739ae039).QrCode.Ecc.MEDIUM,
    Q: (0, $efab925fc5f3f0a2$export$2e2bcd8739ae039).QrCode.Ecc.QUARTILE,
    H: (0, $efab925fc5f3f0a2$export$2e2bcd8739ae039).QrCode.Ecc.HIGH
};



function $6b098bb935d371ee$export$82476f982757e71e(modules, margin) {
    if (margin === void 0) margin = 0;
    var ops = [];
    modules.forEach(function(row, y) {
        var start = null;
        row.forEach(function(cell, x) {
            if (!cell && start !== null) {
                // M0 0h7v1H0z injects the space with the move and drops the comma,
                // saving a char per operation
                ops.push("M".concat(start + margin, " ").concat(y + margin, "h").concat(x - start, "v1H").concat(start + margin, "z"));
                start = null;
                return;
            }
            // end of row, clean up or skip
            if (x === row.length - 1) {
                if (!cell) // We would have closed the op above already so this can only mean
                // 2+ light modules in a row.
                return;
                if (start === null) // Just a single dark module.
                ops.push("M".concat(x + margin, ",").concat(y + margin, " h1v1H").concat(x + margin, "z"));
                else // Otherwise finish the current line.
                ops.push("M".concat(start + margin, ",").concat(y + margin, " h").concat(x + 1 - start, "v1H").concat(start + margin, "z"));
                return;
            }
            if (cell && start === null) start = x;
        });
    });
    return ops.join("");
}
function $6b098bb935d371ee$export$b15668c22ebaa08(modules, excavation) {
    return modules.slice().map(function(row, y) {
        if (y < excavation.y || y >= excavation.y + excavation.h) return row;
        return row.map(function(cell, x) {
            if (x < excavation.x || x >= excavation.x + excavation.w) return cell;
            return false;
        });
    });
}
function $6b098bb935d371ee$export$64d2541f94ecd8e8(cells, size, margin, imageSettings) {
    if (imageSettings == null) return null;
    var numCells = cells.length + margin * 2;
    var defaultSize = Math.floor(size * (0, $5a6d9b3e35da8b84$export$50ee015a607970b));
    var scale = numCells / size;
    var w = (imageSettings.width || defaultSize) * scale;
    var h = (imageSettings.height || defaultSize) * scale;
    var x = imageSettings.x == null ? cells.length / 2 - w / 2 : imageSettings.x * scale;
    var y = imageSettings.y == null ? cells.length / 2 - h / 2 : imageSettings.y * scale;
    var excavation = null;
    if (imageSettings.excavate) {
        var floorX = Math.floor(x);
        var floorY = Math.floor(y);
        var ceilW = Math.ceil(w + x - floorX);
        var ceilH = Math.ceil(h + y - floorY);
        excavation = {
            x: floorX,
            y: floorY,
            w: ceilW,
            h: ceilH
        };
    }
    return {
        x: x,
        y: y,
        h: h,
        w: w,
        excavation: excavation
    };
}
function $6b098bb935d371ee$export$caa75c2027609c5e(includeMargin, marginSize) {
    if (marginSize != null) return Math.floor(marginSize);
    return includeMargin ? (0, $5a6d9b3e35da8b84$export$d4eb2e6b3e7ab9b8) : (0, $5a6d9b3e35da8b84$export$ced36291a2733c72);
}


function $1ee39bcdf3a85af5$var$QRCode(props) {
    var _a;
    var _b = (0, $kyBEk$useState)(function() {
        return false;
    }), available = _b[0], setAvailable = _b[1];
    var _c = (0, $kyBEk$useState)(function() {
        return null;
    }), cells = _c[0], setCells = _c[1];
    var _d = (0, $kyBEk$useState)(function() {
        return null;
    }), calculatedImageSettings = _d[0], setCalculatedImageSettings = _d[1];
    var _e = (0, $kyBEk$useState)(function() {
        return null;
    }), margin = _e[0], setMargin = _e[1];
    var _f = (0, $kyBEk$useState)(function() {
        return null;
    }), fgPath = _f[0], setFgPath = _f[1];
    function genCells() {
        return (0, $efab925fc5f3f0a2$export$2e2bcd8739ae039).QrCode.encodeText(props.value, (0, $5a6d9b3e35da8b84$export$e974b150016dae0b)[props.level]).getModules();
    }
    function numCells() {
        var _a;
        return ((_a = cells === null || cells === void 0 ? void 0 : cells.length) !== null && _a !== void 0 ? _a : 0) + (margin !== null && margin !== void 0 ? margin : 0) * 2;
    }
    (0, $kyBEk$useEffect)(function() {
        setCells(genCells());
    }, []);
    (0, $kyBEk$useEffect)(function() {
        if (props.imageSettings != null && calculatedImageSettings != null) {
            if (calculatedImageSettings.excavation != null) setCells((0, $6b098bb935d371ee$export$b15668c22ebaa08)(cells, calculatedImageSettings.excavation));
            if (!available) setAvailable(true);
        }
    }, [
        props.imageSettings,
        calculatedImageSettings
    ]);
    (0, $kyBEk$useEffect)(function() {
        var newMargin = (0, $6b098bb935d371ee$export$caa75c2027609c5e)(props.includeMargin, props.marginSize);
        setMargin(newMargin);
        setCalculatedImageSettings((0, $6b098bb935d371ee$export$64d2541f94ecd8e8)(cells, props.size, newMargin, props.imageSettings));
        // Drawing strategy: instead of a rect per module, we're going to create a // single path for the dark modules and layer that on top of a light rect, // for a total of 2 DOM nodes. We pay a bit more in string concat but that's
        // way faster than DOM ops.
        // For level 1, 441 nodes -> 2
        // For level 40, 31329 -> 2
        setFgPath((0, $6b098bb935d371ee$export$82476f982757e71e)(cells !== null && cells !== void 0 ? cells : [], newMargin));
    }, [
        props.size,
        props.imageSettings,
        props.includeMargin,
        props.marginSize,
        cells
    ]);
    return (0, $kyBEk$jsxs)("svg", {
        height: props.size,
        width: props.size,
        viewBox: "0 0 ".concat(numCells(), " ").concat(numCells()),
        className: props.className,
        children: [
            !!props.title ? (0, $kyBEk$jsx)((0, $kyBEk$Fragment), {
                children: (0, $kyBEk$jsx)("title", {
                    children: props.title
                })
            }) : null,
            (0, $kyBEk$jsx)("path", {
                "shape-rendering": "crispEdges",
                fill: props.bgColor,
                d: "M0,0 h".concat(numCells(), "v").concat(numCells(), "H0z")
            }),
            (0, $kyBEk$jsx)("path", {
                "shape-rendering": "crispEdges",
                fill: props.fgColor,
                d: fgPath
            }),
            available && !!((_a = props.imageSettings) === null || _a === void 0 ? void 0 : _a.src) ? (0, $kyBEk$jsx)((0, $kyBEk$Fragment), {
                children: (0, $kyBEk$jsx)("image", {
                    preserveAspectRatio: "none",
                    href: props.imageSettings.src,
                    height: calculatedImageSettings.h,
                    width: calculatedImageSettings.w,
                    x: calculatedImageSettings.x + margin,
                    y: calculatedImageSettings.y + margin
                })
            }) : null
        ]
    });
}
$1ee39bcdf3a85af5$var$QRCode.defaultProps = {
    size: (0, $5a6d9b3e35da8b84$export$e4c0458e30711294),
    level: (0, $5a6d9b3e35da8b84$export$480df663967f228c),
    bgColor: (0, $5a6d9b3e35da8b84$export$b39f8333017c702f),
    fgColor: (0, $5a6d9b3e35da8b84$export$67aa667c89b8639e),
    includeMargin: (0, $5a6d9b3e35da8b84$export$a2693684c16df853)
};
var $1ee39bcdf3a85af5$export$2e2bcd8739ae039 = $1ee39bcdf3a85af5$var$QRCode;










var $8f516741145796b7$export$e41b4a95de6d4edb = {
    light: "ub5xun2 gvc3qt2t7 gvc3qt1up gvc3qt2t gvc3qtw ub5xun5",
    dark: "ub5xun2 gvc3qt2t7 gvc3qt1up gvc3qt2t gvc3qtw ub5xun6"
};
var $8f516741145796b7$export$c418485c6670e5ad = "ub5xun0";
var $8f516741145796b7$export$36aff2b6b06e6852 = {
    light: "ub5xune gvc3qt11 gvc3qt1og gvc3qt5 gvc3qt2rs gvc3qt1ta ub5xunh",
    dark: "ub5xune gvc3qt11 gvc3qt1og gvc3qt5 gvc3qt2rs gvc3qt1ta ub5xuni"
};
var $8f516741145796b7$export$6e1c5aba4d75eb13 = "ub5xuna gvc3qt1hv gvc3qt1yp gvc3qt177";


var $88d7265cfe00c65a$export$8ff268355c25979e = "_12nhwbo0";
var $88d7265cfe00c65a$export$2cfdf00f7a1d73d5 = "var(--_12nhwbo1)";
var $88d7265cfe00c65a$export$680119e65cedcefd = "var(--_12nhwbo3)";
var $88d7265cfe00c65a$export$6aba9a96b82ead76 = "var(--_12nhwbo4)";
var $88d7265cfe00c65a$export$96500971c28dcde1 = {
    light: "_12nhwbo5 gvc3qt34s gvc3qt381 gvc3qt3ba gvc3qt31j gvc3qt2ta gvc3qtw gvc3qt1hv gvc3qt1yp gvc3qt177 gvc3qt2fd _12nhwbo8",
    dark: "_12nhwbo5 gvc3qt34s gvc3qt381 gvc3qt3ba gvc3qt31j gvc3qt2ta gvc3qtw gvc3qt1hv gvc3qt1yp gvc3qt177 gvc3qt2fd _12nhwbo9"
};
var $88d7265cfe00c65a$export$fc8e71510aee58be = "_12nhwboe";
var $88d7265cfe00c65a$export$7c5f21a9215e81a2 = "_12nhwbog gvc3qt3 gvc3qt1oa";
var $88d7265cfe00c65a$export$85a74c80eefd5bb7 = {
    light: "_12nhwboi _12nhwboj",
    dark: "_12nhwboi _12nhwbok"
};
var $88d7265cfe00c65a$export$bc166d4d4594db3b = "var(--_12nhwboc)";
var $88d7265cfe00c65a$export$c9239b19a413fad5 = "var(--_12nhwbod)";
var $88d7265cfe00c65a$export$1c06faa6e1504861 = "var(--_12nhwbo2)";



function $c4323e81d0890d81$var$ConnectModalQrCodeError(props) {
    var cleanupRef = (0, $kyBEk$useRef)(null);
    var _a = (0, $kyBEk$useState)(function() {
        return "light";
    }), theme = _a[0], setTheme = _a[1];
    (0, $kyBEk$useEffect)(function() {
        setTheme((0, $65ee908e933b27be$export$6f57813fe9f31bf9).getState().theme);
        cleanupRef.current = (0, $65ee908e933b27be$export$6f57813fe9f31bf9).subscribe(function(newState) {
            setTheme(newState.theme);
        });
    }, []);
    (0, $kyBEk$useEffect)(function() {
        return function() {
            if (typeof cleanupRef.current === "function") cleanupRef.current();
        };
    }, []);
    return (0, $kyBEk$jsxs)("div", {
        className: (0, $kyBEk$clsx)((0, $8f516741145796b7$export$c418485c6670e5ad), (0, $88d7265cfe00c65a$export$96500971c28dcde1), props.className),
        children: [
            (0, $kyBEk$jsx)("div", {
                className: (0, $8f516741145796b7$export$e41b4a95de6d4edb)[theme]
            }),
            (0, $kyBEk$jsx)("div", {
                className: (0, $8f516741145796b7$export$6e1c5aba4d75eb13),
                children: (0, $kyBEk$jsx)("button", {
                    onClick: function(event) {
                        var _a;
                        return (_a = props.onRefresh) === null || _a === void 0 ? void 0 : _a.call(props);
                    },
                    className: (0, $8f516741145796b7$export$36aff2b6b06e6852)[theme],
                    children: (0, $kyBEk$jsx)("span", {
                        children: (0, $kyBEk$jsx)((0, $a7df98dc81165fd3$export$2e2bcd8739ae039), {
                            name: "restart",
                            size: "lg"
                        })
                    })
                })
            }),
            (0, $kyBEk$jsx)((0, $1ee39bcdf3a85af5$export$2e2bcd8739ae039), {
                value: "https://",
                level: "L",
                size: props.qrCodeSize,
                bgColor: (0, $88d7265cfe00c65a$export$2cfdf00f7a1d73d5),
                fgColor: (0, $88d7265cfe00c65a$export$1c06faa6e1504861),
                includeMargin: false
            })
        ]
    });
}
var $c4323e81d0890d81$export$2e2bcd8739ae039 = $c4323e81d0890d81$var$ConnectModalQrCodeError;






function $7428a38f5ec9a8cf$var$ConnectModalQRCode(props) {
    var measureRef = (0, $kyBEk$useRef)(null);
    var shadowRef = (0, $kyBEk$useRef)(null);
    var animationRef = (0, $kyBEk$useRef)(null);
    var cleanupRef = (0, $kyBEk$useRef)(null);
    var _a = (0, $kyBEk$useState)(function() {
        return false;
    }), displayBlur = _a[0], setDisplayBlur = _a[1];
    var _b = (0, $kyBEk$useState)(function() {
        return "light";
    }), theme = _b[0], setTheme = _b[1];
    (0, $kyBEk$useEffect)(function() {
        setTheme((0, $65ee908e933b27be$export$6f57813fe9f31bf9).getState().theme);
        if (measureRef.current) {
            if (measureRef.current.clientHeight >= 64) setDisplayBlur(true);
            else setDisplayBlur(false);
            var scrollHandler_1 = function() {
                var height = Math.abs(measureRef.current.scrollHeight - measureRef.current.clientHeight - measureRef.current.scrollTop);
                if (height < 1) setDisplayBlur(false);
                else setDisplayBlur(true);
            };
            measureRef.current.addEventListener("scroll", scrollHandler_1);
            var themeUnsub_1 = (0, $65ee908e933b27be$export$6f57813fe9f31bf9).subscribe(function(newState) {
                setTheme(newState.theme);
            });
            cleanupRef.current = function() {
                themeUnsub_1();
                if (measureRef.current) measureRef.current.removeEventListener("scroll", scrollHandler_1);
            };
        }
    }, []);
    (0, $kyBEk$useEffect)(function() {
        var _a, _b;
        if (!shadowRef.current) return;
        // Animation not init yet
        if (shadowRef.current && !animationRef.current) animationRef.current = (0, $kyBEk$animejs)({
            targets: shadowRef.current,
            opacity: [
                0,
                1
            ],
            height: [
                0,
                28
            ],
            delay: 50,
            duration: 250,
            direction: "alternate",
            loop: false,
            autoplay: false,
            easing: "easeInOutSine"
        });
        if (displayBlur) (_a = animationRef.current) === null || _a === void 0 || _a.restart();
        else (_b = animationRef.current) === null || _b === void 0 || _b.reverse();
    }, [
        displayBlur,
        shadowRef.current
    ]);
    (0, $kyBEk$useEffect)(function() {
        return function() {
            if (typeof cleanupRef.current === "function") cleanupRef.current();
        };
    }, []);
    return (0, $kyBEk$jsxs)((0, $7718944390218472$exports.default), {
        direction: "column",
        space: "4",
        align: "center",
        children: [
            (0, $kyBEk$jsx)((0, $41ede47214de3bdb$exports.default), {
                fontWeight: "medium",
                size: "md",
                className: (0, $88d7265cfe00c65a$export$8ff268355c25979e),
                children: props.description
            }),
            props.status === "Pending" ? (0, $kyBEk$jsx)((0, $kyBEk$Fragment), {
                children: (0, $kyBEk$jsx)((0, $b333ffce68f4dc6c$export$2e2bcd8739ae039), {})
            }) : null,
            props.status === "Done" ? (0, $kyBEk$jsx)((0, $kyBEk$Fragment), {
                children: (0, $kyBEk$jsx)("div", {
                    className: (0, $88d7265cfe00c65a$export$96500971c28dcde1)[theme],
                    children: (0, $kyBEk$jsx)((0, $1ee39bcdf3a85af5$export$2e2bcd8739ae039), {
                        level: "L",
                        value: props.link,
                        size: props.qrCodeSize,
                        bgColor: (0, $88d7265cfe00c65a$export$2cfdf00f7a1d73d5),
                        fgColor: (0, $88d7265cfe00c65a$export$1c06faa6e1504861),
                        includeMargin: false
                    })
                })
            }) : null,
            props.status === "Error" || props.status === "Expired" ? (0, $kyBEk$jsx)((0, $kyBEk$Fragment), {
                children: (0, $kyBEk$jsx)((0, $c4323e81d0890d81$export$2e2bcd8739ae039), {
                    onRefresh: function(event) {
                        var _a;
                        return (_a = props.onRefresh) === null || _a === void 0 ? void 0 : _a.call(props);
                    },
                    qrCodeSize: props.qrCodeSize
                })
            }) : null,
            !!props.errorTitle ? (0, $kyBEk$jsxs)((0, $kyBEk$Fragment), {
                children: [
                    props.status === "Error" ? (0, $kyBEk$jsx)((0, $kyBEk$Fragment), {
                        children: (0, $kyBEk$jsx)((0, $41ede47214de3bdb$exports.default), {
                            as: "p",
                            fontWeight: "medium",
                            size: "md",
                            marginTop: "2",
                            color: "textDanger",
                            children: props.errorTitle
                        })
                    }) : null,
                    props.status === "Expired" ? (0, $kyBEk$jsx)((0, $kyBEk$Fragment), {
                        children: (0, $kyBEk$jsx)((0, $41ede47214de3bdb$exports.default), {
                            as: "p",
                            fontWeight: "medium",
                            size: "md",
                            marginTop: "2",
                            color: "textWarning",
                            children: props.errorTitle
                        })
                    }) : null
                ]
            }) : null,
            !!props.errorDesc ? (0, $kyBEk$jsx)((0, $kyBEk$Fragment), {
                children: (0, $kyBEk$jsxs)("div", {
                    className: (0, $88d7265cfe00c65a$export$fc8e71510aee58be),
                    children: [
                        (0, $kyBEk$jsx)("div", {
                            ref: measureRef,
                            className: (0, $88d7265cfe00c65a$export$7c5f21a9215e81a2),
                            children: (0, $kyBEk$jsx)("p", {
                                children: props.errorDesc
                            })
                        }),
                        (0, $kyBEk$jsx)("div", {
                            ref: shadowRef,
                            className: (0, $88d7265cfe00c65a$export$85a74c80eefd5bb7)[theme]
                        })
                    ]
                })
            }) : null
        ]
    });
}
$7428a38f5ec9a8cf$var$ConnectModalQRCode.defaultProps = {
    qrCodeSize: 230
};
var $7428a38f5ec9a8cf$export$2e2bcd8739ae039 = $7428a38f5ec9a8cf$var$ConnectModalQRCode;













var $b59641d09bf30933$export$2061aea8534ed47f = {
    light: "gvc3qt4 gvc3qt1og gvc3qt27v gvc3qt89 gvc3qt8a",
    dark: "gvc3qt4 gvc3qt1og gvc3qt27v gvc3qt4x gvc3qt4y"
};
var $b59641d09bf30933$export$56b5435f99f371c4 = {
    light: "gvc3qt23s gvc3qt4 gvc3qt1og gvc3qt89 gvc3qt8a",
    dark: "gvc3qt23s gvc3qt4 gvc3qt1og gvc3qt4x gvc3qt4y"
};
var $b59641d09bf30933$export$223f1504cb0ead3e = {
    light: "_1in45wyo _1in45wyp",
    dark: "_1in45wyo _1in45wyq"
};
var $b59641d09bf30933$export$a1f9e589407ee913 = {
    light: "gvc3qt1og gvc3qt23v gvc3qt8x gvc3qt8y",
    dark: "gvc3qt1og gvc3qt23v gvc3qt91 gvc3qt92"
};
var $b59641d09bf30933$export$51987bb50e1f6752 = {
    light: "gvc3qt3 gvc3qt241 gvc3qt1oa gvc3qtn gvc3qt85 gvc3qt86",
    dark: "gvc3qt3 gvc3qt241 gvc3qt1oa gvc3qtn gvc3qt69 gvc3qt6a"
};
var $b59641d09bf30933$export$79f61c9d7cb91c67 = {
    light: "gvc3qt1og gvc3qt24a gvc3qta1 gvc3qta2",
    dark: "gvc3qt1og gvc3qt24a gvc3qta9 gvc3qtaa"
};
var $b59641d09bf30933$export$d10c99241a302bd2 = {
    light: "_1in45wyb _1in45wyc",
    dark: "_1in45wyb _1in45wyd"
};
var $b59641d09bf30933$export$619474b7e15d2dc3 = "_1in45wy14 gvc3qt3ap gvc3qt30y gvc3qt24d gvc3qt3 gvc3qt2kv";
var $b59641d09bf30933$export$a72c9189e5811eff = {
    light: "_1in45wy4 gvc3qt34p gvc3qt37y gvc3qtm gvc3qt3bj gvc3qt30s gvc3qti9 gvc3qtia",
    dark: "_1in45wy4 gvc3qt34p gvc3qt37y gvc3qtm gvc3qt3bj gvc3qt30s gvc3qtll gvc3qtlm"
};
var $b59641d09bf30933$export$265a16ccffc66043 = {
    light: "_1in45wyy _1in45wyz",
    dark: "_1in45wyy _1in45wy10"
};
var $b59641d09bf30933$export$2969dce492f6c59e = "_1in45wyn";
var $b59641d09bf30933$export$e031787f6e971b8c = "_1in45wya gvc3qt2s4 gvc3qt1tm";
var $b59641d09bf30933$export$3cbde25fba7932cd = "gvc3qt34m gvc3qt37v gvc3qt3b4 gvc3qt31d gvc3qt1hv gvc3qt177 gvc3qt1yp";
var $b59641d09bf30933$export$123db80969c48a69 = "gvc3qt2s4 gvc3qt1tm gvc3qt1hv gvc3qt177 gvc3qt1yp";
var $b59641d09bf30933$export$cb7f85b6d62f82b0 = "gvc3qt2t7 gvc3qt34p gvc3qt37y";



var $91b20174cd44a651$export$6e1e3cd95d0461b9 = {
    light: "_1lxxbxn2 _1lxxbxn1",
    dark: "_1lxxbxn3 _1lxxbxn1"
};



function $abea071f346d6567$var$ConnectModalStatus(props) {
    var _a, _b;
    var cleanupRef = (0, $kyBEk$useRef)(null);
    var _c = (0, $kyBEk$useState)(function() {
        return "light";
    }), theme = _c[0], setTheme = _c[1];
    (0, $kyBEk$useEffect)(function() {
        setTheme((0, $65ee908e933b27be$export$6f57813fe9f31bf9).getState().theme);
        cleanupRef.current = (0, $65ee908e933b27be$export$6f57813fe9f31bf9).subscribe(function(newState) {
            setTheme(newState.theme);
        });
    }, []);
    (0, $kyBEk$useEffect)(function() {
        return function() {
            if (typeof cleanupRef.current === "function") cleanupRef.current();
        };
    }, []);
    return (0, $kyBEk$jsxs)("div", {
        className: (0, $kyBEk$clsx)((0, $b59641d09bf30933$export$a72c9189e5811eff)[theme], props.className),
        children: [
            props.status === "Disconnected" ? (0, $kyBEk$jsxs)((0, $kyBEk$Fragment), {
                children: [
                    (0, $kyBEk$jsxs)("div", {
                        className: (0, $kyBEk$clsx)((0, $b59641d09bf30933$export$e031787f6e971b8c), (0, $47a3451e57ac14cf$export$9f2265a541a48bf2)({
                            marginBottom: "5"
                        })),
                        children: [
                            (0, $kyBEk$jsx)("div", {
                                className: (0, $b59641d09bf30933$export$d10c99241a302bd2)[theme]
                            }),
                            (0, $kyBEk$jsx)("div", {
                                className: (0, $b59641d09bf30933$export$3cbde25fba7932cd),
                                children: (0, $kyBEk$jsx)("img", {
                                    src: props.wallet.logo,
                                    alt: props.wallet.name,
                                    className: (0, $47a3451e57ac14cf$export$9f2265a541a48bf2)({
                                        width: "full",
                                        height: "full"
                                    })
                                })
                            })
                        ]
                    }),
                    (0, $kyBEk$jsx)("p", {
                        className: (0, $b59641d09bf30933$export$79f61c9d7cb91c67)[theme],
                        children: "Wallet is disconnected"
                    }),
                    (0, $kyBEk$jsx)("div", {
                        className: (0, $b59641d09bf30933$export$cb7f85b6d62f82b0),
                        children: (0, $kyBEk$jsx)((0, $6aa42b028ae27f6d$exports.default), {
                            leftIcon: "walletFilled",
                            onClick: function(event) {
                                var _a;
                                return (_a = props.onConnect) === null || _a === void 0 ? void 0 : _a.call(props);
                            },
                            className: (0, $47a3451e57ac14cf$export$9f2265a541a48bf2)({
                                width: "full",
                                marginBottom: "3"
                            }),
                            children: "Connect wallet"
                        })
                    }),
                    !!props.bottomLink ? (0, $kyBEk$jsx)((0, $kyBEk$Fragment), {
                        children: (0, $kyBEk$jsxs)("div", {
                            children: [
                                (0, $kyBEk$jsxs)("a", {
                                    target: "_blank",
                                    rel: "noreferrer",
                                    href: props.bottomLink,
                                    className: (0, $47a3451e57ac14cf$export$9f2265a541a48bf2)({
                                        fontSize: "sm",
                                        color: "body",
                                        fontWeight: "normal"
                                    }),
                                    children: [
                                        "Don't have a wallet?",
                                        " "
                                    ]
                                }),
                                " "
                            ]
                        })
                    }) : null
                ]
            }) : null,
            " ",
            props.status === "Connecting" ? (0, $kyBEk$jsxs)((0, $kyBEk$Fragment), {
                children: [
                    (0, $kyBEk$jsxs)("div", {
                        className: (0, $kyBEk$clsx)((0, $b59641d09bf30933$export$e031787f6e971b8c), (0, $47a3451e57ac14cf$export$9f2265a541a48bf2)({
                            marginBottom: "8"
                        })),
                        children: [
                            " ",
                            (0, $kyBEk$jsx)("div", {
                                className: (0, $b59641d09bf30933$export$223f1504cb0ead3e)[theme]
                            }),
                            " ",
                            (0, $kyBEk$jsxs)("div", {
                                className: (0, $b59641d09bf30933$export$3cbde25fba7932cd),
                                children: [
                                    " ",
                                    (0, $kyBEk$jsx)("img", {
                                        src: props.wallet.logo,
                                        alt: props.wallet.name,
                                        className: (0, $47a3451e57ac14cf$export$9f2265a541a48bf2)({
                                            width: "full",
                                            height: "full"
                                        })
                                    }),
                                    " "
                                ]
                            }),
                            " "
                        ]
                    }),
                    " ",
                    (0, $kyBEk$jsx)("p", {
                        className: (0, $b59641d09bf30933$export$56b5435f99f371c4)[theme],
                        children: props.contentHeader
                    }),
                    " ",
                    (0, $kyBEk$jsxs)("p", {
                        className: (0, $47a3451e57ac14cf$export$9f2265a541a48bf2)({
                            fontSize: "sm",
                            color: "body",
                            fontWeight: "normal",
                            textAlign: "center"
                        }),
                        children: [
                            " ",
                            props.contentDesc,
                            " "
                        ]
                    })
                ]
            }) : null,
            " ",
            props.status === "Connected" ? (0, $kyBEk$jsxs)((0, $kyBEk$Fragment), {
                children: [
                    (0, $kyBEk$jsxs)("div", {
                        className: (0, $kyBEk$clsx)((0, $b59641d09bf30933$export$e031787f6e971b8c), (0, $47a3451e57ac14cf$export$9f2265a541a48bf2)({
                            marginBottom: "8"
                        })),
                        children: [
                            " ",
                            typeof props.connectedInfo.avatar === "string" ? (0, $kyBEk$jsx)((0, $kyBEk$Fragment), {
                                children: (0, $kyBEk$jsxs)("div", {
                                    className: (0, $b59641d09bf30933$export$3cbde25fba7932cd),
                                    children: [
                                        " ",
                                        (0, $kyBEk$jsx)("img", {
                                            src: props.connectedInfo.avatar,
                                            alt: props.connectedInfo.name,
                                            className: (0, $47a3451e57ac14cf$export$9f2265a541a48bf2)({
                                                width: "full",
                                                height: "full"
                                            })
                                        }),
                                        " "
                                    ]
                                })
                            }) : null,
                            " ",
                            !!props.connectedInfo.avatar && typeof props.connectedInfo.avatar !== "string" ? (0, $kyBEk$jsx)((0, $kyBEk$Fragment), {
                                children: (0, $kyBEk$jsxs)("div", {
                                    className: (0, $b59641d09bf30933$export$123db80969c48a69),
                                    children: [
                                        " ",
                                        props.connectedInfo.avatar,
                                        " "
                                    ]
                                })
                            }) : null,
                            " "
                        ]
                    }),
                    " ",
                    (0, $kyBEk$jsxs)("div", {
                        className: (0, $47a3451e57ac14cf$export$9f2265a541a48bf2)({
                            display: "flex",
                            alignItems: "center",
                            marginBottom: "5"
                        }),
                        children: [
                            " ",
                            (0, $kyBEk$jsx)("img", {
                                src: props.wallet.logo,
                                alt: props.wallet.name,
                                className: (0, $47a3451e57ac14cf$export$9f2265a541a48bf2)({
                                    width: "8",
                                    height: "8"
                                })
                            }),
                            " ",
                            !!((_a = props.connectedInfo) === null || _a === void 0 ? void 0 : _a.name) ? (0, $kyBEk$jsx)((0, $kyBEk$Fragment), {
                                children: (0, $kyBEk$jsxs)("p", {
                                    className: (0, $b59641d09bf30933$export$2061aea8534ed47f)[theme],
                                    children: [
                                        " ",
                                        props.connectedInfo.name,
                                        " "
                                    ]
                                })
                            }) : null,
                            " "
                        ]
                    }),
                    " ",
                    (0, $kyBEk$jsxs)("div", {
                        className: (0, $b59641d09bf30933$export$cb7f85b6d62f82b0),
                        children: [
                            " ",
                            (0, $kyBEk$jsx)((0, $aad94d8c88c58f04$export$2e2bcd8739ae039), {
                                truncate: "middle",
                                text: props.connectedInfo.address,
                                className: (0, $47a3451e57ac14cf$export$9f2265a541a48bf2)({
                                    marginBottom: "7"
                                })
                            }),
                            " "
                        ]
                    }),
                    " ",
                    (0, $kyBEk$jsxs)("div", {
                        className: (0, $b59641d09bf30933$export$cb7f85b6d62f82b0),
                        children: [
                            " ",
                            (0, $kyBEk$jsxs)((0, $6aa42b028ae27f6d$exports.default), {
                                leftIcon: "walletFilled",
                                onClick: function(event) {
                                    var _a;
                                    return (_a = props.onDisconnect) === null || _a === void 0 ? void 0 : _a.call(props);
                                },
                                className: (0, $47a3451e57ac14cf$export$9f2265a541a48bf2)({
                                    width: "full"
                                }),
                                children: [
                                    " ",
                                    "Disconnect",
                                    " "
                                ]
                            }),
                            " "
                        ]
                    })
                ]
            }) : null,
            " ",
            props.status === "NotExist" ? (0, $kyBEk$jsxs)((0, $kyBEk$Fragment), {
                children: [
                    (0, $kyBEk$jsxs)("div", {
                        className: (0, $kyBEk$clsx)((0, $b59641d09bf30933$export$e031787f6e971b8c), (0, $47a3451e57ac14cf$export$9f2265a541a48bf2)({
                            marginBottom: "7"
                        })),
                        children: [
                            " ",
                            (0, $kyBEk$jsx)("div", {
                                className: (0, $b59641d09bf30933$export$265a16ccffc66043)[theme]
                            }),
                            " ",
                            (0, $kyBEk$jsxs)("div", {
                                className: (0, $b59641d09bf30933$export$3cbde25fba7932cd),
                                children: [
                                    " ",
                                    (0, $kyBEk$jsx)("img", {
                                        src: props.wallet.logo,
                                        alt: props.wallet.name,
                                        className: (0, $47a3451e57ac14cf$export$9f2265a541a48bf2)({
                                            width: "full",
                                            height: "full"
                                        })
                                    }),
                                    " "
                                ]
                            }),
                            " "
                        ]
                    }),
                    " ",
                    (0, $kyBEk$jsx)("p", {
                        className: (0, $b59641d09bf30933$export$a1f9e589407ee913)[theme],
                        children: props.contentHeader
                    }),
                    " ",
                    (0, $kyBEk$jsxs)("p", {
                        className: (0, $kyBEk$clsx)((0, $10f46b741f72a0fc$export$e96da1e889d6dc74), (0, $b59641d09bf30933$export$51987bb50e1f6752)[theme]),
                        children: [
                            " ",
                            props.contentDesc,
                            " "
                        ]
                    }),
                    " ",
                    (0, $kyBEk$jsxs)("div", {
                        className: (0, $b59641d09bf30933$export$cb7f85b6d62f82b0),
                        children: [
                            " ",
                            (0, $kyBEk$jsxs)((0, $6aa42b028ae27f6d$exports.default), {
                                intent: "primary",
                                variant: "outlined",
                                onClick: function(event) {
                                    var _a;
                                    return (_a = props.onInstall) === null || _a === void 0 ? void 0 : _a.call(props);
                                },
                                disabled: !!props.disableInstall,
                                className: (0, $47a3451e57ac14cf$export$9f2265a541a48bf2)({
                                    width: "full"
                                }),
                                children: [
                                    " ",
                                    (0, $kyBEk$jsxs)("span", {
                                        className: (0, $47a3451e57ac14cf$export$9f2265a541a48bf2)({
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center"
                                        }),
                                        children: [
                                            " ",
                                            (0, $kyBEk$jsx)("span", {
                                                children: props.installIcon
                                            }),
                                            " ",
                                            (0, $kyBEk$jsxs)("span", {
                                                className: (0, $47a3451e57ac14cf$export$9f2265a541a48bf2)({
                                                    marginLeft: "4"
                                                }),
                                                children: [
                                                    " ",
                                                    "Install ",
                                                    (_b = props.wallet.prettyName) !== null && _b !== void 0 ? _b : props.wallet.name,
                                                    " "
                                                ]
                                            }),
                                            " "
                                        ]
                                    }),
                                    " "
                                ]
                            }),
                            " "
                        ]
                    })
                ]
            }) : null,
            " ",
            props.status === "Rejected" ? (0, $kyBEk$jsxs)((0, $kyBEk$Fragment), {
                children: [
                    (0, $kyBEk$jsxs)("div", {
                        className: (0, $kyBEk$clsx)((0, $b59641d09bf30933$export$e031787f6e971b8c), (0, $47a3451e57ac14cf$export$9f2265a541a48bf2)({
                            marginBottom: "7"
                        })),
                        children: [
                            " ",
                            (0, $kyBEk$jsx)("div", {
                                className: (0, $b59641d09bf30933$export$265a16ccffc66043)[theme]
                            }),
                            " ",
                            (0, $kyBEk$jsxs)("div", {
                                className: (0, $b59641d09bf30933$export$3cbde25fba7932cd),
                                children: [
                                    " ",
                                    (0, $kyBEk$jsx)("img", {
                                        src: props.wallet.logo,
                                        alt: props.wallet.name,
                                        className: (0, $47a3451e57ac14cf$export$9f2265a541a48bf2)({
                                            width: "full",
                                            height: "full"
                                        })
                                    }),
                                    " "
                                ]
                            }),
                            " "
                        ]
                    }),
                    " ",
                    (0, $kyBEk$jsx)("p", {
                        className: (0, $b59641d09bf30933$export$a1f9e589407ee913)[theme],
                        children: props.contentHeader
                    }),
                    " ",
                    (0, $kyBEk$jsx)("p", {
                        className: (0, $b59641d09bf30933$export$51987bb50e1f6752)[theme],
                        children: props.contentDesc
                    }),
                    " ",
                    (0, $kyBEk$jsxs)("div", {
                        className: (0, $b59641d09bf30933$export$cb7f85b6d62f82b0),
                        children: [
                            " ",
                            (0, $kyBEk$jsxs)((0, $6aa42b028ae27f6d$exports.default), {
                                leftIcon: "walletFilled",
                                onClick: function(event) {
                                    var _a;
                                    return (_a = props.onConnect) === null || _a === void 0 ? void 0 : _a.call(props);
                                },
                                className: (0, $47a3451e57ac14cf$export$9f2265a541a48bf2)({
                                    width: "full",
                                    marginBottom: "3"
                                }),
                                children: [
                                    " ",
                                    "Reconnect",
                                    " "
                                ]
                            }),
                            " "
                        ]
                    })
                ]
            }) : null,
            " ",
            props.status === "Error" ? (0, $kyBEk$jsxs)((0, $kyBEk$Fragment), {
                children: [
                    (0, $kyBEk$jsxs)("div", {
                        className: (0, $kyBEk$clsx)((0, $b59641d09bf30933$export$e031787f6e971b8c), (0, $47a3451e57ac14cf$export$9f2265a541a48bf2)({
                            marginBottom: "7"
                        })),
                        children: [
                            " ",
                            (0, $kyBEk$jsx)("div", {
                                className: (0, $b59641d09bf30933$export$265a16ccffc66043)[theme]
                            }),
                            " ",
                            (0, $kyBEk$jsxs)("div", {
                                className: (0, $b59641d09bf30933$export$3cbde25fba7932cd),
                                children: [
                                    " ",
                                    (0, $kyBEk$jsx)("img", {
                                        src: props.wallet.logo,
                                        alt: props.wallet.name,
                                        className: (0, $47a3451e57ac14cf$export$9f2265a541a48bf2)({
                                            width: "full",
                                            height: "full"
                                        })
                                    }),
                                    " "
                                ]
                            }),
                            " "
                        ]
                    }),
                    " ",
                    (0, $kyBEk$jsx)("p", {
                        className: (0, $b59641d09bf30933$export$a1f9e589407ee913)[theme],
                        children: props.contentHeader
                    }),
                    " ",
                    (0, $kyBEk$jsxs)("div", {
                        className: (0, $47a3451e57ac14cf$export$9f2265a541a48bf2)({
                            position: "relative"
                        }),
                        children: [
                            " ",
                            (0, $kyBEk$jsxs)("div", {
                                className: (0, $b59641d09bf30933$export$619474b7e15d2dc3),
                                children: [
                                    " ",
                                    (0, $kyBEk$jsx)("p", {
                                        className: (0, $b59641d09bf30933$export$51987bb50e1f6752)[theme],
                                        children: props.contentDesc
                                    }),
                                    " "
                                ]
                            }),
                            " ",
                            (0, $kyBEk$jsx)("div", {
                                className: (0, $91b20174cd44a651$export$6e1e3cd95d0461b9)[theme]
                            }),
                            " "
                        ]
                    }),
                    " ",
                    (0, $kyBEk$jsxs)("div", {
                        className: (0, $b59641d09bf30933$export$cb7f85b6d62f82b0),
                        children: [
                            " ",
                            (0, $kyBEk$jsxs)((0, $6aa42b028ae27f6d$exports.default), {
                                leftIcon: "walletFilled",
                                onClick: function(event) {
                                    var _a;
                                    return (_a = props.onChangeWallet) === null || _a === void 0 ? void 0 : _a.call(props);
                                },
                                className: (0, $47a3451e57ac14cf$export$9f2265a541a48bf2)({
                                    width: "full",
                                    marginBottom: "3"
                                }),
                                children: [
                                    " ",
                                    "Change wallet",
                                    " "
                                ]
                            }),
                            " "
                        ]
                    })
                ]
            }) : null,
            " "
        ]
    });
}
var $abea071f346d6567$export$2e2bcd8739ae039 = $abea071f346d6567$var$ConnectModalStatus;









var $8af6413ca3769b33$export$80958133491891b3 = {
    light: "_13l9dkkj gvc3qt3 gvc3qt1oa gvc3qt79 gvc3qt7a",
    dark: "_13l9dkkj gvc3qt3 gvc3qt1oa gvc3qt69 gvc3qt6a"
};
var $8af6413ca3769b33$export$4becb9d005406900 = (0, $kyBEk$createRuntimeFn)({
    defaultClassName: "_13l9dkkp",
    variantClassNames: {
        variant: {
            square: "_13l9dkkq",
            list: "gvc3qt1ia"
        }
    },
    defaultVariants: {
        variant: "square"
    },
    compoundVariants: []
});
var $8af6413ca3769b33$export$9936539488368473 = {
    light: "_13l9dkk3 _13l9dkk4 gvc3qt79 gvc3qt7a gvc3qtkx gvc3qtky",
    dark: "_13l9dkk3 _13l9dkk6 gvc3qt65 gvc3qt66 gvc3qtk9 gvc3qtka"
};
var $8af6413ca3769b33$export$626e4a1f6af3e0a7 = (0, $kyBEk$createRuntimeFn)({
    defaultClassName: "_13l9dkka",
    variantClassNames: {
        variant: {
            square: "_13l9dkk1",
            list: "_13l9dkk2"
        }
    },
    defaultVariants: {
        variant: "square"
    },
    compoundVariants: []
});
var $8af6413ca3769b33$export$f97737d65bc9e08d = (0, $kyBEk$createRuntimeFn)({
    defaultClassName: "_13l9dkkf",
    variantClassNames: {
        variant: {
            square: "gvc3qt2rv gvc3qt1td gvc3qt244",
            list: "gvc3qt2rj gvc3qt1t1 gvc3qt2c1"
        }
    },
    defaultVariants: {
        variant: "square"
    },
    compoundVariants: []
});
var $8af6413ca3769b33$export$7ecc62b35127990b = "var(--_13l9dkk0)";
var $8af6413ca3769b33$export$22cb9e1993701f73 = "_13l9dkkz gvc3qtid gvc3qtie gvc3qt11 gvc3qt2bj";
var $8af6413ca3769b33$export$dc4dcc6ab27b4e23 = {
    light: "_13l9dkkt gvc3qt11 gvc3qtkx gvc3qtky gvc3qty9 gvc3qtya",
    dark: "_13l9dkkt gvc3qt11 gvc3qtll gvc3qtlm gvc3qtyx gvc3qtyy"
};





function $09019c53bb4d0154$var$ConnectModalWalletButton(props) {
    var cleanupRef = (0, $kyBEk$useRef)(null);
    var _a = (0, $kyBEk$useState)(function() {
        return "light";
    }), theme = _a[0], setTheme = _a[1];
    (0, $kyBEk$useEffect)(function() {
        setTheme((0, $65ee908e933b27be$export$6f57813fe9f31bf9).getState().theme);
        cleanupRef.current = (0, $65ee908e933b27be$export$6f57813fe9f31bf9).subscribe(function(newState) {
            setTheme(newState.theme);
        });
    }, []);
    (0, $kyBEk$useEffect)(function() {
        return function() {
            if (typeof cleanupRef.current === "function") cleanupRef.current();
        };
    }, []);
    return (0, $kyBEk$jsxs)("button", {
        className: (0, $kyBEk$clsx)((0, $8af6413ca3769b33$export$9936539488368473)[theme], (0, $8af6413ca3769b33$export$626e4a1f6af3e0a7)({
            variant: props.variant
        })),
        onClick: function(event) {
            return props.onClick(event);
        },
        children: [
            !!props.logo ? (0, $kyBEk$jsx)((0, $kyBEk$Fragment), {
                children: (0, $kyBEk$jsxs)("span", {
                    className: (0, $kyBEk$clsx)((0, $8af6413ca3769b33$export$f97737d65bc9e08d)({
                        variant: props.variant
                    }), (0, $47a3451e57ac14cf$export$9f2265a541a48bf2)({
                        position: "relative",
                        display: "block"
                    })),
                    children: [
                        (0, $kyBEk$jsx)("img", {
                            alt: props.name,
                            src: props.logo,
                            className: (0, $47a3451e57ac14cf$export$9f2265a541a48bf2)({
                                width: "full",
                                height: "full"
                            })
                        }),
                        props.variant === "square" && typeof props.subLogo === "string" ? (0, $kyBEk$jsx)((0, $kyBEk$Fragment), {
                            children: (0, $kyBEk$jsxs)("span", {
                                className: (0, $8af6413ca3769b33$export$dc4dcc6ab27b4e23)[theme],
                                children: [
                                    props.subLogo === "walletConnect" ? (0, $kyBEk$jsx)((0, $kyBEk$Fragment), {
                                        children: (0, $kyBEk$jsx)((0, $a7df98dc81165fd3$export$2e2bcd8739ae039), {
                                            name: "mobileWalletCircle",
                                            size: "2xl"
                                        })
                                    }) : null,
                                    props.subLogo !== "walletConnect" ? (0, $kyBEk$jsx)((0, $kyBEk$Fragment), {
                                        children: (0, $kyBEk$jsx)("img", {
                                            src: props.subLogo,
                                            alt: "".concat(props.name, " sub logo"),
                                            className: (0, $47a3451e57ac14cf$export$9f2265a541a48bf2)({
                                                width: "10",
                                                height: "10"
                                            })
                                        })
                                    }) : null
                                ]
                            })
                        }) : null
                    ]
                })
            }) : null,
            (0, $kyBEk$jsx)("span", {
                className: (0, $kyBEk$clsx)((0, $8af6413ca3769b33$export$80958133491891b3)[theme], (0, $8af6413ca3769b33$export$4becb9d005406900)({
                    variant: props.variant
                })),
                children: props.name
            }),
            props.variant === "list" && typeof props.subLogo === "string" ? (0, $kyBEk$jsx)((0, $kyBEk$Fragment), {
                children: (0, $kyBEk$jsxs)("span", {
                    className: (0, $8af6413ca3769b33$export$22cb9e1993701f73),
                    children: [
                        props.subLogo === "walletConnect" ? (0, $kyBEk$jsx)((0, $kyBEk$Fragment), {
                            children: (0, $kyBEk$jsx)((0, $a7df98dc81165fd3$export$2e2bcd8739ae039), {
                                name: "mobileWallet",
                                size: "xl"
                            })
                        }) : null,
                        props.subLogo !== "walletConnect" ? (0, $kyBEk$jsx)((0, $kyBEk$Fragment), {
                            children: (0, $kyBEk$jsx)("img", {
                                src: props.subLogo,
                                alt: "".concat(props.name, " sub logo"),
                                className: (0, $47a3451e57ac14cf$export$9f2265a541a48bf2)({
                                    width: "9",
                                    height: "9"
                                })
                            })
                        }) : null
                    ]
                })
            }) : null
        ]
    });
}
var $09019c53bb4d0154$export$2e2bcd8739ae039 = $09019c53bb4d0154$var$ConnectModalWalletButton;




var $aebf0d9ca8db48ff$exports = {};

$parcel$export($aebf0d9ca8db48ff$exports, "default", function () { return $aebf0d9ca8db48ff$export$2e2bcd8739ae039; }, function (v) { return $aebf0d9ca8db48ff$export$2e2bcd8739ae039 = v; });






var $d2901573511bcad2$export$34e0f9847d4c02dd = "l7cqud0";
var $d2901573511bcad2$export$b55d47878224aab1 = "l7cqud6 gvc3qt27m gvc3qt2bg gvc3qt314";
var $d2901573511bcad2$export$827a23ec99a19829 = "l7cqud4 gvc3qt27m gvc3qt2bg";
var $d2901573511bcad2$export$ce9cb47cf3eb8389 = "l7cqud2 gvc3qt31g gvc3qt3am";




var $aebf0d9ca8db48ff$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $aebf0d9ca8db48ff$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
function $aebf0d9ca8db48ff$var$ConnectModalWalletList(props) {
    var _this = this;
    var _a, _b;
    var measureRef = (0, $kyBEk$useRef)(null);
    var shadowRef = (0, $kyBEk$useRef)(null);
    var animationRef = (0, $kyBEk$useRef)(null);
    var cleanupRef = (0, $kyBEk$useRef)(null);
    var _c = (0, $kyBEk$useState)(function() {
        return false;
    }), displayBlur = _c[0], setDisplayBlur = _c[1];
    var _d = (0, $kyBEk$useState)(function() {
        return "light";
    }), theme = _d[0], setTheme = _d[1];
    function onWalletItemClickAsync(exec) {
        (function() {
            return $aebf0d9ca8db48ff$var$__awaiter(this, void 0, void 0, function() {
                return $aebf0d9ca8db48ff$var$__generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                exec()
                            ];
                        case 1:
                            _a.sent();
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        })();
    }
    (0, $kyBEk$useEffect)(function() {
        setTheme((0, $65ee908e933b27be$export$6f57813fe9f31bf9).getState().theme);
        var unsubTheme = (0, $65ee908e933b27be$export$6f57813fe9f31bf9).subscribe(function(newState) {
            setTheme(newState.theme);
        });
        if (measureRef.current) {
            if (measureRef.current.clientHeight >= 320) setDisplayBlur(true);
            else setDisplayBlur(false);
            var scrollHandler_1 = function() {
                var height = Math.abs(measureRef.current.scrollHeight - measureRef.current.clientHeight - measureRef.current.scrollTop);
                if (height < 1) setDisplayBlur(false);
                else setDisplayBlur(true);
            };
            measureRef.current.addEventListener("scroll", scrollHandler_1);
            cleanupRef.current = function() {
                unsubTheme();
                if (measureRef.current) measureRef.current.removeEventListener("scroll", scrollHandler_1);
            };
        }
    }, []);
    (0, $kyBEk$useEffect)(function() {
        var _a, _b;
        if (!shadowRef.current) return;
        // Animation not init yet
        if (shadowRef.current && !animationRef.current) animationRef.current = (0, $kyBEk$animejs)({
            targets: shadowRef.current,
            opacity: [
                0,
                1
            ],
            height: [
                0,
                36
            ],
            delay: 50,
            duration: 250,
            direction: "alternate",
            loop: false,
            autoplay: false,
            easing: "easeInOutSine"
        });
        if (displayBlur) (_a = animationRef.current) === null || _a === void 0 || _a.restart();
        else (_b = animationRef.current) === null || _b === void 0 || _b.reverse();
    }, [
        displayBlur,
        shadowRef.current
    ]);
    (0, $kyBEk$useEffect)(function() {
        return function() {
            if (typeof cleanupRef.current === "function") cleanupRef.current();
        };
    }, []);
    return (0, $kyBEk$jsxs)("div", {
        className: (0, $kyBEk$clsx)((0, $d2901573511bcad2$export$34e0f9847d4c02dd), props.className),
        children: [
            (0, $kyBEk$jsxs)("div", {
                ref: measureRef,
                className: (0, $d2901573511bcad2$export$ce9cb47cf3eb8389),
                children: [
                    props.wallets.slice(0, 2).every(function(wallet) {
                        return wallet.shape === "square";
                    }) ? (0, $kyBEk$jsx)((0, $kyBEk$Fragment), {
                        children: (0, $kyBEk$jsx)("div", {
                            className: (0, $d2901573511bcad2$export$827a23ec99a19829),
                            children: (_a = props.wallets.slice(0, 2)) === null || _a === void 0 ? void 0 : _a.map(function(wallet, index) {
                                var _a;
                                return (0, $kyBEk$jsx)((0, $09019c53bb4d0154$export$2e2bcd8739ae039), {
                                    variant: "square",
                                    name: (_a = wallet.prettyName) !== null && _a !== void 0 ? _a : wallet.name,
                                    logo: wallet.logo,
                                    subLogo: wallet.subLogo,
                                    onClick: function(event) {
                                        return onWalletItemClickAsync(function() {
                                            return $aebf0d9ca8db48ff$var$__awaiter(_this, void 0, void 0, function() {
                                                var _a;
                                                return $aebf0d9ca8db48ff$var$__generator(this, function(_b) {
                                                    return [
                                                        2 /*return*/ ,
                                                        (_a = props.onWalletItemClick) === null || _a === void 0 ? void 0 : _a.call(props, wallet.originalWallet)
                                                    ];
                                                });
                                            });
                                        });
                                    }
                                }, wallet.name);
                            })
                        })
                    }) : null,
                    (0, $kyBEk$jsx)("div", {
                        className: (0, $d2901573511bcad2$export$b55d47878224aab1),
                        children: (_b = props.wallets.filter(function(w) {
                            return w.shape === "list";
                        })) === null || _b === void 0 ? void 0 : _b.map(function(wallet, index) {
                            var _a;
                            return (0, $kyBEk$jsx)((0, $09019c53bb4d0154$export$2e2bcd8739ae039), {
                                variant: "list",
                                name: (_a = wallet.prettyName) !== null && _a !== void 0 ? _a : wallet.name,
                                logo: wallet.logo,
                                subLogo: wallet.subLogo,
                                onClick: function(event) {
                                    return onWalletItemClickAsync(function() {
                                        return $aebf0d9ca8db48ff$var$__awaiter(_this, void 0, void 0, function() {
                                            var _a;
                                            return $aebf0d9ca8db48ff$var$__generator(this, function(_b) {
                                                return [
                                                    2 /*return*/ ,
                                                    (_a = props.onWalletItemClick) === null || _a === void 0 ? void 0 : _a.call(props, wallet.originalWallet)
                                                ];
                                            });
                                        });
                                    });
                                }
                            }, wallet.name);
                        })
                    })
                ]
            }),
            (0, $kyBEk$jsx)("div", {
                ref: shadowRef,
                className: (0, $91b20174cd44a651$export$6e1e3cd95d0461b9)[theme]
            })
        ]
    });
}
var $aebf0d9ca8db48ff$export$2e2bcd8739ae039 = $aebf0d9ca8db48ff$var$ConnectModalWalletList;














var $05e2d5a34ca80a28$export$cb6c30b631422a13 = "_66pptw4";
var $05e2d5a34ca80a28$export$34e0f9847d4c02dd = "_66pptw0";
var $05e2d5a34ca80a28$export$a7db06668cad9adb = "_66pptw5";
var $05e2d5a34ca80a28$export$b3e5e3e1ed7a551a = "_66pptw3";
var $05e2d5a34ca80a28$export$b8972b998723d602 = {
    light: "_66pptw1",
    dark: "_66pptw2"
};


function $becba96142f0a79e$var$ShowMore(props) {
    var eleHeight = (0, $kyBEk$useRef)(null);
    var initHeightRef = (0, $kyBEk$useRef)(0);
    var isVisibleRef = (0, $kyBEk$useRef)(false);
    var animationRef = (0, $kyBEk$useRef)(null);
    var elementRef = (0, $kyBEk$useRef)(null);
    var cleanupRef = (0, $kyBEk$useRef)(null);
    var resizeRef = (0, $kyBEk$useRef)(null);
    var _a = (0, $kyBEk$useState)(function() {
        return false;
    }), isVisible = _a[0], setIsVisible = _a[1];
    function toggle() {
        isVisibleRef.current = !isVisible;
        setIsVisible(!isVisible);
    }
    function updateAnimationRef() {
        animationRef.current = (0, $kyBEk$animejs)({
            targets: elementRef.current,
            height: [
                eleHeight.current * initHeightRef.current,
                eleHeight.current
            ],
            duration: 250,
            direction: "alternate",
            loop: false,
            autoplay: false,
            easing: "easeInOutExpo"
        });
        setIsVisible(false);
    }
    var _b = (0, $kyBEk$useState)(function() {
        return "";
    }), theme = _b[0], setTheme = _b[1];
    (0, $kyBEk$useEffect)(function() {
        setTheme((0, $65ee908e933b27be$export$6f57813fe9f31bf9).getState().theme);
        cleanupRef.current = (0, $65ee908e933b27be$export$6f57813fe9f31bf9).subscribe(function(newState, prevState) {
            setTheme(newState.theme);
        });
        // Listen the resize event to get container height
        resizeRef.current = (0, $kyBEk$lodashdebounce)(function() {
            elementRef.current.style.height = "auto";
            eleHeight.current = elementRef.current.offsetHeight + 50;
            elementRef.current.style.height = isVisibleRef.current ? "".concat(eleHeight.current, "px") : "".concat(eleHeight.current * initHeightRef.current, "px");
            updateAnimationRef();
        }, 300);
        window.addEventListener("resize", resizeRef.current);
        // Simulate useLayoutEffect
        setTimeout(function() {
            if (!eleHeight.current) eleHeight.current = elementRef.current.offsetHeight + 50;
            updateAnimationRef();
        }, 500);
    }, []);
    (0, $kyBEk$useEffect)(function() {
        initHeightRef.current = props.initialHeightPercent;
        updateAnimationRef();
    }, [
        props.initialHeightPercent
    ]);
    (0, $kyBEk$useEffect)(function() {
        return function() {
            if (typeof cleanupRef.current === "function") cleanupRef.current();
            if (window) window.removeEventListener("resize", resizeRef.current);
        };
    }, []);
    return (0, $kyBEk$jsxs)("div", {
        ref: elementRef,
        className: (0, $kyBEk$clsx)($05e2d5a34ca80a28$export$34e0f9847d4c02dd, props.className),
        children: [
            props.children,
            !isVisible ? (0, $kyBEk$jsx)((0, $kyBEk$Fragment), {
                children: (0, $kyBEk$jsx)((0, $7718944390218472$exports.default), {
                    justify: "center",
                    align: "flex-end",
                    className: (0, $kyBEk$clsx)($05e2d5a34ca80a28$export$b3e5e3e1ed7a551a, $05e2d5a34ca80a28$export$b8972b998723d602[theme]),
                    children: (0, $kyBEk$jsxs)("div", {
                        onClick: function(event) {
                            var _a;
                            toggle();
                            (_a = animationRef.current) === null || _a === void 0 || _a.play();
                        },
                        className: $05e2d5a34ca80a28$export$cb6c30b631422a13,
                        children: [
                            (0, $kyBEk$jsx)((0, $41ede47214de3bdb$exports.default), {
                                color: "textSecondary",
                                weight: "semibold",
                                attributes: {
                                    marginRight: "5"
                                },
                                children: props.showMoreTitle
                            }),
                            (0, $kyBEk$jsx)((0, $a7df98dc81165fd3$export$2e2bcd8739ae039), {
                                name: "arrowDownS",
                                color: "textSecondary"
                            })
                        ]
                    })
                })
            }) : null,
            !!isVisible ? (0, $kyBEk$jsx)((0, $kyBEk$Fragment), {
                children: (0, $kyBEk$jsx)((0, $7718944390218472$exports.default), {
                    justify: "center",
                    align: "flex-end",
                    className: $05e2d5a34ca80a28$export$b3e5e3e1ed7a551a,
                    children: (0, $kyBEk$jsxs)("div", {
                        onClick: function(event) {
                            var _a, _b;
                            toggle();
                            (_a = animationRef.current) === null || _a === void 0 || _a.reverse();
                            (_b = animationRef.current) === null || _b === void 0 || _b.play();
                        },
                        className: $05e2d5a34ca80a28$export$cb6c30b631422a13,
                        children: [
                            (0, $kyBEk$jsx)((0, $41ede47214de3bdb$exports.default), {
                                color: "textSecondary",
                                weight: "semibold",
                                attributes: {
                                    marginRight: "5"
                                },
                                children: props.showLessTitle
                            }),
                            (0, $kyBEk$jsx)((0, $a7df98dc81165fd3$export$2e2bcd8739ae039), {
                                name: "arrowUpS",
                                color: "textSecondary"
                            })
                        ]
                    })
                })
            }) : null
        ]
    });
}
$becba96142f0a79e$var$ShowMore.defaultProps = {
    initialHeightPercent: 0.5,
    showMoreTitle: "Show more",
    showLessTitle: "Show less"
};
var $becba96142f0a79e$export$2e2bcd8739ae039 = $becba96142f0a79e$var$ShowMore;










function $7f84db23fdb0c43f$var$I18nProvider(props) {
    var numberFormatterRef = (0, $kyBEk$useRef)(null);
    var formatNumberFnRef = (0, $kyBEk$useRef)(null);
    var initialCurrencyConfigRef = (0, $kyBEk$useRef)({
        currency: props.currency,
        currencySign: props.currencySign,
        useGrouping: props.useGrouping,
        minimumIntegerDigits: props.minimumIntegerDigits,
        minimumFractionDigits: props.minimumFractionDigits,
        maximumFractionDigits: props.maximumFractionDigits,
        minimumSignificantDigits: props.minimumSignificantDigits,
        maximumSignificantDigits: props.maximumSignificantDigits
    });
    (0, $kyBEk$useEffect)(function() {
        numberFormatterRef.current = (0, $b63aebbaf0c2c0b0$export$67198cb146c234dd)(props.locale, initialCurrencyConfigRef.current);
        formatNumberFnRef.current = function(subProps) {
            numberFormatterRef.current = (0, $b63aebbaf0c2c0b0$export$67198cb146c234dd)(props.locale, Object.assign(initialCurrencyConfigRef.current, {
                style: subProps.style
            }));
            return (0, $b63aebbaf0c2c0b0$export$54906d710afac876)(numberFormatterRef.current, new (0, $kyBEk$bignumberjs)(subProps.value));
        };
        (0, $65ee908e933b27be$export$6f57813fe9f31bf9).getState().setFormatNumberFn(formatNumberFnRef.current);
    }, []);
    return (0, $kyBEk$jsx)("div", {
        children: props.children
    });
}
var $7f84db23fdb0c43f$export$2e2bcd8739ae039 = $7f84db23fdb0c43f$var$I18nProvider;










var $bada9024288499a7$export$9338cf6ae76db7e8 = "_1palp115 _1palp114 gvc3qt2rp gvc3qt1t7";
var $bada9024288499a7$export$fb4e5e38aa0c29c2 = "_1palp116 _1palp114 gvc3qt2rp gvc3qt1t7";
var $bada9024288499a7$export$517d4726d56152f4 = "_1palp112 gvc3qt2z1 gvc3qt1t7 gvc3qt2c7";
var $bada9024288499a7$export$1100c59bcd9cefe1 = "_1palp114 gvc3qt2rp gvc3qt1t7";
var $bada9024288499a7$export$391771f774c7c6fc = "_1palp117";
var $bada9024288499a7$export$c9a65ec05dd9f0a2 = "_1palp11b";
var $bada9024288499a7$export$f07694b365dbf4a8 = "_1palp110";
var $bada9024288499a7$export$f041df5e2d098f58 = "gvc3qt2sa";


function $3a9b1dc339827865$var$PoolsHeader(props) {
    var _a, _b, _c, _d;
    return (0, $kyBEk$jsxs)((0, $c05182ab934fe0bd$exports.default), {
        className: $bada9024288499a7$export$f07694b365dbf4a8,
        children: [
            (0, $kyBEk$jsxs)((0, $7718944390218472$exports.default), {
                direction: "column",
                children: [
                    (0, $kyBEk$jsxs)((0, $41ede47214de3bdb$exports.default), {
                        size: "xl",
                        weight: "semibold",
                        children: [
                            props.token1.name,
                            "/",
                            props.token2.name
                        ]
                    }),
                    (0, $kyBEk$jsxs)((0, $41ede47214de3bdb$exports.default), {
                        color: "textSecondary",
                        attributes: {
                            marginTop: "3",
                            marginBottom: "13"
                        },
                        children: [
                            "Pool #",
                            props.id
                        ]
                    })
                ]
            }),
            (0, $kyBEk$jsxs)((0, $7718944390218472$exports.default), {
                flexWrap: "wrap",
                align: "center",
                children: [
                    (0, $kyBEk$jsxs)((0, $c05182ab934fe0bd$exports.default), {
                        className: $bada9024288499a7$export$517d4726d56152f4,
                        children: [
                            (0, $kyBEk$jsx)("img", {
                                src: props.token1.imgSrc,
                                className: $bada9024288499a7$export$9338cf6ae76db7e8
                            }),
                            (0, $kyBEk$jsx)("img", {
                                src: props.token2.imgSrc,
                                className: $bada9024288499a7$export$fb4e5e38aa0c29c2
                            })
                        ]
                    }),
                    (0, $kyBEk$jsxs)((0, $7718944390218472$exports.default), {
                        direction: "column",
                        className: $bada9024288499a7$export$391771f774c7c6fc,
                        children: [
                            (0, $kyBEk$jsx)((0, $41ede47214de3bdb$exports.default), {
                                color: "textSecondary",
                                children: "Pool liquidity"
                            }),
                            (0, $kyBEk$jsxs)((0, $7718944390218472$exports.default), {
                                align: "baseline",
                                children: [
                                    (0, $kyBEk$jsx)((0, $41ede47214de3bdb$exports.default), {
                                        attributes: {
                                            marginRight: "1"
                                        },
                                        children: "$"
                                    }),
                                    (0, $kyBEk$jsx)((0, $41ede47214de3bdb$exports.default), {
                                        size: "4xl",
                                        weight: "semibold",
                                        children: (_b = (_a = (0, $65ee908e933b27be$export$6f57813fe9f31bf9).getState()) === null || _a === void 0 ? void 0 : _a.formatNumber) === null || _b === void 0 ? void 0 : _b.call(_a, {
                                            value: props.poolLiquidity
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    (0, $kyBEk$jsx)((0, $c05182ab934fe0bd$exports.default), {
                        width: "full",
                        height: "8",
                        className: $bada9024288499a7$export$c9a65ec05dd9f0a2
                    }),
                    (0, $kyBEk$jsxs)((0, $7718944390218472$exports.default), {
                        direction: "column",
                        className: $bada9024288499a7$export$f041df5e2d098f58,
                        children: [
                            (0, $kyBEk$jsx)((0, $41ede47214de3bdb$exports.default), {
                                color: "textSecondary",
                                children: "Swap fee"
                            }),
                            (0, $kyBEk$jsxs)((0, $7718944390218472$exports.default), {
                                align: "baseline",
                                children: [
                                    (0, $kyBEk$jsx)((0, $41ede47214de3bdb$exports.default), {
                                        size: "4xl",
                                        weight: "semibold",
                                        children: props.swapFee
                                    }),
                                    (0, $kyBEk$jsx)((0, $41ede47214de3bdb$exports.default), {
                                        children: "%"
                                    })
                                ]
                            })
                        ]
                    }),
                    (0, $kyBEk$jsxs)((0, $7718944390218472$exports.default), {
                        direction: "column",
                        className: $bada9024288499a7$export$391771f774c7c6fc,
                        children: [
                            (0, $kyBEk$jsx)((0, $41ede47214de3bdb$exports.default), {
                                color: "textSecondary",
                                children: "24h trading volume"
                            }),
                            (0, $kyBEk$jsxs)((0, $7718944390218472$exports.default), {
                                align: "baseline",
                                children: [
                                    (0, $kyBEk$jsx)((0, $41ede47214de3bdb$exports.default), {
                                        attributes: {
                                            marginRight: "1"
                                        },
                                        children: "$"
                                    }),
                                    (0, $kyBEk$jsx)((0, $41ede47214de3bdb$exports.default), {
                                        size: "4xl",
                                        weight: "semibold",
                                        children: (_d = (_c = (0, $65ee908e933b27be$export$6f57813fe9f31bf9).getState()) === null || _c === void 0 ? void 0 : _c.formatNumber) === null || _d === void 0 ? void 0 : _d.call(_c, {
                                            value: props.volume24H
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
var $3a9b1dc339827865$export$2e2bcd8739ae039 = $3a9b1dc339827865$var$PoolsHeader;












var $48bdf3dd57805943$export$34e0f9847d4c02dd = "_17jactu1 gvc3qt3ba gvc3qt384 gvc3qt31m gvc3qt34s";
var $48bdf3dd57805943$export$5c452ff88e35e47d = "gvc3qt2r7 gvc3qt1sp";
var $48bdf3dd57805943$export$4e537741c1f4b599 = "gvc3qt2c1";
var $48bdf3dd57805943$export$2283fef97d17a10b = "_17jactu4";


function $877b6ae87e46e23d$var$ManageLiquidityCard(props) {
    var cleanupRef = (0, $kyBEk$useRef)(null);
    var _a = (0, $kyBEk$useState)(function() {
        return "light";
    }), theme = _a[0], setTheme = _a[1];
    (0, $kyBEk$useEffect)(function() {
        setTheme((0, $65ee908e933b27be$export$6f57813fe9f31bf9).getState().theme);
        cleanupRef.current = (0, $65ee908e933b27be$export$6f57813fe9f31bf9).subscribe(function(newState) {
            setTheme(newState.theme);
        });
    }, []);
    (0, $kyBEk$useEffect)(function() {
        return function() {
            if (typeof cleanupRef.current === "function") cleanupRef.current();
        };
    }, []);
    return (0, $kyBEk$jsxs)((0, $7718944390218472$exports.default), {
        align: "flex-end",
        flexWrap: "wrap",
        attributes: {
            marginTop: "16",
            marginBottom: "10",
            borderRadius: "lg"
        },
        className: $48bdf3dd57805943$export$34e0f9847d4c02dd,
        children: [
            (0, $kyBEk$jsxs)((0, $7718944390218472$exports.default), {
                direction: "column",
                className: $48bdf3dd57805943$export$4e537741c1f4b599,
                children: [
                    (0, $kyBEk$jsx)((0, $41ede47214de3bdb$exports.default), {
                        color: "textSecondary",
                        weight: "semibold",
                        children: "Your pool balance"
                    }),
                    (0, $kyBEk$jsxs)((0, $7718944390218472$exports.default), {
                        align: "baseline",
                        attributes: {
                            my: "2"
                        },
                        children: [
                            (0, $kyBEk$jsx)((0, $41ede47214de3bdb$exports.default), {
                                weight: "semibold",
                                attributes: {
                                    marginRight: "1"
                                },
                                children: "$"
                            }),
                            (0, $kyBEk$jsx)((0, $41ede47214de3bdb$exports.default), {
                                size: "4xl",
                                weight: "semibold",
                                children: props.pollBalance
                            })
                        ]
                    }),
                    (0, $kyBEk$jsx)((0, $41ede47214de3bdb$exports.default), {
                        children: "No pool shares yet"
                    }),
                    (0, $kyBEk$jsx)((0, $6aa42b028ae27f6d$exports.default), {
                        intent: "tertiary",
                        attributes: {
                            marginTop: "11"
                        },
                        children: "Add Liquidity"
                    })
                ]
            }),
            (0, $kyBEk$jsxs)((0, $7718944390218472$exports.default), {
                direction: "column",
                align: "flex-end",
                children: [
                    (0, $kyBEk$jsxs)((0, $7718944390218472$exports.default), {
                        children: [
                            (0, $kyBEk$jsx)("img", {
                                src: props.token1.imgSrc,
                                className: $48bdf3dd57805943$export$5c452ff88e35e47d
                            }),
                            (0, $kyBEk$jsx)((0, $41ede47214de3bdb$exports.default), {
                                color: "textSecondary",
                                weight: "semibold",
                                attributes: {
                                    px: "4"
                                },
                                children: props.token1.asset
                            }),
                            (0, $kyBEk$jsx)((0, $41ede47214de3bdb$exports.default), {
                                color: "textSecondary",
                                children: props.token1.name
                            })
                        ]
                    }),
                    (0, $kyBEk$jsx)((0, $c05182ab934fe0bd$exports.default), {
                        height: "5"
                    }),
                    (0, $kyBEk$jsxs)((0, $7718944390218472$exports.default), {
                        children: [
                            (0, $kyBEk$jsx)("img", {
                                src: props.token2.imgSrc,
                                className: $48bdf3dd57805943$export$5c452ff88e35e47d
                            }),
                            (0, $kyBEk$jsx)((0, $41ede47214de3bdb$exports.default), {
                                color: "textSecondary",
                                weight: "semibold",
                                attributes: {
                                    px: "4"
                                },
                                children: props.token2.asset
                            }),
                            (0, $kyBEk$jsx)((0, $41ede47214de3bdb$exports.default), {
                                color: "textSecondary",
                                children: props.token2.name
                            })
                        ]
                    }),
                    (0, $kyBEk$jsx)((0, $6aa42b028ae27f6d$exports.default), {
                        intent: "tertiary",
                        variant: "outlined",
                        attributes: {
                            marginTop: "11"
                        },
                        children: "Remove Liquidity"
                    })
                ]
            }),
            (0, $kyBEk$jsxs)((0, $7718944390218472$exports.default), {
                direction: "column",
                className: $48bdf3dd57805943$export$2283fef97d17a10b,
                children: [
                    (0, $kyBEk$jsx)((0, $41ede47214de3bdb$exports.default), {
                        color: "textSecondary",
                        weight: "semibold",
                        children: "Available LP Tokens"
                    }),
                    (0, $kyBEk$jsxs)((0, $7718944390218472$exports.default), {
                        align: "baseline",
                        children: [
                            (0, $kyBEk$jsx)((0, $41ede47214de3bdb$exports.default), {
                                weight: "semibold",
                                attributes: {
                                    marginRight: "1"
                                },
                                children: "$"
                            }),
                            (0, $kyBEk$jsx)((0, $41ede47214de3bdb$exports.default), {
                                size: "4xl",
                                weight: "semibold",
                                children: props.lpTokens
                            })
                        ]
                    }),
                    (0, $kyBEk$jsx)((0, $41ede47214de3bdb$exports.default), {
                        children: "No pool shares yet"
                    }),
                    (0, $kyBEk$jsx)((0, $6aa42b028ae27f6d$exports.default), {
                        intent: "tertiary",
                        variant: "outlined",
                        attributes: {
                            marginTop: "11"
                        },
                        children: "Start earning"
                    })
                ]
            })
        ]
    });
}
var $877b6ae87e46e23d$export$2e2bcd8739ae039 = $877b6ae87e46e23d$var$ManageLiquidityCard;









var $6a38430da26ee6db$export$34e0f9847d4c02dd = "_1j3p3fo1 gvc3qt2w1";


function $17bb0f000238f803$var$BondingCard(props) {
    return (0, $kyBEk$jsx)((0, $c05182ab934fe0bd$exports.default), {
        p: "9",
        borderRadius: "lg",
        backgroundColor: "cardBg",
        className: $6a38430da26ee6db$export$34e0f9847d4c02dd,
        children: (0, $kyBEk$jsxs)((0, $7718944390218472$exports.default), {
            direction: "column",
            justify: "center",
            children: [
                (0, $kyBEk$jsx)((0, $41ede47214de3bdb$exports.default), {
                    size: "2xl",
                    weight: "semibold",
                    attributes: {
                        marginBottom: "3"
                    },
                    children: props.title
                }),
                (0, $kyBEk$jsx)((0, $41ede47214de3bdb$exports.default), {
                    children: props.value
                })
            ]
        })
    });
}
var $17bb0f000238f803$export$2e2bcd8739ae039 = $17bb0f000238f803$var$BondingCard;









function $a80ba355bd2ee3fc$var$PoolCardList(props) {
    var _a;
    return (0, $kyBEk$jsx)((0, $c05182ab934fe0bd$exports.default), {
        children: (0, $kyBEk$jsx)((0, $7718944390218472$exports.default), {
            space: "10",
            flexWrap: "nowrap",
            children: (_a = props.list) === null || _a === void 0 ? void 0 : _a.map(function(item, index) {
                return (0, $kyBEk$jsx)((0, $c05182ab934fe0bd$exports.default), {
                    width: "1/3",
                    children: (0, $kyBEk$jsx)((0, $17bb0f000238f803$export$2e2bcd8739ae039), {
                        title: item.title,
                        value: item.value
                    })
                }, item.title);
            })
        })
    });
}
var $a80ba355bd2ee3fc$export$2e2bcd8739ae039 = $a80ba355bd2ee3fc$var$PoolCardList;









var $47f6fc76255cd662$export$7061c75fc5af8b7e = "_8r8o540";
var $47f6fc76255cd662$export$517d57201a3624d1 = "_8r8o541";


function $3ae8aa3fba6759b4$var$BondingListItem(props) {
    return (0, $kyBEk$jsxs)((0, $7718944390218472$exports.default), {
        align: "center",
        children: [
            (0, $kyBEk$jsx)((0, $41ede47214de3bdb$exports.default), {
                color: "textSecondary",
                weight: "semibold",
                size: "xs",
                className: $47f6fc76255cd662$export$7061c75fc5af8b7e,
                children: props.title
            }),
            (0, $kyBEk$jsx)((0, $41ede47214de3bdb$exports.default), {
                color: "textSecondary",
                size: "xs",
                className: $47f6fc76255cd662$export$7061c75fc5af8b7e,
                children: props.apr
            }),
            (0, $kyBEk$jsx)((0, $41ede47214de3bdb$exports.default), {
                color: "textSecondary",
                size: "xs",
                className: $47f6fc76255cd662$export$7061c75fc5af8b7e,
                children: props.amount
            }),
            (0, $kyBEk$jsx)((0, $41ede47214de3bdb$exports.default), {
                color: "textSecondary",
                size: "xs",
                className: $47f6fc76255cd662$export$7061c75fc5af8b7e,
                children: props.per
            }),
            (0, $kyBEk$jsx)((0, $6aa42b028ae27f6d$exports.default), {
                size: "xs",
                variant: "unstyled",
                onClick: function(e) {
                    return props.onUnbond(e);
                },
                children: "Unbond All"
            })
        ]
    });
}
var $3ae8aa3fba6759b4$export$2e2bcd8739ae039 = $3ae8aa3fba6759b4$var$BondingListItem;









function $17b87c5e14580680$var$BondingList(props) {
    var _a;
    return (0, $kyBEk$jsx)((0, $c05182ab934fe0bd$exports.default), {
        children: (0, $kyBEk$jsx)((0, $7718944390218472$exports.default), {
            direction: "column",
            space: "10",
            children: (_a = props.list) === null || _a === void 0 ? void 0 : _a.map(function(item, index) {
                return (0, $kyBEk$jsx)((0, $3ae8aa3fba6759b4$export$2e2bcd8739ae039), {
                    title: item.title,
                    apr: item.apr,
                    amount: item.amount,
                    per: item.per,
                    onUnbond: function(e) {
                        var _a;
                        return (_a = item.onUnbond) === null || _a === void 0 ? void 0 : _a.call(item, e);
                    }
                }, item.title);
            })
        })
    });
}
var $17b87c5e14580680$export$2e2bcd8739ae039 = $17b87c5e14580680$var$BondingList;










var $e58f75916f72adc8$export$34e0f9847d4c02dd = "_5zn49q0";


function $2699fc59945b7af0$var$BondingListItemSm(props) {
    return (0, $kyBEk$jsx)((0, $c05182ab934fe0bd$exports.default), {
        px: "8",
        py: "10",
        backgroundColor: "cardBg",
        borderRadius: "lg",
        className: $e58f75916f72adc8$export$34e0f9847d4c02dd,
        children: (0, $kyBEk$jsxs)((0, $7718944390218472$exports.default), {
            justify: "space-between",
            children: [
                (0, $kyBEk$jsxs)((0, $7718944390218472$exports.default), {
                    direction: "column",
                    children: [
                        (0, $kyBEk$jsx)((0, $41ede47214de3bdb$exports.default), {
                            color: "textSecondary",
                            weight: "semibold",
                            children: props.title
                        }),
                        (0, $kyBEk$jsxs)((0, $7718944390218472$exports.default), {
                            align: "baseline",
                            attributes: {
                                marginTop: "3",
                                marginBottom: "9"
                            },
                            children: [
                                (0, $kyBEk$jsx)((0, $41ede47214de3bdb$exports.default), {
                                    color: "textSecondary",
                                    weight: "semibold",
                                    attributes: {
                                        marginRight: "5"
                                    },
                                    children: "APR"
                                }),
                                (0, $kyBEk$jsx)((0, $41ede47214de3bdb$exports.default), {
                                    size: "4xl",
                                    color: "textSecondary",
                                    weight: "semibold",
                                    attributes: {
                                        marginRight: "3"
                                    },
                                    children: props.apr
                                }),
                                (0, $kyBEk$jsx)((0, $41ede47214de3bdb$exports.default), {
                                    color: "textSecondary",
                                    weight: "semibold",
                                    children: "%"
                                })
                            ]
                        }),
                        (0, $kyBEk$jsx)((0, $6aa42b028ae27f6d$exports.default), {
                            size: "sm",
                            intent: "tertiary",
                            variant: "outlined",
                            children: "Unbond"
                        })
                    ]
                }),
                (0, $kyBEk$jsxs)((0, $7718944390218472$exports.default), {
                    direction: "column",
                    children: [
                        (0, $kyBEk$jsxs)((0, $7718944390218472$exports.default), {
                            align: "baseline",
                            children: [
                                (0, $kyBEk$jsx)((0, $41ede47214de3bdb$exports.default), {
                                    weight: "semibold",
                                    attributes: {
                                        marginRight: "1"
                                    },
                                    children: "$"
                                }),
                                (0, $kyBEk$jsx)((0, $41ede47214de3bdb$exports.default), {
                                    weight: "semibold",
                                    size: "4xl",
                                    children: props.amount
                                })
                            ]
                        }),
                        (0, $kyBEk$jsxs)((0, $7718944390218472$exports.default), {
                            attributes: {
                                marginTop: "3",
                                marginBottom: "9"
                            },
                            children: [
                                (0, $kyBEk$jsxs)((0, $41ede47214de3bdb$exports.default), {
                                    weight: "semibold",
                                    children: [
                                        props.poolShares,
                                        "\xa0"
                                    ]
                                }),
                                (0, $kyBEk$jsx)((0, $41ede47214de3bdb$exports.default), {
                                    children: "pool shares"
                                })
                            ]
                        }),
                        (0, $kyBEk$jsx)((0, $6aa42b028ae27f6d$exports.default), {
                            size: "sm",
                            intent: "tertiary",
                            children: "Bond more"
                        })
                    ]
                })
            ]
        })
    });
}
var $2699fc59945b7af0$export$2e2bcd8739ae039 = $2699fc59945b7af0$var$BondingListItemSm;










function $5429ef3689137234$var$BondingListSm(props) {
    var _a;
    return (0, $kyBEk$jsxs)((0, $c05182ab934fe0bd$exports.default), {
        width: "full",
        children: [
            (0, $kyBEk$jsx)((0, $41ede47214de3bdb$exports.default), {
                size: "xl",
                weight: "semibold",
                children: "Bond your liquidity"
            }),
            (0, $kyBEk$jsx)((0, $41ede47214de3bdb$exports.default), {
                attributes: {
                    marginTop: "2"
                },
                children: "Bond your tokens to earn additional OSMO rewards to the swap fees."
            }),
            (0, $kyBEk$jsx)((0, $41ede47214de3bdb$exports.default), {
                color: "textSecondary",
                weight: "semibold",
                attributes: {
                    marginTop: "10"
                },
                children: "Unbonded"
            }),
            (0, $kyBEk$jsx)((0, $41ede47214de3bdb$exports.default), {
                size: "4xl",
                weight: "semibold",
                attributes: {
                    my: "2"
                },
                children: props.unbondedAmt
            }),
            (0, $kyBEk$jsxs)((0, $7718944390218472$exports.default), {
                attributes: {
                    marginBottom: "9"
                },
                children: [
                    (0, $kyBEk$jsx)((0, $41ede47214de3bdb$exports.default), {
                        weight: "semibold",
                        children: props.unbondedShares
                    }),
                    (0, $kyBEk$jsx)((0, $41ede47214de3bdb$exports.default), {
                        children: "\xa0 pool shares"
                    })
                ]
            }),
            (0, $kyBEk$jsx)((0, $7718944390218472$exports.default), {
                space: "10",
                direction: "column",
                children: (_a = props.list) === null || _a === void 0 ? void 0 : _a.map(function(item, index) {
                    return (0, $kyBEk$jsx)((0, $2699fc59945b7af0$export$2e2bcd8739ae039), {
                        title: item.title,
                        amount: item.amount,
                        poolShares: item.poolShares,
                        apr: item.apr
                    }, item.title);
                })
            })
        ]
    });
}
var $5429ef3689137234$export$2e2bcd8739ae039 = $5429ef3689137234$var$BondingListSm;











var $c37139ac7341f6c8$export$e8d14c98483cff38 = "v7c6b60";
var $c37139ac7341f6c8$export$b9c7df6d21cb7f56 = "v7c6b61";
var $c37139ac7341f6c8$export$5ce0f3e73495726d = "v7c6b62";


function $2fc58d3899360766$var$BondingArea(props) {
    return (0, $kyBEk$jsxs)((0, $c05182ab934fe0bd$exports.default), {
        width: "full",
        className: $c37139ac7341f6c8$export$e8d14c98483cff38,
        children: [
            (0, $kyBEk$jsxs)((0, $7718944390218472$exports.default), {
                direction: "column",
                className: $c37139ac7341f6c8$export$b9c7df6d21cb7f56,
                children: [
                    (0, $kyBEk$jsx)((0, $a80ba355bd2ee3fc$export$2e2bcd8739ae039), {
                        list: props.bondingCardList
                    }),
                    (0, $kyBEk$jsx)((0, $c05182ab934fe0bd$exports.default), {
                        height: "14"
                    }),
                    (0, $kyBEk$jsx)((0, $17b87c5e14580680$export$2e2bcd8739ae039), {
                        list: props.bondingList
                    })
                ]
            }),
            (0, $kyBEk$jsx)((0, $c05182ab934fe0bd$exports.default), {
                className: $c37139ac7341f6c8$export$5ce0f3e73495726d,
                children: (0, $kyBEk$jsx)((0, $5429ef3689137234$export$2e2bcd8739ae039), {
                    list: props.bondingListSm.list,
                    unbondedAmt: props.bondingListSm.unbondedAmt,
                    unbondedShares: props.bondingListSm.unbondedShares
                })
            })
        ]
    });
}
var $2fc58d3899360766$export$2e2bcd8739ae039 = $2fc58d3899360766$var$BondingArea;











var $7e77dc045b1db17b$export$34e0f9847d4c02dd = "_12i279p0";
var $7e77dc045b1db17b$export$2077e0241d6afd3c = {
    true: "_12i279p1"
};
var $7e77dc045b1db17b$export$2f0084313b87d4cc = (0, $kyBEk$createRuntimeFn)({
    defaultClassName: "",
    variantClassNames: {
        round: {
            true: "_12i279p1"
        }
    },
    defaultVariants: {},
    compoundVariants: []
});


function $a6a228fbeba47621$var$IconButton(props) {
    return (0, $kyBEk$jsx)((0, $6aa42b028ae27f6d$exports.default), {
        variant: props.variant,
        intent: props.intent,
        size: props.size,
        disabled: props.disabled,
        onClick: function(e) {
            var _a;
            return (_a = props.onClick) === null || _a === void 0 ? void 0 : _a.call(props, e);
        },
        className: (0, $kyBEk$clsx)($7e77dc045b1db17b$export$34e0f9847d4c02dd, $7e77dc045b1db17b$export$2f0084313b87d4cc({
            round: props.isRound ? true : undefined
        })),
        children: (0, $kyBEk$jsx)((0, $a7df98dc81165fd3$export$2e2bcd8739ae039), {
            name: props.icon,
            size: props.iconSize
        })
    });
}
var $a6a228fbeba47621$export$2e2bcd8739ae039 = $a6a228fbeba47621$var$IconButton;








var $715d15ba79217f6a$export$d02631cccf789723 = "_1xur4vf1 gvc3qt1s7 gvc3qtx gvc3qthl gvc3qthm";


function $3cb3fe3af8a37fe1$var$ProgressBar(props) {
    var inputRef = (0, $kyBEk$useRef)(null);
    (0, $kyBEk$useEffect)(function() {
        inputRef.current.style.backgroundSize = "".concat(props.progress, "% 100%");
    }, []);
    (0, $kyBEk$useEffect)(function() {
        inputRef.current.style.backgroundSize = "".concat(props.progress, "% 100%");
    }, [
        props.progress
    ]);
    return (0, $kyBEk$jsx)((0, $c05182ab934fe0bd$exports.default), {
        "aria-valuemax": 100,
        "aria-valuemin": 0,
        children: (0, $kyBEk$jsx)("input", {
            type: "range",
            min: "0",
            max: "100",
            ref: inputRef,
            onChange: function(e) {
                var min = Number(e.target.min);
                var max = Number(e.target.max);
                var val = Number(e.target.value);
                var result = (val - min) * 100 / (max - min);
                e.target.style.backgroundSize = "".concat(result, "% 100%");
                props.onProgressChange(result);
            },
            value: props.progress,
            className: $715d15ba79217f6a$export$d02631cccf789723
        })
    });
}
var $3cb3fe3af8a37fe1$export$2e2bcd8739ae039 = $3cb3fe3af8a37fe1$var$ProgressBar;









var $75a0ca91b87531fb$export$e1d786d2f707b414 = "joscth0";
var $75a0ca91b87531fb$export$34e0f9847d4c02dd = "joscth2";
var $75a0ca91b87531fb$export$450ab5be2daeefa8 = "joscth1";
var $75a0ca91b87531fb$export$5f5ea6773321f799 = "joscth3";


function $0383195aac1b1cc7$var$CicularProgressBar(props) {
    var _a = (0, $kyBEk$useState)(function() {
        return 0;
    }), strokeWidth = _a[0], setStrokeWidth = _a[1];
    var _b = (0, $kyBEk$useState)(function() {
        return 0;
    }), radius = _b[0], setRadius = _b[1];
    var _c = (0, $kyBEk$useState)(function() {
        return 0;
    }), circumference = _c[0], setCircumference = _c[1];
    var _d = (0, $kyBEk$useState)(function() {
        return 0;
    }), offset = _d[0], setOffset = _d[1];
    (0, $kyBEk$useEffect)(function() {
        var _strokeWidth = 4;
        var _radius = props.width / 2;
        var _circumference = _radius * 2 * Math.PI;
        var _offset = _circumference - props.progress / 100 * _circumference;
        setStrokeWidth(_strokeWidth);
        setRadius(_radius);
        setCircumference(_circumference);
        setOffset(_offset);
    }, []);
    (0, $kyBEk$useEffect)(function() {
        var updatedOffset = circumference - props.progress / 100 * circumference;
        setOffset(updatedOffset);
    }, [
        props.progress,
        circumference
    ]);
    return (0, $kyBEk$jsxs)("div", {
        style: {
            width: "".concat(props.width, "px"),
            height: "".concat(props.width, "px")
        },
        className: $75a0ca91b87531fb$export$34e0f9847d4c02dd,
        children: [
            (0, $kyBEk$jsxs)("svg", {
                role: "progressbar",
                viewBox: "0 0 100 100",
                version: "1.1",
                xmlns: "http://www.w3.org/2000/svg",
                "aria-valuemax": 100,
                "aria-valuemin": 0,
                height: props.width,
                width: props.width,
                children: [
                    (0, $kyBEk$jsx)("circle", {
                        cx: "50",
                        cy: "50",
                        r: radius,
                        "stroke-width": strokeWidth,
                        className: $75a0ca91b87531fb$export$e1d786d2f707b414
                    }),
                    (0, $kyBEk$jsx)("circle", {
                        cx: "50",
                        cy: "50",
                        "data-testid": "progress-bar-bar",
                        r: radius,
                        "stroke-dasharray": "".concat(circumference, " ").concat(circumference),
                        "stroke-dashoffset": offset,
                        "stroke-width": strokeWidth,
                        className: $75a0ca91b87531fb$export$450ab5be2daeefa8
                    })
                ]
            }),
            (0, $kyBEk$jsx)((0, $7718944390218472$exports.default), {
                align: "center",
                justify: "center",
                className: $75a0ca91b87531fb$export$5f5ea6773321f799,
                children: (0, $kyBEk$jsxs)((0, $41ede47214de3bdb$exports.default), {
                    size: "lg",
                    weight: "semibold",
                    children: [
                        props.progress,
                        "%"
                    ]
                })
            })
        ]
    });
}
$0383195aac1b1cc7$var$CicularProgressBar.defaultProps = {
    width: 80
};
var $0383195aac1b1cc7$export$2e2bcd8739ae039 = $0383195aac1b1cc7$var$CicularProgressBar;












var $1a9a29c94baa8fd8$export$1650b576171e13c6 = "gvc3qt3ds gvc3qt1up gvc3qt3ev";
var $1a9a29c94baa8fd8$export$6a86c20f56035829 = "gvc3qt2";
var $1a9a29c94baa8fd8$export$683472f6198a076e = "_1rzl9dke";
var $1a9a29c94baa8fd8$export$1ca1ec8b29a4ce27 = "gvc3qt2rm gvc3qt1t4 gvc3qtu gvc3qthl gvc3qthm gvc3qt28a gvc3qt1hv gvc3qt1yp gvc3qt177 gvc3qt1k";
var $1a9a29c94baa8fd8$export$b4173b61fac0c4b8 = "_1rzl9dk2";
var $1a9a29c94baa8fd8$export$463b44d9bf3628be = "gvc3qt2rp gvc3qt1t7";
var $1a9a29c94baa8fd8$export$a4988d9b36ebee35 = "_1rzl9dk8 gvc3qt2s1 gvc3qt1up gvc3qtv1 gvc3qtv2";
var $1a9a29c94baa8fd8$export$1d6e32fec5a4f082 = "_1rzl9dk6 gvc3qtv1 gvc3qtv2 gvc3qtv gvc3qthl gvc3qthm gvc3qt3dy";
var $1a9a29c94baa8fd8$export$ff07aafb46fd866b = "_1rzl9dkf";
var $1a9a29c94baa8fd8$export$2612087cf48ded35 = "_1rzl9dk1 gvc3qt2c7";
var $1a9a29c94baa8fd8$export$9e1725a4cfeada27 = "_1rzl9dkb gvc3qt2t7 gvc3qthl gvc3qthm gvc3qtw";


function $cf5bbf0f1742e4cc$var$TokenInput(props) {
    var _a, _b;
    var _c = (0, $kyBEk$useState)(function() {
        return "";
    }), symbolValue = _c[0], setSymbolValue = _c[1];
    var _d = (0, $kyBEk$useState)(function() {
        return false;
    }), disabled = _d[0], setDisabled = _d[1];
    function handleTokenInput(e) {
        setSymbolValue(e.target.value);
        props.onAmountChange(e.target.value);
    }
    function handleIconClick(e) {
        var newProgress = 0;
        if (props.progress === 50) newProgress = 0;
        else newProgress = 50;
        props.onProgressChange(newProgress);
    }
    (0, $kyBEk$useEffect)(function() {
        if (props.progress === 0) setDisabled(true);
        else setDisabled(false);
    }, [
        props.progress
    ]);
    return (0, $kyBEk$jsxs)((0, $7718944390218472$exports.default), {
        flexWrap: "wrap",
        align: "center",
        children: [
            (0, $kyBEk$jsxs)((0, $7718944390218472$exports.default), {
                justify: "flex-end",
                attributes: {
                    width: "full",
                    marginBottom: "7"
                },
                className: (0, $kyBEk$clsx)((_a = {}, _a[$1a9a29c94baa8fd8$export$683472f6198a076e] = disabled, _a)),
                children: [
                    !props.hasProgressBar ? (0, $kyBEk$jsx)((0, $kyBEk$Fragment), {
                        children: (0, $kyBEk$jsx)((0, $41ede47214de3bdb$exports.default), {
                            color: "textSecondary",
                            weight: "semibold",
                            size: "lg",
                            className: $1a9a29c94baa8fd8$export$ff07aafb46fd866b,
                            children: "Select amount"
                        })
                    }) : null,
                    (0, $kyBEk$jsx)((0, $41ede47214de3bdb$exports.default), {
                        color: "textSecondary",
                        children: "Available\xa0"
                    }),
                    (0, $kyBEk$jsx)((0, $41ede47214de3bdb$exports.default), {
                        color: "textSecondary",
                        weight: "semibold",
                        children: props.available
                    }),
                    (0, $kyBEk$jsx)((0, $41ede47214de3bdb$exports.default), {
                        color: "textSecondary",
                        weight: "semibold",
                        children: props.symbol
                    })
                ]
            }),
            props.hasProgressBar ? (0, $kyBEk$jsx)((0, $kyBEk$Fragment), {
                children: (0, $kyBEk$jsxs)((0, $7718944390218472$exports.default), {
                    align: "center",
                    className: $1a9a29c94baa8fd8$export$2612087cf48ded35,
                    children: [
                        (0, $kyBEk$jsx)((0, $0383195aac1b1cc7$export$2e2bcd8739ae039), {
                            progress: props.progress
                        }),
                        (0, $kyBEk$jsxs)((0, $7718944390218472$exports.default), {
                            align: "center",
                            className: $1a9a29c94baa8fd8$export$b4173b61fac0c4b8,
                            children: [
                                (0, $kyBEk$jsxs)((0, $7718944390218472$exports.default), {
                                    direction: "column",
                                    justify: "center",
                                    attributes: {
                                        marginLeft: "8",
                                        width: "17"
                                    },
                                    children: [
                                        (0, $kyBEk$jsx)((0, $41ede47214de3bdb$exports.default), {
                                            weight: "semibold",
                                            children: props.symbol
                                        }),
                                        (0, $kyBEk$jsx)((0, $41ede47214de3bdb$exports.default), {
                                            color: "textSecondary",
                                            size: "xs",
                                            children: props.denom
                                        })
                                    ]
                                }),
                                (0, $kyBEk$jsxs)("div", {
                                    onClick: function(e) {
                                        return handleIconClick(e);
                                    },
                                    className: $1a9a29c94baa8fd8$export$1ca1ec8b29a4ce27,
                                    children: [
                                        props.progress === 0 ? (0, $kyBEk$jsx)((0, $kyBEk$Fragment), {
                                            children: (0, $kyBEk$jsx)((0, $a7df98dc81165fd3$export$2e2bcd8739ae039), {
                                                name: "add",
                                                color: "text",
                                                size: "3xl"
                                            })
                                        }) : null,
                                        props.progress === 50 ? (0, $kyBEk$jsx)((0, $kyBEk$Fragment), {
                                            children: (0, $kyBEk$jsx)((0, $a7df98dc81165fd3$export$2e2bcd8739ae039), {
                                                name: "subtract",
                                                color: "text",
                                                size: "3xl"
                                            })
                                        }) : null
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }) : null,
            (0, $kyBEk$jsxs)((0, $7718944390218472$exports.default), {
                className: (0, $kyBEk$clsx)($1a9a29c94baa8fd8$export$1d6e32fec5a4f082, (_b = {}, _b[$1a9a29c94baa8fd8$export$683472f6198a076e] = disabled, _b)),
                children: [
                    (0, $kyBEk$jsx)((0, $7718944390218472$exports.default), {
                        justify: "center",
                        align: "center",
                        className: $1a9a29c94baa8fd8$export$a4988d9b36ebee35,
                        children: (0, $kyBEk$jsx)("img", {
                            src: props.imgSrc,
                            className: $1a9a29c94baa8fd8$export$463b44d9bf3628be
                        })
                    }),
                    (0, $kyBEk$jsx)("input", {
                        value: props.amount,
                        disabled: disabled,
                        onChange: function(e) {
                            return handleTokenInput(e);
                        },
                        className: $1a9a29c94baa8fd8$export$9e1725a4cfeada27
                    }),
                    (0, $kyBEk$jsxs)((0, $7718944390218472$exports.default), {
                        justify: "flex-end",
                        align: "center",
                        className: $1a9a29c94baa8fd8$export$1650b576171e13c6,
                        children: [
                            (0, $kyBEk$jsx)((0, $41ede47214de3bdb$exports.default), {
                                weight: "semibold",
                                children: props.symbol
                            }),
                            (0, $kyBEk$jsxs)((0, $41ede47214de3bdb$exports.default), {
                                color: "textSecondary",
                                children: [
                                    "≈ $",
                                    symbolValue
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
$cf5bbf0f1742e4cc$var$TokenInput.defaultProps = {
    hasProgressBar: true
};
var $cf5bbf0f1742e4cc$export$2e2bcd8739ae039 = $cf5bbf0f1742e4cc$var$TokenInput;











function $2dd8484f3d9d6bc0$var$AddLiquidity(props) {
    var _a = (0, $kyBEk$useState)(function() {
        return 50;
    }), progress1 = _a[0], setProgress1 = _a[1];
    var _b = (0, $kyBEk$useState)(function() {
        return 50;
    }), progress2 = _b[0], setProgress2 = _b[1];
    var _c = (0, $kyBEk$useState)(function() {
        return "";
    }), amount1 = _c[0], setAmount1 = _c[1];
    var _d = (0, $kyBEk$useState)(function() {
        return "";
    }), amount2 = _d[0], setAmount2 = _d[1];
    var _e = (0, $kyBEk$useState)(function() {
        return "Amount is empty";
    }), btnText = _e[0], setBtnText = _e[1];
    var _f = (0, $kyBEk$useState)(function() {
        return false;
    }), disabled = _f[0], setDisabled = _f[1];
    function handleProgress1Change(progress) {
        setProgress1(progress);
        setProgress2(100 - progress);
    }
    function handleProgress2Change(progress) {
        setProgress2(progress);
        setProgress1(100 - progress);
    }
    function handleAmoount1Change(value) {
        setAmount1(value);
        if (progress1 === 50) setAmount2(value);
    }
    function handleAmoount2Change(value) {
        setAmount2(value);
        if (progress2 === 50) setAmount1(value);
    }
    (0, $kyBEk$useEffect)(function() {
        if (amount1 && amount2) {
            setBtnText("Add liquidity");
            setDisabled(false);
        } else {
            setBtnText("Amount is empty");
            setDisabled(true);
        }
    }, [
        amount1,
        amount2
    ]);
    return (0, $kyBEk$jsxs)((0, $7718944390218472$exports.default), {
        direction: "column",
        space: "10",
        children: [
            (0, $kyBEk$jsxs)((0, $7718944390218472$exports.default), {
                direction: "column",
                children: [
                    (0, $kyBEk$jsx)((0, $41ede47214de3bdb$exports.default), {
                        size: "xl",
                        weight: "semibold",
                        children: "Add liquidity"
                    }),
                    (0, $kyBEk$jsxs)((0, $7718944390218472$exports.default), {
                        align: "center",
                        children: [
                            (0, $kyBEk$jsx)((0, $41ede47214de3bdb$exports.default), {
                                color: "textSecondary",
                                children: props.token1.symbol
                            }),
                            (0, $kyBEk$jsx)((0, $41ede47214de3bdb$exports.default), {
                                color: "textSecondary",
                                attributes: {
                                    px: "3"
                                },
                                children: "/"
                            }),
                            (0, $kyBEk$jsx)((0, $41ede47214de3bdb$exports.default), {
                                color: "textSecondary",
                                children: props.token2.symbol
                            })
                        ]
                    })
                ]
            }),
            (0, $kyBEk$jsx)((0, $cf5bbf0f1742e4cc$export$2e2bcd8739ae039), {
                progress: progress1,
                symbol: props.token1.symbol,
                denom: props.token1.denom,
                available: props.token1.available,
                imgSrc: props.token1.imgSrc,
                amount: Number(amount1),
                onProgressChange: function(v) {
                    return handleProgress1Change(v);
                },
                onAmountChange: function(value) {
                    return handleAmoount1Change(value);
                }
            }),
            (0, $kyBEk$jsx)((0, $cf5bbf0f1742e4cc$export$2e2bcd8739ae039), {
                progress: progress2,
                symbol: props.token2.symbol,
                denom: props.token2.denom,
                available: props.token2.available,
                imgSrc: props.token2.imgSrc,
                amount: Number(amount2),
                onProgressChange: function(v) {
                    return handleProgress2Change(v);
                },
                onAmountChange: function(value) {
                    return handleAmoount2Change(value);
                }
            }),
            (0, $kyBEk$jsx)((0, $6aa42b028ae27f6d$exports.default), {
                intent: "tertiary",
                disabled: disabled,
                children: btnText
            })
        ]
    });
}
var $2dd8484f3d9d6bc0$export$2e2bcd8739ae039 = $2dd8484f3d9d6bc0$var$AddLiquidity;











var $3667228f6b91dd05$export$463b44d9bf3628be = "gvc3qt2r7 gvc3qt1sp gvc3qtw";


function $a131cc53bd368f08$var$RemoveLiquidity(props) {
    var _a;
    var _b = (0, $kyBEk$useState)(function() {
        return 50;
    }), progress = _b[0], setProgress = _b[1];
    function handeProgressClick(value) {
        setProgress(value);
    }
    return (0, $kyBEk$jsxs)((0, $7718944390218472$exports.default), {
        direction: "column",
        children: [
            (0, $kyBEk$jsxs)((0, $7718944390218472$exports.default), {
                direction: "column",
                children: [
                    (0, $kyBEk$jsx)((0, $41ede47214de3bdb$exports.default), {
                        size: "xl",
                        weight: "semibold",
                        children: "Remove liquidity"
                    }),
                    (0, $kyBEk$jsxs)((0, $7718944390218472$exports.default), {
                        align: "center",
                        children: [
                            (0, $kyBEk$jsx)((0, $41ede47214de3bdb$exports.default), {
                                color: "textSecondary",
                                children: props.token1.symbol
                            }),
                            (0, $kyBEk$jsx)((0, $41ede47214de3bdb$exports.default), {
                                color: "textSecondary",
                                attributes: {
                                    px: "3"
                                },
                                children: "/"
                            }),
                            (0, $kyBEk$jsx)((0, $41ede47214de3bdb$exports.default), {
                                color: "textSecondary",
                                children: props.token2.symbol
                            })
                        ]
                    })
                ]
            }),
            (0, $kyBEk$jsxs)((0, $7718944390218472$exports.default), {
                align: "baseline",
                justify: "center",
                attributes: {
                    marginTop: "9",
                    marginBottom: "5"
                },
                children: [
                    (0, $kyBEk$jsx)((0, $41ede47214de3bdb$exports.default), {
                        weight: "semibold",
                        attributes: {
                            marginRight: "1"
                        },
                        children: "$"
                    }),
                    (0, $kyBEk$jsx)((0, $41ede47214de3bdb$exports.default), {
                        size: "7xl",
                        weight: "semibold",
                        children: props.myLiquidity
                    })
                ]
            }),
            (0, $kyBEk$jsxs)((0, $7718944390218472$exports.default), {
                align: "center",
                justify: "center",
                attributes: {
                    marginBottom: "10"
                },
                children: [
                    (0, $kyBEk$jsx)((0, $41ede47214de3bdb$exports.default), {
                        attributes: {
                            marginRight: "3"
                        },
                        children: props.unbondedShares
                    }),
                    (0, $kyBEk$jsx)((0, $41ede47214de3bdb$exports.default), {
                        children: "pool shares"
                    })
                ]
            }),
            (0, $kyBEk$jsxs)((0, $7718944390218472$exports.default), {
                space: "13",
                justify: "center",
                attributes: {
                    marginBottom: "11"
                },
                children: [
                    (0, $kyBEk$jsxs)((0, $7718944390218472$exports.default), {
                        align: "center",
                        children: [
                            (0, $kyBEk$jsx)("img", {
                                src: props.token1.imgSrc,
                                className: $3667228f6b91dd05$export$463b44d9bf3628be
                            }),
                            (0, $kyBEk$jsx)((0, $41ede47214de3bdb$exports.default), {
                                color: "textSecondary",
                                weight: "semibold",
                                attributes: {
                                    mx: "4"
                                },
                                children: props.token1.amount
                            }),
                            (0, $kyBEk$jsx)((0, $41ede47214de3bdb$exports.default), {
                                color: "textSecondary",
                                children: props.token1.symbol
                            })
                        ]
                    }),
                    (0, $kyBEk$jsxs)((0, $7718944390218472$exports.default), {
                        align: "center",
                        children: [
                            (0, $kyBEk$jsx)("img", {
                                src: props.token2.imgSrc,
                                className: $3667228f6b91dd05$export$463b44d9bf3628be
                            }),
                            (0, $kyBEk$jsx)((0, $41ede47214de3bdb$exports.default), {
                                color: "textSecondary",
                                weight: "semibold",
                                attributes: {
                                    mx: "4"
                                },
                                children: props.token2.amount
                            }),
                            (0, $kyBEk$jsx)((0, $41ede47214de3bdb$exports.default), {
                                color: "textSecondary",
                                children: props.token2.symbol
                            })
                        ]
                    })
                ]
            }),
            (0, $kyBEk$jsx)((0, $3cb3fe3af8a37fe1$export$2e2bcd8739ae039), {
                progress: progress,
                onProgressChange: function(v) {
                    return handeProgressClick(v);
                }
            }),
            (0, $kyBEk$jsx)((0, $7718944390218472$exports.default), {
                space: "8",
                justify: "center",
                attributes: {
                    marginTop: "12"
                },
                children: (_a = [
                    25,
                    50,
                    75,
                    100
                ], _a === void 0) ? void 0 : _a.map(function(value, index) {
                    return (0, $kyBEk$jsxs)((0, $6aa42b028ae27f6d$exports.default), {
                        size: "xs",
                        intent: "text",
                        onClick: function(event) {
                            return handeProgressClick(value);
                        },
                        children: [
                            value,
                            "%"
                        ]
                    });
                })
            }),
            (0, $kyBEk$jsx)((0, $6aa42b028ae27f6d$exports.default), {
                size: "lg",
                intent: "tertiary",
                attributes: {
                    marginTop: "18"
                },
                children: "Remove Liquidity"
            })
        ]
    });
}
var $a131cc53bd368f08$export$2e2bcd8739ae039 = $a131cc53bd368f08$var$RemoveLiquidity;












var $0b7c5724f046b77c$export$72108e4fb43880e3 = "k52plx1 gvc3qtv1 gvc3qtv2";
var $0b7c5724f046b77c$export$9e1725a4cfeada27 = "k52plx3 gvc3qt2t7 gvc3qt1up gvc3qthl gvc3qthm";


function $1af6adbdf8801307$var$BondingMore(props) {
    var _a = (0, $kyBEk$useState)(function() {
        return "Amount is empty";
    }), btnText = _a[0], setBtnText = _a[1];
    var _b = (0, $kyBEk$useState)(function() {
        return true;
    }), disabled = _b[0], setDisabled = _b[1];
    function handleInputChange(e) {
        var value = e.target.value;
        if (value === "") {
            setDisabled(true);
            setBtnText("Amount is empty");
        } else if ((0, $kyBEk$bignumberjs)(value).eq(0)) {
            setDisabled(true);
            setBtnText("Amount is zero");
        } else if ((0, $kyBEk$bignumberjs)(value).gt(props.available)) {
            setDisabled(true);
            setBtnText("Insufficient mount");
        } else {
            setDisabled(false);
            setBtnText("Bond");
        }
    }
    return (0, $kyBEk$jsxs)((0, $7718944390218472$exports.default), {
        direction: "column",
        children: [
            (0, $kyBEk$jsxs)((0, $7718944390218472$exports.default), {
                direction: "column",
                children: [
                    (0, $kyBEk$jsx)((0, $41ede47214de3bdb$exports.default), {
                        size: "xl",
                        weight: "semibold",
                        children: "Bonding LP Tokens"
                    }),
                    (0, $kyBEk$jsxs)((0, $7718944390218472$exports.default), {
                        align: "center",
                        children: [
                            (0, $kyBEk$jsx)((0, $41ede47214de3bdb$exports.default), {
                                color: "textSecondary",
                                children: props.symbol1
                            }),
                            (0, $kyBEk$jsx)((0, $41ede47214de3bdb$exports.default), {
                                color: "textSecondary",
                                attributes: {
                                    p: "2"
                                },
                                children: "/"
                            }),
                            (0, $kyBEk$jsx)((0, $41ede47214de3bdb$exports.default), {
                                color: "textSecondary",
                                children: props.symbol2
                            })
                        ]
                    })
                ]
            }),
            (0, $kyBEk$jsxs)((0, $7718944390218472$exports.default), {
                justify: "space-between",
                attributes: {
                    marginTop: "13"
                },
                children: [
                    (0, $kyBEk$jsx)((0, $41ede47214de3bdb$exports.default), {
                        color: "textSecondary",
                        size: "lg",
                        weight: "semibold",
                        children: "Amount to bound"
                    }),
                    (0, $kyBEk$jsxs)((0, $7718944390218472$exports.default), {
                        align: "center",
                        attributes: {
                            marginBottom: "6"
                        },
                        children: [
                            (0, $kyBEk$jsx)((0, $41ede47214de3bdb$exports.default), {
                                color: "textSecondary",
                                children: "Available LP Token"
                            }),
                            (0, $kyBEk$jsx)((0, $41ede47214de3bdb$exports.default), {
                                color: "textSecondary",
                                children: props.available
                            })
                        ]
                    })
                ]
            }),
            (0, $kyBEk$jsx)((0, $c05182ab934fe0bd$exports.default), {
                marginBottom: "10",
                marginTop: "5",
                className: $0b7c5724f046b77c$export$72108e4fb43880e3,
                children: (0, $kyBEk$jsx)("input", {
                    onChange: function(e) {
                        return handleInputChange(e);
                    },
                    className: $0b7c5724f046b77c$export$9e1725a4cfeada27
                })
            }),
            (0, $kyBEk$jsx)((0, $6aa42b028ae27f6d$exports.default), {
                intent: "tertiary",
                size: "lg",
                disabled: disabled,
                children: btnText
            })
        ]
    });
}
var $1af6adbdf8801307$export$2e2bcd8739ae039 = $1af6adbdf8801307$var$BondingMore;









var $6c2b4d73cbde5027$export$dc1729746a6137fa = "_1m6nuim0";
var $6c2b4d73cbde5027$export$aa3e815946b80764 = "gvc3qt3bd gvc3qt31m gvc3qt34v gvc3qt384 gvc3qthl gvc3qthm gvc3qt2ty gvc3qtw";
var $6c2b4d73cbde5027$export$b8546401f1ede556 = "gvc3qt2ty";
var $6c2b4d73cbde5027$export$5679e5fce943fc50 = "_1m6nuim1";
var $6c2b4d73cbde5027$export$6634f3e1d70d59b4 = "_1m6nuim5 gvc3qt3bd gvc3qt31m gvc3qt34v gvc3qt384 gvc3qt2t7 gvc3qt2w1 gvc3qthl gvc3qthm gvc3qtw";


function $fdf76a7f9246794c$var$AssetListHeader(props) {
    var _a;
    return (0, $kyBEk$jsxs)((0, $7718944390218472$exports.default), {
        direction: "column",
        className: $6c2b4d73cbde5027$export$dc1729746a6137fa,
        children: [
            (0, $kyBEk$jsx)((0, $41ede47214de3bdb$exports.default), {
                size: "xl",
                weight: "semibold",
                attributes: {
                    marginBottom: "10"
                },
                children: "Your assets"
            }),
            !props.isSingle ? (0, $kyBEk$jsx)((0, $kyBEk$Fragment), {
                children: (0, $kyBEk$jsxs)((0, $7718944390218472$exports.default), {
                    space: "10",
                    className: $6c2b4d73cbde5027$export$5679e5fce943fc50,
                    children: [
                        (_a = [
                            {
                                text: "Total on Osmosis",
                                value: props.total
                            },
                            {
                                text: "Total across all chains",
                                value: props.totalOnAll
                            }
                        ], _a === void 0) ? void 0 : _a.map(function(item, index) {
                            return (0, $kyBEk$jsxs)((0, $7718944390218472$exports.default), {
                                direction: "column",
                                justify: "center",
                                className: $6c2b4d73cbde5027$export$aa3e815946b80764,
                                children: [
                                    (0, $kyBEk$jsx)((0, $41ede47214de3bdb$exports.default), {
                                        color: "textSecondary",
                                        weight: "semibold",
                                        children: item.text
                                    }),
                                    (0, $kyBEk$jsxs)((0, $7718944390218472$exports.default), {
                                        align: "baseline",
                                        children: [
                                            (0, $kyBEk$jsx)((0, $41ede47214de3bdb$exports.default), {
                                                weight: "semibold",
                                                attributes: {
                                                    marginRight: "1"
                                                },
                                                children: "$"
                                            }),
                                            (0, $kyBEk$jsx)((0, $41ede47214de3bdb$exports.default), {
                                                size: "4xl",
                                                weight: "semibold",
                                                children: item.value
                                            })
                                        ]
                                    })
                                ]
                            });
                        }),
                        (0, $kyBEk$jsxs)((0, $7718944390218472$exports.default), {
                            direction: "column",
                            justify: "space-between",
                            className: $6c2b4d73cbde5027$export$b8546401f1ede556,
                            children: [
                                props.canWithdraw ? (0, $kyBEk$jsx)((0, $kyBEk$Fragment), {
                                    children: (0, $kyBEk$jsx)((0, $6aa42b028ae27f6d$exports.default), {
                                        intent: "tertiary",
                                        onClick: function(event) {
                                            return console.log("withdraw");
                                        },
                                        children: "Withdraw"
                                    })
                                }) : null,
                                props.canDeposit ? (0, $kyBEk$jsx)((0, $kyBEk$Fragment), {
                                    children: (0, $kyBEk$jsx)((0, $6aa42b028ae27f6d$exports.default), {
                                        intent: "tertiary",
                                        variant: "outlined",
                                        onClick: function(event) {
                                            return console.log("deposit");
                                        },
                                        children: "Deposite"
                                    })
                                }) : null
                            ]
                        })
                    ]
                })
            }) : null,
            props.isSingle ? (0, $kyBEk$jsx)((0, $kyBEk$Fragment), {
                children: (0, $kyBEk$jsxs)((0, $7718944390218472$exports.default), {
                    justify: "space-between",
                    align: "center",
                    className: $6c2b4d73cbde5027$export$6634f3e1d70d59b4,
                    children: [
                        (0, $kyBEk$jsxs)((0, $7718944390218472$exports.default), {
                            direction: "column",
                            children: [
                                (0, $kyBEk$jsx)((0, $41ede47214de3bdb$exports.default), {
                                    children: "Total on Osmosis"
                                }),
                                (0, $kyBEk$jsxs)((0, $7718944390218472$exports.default), {
                                    align: "baseline",
                                    children: [
                                        (0, $kyBEk$jsx)((0, $41ede47214de3bdb$exports.default), {
                                            weight: "semibold",
                                            children: "$"
                                        }),
                                        (0, $kyBEk$jsx)((0, $41ede47214de3bdb$exports.default), {
                                            size: "4xl",
                                            weight: "semibold",
                                            children: props.total
                                        })
                                    ]
                                })
                            ]
                        }),
                        (0, $kyBEk$jsxs)((0, $7718944390218472$exports.default), {
                            space: "12",
                            align: "center",
                            children: [
                                props.canWithdraw ? (0, $kyBEk$jsx)((0, $kyBEk$Fragment), {
                                    children: (0, $kyBEk$jsx)((0, $6aa42b028ae27f6d$exports.default), {
                                        intent: "tertiary",
                                        variant: "outlined",
                                        attributes: {
                                            width: "25"
                                        },
                                        onClick: function(event) {
                                            return console.log("withdraw");
                                        },
                                        children: "Withdraw"
                                    })
                                }) : null,
                                props.canDeposit ? (0, $kyBEk$jsx)((0, $kyBEk$Fragment), {
                                    children: (0, $kyBEk$jsx)((0, $6aa42b028ae27f6d$exports.default), {
                                        intent: "tertiary",
                                        attributes: {
                                            width: "25"
                                        },
                                        onClick: function(event) {
                                            return console.log("deposit");
                                        },
                                        children: "Deposit"
                                    })
                                }) : null
                            ]
                        })
                    ]
                })
            }) : null
        ]
    });
}
$fdf76a7f9246794c$var$AssetListHeader.defaultProps = {
    isSingle: false
};
var $fdf76a7f9246794c$export$2e2bcd8739ae039 = $fdf76a7f9246794c$var$AssetListHeader;












var $932fa739a9342ead$export$d9115d73e8950402 = "_1l1s50n0";
var $932fa739a9342ead$export$9cc28892e1853afe = "gvc3qt2tv";
var $932fa739a9342ead$export$63e82393dc8977bf = "gvc3qt2s4";
var $932fa739a9342ead$export$fb01d6942c5883ea = "gvc3qt2rp gvc3qt1t7";
var $932fa739a9342ead$export$b84cb8cf0c297eb6 = "gvc3qt2rd gvc3qt1sv";


function $21a4d0ca005c50ac$var$AssetListItem(props) {
    var _a = (0, $kyBEk$useState)(function() {
        return "xs";
    }), size = _a[0], setSize = _a[1];
    (0, $kyBEk$useEffect)(function() {
        setSize(props.isOtherChains ? "xs" : "sm");
    }, [
        props.isOtherChains
    ]);
    return (0, $kyBEk$jsxs)((0, $7718944390218472$exports.default), {
        align: "center",
        className: $932fa739a9342ead$export$d9115d73e8950402,
        children: [
            (0, $kyBEk$jsx)((0, $c05182ab934fe0bd$exports.default), {
                className: $932fa739a9342ead$export$63e82393dc8977bf,
                children: (0, $kyBEk$jsx)("img", {
                    src: props.imgSrc,
                    className: props.isOtherChains ? $932fa739a9342ead$export$b84cb8cf0c297eb6 : $932fa739a9342ead$export$fb01d6942c5883ea
                })
            }),
            (0, $kyBEk$jsxs)((0, $7718944390218472$exports.default), {
                align: "center",
                className: (0, $47a3451e57ac14cf$export$9f2265a541a48bf2)({
                    flex: 1
                }),
                children: [
                    (0, $kyBEk$jsxs)((0, $7718944390218472$exports.default), {
                        direction: "column",
                        className: $932fa739a9342ead$export$9cc28892e1853afe,
                        children: [
                            (0, $kyBEk$jsx)((0, $41ede47214de3bdb$exports.default), {
                                weight: "semibold",
                                size: size,
                                attributes: {
                                    marginBottom: "2"
                                },
                                children: props.symbol
                            }),
                            (0, $kyBEk$jsx)((0, $41ede47214de3bdb$exports.default), {
                                color: "textSecondary",
                                size: size,
                                children: props.denom
                            })
                        ]
                    }),
                    props.needChainSpace ? (0, $kyBEk$jsx)((0, $kyBEk$Fragment), {
                        children: (0, $kyBEk$jsx)((0, $7718944390218472$exports.default), {
                            className: $932fa739a9342ead$export$9cc28892e1853afe,
                            children: props.isOtherChains ? (0, $kyBEk$jsx)((0, $kyBEk$Fragment), {
                                children: (0, $kyBEk$jsx)((0, $41ede47214de3bdb$exports.default), {
                                    color: "textSecondary",
                                    size: size,
                                    children: props.chainName
                                })
                            }) : null
                        })
                    }) : null,
                    (0, $kyBEk$jsxs)((0, $7718944390218472$exports.default), {
                        direction: "column",
                        className: $932fa739a9342ead$export$9cc28892e1853afe,
                        children: [
                            (0, $kyBEk$jsx)((0, $41ede47214de3bdb$exports.default), {
                                weight: "semibold",
                                size: size,
                                attributes: {
                                    marginBottom: "2"
                                },
                                children: props.amount
                            }),
                            (0, $kyBEk$jsxs)((0, $41ede47214de3bdb$exports.default), {
                                color: "textSecondary",
                                size: size,
                                children: [
                                    "$",
                                    props.dollarAmount
                                ]
                            })
                        ]
                    }),
                    !props.needChainSpace ? (0, $kyBEk$jsx)((0, $kyBEk$Fragment), {
                        children: (0, $kyBEk$jsx)((0, $7718944390218472$exports.default), {
                            className: $932fa739a9342ead$export$9cc28892e1853afe
                        })
                    }) : null,
                    (0, $kyBEk$jsxs)((0, $7718944390218472$exports.default), {
                        space: "5",
                        justify: "flex-end",
                        className: $932fa739a9342ead$export$9cc28892e1853afe,
                        children: [
                            props.canDeposit ? (0, $kyBEk$jsx)((0, $kyBEk$Fragment), {
                                children: (0, $kyBEk$jsx)((0, $6aa42b028ae27f6d$exports.default), {
                                    intent: "text",
                                    size: "sm",
                                    onClick: function(event) {
                                        return console.log("deposit");
                                    },
                                    children: "Deposit"
                                })
                            }) : null,
                            props.canWithdraw ? (0, $kyBEk$jsx)((0, $kyBEk$Fragment), {
                                children: (0, $kyBEk$jsx)((0, $6aa42b028ae27f6d$exports.default), {
                                    intent: "text",
                                    size: "sm",
                                    onClick: function(event) {
                                        return console.log("withdraw");
                                    },
                                    children: "Withdraw"
                                })
                            }) : null
                        ]
                    })
                ]
            })
        ]
    });
}
$21a4d0ca005c50ac$var$AssetListItem.defaultProps = {
    isOtherChains: false,
    needChainSpace: false
};
var $21a4d0ca005c50ac$export$2e2bcd8739ae039 = $21a4d0ca005c50ac$var$AssetListItem;










var $3ba73dd87bc053e9$export$eb2eba2018782a30 = "_1urdhkj0";


function $66f5ae7b17b3d1d2$var$AssetList(props) {
    var _a;
    return (0, $kyBEk$jsxs)((0, $7718944390218472$exports.default), {
        direction: "column",
        className: $3ba73dd87bc053e9$export$eb2eba2018782a30,
        children: [
            (0, $kyBEk$jsxs)((0, $7718944390218472$exports.default), {
                children: [
                    (0, $kyBEk$jsx)((0, $c05182ab934fe0bd$exports.default), {
                        width: "19"
                    }),
                    (0, $kyBEk$jsxs)((0, $7718944390218472$exports.default), {
                        flex: 1,
                        attributes: {
                            marginBottom: "12"
                        },
                        children: [
                            (0, $kyBEk$jsx)((0, $41ede47214de3bdb$exports.default), {
                                color: "textSecondary",
                                attributes: {
                                    width: "1/4"
                                },
                                children: "Asset"
                            }),
                            props.needChainSpace ? (0, $kyBEk$jsx)((0, $kyBEk$Fragment), {
                                children: (0, $kyBEk$jsx)((0, $c05182ab934fe0bd$exports.default), {
                                    width: "1/4",
                                    children: props.isOtherChains ? (0, $kyBEk$jsx)((0, $kyBEk$Fragment), {
                                        children: (0, $kyBEk$jsx)((0, $41ede47214de3bdb$exports.default), {
                                            color: "textSecondary",
                                            children: "Chain"
                                        })
                                    }) : null
                                })
                            }) : null,
                            (0, $kyBEk$jsx)((0, $41ede47214de3bdb$exports.default), {
                                color: "textSecondary",
                                attributes: {
                                    width: "1/4"
                                },
                                children: "Balance"
                            })
                        ]
                    })
                ]
            }),
            (0, $kyBEk$jsx)((0, $7718944390218472$exports.default), {
                space: "10",
                direction: "column",
                children: (_a = props.list) === null || _a === void 0 ? void 0 : _a.map(function(item, index) {
                    return (0, $kyBEk$jsx)((0, $c05182ab934fe0bd$exports.default), {
                        children: (0, $kyBEk$jsx)((0, $21a4d0ca005c50ac$export$2e2bcd8739ae039), {
                            needChainSpace: props.needChainSpace,
                            isOtherChains: props.isOtherChains,
                            imgSrc: item.imgSrc,
                            symbol: item.symbol,
                            denom: item.denom,
                            amount: item.amount,
                            dollarAmount: item.dollarAmount,
                            canDeposit: item.canDeposit,
                            canWithdraw: item.canWithdraw,
                            chainName: item === null || item === void 0 ? void 0 : item.chainName
                        })
                    }, index);
                })
            })
        ]
    });
}
$66f5ae7b17b3d1d2$var$AssetList.defaultProps = {
    isOtherChains: false
};
var $66f5ae7b17b3d1d2$export$2e2bcd8739ae039 = $66f5ae7b17b3d1d2$var$AssetList;











var $ece00dc123fff496$export$34e0f9847d4c02dd = "q4595g0";


function $fd961a25f6b0825c$var$CrossChain(props) {
    return (0, $kyBEk$jsx)((0, $becba96142f0a79e$export$2e2bcd8739ae039), {
        className: $ece00dc123fff496$export$34e0f9847d4c02dd,
        children: (0, $kyBEk$jsxs)((0, $7718944390218472$exports.default), {
            direction: "column",
            children: [
                (0, $kyBEk$jsx)((0, $fdf76a7f9246794c$export$2e2bcd8739ae039), {
                    isSingle: props.header.isSingle,
                    total: props.header.total,
                    totalOnAll: props.header.totalOnAll,
                    canWithdraw: props.header.canWithdraw,
                    canDeposit: props.header.canDeposit
                }),
                (0, $kyBEk$jsx)((0, $41ede47214de3bdb$exports.default), {
                    color: "textSecondary",
                    size: "lg",
                    weight: "semibold",
                    attributes: {
                        my: "9"
                    },
                    children: "On Osmosis"
                }),
                (0, $kyBEk$jsx)((0, $66f5ae7b17b3d1d2$export$2e2bcd8739ae039), {
                    needChainSpace: true,
                    isOtherChains: false,
                    list: props.list
                }),
                (0, $kyBEk$jsx)((0, $41ede47214de3bdb$exports.default), {
                    color: "textSecondary",
                    size: "lg",
                    weight: "semibold",
                    attributes: {
                        marginTop: "15",
                        marginBottom: "9"
                    },
                    children: "On other chains"
                }),
                (0, $kyBEk$jsx)((0, $66f5ae7b17b3d1d2$export$2e2bcd8739ae039), {
                    needChainSpace: true,
                    isOtherChains: true,
                    list: props.otherList
                })
            ]
        })
    });
}
var $fd961a25f6b0825c$export$2e2bcd8739ae039 = $fd961a25f6b0825c$var$CrossChain;











var $30da4d95608be509$export$34e0f9847d4c02dd = "_1s3t8a60";


function $8272508792f43ca7$var$SingleChain(props) {
    return (0, $kyBEk$jsx)((0, $becba96142f0a79e$export$2e2bcd8739ae039), {
        className: $30da4d95608be509$export$34e0f9847d4c02dd,
        children: (0, $kyBEk$jsxs)((0, $7718944390218472$exports.default), {
            direction: "column",
            children: [
                (0, $kyBEk$jsx)((0, $fdf76a7f9246794c$export$2e2bcd8739ae039), {
                    isSingle: props.header.isSingle,
                    total: props.header.total,
                    totalOnAll: props.header.totalOnAll,
                    canWithdraw: props.header.canWithdraw,
                    canDeposit: props.header.canDeposit
                }),
                (0, $kyBEk$jsx)((0, $41ede47214de3bdb$exports.default), {
                    color: "textSecondary",
                    size: "lg",
                    weight: "semibold",
                    attributes: {
                        marginTop: "10",
                        marginBottom: "9"
                    },
                    children: "On Osmosis"
                }),
                (0, $kyBEk$jsx)((0, $66f5ae7b17b3d1d2$export$2e2bcd8739ae039), {
                    needChainSpace: false,
                    isOtherChains: false,
                    list: props.list
                })
            ]
        })
    });
}
var $8272508792f43ca7$export$2e2bcd8739ae039 = $8272508792f43ca7$var$SingleChain;











var $a067da1cbc0d9669$export$30b7d84b1e5fdac2 = {
    light: "_17k4qq35 _17k4qq34",
    dark: "_17k4qq36 _17k4qq34"
};
var $a067da1cbc0d9669$export$463b44d9bf3628be = "gvc3qt2rs gvc3qt1ta";
var $a067da1cbc0d9669$export$de2745c3c6ec10a1 = "_17k4qq32";
var $a067da1cbc0d9669$export$4a6f8e780e582185 = {
    light: "_17k4qq3a _17k4qq39",
    dark: "_17k4qq3b _17k4qq39"
};




function $cc533390baae922f$var$OverviewTransfer(props) {
    var cleanupRef = (0, $kyBEk$useRef)(null);
    var _a = (0, $kyBEk$useState)(function() {
        return "light";
    }), theme = _a[0], setTheme = _a[1];
    (0, $kyBEk$useEffect)(function() {
        setTheme((0, $65ee908e933b27be$export$6f57813fe9f31bf9).getState().theme);
        cleanupRef.current = (0, $65ee908e933b27be$export$6f57813fe9f31bf9).subscribe(function(newState) {
            setTheme(newState.theme);
        });
    }, []);
    (0, $kyBEk$useEffect)(function() {
        return function() {
            if (typeof cleanupRef.current === "function") cleanupRef.current();
        };
    }, []);
    return (0, $kyBEk$jsxs)((0, $7718944390218472$exports.default), {
        direction: "column",
        className: $a067da1cbc0d9669$export$de2745c3c6ec10a1,
        children: [
            (0, $kyBEk$jsx)((0, $41ede47214de3bdb$exports.default), {
                size: "xl",
                weight: "semibold",
                attributes: {
                    marginBottom: "10"
                },
                children: props.type
            }),
            (0, $kyBEk$jsxs)((0, $7718944390218472$exports.default), {
                direction: "column",
                attributes: {
                    backgroundColor: "progressBg",
                    borderRadius: "lg",
                    paddingTop: "7",
                    paddingLeft: "9",
                    paddingRight: "5",
                    paddingBottom: "8"
                },
                children: [
                    (0, $kyBEk$jsxs)((0, $7718944390218472$exports.default), {
                        justify: "flex-end",
                        align: "center",
                        attributes: {
                            marginBottom: "7"
                        },
                        children: [
                            (0, $kyBEk$jsx)((0, $41ede47214de3bdb$exports.default), {
                                color: "textSecondary",
                                weight: "semibold",
                                children: "Available"
                            }),
                            (0, $kyBEk$jsx)((0, $41ede47214de3bdb$exports.default), {
                                weight: "semibold",
                                attributes: {
                                    marginLeft: "4",
                                    marginRight: "9"
                                },
                                children: "713.32"
                            }),
                            (0, $kyBEk$jsx)((0, $6aa42b028ae27f6d$exports.default), {
                                size: "xs",
                                className: $a067da1cbc0d9669$export$4a6f8e780e582185[theme],
                                children: "Max"
                            })
                        ]
                    }),
                    (0, $kyBEk$jsxs)((0, $7718944390218472$exports.default), {
                        justify: "space-between",
                        align: "center",
                        children: [
                            (0, $kyBEk$jsxs)((0, $7718944390218472$exports.default), {
                                align: "center",
                                children: [
                                    (0, $kyBEk$jsx)("img", {
                                        src: "https://raw.githubusercontent.com/cosmos/chain-registry/master/umee/images/umee.png",
                                        className: $a067da1cbc0d9669$export$463b44d9bf3628be
                                    }),
                                    (0, $kyBEk$jsxs)((0, $7718944390218472$exports.default), {
                                        direction: "column",
                                        attributes: {
                                            marginLeft: "9"
                                        },
                                        children: [
                                            (0, $kyBEk$jsxs)((0, $7718944390218472$exports.default), {
                                                align: "center",
                                                children: [
                                                    (0, $kyBEk$jsx)((0, $41ede47214de3bdb$exports.default), {
                                                        size: "2xl",
                                                        weight: "semibold",
                                                        attributes: {
                                                            marginRight: "5"
                                                        },
                                                        children: "UMEE"
                                                    }),
                                                    (0, $kyBEk$jsx)((0, $a7df98dc81165fd3$export$2e2bcd8739ae039), {
                                                        name: "arrowDownS",
                                                        color: "textSecondary"
                                                    })
                                                ]
                                            }),
                                            (0, $kyBEk$jsx)((0, $41ede47214de3bdb$exports.default), {
                                                color: "textSecondary",
                                                children: "Umee"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            (0, $kyBEk$jsxs)((0, $7718944390218472$exports.default), {
                                direction: "column",
                                children: [
                                    (0, $kyBEk$jsx)("input", {}),
                                    (0, $kyBEk$jsx)((0, $41ede47214de3bdb$exports.default), {
                                        color: "textSecondary",
                                        size: "xs",
                                        align: "right",
                                        attributes: {
                                            marginTop: "1"
                                        },
                                        children: "~ $98.23"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            (0, $kyBEk$jsxs)((0, $7718944390218472$exports.default), {
                justify: "center",
                align: "center",
                attributes: {
                    marginTop: "11",
                    marginBottom: "13"
                },
                children: [
                    (0, $kyBEk$jsx)("img", {
                        src: "https://raw.githubusercontent.com/cosmos/chain-registry/master/umee/images/umee.png",
                        className: $a067da1cbc0d9669$export$463b44d9bf3628be
                    }),
                    (0, $kyBEk$jsx)((0, $a7df98dc81165fd3$export$2e2bcd8739ae039), {
                        name: "arrowRightLine",
                        color: "textSecondary",
                        size: "xl",
                        className: (0, $47a3451e57ac14cf$export$9f2265a541a48bf2)({
                            mx: "9"
                        })
                    }),
                    (0, $kyBEk$jsx)("img", {
                        src: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/osmo.svg",
                        className: $a067da1cbc0d9669$export$463b44d9bf3628be
                    })
                ]
            }),
            (0, $kyBEk$jsx)((0, $6aa42b028ae27f6d$exports.default), {
                intent: "tertiary",
                children: (0, $kyBEk$jsxs)((0, $7718944390218472$exports.default), {
                    align: "center",
                    children: [
                        (0, $kyBEk$jsx)((0, $41ede47214de3bdb$exports.default), {
                            size: "lg",
                            weight: "semibold",
                            className: $a067da1cbc0d9669$export$30b7d84b1e5fdac2[theme],
                            children: "Transfer"
                        }),
                        (0, $kyBEk$jsx)((0, $a7df98dc81165fd3$export$2e2bcd8739ae039), {
                            name: "timeLine",
                            size: "xs",
                            className: (0, $47a3451e57ac14cf$export$9f2265a541a48bf2)({
                                marginLeft: "8",
                                marginRight: "4"
                            })
                        }),
                        (0, $kyBEk$jsx)((0, $41ede47214de3bdb$exports.default), {
                            size: "xs",
                            className: $a067da1cbc0d9669$export$30b7d84b1e5fdac2[theme],
                            children: "≈ 20 seconds"
                        })
                    ]
                })
            }),
            (0, $kyBEk$jsx)((0, $6aa42b028ae27f6d$exports.default), {
                variant: "unstyled",
                children: "Cancel"
            })
        ]
    });
}
var $cc533390baae922f$export$2e2bcd8739ae039 = $cc533390baae922f$var$OverviewTransfer;












var $f646d44b15a467ea$export$30b7d84b1e5fdac2 = {
    light: "_12x8gps8 _12x8gps7",
    dark: "_12x8gps9 _12x8gps7"
};
var $f646d44b15a467ea$export$34e0f9847d4c02dd = "_12x8gps1";
var $f646d44b15a467ea$export$fce79930bd73619a = "_12x8gps4";
var $f646d44b15a467ea$export$463b44d9bf3628be = "gvc3qt2rs gvc3qt1ta";
var $f646d44b15a467ea$export$8b861f75e49e4d12 = "_12x8gps5";
var $f646d44b15a467ea$export$5ce0f3e73495726d = "_12x8gps6";
var $f646d44b15a467ea$export$b84cb8cf0c297eb6 = "gvc3qt2rg gvc3qt1sy gvc3qt2bs";




function $50bcfa5ac46069c9$var$AssetItemTransfer(props) {
    var cleanupRef = (0, $kyBEk$useRef)(null);
    var _a = (0, $kyBEk$useState)(function() {
        return "";
    }), theme = _a[0], setTheme = _a[1];
    (0, $kyBEk$useEffect)(function() {
        setTheme((0, $65ee908e933b27be$export$6f57813fe9f31bf9).getState().theme);
        cleanupRef.current = (0, $65ee908e933b27be$export$6f57813fe9f31bf9).subscribe(function(newState) {
            setTheme(newState.theme);
        });
    }, []);
    (0, $kyBEk$useEffect)(function() {
        return function() {
            if (typeof cleanupRef.current === "function") cleanupRef.current();
        };
    }, []);
    return (0, $kyBEk$jsxs)((0, $7718944390218472$exports.default), {
        direction: "column",
        className: $f646d44b15a467ea$export$34e0f9847d4c02dd,
        children: [
            (0, $kyBEk$jsxs)((0, $7718944390218472$exports.default), {
                children: [
                    (0, $kyBEk$jsx)((0, $41ede47214de3bdb$exports.default), {
                        size: "xl",
                        weight: "semibold",
                        attributes: {
                            marginRight: "3"
                        },
                        children: props.type
                    }),
                    (0, $kyBEk$jsx)((0, $41ede47214de3bdb$exports.default), {
                        size: "xl",
                        weight: "semibold",
                        children: "ATOM"
                    })
                ]
            }),
            (0, $kyBEk$jsxs)((0, $7718944390218472$exports.default), {
                justify: "center",
                align: "center",
                attributes: {
                    marginTop: "11",
                    marginBottom: "13"
                },
                className: $f646d44b15a467ea$export$5ce0f3e73495726d,
                children: [
                    (0, $kyBEk$jsx)("img", {
                        src: "https://raw.githubusercontent.com/cosmos/chain-registry/master/umee/images/umee.png",
                        className: $f646d44b15a467ea$export$463b44d9bf3628be
                    }),
                    (0, $kyBEk$jsx)((0, $a7df98dc81165fd3$export$2e2bcd8739ae039), {
                        name: "arrowRightLine",
                        color: "textSecondary",
                        size: "xl",
                        className: (0, $47a3451e57ac14cf$export$9f2265a541a48bf2)({
                            mx: "9"
                        })
                    }),
                    (0, $kyBEk$jsx)("img", {
                        src: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/osmo.svg",
                        className: $f646d44b15a467ea$export$463b44d9bf3628be
                    })
                ]
            }),
            (0, $kyBEk$jsxs)((0, $7718944390218472$exports.default), {
                justify: "center",
                align: "flex-end",
                attributes: {
                    marginTop: "13",
                    marginBottom: "10"
                },
                className: $f646d44b15a467ea$export$8b861f75e49e4d12,
                children: [
                    (0, $kyBEk$jsxs)((0, $7718944390218472$exports.default), {
                        direction: "column",
                        className: $f646d44b15a467ea$export$fce79930bd73619a,
                        children: [
                            (0, $kyBEk$jsx)((0, $41ede47214de3bdb$exports.default), {
                                color: "textSecondary",
                                weight: "semibold",
                                attributes: {
                                    marginBottom: "6"
                                },
                                children: "From Cosmos Hub"
                            }),
                            (0, $kyBEk$jsxs)((0, $7718944390218472$exports.default), {
                                align: "center",
                                attributes: {
                                    p: "6",
                                    backgroundColor: "cardBg",
                                    borderRadius: "lg"
                                },
                                children: [
                                    (0, $kyBEk$jsx)("img", {
                                        src: "https://raw.githubusercontent.com/cosmos/chain-registry/master/umee/images/umee.png",
                                        className: $f646d44b15a467ea$export$b84cb8cf0c297eb6
                                    }),
                                    (0, $kyBEk$jsx)((0, $41ede47214de3bdb$exports.default), {
                                        color: "textSecondary",
                                        children: "atom1xy5y...m6wwz9a"
                                    })
                                ]
                            })
                        ]
                    }),
                    (0, $kyBEk$jsx)((0, $a7df98dc81165fd3$export$2e2bcd8739ae039), {
                        name: "arrowRightLine",
                        color: "textSecondary",
                        size: "md",
                        className: (0, $47a3451e57ac14cf$export$9f2265a541a48bf2)({
                            mx: "4",
                            marginBottom: "9"
                        })
                    }),
                    (0, $kyBEk$jsxs)((0, $7718944390218472$exports.default), {
                        direction: "column",
                        className: $f646d44b15a467ea$export$fce79930bd73619a,
                        children: [
                            (0, $kyBEk$jsx)((0, $41ede47214de3bdb$exports.default), {
                                color: "textSecondary",
                                weight: "semibold",
                                attributes: {
                                    marginBottom: "6"
                                },
                                children: "From Cosmos Hub"
                            }),
                            (0, $kyBEk$jsxs)((0, $7718944390218472$exports.default), {
                                align: "center",
                                attributes: {
                                    p: "6",
                                    backgroundColor: "cardBg",
                                    borderRadius: "lg"
                                },
                                children: [
                                    (0, $kyBEk$jsx)("img", {
                                        src: "https://raw.githubusercontent.com/cosmos/chain-registry/master/umee/images/umee.png",
                                        className: $f646d44b15a467ea$export$b84cb8cf0c297eb6
                                    }),
                                    (0, $kyBEk$jsx)((0, $41ede47214de3bdb$exports.default), {
                                        color: "textSecondary",
                                        children: "atom1xy5y...m6wwz9a"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            (0, $kyBEk$jsx)((0, $cf5bbf0f1742e4cc$export$2e2bcd8739ae039), {
                symbol: "OMSO",
                denom: "Osmosis",
                imgSrc: "https://raw.githubusercontent.com/cosmos/chain-registry/master/assetmantle/images/mntl.png",
                hasProgressBar: false,
                progress: 50,
                available: 0.71263,
                amount: 10
            }),
            (0, $kyBEk$jsxs)((0, $7718944390218472$exports.default), {
                justify: "flex-end",
                space: "5",
                attributes: {
                    marginTop: "5",
                    marginBottom: "11"
                },
                children: [
                    (0, $kyBEk$jsx)((0, $6aa42b028ae27f6d$exports.default), {
                        intent: "text",
                        size: "xs",
                        children: "Max"
                    }),
                    (0, $kyBEk$jsx)((0, $6aa42b028ae27f6d$exports.default), {
                        intent: "text",
                        size: "xs",
                        children: "1/2"
                    }),
                    (0, $kyBEk$jsx)((0, $6aa42b028ae27f6d$exports.default), {
                        intent: "text",
                        size: "xs",
                        children: "1/3"
                    })
                ]
            }),
            (0, $kyBEk$jsxs)((0, $7718944390218472$exports.default), {
                align: "center",
                attributes: {
                    p: "6",
                    borderRadius: "md",
                    backgroundColor: "cardBg",
                    marginBottom: "9"
                },
                className: $f646d44b15a467ea$export$8b861f75e49e4d12,
                children: [
                    (0, $kyBEk$jsx)((0, $a7df98dc81165fd3$export$2e2bcd8739ae039), {
                        name: "timeLine",
                        size: "md",
                        className: (0, $47a3451e57ac14cf$export$9f2265a541a48bf2)({
                            marginRight: "7"
                        })
                    }),
                    (0, $kyBEk$jsx)((0, $41ede47214de3bdb$exports.default), {
                        children: "Estimated time:"
                    }),
                    (0, $kyBEk$jsx)((0, $41ede47214de3bdb$exports.default), {
                        weight: "semibold",
                        children: " 20 seconds"
                    })
                ]
            }),
            (0, $kyBEk$jsx)((0, $6aa42b028ae27f6d$exports.default), {
                intent: "tertiary",
                children: (0, $kyBEk$jsxs)((0, $7718944390218472$exports.default), {
                    align: "center",
                    children: [
                        (0, $kyBEk$jsx)((0, $41ede47214de3bdb$exports.default), {
                            size: "lg",
                            weight: "semibold",
                            className: $f646d44b15a467ea$export$30b7d84b1e5fdac2[theme],
                            children: "Transfer"
                        }),
                        (0, $kyBEk$jsxs)((0, $7718944390218472$exports.default), {
                            align: "center",
                            className: $f646d44b15a467ea$export$8b861f75e49e4d12,
                            children: [
                                (0, $kyBEk$jsx)((0, $a7df98dc81165fd3$export$2e2bcd8739ae039), {
                                    name: "timeLine",
                                    size: "xs",
                                    className: (0, $47a3451e57ac14cf$export$9f2265a541a48bf2)({
                                        marginLeft: "8",
                                        marginRight: "4"
                                    })
                                }),
                                (0, $kyBEk$jsx)((0, $41ede47214de3bdb$exports.default), {
                                    size: "xs",
                                    className: $f646d44b15a467ea$export$30b7d84b1e5fdac2[theme],
                                    children: "≈ 20 seconds"
                                })
                            ]
                        })
                    ]
                })
            }),
            (0, $kyBEk$jsx)((0, $6aa42b028ae27f6d$exports.default), {
                variant: "unstyled",
                children: "Cancel"
            })
        ]
    });
}
var $50bcfa5ac46069c9$export$2e2bcd8739ae039 = $50bcfa5ac46069c9$var$AssetItemTransfer;





// End Components
(0, $3a23b7a7442a0ab3$export$5f05d56a0f2349cc)((0, $3a23b7a7442a0ab3$export$2dffd0b5373a4389).React);


export {$ee947b15541e898f$export$d6c2b47acf98a8f8 as setDebugLevel, $dd30de1fdfe56750$export$3d2702f5c006feb7 as createCustomTheme, $ee947b15541e898f$export$81abf30fb640fb72 as DebugLevel, $65ee908e933b27be$export$6f57813fe9f31bf9 as store, $c05182ab934fe0bd$export$2e2bcd8739ae039 as Box, $7718944390218472$export$2e2bcd8739ae039 as Stack, $a7df98dc81165fd3$export$2e2bcd8739ae039 as Icon, $41ede47214de3bdb$export$2e2bcd8739ae039 as Text, $6aa42b028ae27f6d$export$2e2bcd8739ae039 as Button, $aad94d8c88c58f04$export$2e2bcd8739ae039 as ClipboardCopyText, $b24d996ce2c2bd4a$export$2e2bcd8739ae039 as ThemeProvider, $509770f1f99d27e1$export$2e2bcd8739ae039 as FadeIn, $4950aa983a2d5553$export$2e2bcd8739ae039 as PoolsHeader, $e7fdf0e3b8813495$export$2e2bcd8739ae039 as PoolList, $56109dfc633821a9$export$2e2bcd8739ae039 as PoolListItem, $3c3a4a172d9b3610$export$2e2bcd8739ae039 as PoolCard, $9125f1d960bc2f77$export$2e2bcd8739ae039 as PoolCardList, $10743afa76cdfee5$export$2e2bcd8739ae039 as ConnectModal, $5910f4dbd1d8d9b6$export$2e2bcd8739ae039 as ConnectModalHead, $7428a38f5ec9a8cf$export$2e2bcd8739ae039 as ConnectModalQRCode, $c4323e81d0890d81$export$2e2bcd8739ae039 as ConnectModalQRCodeError, $b333ffce68f4dc6c$export$2e2bcd8739ae039 as ConnectModalQRCodeSkeleton, $abea071f346d6567$export$2e2bcd8739ae039 as ConnectModalStatus, $09019c53bb4d0154$export$2e2bcd8739ae039 as ConnectModalWalletButton, $aebf0d9ca8db48ff$export$2e2bcd8739ae039 as ConnectModalWalletList, $becba96142f0a79e$export$2e2bcd8739ae039 as ShowMore, $7f84db23fdb0c43f$export$2e2bcd8739ae039 as I18nProvider, $3a9b1dc339827865$export$2e2bcd8739ae039 as PoolInfoHeader, $877b6ae87e46e23d$export$2e2bcd8739ae039 as ManageLiquidityCard, $17bb0f000238f803$export$2e2bcd8739ae039 as BondingCard, $a80ba355bd2ee3fc$export$2e2bcd8739ae039 as BondingCardList, $3ae8aa3fba6759b4$export$2e2bcd8739ae039 as BondingListItem, $17b87c5e14580680$export$2e2bcd8739ae039 as BondingList, $2699fc59945b7af0$export$2e2bcd8739ae039 as BondingListItemSm, $5429ef3689137234$export$2e2bcd8739ae039 as BondingListSm, $2fc58d3899360766$export$2e2bcd8739ae039 as BondingArea, $1ee39bcdf3a85af5$export$2e2bcd8739ae039 as QRCode, $a6a228fbeba47621$export$2e2bcd8739ae039 as IconButton, $3cb3fe3af8a37fe1$export$2e2bcd8739ae039 as ProgressBar, $0383195aac1b1cc7$export$2e2bcd8739ae039 as CircularProgressBar, $cf5bbf0f1742e4cc$export$2e2bcd8739ae039 as TokenInput, $2dd8484f3d9d6bc0$export$2e2bcd8739ae039 as AddLiquidity, $a131cc53bd368f08$export$2e2bcd8739ae039 as RemoveLiquidity, $1af6adbdf8801307$export$2e2bcd8739ae039 as BondingMore, $fdf76a7f9246794c$export$2e2bcd8739ae039 as AssetListHeader, $21a4d0ca005c50ac$export$2e2bcd8739ae039 as AssetListItem, $66f5ae7b17b3d1d2$export$2e2bcd8739ae039 as AssetList, $fd961a25f6b0825c$export$2e2bcd8739ae039 as CrossChain, $8272508792f43ca7$export$2e2bcd8739ae039 as SingleChain, $cc533390baae922f$export$2e2bcd8739ae039 as OverviewTransfer, $50bcfa5ac46069c9$export$2e2bcd8739ae039 as AssetItemTransfer, $5ed443ae3726df7f$export$2e2bcd8739ae039 as Modal};
//# sourceMappingURL=interchain-ui-kit-react.esm.js.map